import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import styled, { css, keyframes } from 'styled-components';
import * as React from 'react';
import React__default, { useState, useEffect, useRef, useCallback, useContext, useMemo, useLayoutEffect, createContext, forwardRef } from 'react';
import $k7QOs$reactdom, { createPortal } from 'react-dom';
import { Link } from 'react-router-dom';

var Colors;
(function (Colors) {
    Colors["Electric100"] = "#ECEEFF";
    Colors["Electric200"] = "#DCE0FF";
    Colors["Electric300"] = "#C4C9FF";
    Colors["Electric400"] = "#A1A8FF";
    Colors["Electric500"] = "#808AFF";
    Colors["Electric600"] = "#6673FF";
    Colors["Electric700"] = "#4C48EF";
    Colors["ElectricBrand"] = "#3B2FC9";
    Colors["Electric900"] = "#0C009D";
    Colors["Midnight100"] = "#C2C3E9";
    Colors["Midnight200"] = "#9698D0";
    Colors["Midnight300"] = "#6668A1";
    Colors["Midnight400"] = "#54568F";
    Colors["Midnight500"] = "#3D3F7A";
    Colors["Midnight600"] = "#2E3168";
    Colors["Midnight700"] = "#1D1F4A";
    Colors["Midnight800"] = "#111338";
    Colors["MidnightBrand"] = "#090B2B";
    Colors["Pigeon100"] = "#F6F8FC";
    Colors["Pigeon200"] = "#E8EDF4";
    Colors["Pigeon300"] = "#D7DEE8";
    Colors["Pigeon400"] = "#CAD0DC";
    Colors["Pigeon500"] = "#B4BCCC";
    Colors["Pigeon600"] = "#8B93A4";
    Colors["Pigeon700"] = "#616A7D";
    Colors["Pigeon800"] = "#404857";
    Colors["Pigeon900"] = "#303744";
    Colors["Sky100"] = "#D4EAFF";
    Colors["Sky200"] = "#B9DCFF";
    Colors["Sky300"] = "#94C9FF";
    Colors["Sky400"] = "#73B2F0";
    Colors["Sky500"] = "#54A0EA";
    Colors["Sky600"] = "#2473D1";
    Colors["Sky700"] = "#034EB9";
    Colors["Sky800"] = "#003D95";
    Colors["Sky900"] = "#002E70";
    Colors["Pinata100"] = "#FFE9E8";
    Colors["Pinata200"] = "#FFDDDB";
    Colors["Pinata300"] = "#FFD1CF";
    Colors["Pinata400"] = "#FFBEBB";
    Colors["Pinata500"] = "#FFB1A9";
    Colors["Pinata600"] = "#FFA197";
    Colors["Pinata700"] = "#FF8D77";
    Colors["Pinata800"] = "#FD7F67";
    Colors["Pinata900"] = "#D64B32";
    Colors["Sunflower100"] = "#FFFAED";
    Colors["Sunflower200"] = "#FFF5D9";
    Colors["Sunflower300"] = "#FFEFC2";
    Colors["Sunflower400"] = "#FFE9AD";
    Colors["Sunflower500"] = "#FFE396";
    Colors["Sunflower600"] = "#FFDD81";
    Colors["Sunflower700"] = "#FFD86E";
    Colors["Sunflower800"] = "#FFD152";
    Colors["Sunflower900"] = "#D96A00";
    Colors["Nectar100"] = "#FFF9F5";
    Colors["Nectar200"] = "#FFF5ED";
    Colors["Nectar300"] = "#FFF0E3";
    Colors["Nectar400"] = "#FFE4CC";
    Colors["Nectar500"] = "#FFDCBD";
    Colors["Nectar600"] = "#FFD9B7";
    Colors["Nectar700"] = "#FBCCA2";
    Colors["Nectar800"] = "#F9C493";
    Colors["Nectar900"] = "#F6BA83";
    Colors["Jade100"] = "#E9F5EE";
    Colors["Jade200"] = "#C7F1DF";
    Colors["Jade300"] = "#B6E7D2";
    Colors["Jade400"] = "#A2E4C7";
    Colors["Jade500"] = "#80DDB4";
    Colors["Jade600"] = "#6FD0A6";
    Colors["Jade700"] = "#6FD0A6";
    Colors["Jade800"] = "#3DB983";
    Colors["Jade900"] = "#32A673";
    Colors["White"] = "#FFFFFF";
    Colors["SuccessStrong"] = "#009F42";
    Colors["DarkBlue"] = "#08415C";
    Colors["LightBlue"] = "#E7EDEF";
    Colors["Pink"] = "#C04ABC";
    Colors["LightPink"] = "#F9EDF9";
    Colors["Brown"] = "#6D435A";
    Colors["LightBrown"] = "rgba(109, 67, 90, 0.10)";
    Colors["Indigo"] = "#414073";
    Colors["LightIndigo"] = "#EEF8F7";
    Colors["Purple"] = "#642CA9";
    Colors["LightPurple"] = "#F0EAF7";
    Colors["Transparent"] = "transparent";
})(Colors || (Colors = {}));
var Colors$1 = Colors;

const baseSvgProps = {
    xmlns: 'http://www.w3.org/2000/svg',
    width: '24',
    height: '24',
    fill: 'none',
    viewBox: '0 0 24 24',
    role: 'img',
};
const Icons = {
    add: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.799 3.276c-.212.043-.39.165-.468.322-.066.132-.072.4-.082 3.891l-.011 3.749-3.749.011-3.749.011-.169.097c-.221.126-.308.308-.31.643-.001.332.101.542.322.657.155.082.206.083 3.906.094l3.749.011.011 3.749c.011 3.7.012 3.751.094 3.906.115.22.325.323.657.323s.542-.103.657-.323c.082-.155.083-.206.094-3.906l.011-3.749 3.749-.011c3.7-.011 3.751-.012 3.906-.094.221-.115.323-.325.322-.657-.002-.335-.089-.517-.31-.643l-.169-.097-3.749-.011-3.749-.011-.011-3.749c-.01-3.507-.016-3.758-.082-3.892-.123-.246-.516-.391-.87-.321' }) })),
    alertCircle: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.32 2.28A9.74 9.74 0 003.258 7.7c-.46.94-.762 1.914-.924 2.98-.097.636-.097 2.004 0 2.64.446 2.941 2.052 5.409 4.533 6.968 1.075.676 2.441 1.17 3.813 1.378.636.097 2.004.097 2.64 0 2.1-.319 3.932-1.206 5.405-2.618 1.601-1.534 2.6-3.479 2.941-5.728.097-.636.097-2.004 0-2.64-.443-2.919-2.04-5.389-4.49-6.941-.824-.522-2.118-1.053-3.056-1.253a10.872 10.872 0 00-2.8-.206m2 1.578a8.277 8.277 0 014.628 2.435c1.176 1.231 1.913 2.713 2.2 4.423.1.593.1 1.975 0 2.568-.612 3.649-3.463 6.426-7.08 6.895-3.771.489-7.369-1.653-8.767-5.219a9.164 9.164 0 01-.449-1.676c-.1-.593-.1-1.975 0-2.568.299-1.783 1.066-3.282 2.324-4.54 1.389-1.388 2.977-2.138 5.064-2.391.313-.038 1.715.011 2.08.073m-1.521 3.418c-.212.043-.39.165-.468.322-.065.131-.071.322-.071 2.402 0 2.206.002 2.264.083 2.417.115.22.325.323.657.323s.542-.103.657-.323c.081-.153.083-.211.083-2.417 0-2.09-.005-2.271-.071-2.403-.123-.246-.516-.391-.87-.321m0 8c-.37.075-.536.299-.538.724-.002.508.236.74.759.74.325 0 .535-.102.65-.314.094-.173.094-.679 0-.852-.129-.24-.514-.371-.871-.298' }) })),
    alertTriangle: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.623 2.287c-.736.083-1.504.565-1.92 1.204-.226.349-7.029 12.154-7.13 12.374a2.748 2.748 0 00.965 3.408c.349.234.647.355 1.062.43.444.08 14.356.08 14.8 0a2.74 2.74 0 002.146-1.882 2.738 2.738 0 00-.119-1.956c-.121-.263-6.946-12.086-7.161-12.405-.584-.866-1.553-1.296-2.643-1.173m.903 1.582c.102.046.255.153.34.239.101.102 1.36 2.246 3.664 6.238 1.93 3.345 3.536 6.147 3.57 6.227.035.084.06.267.06.439 0 .486-.242.878-.691 1.118l-.169.09H4.7l-.169-.09a1.242 1.242 0 01-.569-.579c-.104-.208-.122-.288-.121-.547 0-.207.024-.355.074-.464.075-.165 6.677-11.618 6.989-12.125.197-.321.382-.48.676-.586.259-.092.687-.074.946.04m-.727 4.407c-.212.043-.39.165-.468.322-.063.127-.071.278-.071 1.402 0 1.196.004 1.268.083 1.417.115.22.325.323.657.323s.542-.103.657-.323c.079-.149.083-.221.083-1.417 0-1.13-.007-1.275-.071-1.403-.123-.246-.516-.391-.87-.321m0 6c-.37.075-.536.299-.538.724-.002.508.236.74.759.74.325 0 .535-.102.65-.314.094-.173.094-.679 0-.852-.129-.24-.514-.371-.871-.298' }) })),
    arrowLeft: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M9.76 4.263c-.09.039-1.403 1.319-3.681 3.589a720.538 720.538 0 01-3.643 3.615.872.872 0 00-.177.31c-.074.219-.074.227.001.449a.865.865 0 00.195.33 709.79 709.79 0 013.662 3.631c3.888 3.869 3.681 3.686 4.048 3.576.218-.065.533-.38.598-.598.11-.365.239-.216-2.995-3.455l-2.946-2.949 8.219-.011c8.217-.01 8.219-.01 8.376-.093.221-.115.323-.325.322-.657-.002-.335-.089-.517-.31-.643l-.169-.097-8.219-.011-8.219-.01 2.946-2.95c3.218-3.222 3.104-3.091 2.999-3.441-.091-.305-.503-.651-.77-.646a.766.766 0 00-.237.061' }) })),
    arrowRight: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M13.729 4.285c-.209.103-.435.36-.496.563-.105.35-.219.219 2.999 3.441l2.946 2.95-8.219.01-8.219.011-.169.097c-.221.126-.308.308-.31.643-.001.332.101.542.322.657.157.083.159.083 8.376.093l8.219.011-2.946 2.949c-3.234 3.239-3.105 3.09-2.995 3.455.065.218.38.533.598.598.367.11.16.293 4.048-3.576a709.79 709.79 0 013.662-3.631.865.865 0 00.195-.33c.075-.222.075-.23.001-.449a.872.872 0 00-.177-.31 720.538 720.538 0 01-3.643-3.615c-2.478-2.47-3.586-3.547-3.69-3.59-.198-.083-.298-.078-.502.023' }) })),
    arrowRotateLeft: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M5.25 11C4.8125 11 4.5 10.6875 4.5 10.25V5.75C4.5 5.34375 4.8125 5 5.25 5C5.65625 5 6 5.34375 6 5.75V8.28125L6.625 7.53125C7.90625 6 9.8125 5 12 5C15.8438 5 19 8.15625 19 12C19 15.875 15.8438 19 12 19C10.4062 19 8.96875 18.5 7.78125 17.625C7.46875 17.375 7.375 16.9062 7.625 16.5625C7.875 16.2188 8.34375 16.1562 8.6875 16.4062C9.59375 17.0938 10.75 17.5 12 17.5C15.0312 17.5 17.5 15.0625 17.5 12C17.5 8.96875 15.0312 6.5 12 6.5C10.2812 6.5 8.78125 7.28125 7.75 8.5L6.90625 9.5H9.75C10.1562 9.5 10.5 9.84375 10.5 10.25C10.5 10.6875 10.1562 11 9.75 11H5.25Z' }) })),
    arrowProgress: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M18.75 6C18.75 5.59375 18.4062 5.25 18 5.25C17.5625 5.25 17.25 5.59375 17.25 6C17.25 6.4375 17.5625 6.75 18 6.75C18.4062 6.75 18.75 6.4375 18.75 6ZM16 6C16 5.3125 16.375 4.65625 17 4.28125C17.5938 3.9375 18.375 3.9375 19 4.28125C19.5938 4.65625 20 5.3125 20 6C20 6.71875 19.5938 7.375 19 7.75C18.375 8.09375 17.5938 8.09375 17 7.75C16.375 7.375 16 6.71875 16 6ZM4 9C4 6.9375 5.65625 5.25 7.75 5.25H12V4.5625C12 4.25 12.25 4 12.5312 4C12.6562 4 12.7812 4.0625 12.875 4.125L14.7812 5.625C14.9062 5.71875 15 5.84375 15 6C15 6.15625 14.9062 6.3125 14.7812 6.40625L12.875 7.90625C12.7812 7.96875 12.6562 8 12.5312 8C12.25 8 12 7.75 12 7.46875V6.75H7.75C6.5 6.75 5.5 7.78125 5.5 9C5.5 10.25 6.5 11.25 7.75 11.25H16.25C18.3125 11.25 20 12.9375 20 15C20 16.875 18.625 18.4062 16.875 18.7188C16.5625 19.4688 15.8438 20 15 20C13.875 20 13 19.125 13 18C13 16.9062 13.875 16 15 16C15.7812 16 16.5 16.5 16.8125 17.1875C17.7812 16.9375 18.5 16.0625 18.5 15C18.5 13.7812 17.4688 12.75 16.25 12.75H7.75C5.65625 12.75 4 11.0938 4 9ZM7.84375 17.25H9V16.5625C9 16.25 9.25 16 9.53125 16C9.65625 16 9.78125 16.0625 9.875 16.125L11.7812 17.625C11.9062 17.7188 12 17.8438 12 18C12 18.1562 11.9062 18.3125 11.7812 18.4062L9.875 19.9062C9.78125 19.9688 9.65625 20 9.53125 20C9.25 20 9 19.75 9 19.4688V18.75H7.84375C7.53125 19.5 6.8125 20 6 20C4.875 20 4 19.125 4 18C4 16.9062 4.875 16 6 16C6.8125 16 7.53125 16.5312 7.84375 17.25ZM6.75 18C6.75 17.5938 6.40625 17.25 6 17.25C5.5625 17.25 5.25 17.5938 5.25 18C5.25 18.4375 5.5625 18.75 6 18.75C6.40625 18.75 6.75 18.4375 6.75 18ZM15 18.75C15.4062 18.75 15.75 18.4375 15.75 18C15.75 17.5938 15.4062 17.25 15 17.25C14.5625 17.25 14.25 17.5938 14.25 18C14.25 18.4375 14.5625 18.75 15 18.75Z' }) })),
    arrowUpRight: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M14.62 4.239l-4.28.021-.169.097c-.221.126-.308.308-.31.643-.001.332.101.542.322.657.155.082.21.083 3.576.094l3.419.011-6.446 6.449c-7.071 7.075-6.608 6.579-6.495 6.954.065.218.38.533.598.598.375.113-.121.576 6.955-6.496l6.45-6.446v3.332c0 2.349.013 3.385.045 3.512.063.248.225.398.495.459.455.101.841-.087.934-.455.03-.122.045-1.493.047-4.518l.004-4.342-.086-.183c-.073-.154-.126-.203-.329-.305-.134-.066-.289-.117-.346-.112-.057.005-2.03.019-4.384.03' }) })),
    arrowsMaximize: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M3.634 3.331c-.188.093-.241.143-.315.299-.087.187-.088.198-.081 2.329.004 1.382.021 2.202.049 2.313.092.365.48.553.933.452.27-.061.432-.211.495-.459.028-.113.045-.602.045-1.312V5.822l1.95 1.945c2.145 2.14 2.099 2.103 2.455 1.996.218-.065.533-.38.598-.598.107-.356.144-.311-1.993-2.453L5.826 4.764l1.217-.012c1.139-.011 1.227-.017 1.374-.095.221-.115.323-.325.322-.657-.002-.335-.089-.517-.31-.643-.187-.108.074-.098-3.369-.127l-1.2-.01-.226.111m14.186-.092-2.08.021-.169.097c-.221.126-.308.308-.31.643-.001.332.101.542.322.657.147.078.235.084 1.374.095l1.217.012-1.944 1.948c-2.137 2.142-2.1 2.097-1.993 2.453.065.218.38.533.598.598.356.107.31.144 2.455-1.996l1.95-1.945v1.131c0 .71.017 1.199.045 1.312.063.248.225.398.495.459.453.101.841-.087.933-.452.028-.111.045-.931.049-2.313.007-2.131.006-2.142-.081-2.329-.075-.158-.127-.207-.331-.309-.134-.066-.289-.117-.346-.112-.057.004-1.04.018-2.184.03M8.76 14.263c-.088.038-.855.775-2.068 1.986l-1.928 1.925-.012-1.217c-.014-1.384-.023-1.43-.319-1.596-.232-.13-.634-.13-.866 0-.314.177-.304.099-.327 2.559-.022 2.379-.019 2.413.204 2.636.223.223.257.226 2.636.204 2.105-.019 2.185-.023 2.337-.103.221-.115.323-.325.322-.657-.002-.335-.089-.517-.31-.643-.167-.096-.184-.097-1.385-.11l-1.216-.013 1.942-1.947c2.124-2.129 2.099-2.098 1.997-2.439-.091-.305-.503-.651-.77-.646a.766.766 0 0 0-.237.061m5.969.022c-.209.103-.435.36-.496.563-.102.341-.127.31 1.997 2.439l1.942 1.947-1.216.013c-1.201.013-1.218.014-1.385.11-.221.126-.308.308-.31.643-.001.332.101.542.322.657.152.08.232.084 2.337.103 2.379.022 2.413.019 2.636-.204.223-.223.226-.257.204-2.636-.023-2.46-.013-2.382-.327-2.559-.232-.13-.634-.13-.866 0-.296.166-.305.212-.319 1.596l-.012 1.217-1.928-1.925c-1.913-1.911-2.07-2.049-2.317-2.049a.8.8 0 0 0-.262.085' }) })),
    at: (domProps) => (jsx("svg", { ...baseSvgProps, viewBox: '0 0 16 16', ...domProps, children: jsx("path", { d: 'M8 1.5C4.40625 1.5 1.5 4.4375 1.5 8C1.5 11.5938 4.40625 14.5 8 14.5C8.40625 14.5 8.75 14.8438 8.75 15.25C8.75 15.6875 8.40625 16 8 16C3.5625 16 0 12.4375 0 8C0 3.59375 3.5625 0 8 0C12.4062 0 16 3.59375 16 8V8.875C16 10.4688 14.6875 11.75 13.125 11.75C12.125 11.75 11.2812 11.2812 10.75 10.5312C10.0625 11.2812 9.09375 11.75 8 11.75C5.90625 11.75 4.25 10.0938 4.25 8C4.25 5.9375 5.90625 4.25 8 4.25C8.875 4.25 9.71875 4.59375 10.3438 5.09375C10.5 4.90625 10.7188 4.75 11 4.75C11.4062 4.75 11.75 5.09375 11.75 5.5V8V8.875C11.75 9.65625 12.3438 10.25 13.125 10.25C13.875 10.25 14.5 9.65625 14.5 8.875V8C14.5 4.4375 11.5625 1.5 8 1.5ZM10.25 8C10.25 7.21875 9.8125 6.46875 9.125 6.0625C8.40625 5.65625 7.5625 5.65625 6.875 6.0625C6.15625 6.46875 5.75 7.21875 5.75 8C5.75 8.8125 6.15625 9.5625 6.875 9.96875C7.5625 10.375 8.40625 10.375 9.125 9.96875C9.8125 9.5625 10.25 8.8125 10.25 8Z', fill: '#616A7D' }) })),
    ban: (domProps) => (jsx("svg", { color: 'white', stroke: 'var(--color-danger)', ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M18.364 18.364C21.8787 14.8492 21.8787 9.15076 18.364 5.63604C14.8492 2.12132 9.15076 2.12132 5.63604 5.63604M18.364 18.364C14.8492 21.8787 9.15076 21.8787 5.63604 18.364C2.12132 14.8492 2.12132 9.15076 5.63604 5.63604M18.364 18.364L5.63604 5.63604', strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }) })),
    boxLogo: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, viewBox: '0 0 64 64', height: '24', width: '24', children: jsx("path", { d: 'M32.898 43.9c-3.92.02-7.118-3.133-7.138-7.052-.03-3.92 3.127-7.113 7.05-7.137 3.92-.03 7.116 3.127 7.143 7.046s-3.13 7.12-7.053 7.143m-20.9.133c-3.922.027-7.12-3.13-7.142-7.046-.027-3.922 3.13-7.12 7.053-7.143a7.1 7.1 0 0 1 7.141 7.046 7.1 7.1 0 0 1-7.052 7.143m20.78-19.06c-4.533.032-8.447 2.605-10.41 6.353-2.013-3.727-5.96-6.25-10.488-6.218-2.56.01-5.047.856-7.084 2.408l-.064-9.962a2.37 2.37 0 0 0-2.384-2.304 2.36 2.36 0 0 0-2.346 2.333L.118 37.2h.006a11.83 11.83 0 0 0 11.9 11.56c4.528-.03 8.443-2.603 10.413-6.354 2.008 3.725 5.962 6.248 10.49 6.22 6.533-.04 11.795-5.373 11.755-11.907S39.3 24.92 32.774 24.962m30.73 19.747l-6.642-8.06 6.536-8.144c.8-1.045.563-2.502-.56-3.27-1.134-.765-2.718-.56-3.572.457v-.004l-5.648 7.03-5.733-6.95c-.87-1.008-2.46-1.196-3.575-.414-1.12.783-1.346 2.24-.52 3.282l6.636 8.055-6.537 8.14c-.81 1.05-.564 2.503.568 3.27 1.123.77 2.712.563 3.566-.455l5.643-7.026 5.74 6.954c.867 1.01 2.456 1.193 3.58.412 1.117-.79 1.34-2.24.52-3.28', fill: '#22a7f0' }) })),
    boxOpen: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M2.53125 7.9375L3.8125 5.34375C3.90625 5.15625 4.125 5.03125 4.34375 5.0625L12 6L9.375 10.3438C9.15625 10.75 8.6875 10.9375 8.25 10.8125L3.15625 9.34375C2.53125 9.1875 2.25 8.5 2.53125 7.9375ZM12 6L19.625 5.0625C19.8438 5.03125 20.0625 5.125 20.1562 5.34375L21.4375 7.9375C21.7188 8.5 21.4375 9.1875 20.8125 9.34375L15.7188 10.8125C15.2812 10.9375 14.8125 10.75 14.5938 10.3438L12 6ZM11.9375 8H12.0312H11.9375ZM18.5 11.0625L20 10.625V15.8438C20 16.5312 19.5312 17.125 18.8438 17.3125L12.4688 18.9062C12.1562 18.9688 11.8125 18.9688 11.5 18.9062L5.125 17.3125C4.46875 17.125 4 16.5312 4 15.8438V10.625L5.5 11.0625V15.8438L11.25 17.2812V9.75C11.25 9.34375 11.5625 9 12 9C12.4062 9 12.75 9.34375 12.75 9.75V17.2812L18.5 15.8438V11.0625Z' }) })),
    building: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M6.617 2.283c-.583.068-1.098.327-1.552.781a2.742 2.742 0 00-.696 1.116l-.109.32-.011 7.866-.01 7.865-.75.015c-.702.014-.76.021-.918.111-.221.126-.308.307-.31.643-.001.332.101.542.322.657l.157.083h18.52l.157-.083c.221-.115.323-.325.322-.657-.002-.336-.089-.517-.31-.643-.158-.09-.216-.097-.918-.111l-.75-.015-.01-7.865L19.74 4.5l-.109-.32a2.742 2.742 0 00-.696-1.116c-.472-.471-.961-.709-1.606-.783-.424-.049-10.294-.046-10.712.002m10.911 1.59c.239.118.481.36.599.599l.093.188.01 7.79.011 7.79H14.76l-.001-2.17c0-2.317-.014-2.507-.202-2.875-.122-.24-.533-.634-.797-.765-.31-.153-.641-.188-1.76-.188s-1.45.035-1.76.188c-.264.131-.675.525-.797.765-.188.368-.202.558-.202 2.875l-.001 2.17H5.76v-7.735c0-8.483-.017-7.888.236-8.233.14-.19.38-.373.59-.45.13-.048.973-.056 5.454-.049l5.3.007.188.093M8.799 6.275c-.371.078-.536.3-.538.725-.001.332.101.542.322.657.143.075.227.083.917.083.69 0 .774-.008.917-.083.221-.115.323-.325.322-.657-.002-.336-.089-.517-.31-.642-.157-.089-.216-.096-.829-.104-.363-.005-.723.004-.801.021m5 0c-.371.078-.536.3-.538.725-.001.332.101.542.322.657.143.075.227.083.917.083.69 0 .774-.008.917-.083.221-.115.323-.325.322-.657-.002-.336-.089-.517-.31-.642-.157-.089-.216-.096-.829-.104-.363-.005-.723.004-.801.021m-5 4c-.371.078-.536.3-.538.725-.001.332.101.542.322.657.143.075.227.083.917.083.69 0 .774-.008.917-.083.221-.115.323-.325.322-.657-.002-.336-.089-.517-.31-.642-.157-.089-.216-.096-.829-.104-.363-.005-.723.004-.801.021m5 0c-.371.078-.536.3-.538.725-.001.332.101.542.322.657.143.075.227.083.917.083.69 0 .774-.008.917-.083.221-.115.323-.325.322-.657-.002-.336-.089-.517-.31-.642-.157-.089-.216-.096-.829-.104-.363-.005-.723.004-.801.021m-.632 5.551c.069.063.073.185.073 2.24v2.174h-2.48v-2.167c0-1.96.006-2.174.066-2.24.061-.067.152-.073 1.167-.073.968 0 1.11.008 1.174.066' }) })),
    chat: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M4.617 3.283c-.583.068-1.098.327-1.552.781a2.742 2.742 0 00-.696 1.116l-.109.32v9l.109.32c.151.445.362.783.695 1.116.334.334.673.545 1.116.694l.32.108 1.87.013 1.87.014v2.147c0 1.437.015 2.201.044 2.308.056.203.337.479.555.544.357.107.26.189 2.981-2.526l2.48-2.475 2.6-.012 2.6-.012.32-.108a2.743 2.743 0 001.116-.695c.333-.333.544-.671.695-1.116l.109-.32v-9l-.109-.32a2.742 2.742 0 00-.696-1.116c-.472-.471-.961-.709-1.606-.783-.426-.049-14.293-.047-14.712.002m14.911 1.59c.239.118.481.36.599.599l.093.188v8.68l-.093.188a1.452 1.452 0 01-.607.608c-.176.082-.243.084-2.96.104-2.509.018-2.792.027-2.9.087-.066.037-.966.915-2 1.951L9.78 19.16l-.02-1.71c-.023-1.936-.019-1.915-.331-2.093l-.169-.097-2.3-.02c-2.229-.019-2.306-.023-2.48-.104a1.452 1.452 0 01-.607-.608l-.093-.188-.011-4.26c-.009-3.158 0-4.304.035-4.43.093-.34.433-.7.782-.828.131-.048 1.254-.056 7.454-.049l7.3.007.188.093M7.799 9.276c-.37.075-.536.299-.538.724-.002.508.236.74.759.74.224 0 .31-.019.431-.094.219-.136.287-.289.287-.646 0-.349-.068-.511-.267-.632-.15-.091-.465-.135-.672-.092m4 0c-.37.075-.536.299-.538.724-.002.508.236.74.759.74.325 0 .535-.102.65-.314.094-.173.094-.679 0-.852-.129-.24-.514-.371-.871-.298m4 0c-.37.075-.536.299-.538.724-.002.508.236.74.759.74.325 0 .535-.102.65-.314.094-.173.094-.679 0-.852-.129-.24-.514-.371-.871-.298' }) })),
    checkmark: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M18.76 6.261c-.089.039-1.9 1.822-4.95 4.87l-4.809 4.808-1.831-1.826c-2.013-2.009-1.981-1.982-2.335-1.876-.218.065-.533.38-.598.598-.108.36-.168.288 2.236 2.692 1.899 1.898 2.209 2.193 2.357 2.236.38.111.004.457 5.661-5.196 3.697-3.694 5.175-5.196 5.235-5.32.104-.214.081-.401-.076-.625-.239-.34-.604-.488-.89-.361' }) })),
    checkmarkCircle: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.32 2.28A9.74 9.74 0 003.258 7.7c-.46.94-.762 1.914-.924 2.98-.097.636-.097 2.004 0 2.64.446 2.941 2.052 5.409 4.533 6.968 1.075.676 2.441 1.17 3.813 1.378.636.097 2.004.097 2.64 0 2.1-.319 3.932-1.206 5.405-2.618 1.601-1.534 2.6-3.479 2.941-5.728.097-.636.097-2.004 0-2.64-.443-2.919-2.04-5.389-4.49-6.941-.824-.522-2.118-1.053-3.056-1.253a10.872 10.872 0 00-2.8-.206m2 1.578a8.277 8.277 0 014.628 2.435c1.176 1.231 1.913 2.713 2.2 4.423.1.593.1 1.975 0 2.568-.612 3.649-3.463 6.426-7.08 6.895-3.771.489-7.369-1.653-8.767-5.219a9.164 9.164 0 01-.449-1.676c-.1-.593-.1-1.975 0-2.568.299-1.783 1.066-3.282 2.324-4.54 1.389-1.388 2.977-2.138 5.064-2.391.313-.038 1.715.011 2.08.073m1.44 5.403c-.085.038-.851.773-1.949 1.869l-1.81 1.807-.83-.824c-.924-.917-1.011-.974-1.336-.876-.218.065-.533.38-.598.598-.103.342-.075.38 1.236 1.692 1.007 1.006 1.213 1.194 1.357 1.236.365.107.293.166 2.661-2.197 1.505-1.501 2.176-2.198 2.235-2.319.104-.214.081-.402-.076-.625-.239-.34-.604-.488-.89-.361' }) })),
    checkmarkShield: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.764 2.222c-.074.032-.281.181-.46.33-.801.67-1.454 1.099-2.324 1.528-1.63.803-3.182 1.16-5.043 1.16-1.087 0-1.143.035-1.34.833-.439 1.779-.458 3.769-.055 5.64.257 1.195.786 2.583 1.368 3.587 1.673 2.891 4.423 5.062 7.525 5.941.543.154.657.149 1.325-.058a12.597 12.597 0 005.112-3.039 12.69 12.69 0 003.584-6.424c.405-1.841.386-3.866-.053-5.647-.197-.798-.253-.833-1.34-.833-1.861 0-3.413-.357-5.043-1.16a10.864 10.864 0 01-2.325-1.527c-.461-.387-.648-.454-.931-.331m.527 1.932c.322.251 1.002.701 1.409.933 1.732.988 3.711 1.555 5.786 1.657l.546.027.062.405c.217 1.399.184 2.872-.094 4.164a11.278 11.278 0 01-2.225 4.7c-.378.478-1.4 1.483-1.875 1.844a11.464 11.464 0 01-3.55 1.857l-.35.108-.35-.108c-1.245-.387-2.434-1.008-3.55-1.856-.472-.358-1.493-1.363-1.874-1.845-2.008-2.535-2.829-5.67-2.32-8.864l.064-.405.545-.027c2.402-.118 4.653-.855 6.573-2.152.257-.174.554-.386.66-.472.105-.087.215-.158.243-.159.028 0 .163.086.3.193m2.469 5.107c-.085.038-.851.773-1.949 1.869l-1.81 1.807-.83-.824c-.924-.917-1.011-.974-1.336-.876-.218.065-.533.38-.598.598-.103.342-.075.38 1.236 1.692 1.007 1.006 1.213 1.194 1.357 1.236.365.107.293.166 2.661-2.197 1.505-1.501 2.176-2.198 2.235-2.319.104-.214.081-.402-.076-.625-.239-.34-.604-.488-.89-.361' }) })),
    chevronDown: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M4.729 8.285c-.209.103-.435.36-.496.563-.106.354-.289.15 3.74 4.179 3.236 3.236 3.708 3.693 3.857 3.736.376.11.145.316 4.197-3.736 4.047-4.047 3.847-3.823 3.736-4.192-.065-.218-.38-.533-.598-.598-.367-.11-.179-.275-3.835 3.376L12 14.939l-3.31-3.308C6.368 9.31 5.336 8.305 5.231 8.262c-.198-.083-.298-.078-.502.023' }) })),
    chevronDoubleDown: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M4.729 4.285c-.209.103-.435.36-.496.563-.106.354-.289.15 3.74 4.179 3.236 3.236 3.708 3.693 3.857 3.736.376.11.145.316 4.197-3.736 4.047-4.047 3.847-3.823 3.736-4.192-.065-.218-.38-.533-.598-.598-.367-.11-.179-.275-3.835 3.376L12 10.939 8.69 7.631C6.368 5.31 5.336 4.305 5.231 4.262c-.198-.083-.298-.078-.502.023m0 8c-.209.103-.435.36-.496.563-.106.354-.289.15 3.74 4.179 3.236 3.236 3.708 3.693 3.857 3.736.376.11.145.316 4.197-3.736 4.047-4.047 3.847-3.823 3.736-4.192-.065-.218-.38-.533-.598-.598-.367-.11-.179-.275-3.835 3.376L12 18.939l-3.31-3.308c-2.322-2.321-3.354-3.326-3.459-3.369-.198-.083-.298-.078-.502.023' }) })),
    chevronRight: (domProps) => (jsx("svg", { ...domProps, children: jsx("path", { d: 'M4.5 2.5L8 6L4.5 9.5', strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }) })),
    clipboardCheck: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M10.656 2.28a2.434 2.434 0 00-.867.263 2.734 2.734 0 00-1.351 1.463l-.085.224-.887.022c-.99.024-1.216.063-1.67.287A2.799 2.799 0 004.333 6.32c-.069.246-.073.598-.073 6.68s.004 6.434.073 6.68a2.823 2.823 0 001.987 1.987c.245.069.564.073 5.68.073 5.132 0 5.434-.004 5.68-.073a2.83 2.83 0 001.987-1.987c.069-.247.073-.579.073-6.68s-.004-6.433-.073-6.68a2.792 2.792 0 00-1.465-1.782c-.452-.223-.679-.262-1.669-.286l-.886-.022-.068-.185a2.803 2.803 0 00-1.377-1.507c-.5-.247-.642-.266-2.042-.28-.693-.006-1.37.003-1.504.022m2.881 1.597c.251.123.463.335.586.586.14.284.139.791-.001 1.076a1.306 1.306 0 01-.665.619c-.205.076-.306.082-1.457.082s-1.252-.006-1.457-.082a1.301 1.301 0 01-.664-.619c-.115-.236-.152-.655-.079-.885.079-.248.277-.528.466-.658.334-.23.358-.233 1.774-.224 1.287.008 1.302.009 1.497.105M8.419 5.95c.257.697.877 1.333 1.565 1.604.447.176.744.206 2.016.206 1.293 0 1.583-.031 2.047-.22.66-.268 1.27-.891 1.516-1.547l.088-.237.845.012c.799.011.854.017 1.041.109.251.123.463.335.586.586l.097.197v12.68l-.098.199a1.306 1.306 0 01-.665.619c-.218.081-.266.082-5.457.082s-5.239-.001-5.457-.082c-.267-.1-.53-.345-.665-.619l-.098-.199-.012-6.26c-.008-4.578.001-6.303.034-6.42a1.31 1.31 0 01.789-.839c.107-.04.377-.056.954-.058l.804-.003.07.19m6.301 5.353c-.088.038-.804.723-1.93 1.848L11 14.939l-.77-.768c-.49-.489-.824-.79-.919-.83a.755.755 0 00-.896.243.768.768 0 00-.062.759c.045.088.564.637 1.174 1.243.908.903 1.12 1.094 1.253 1.13.199.054.241.054.44 0 .137-.036.469-.35 2.273-2.149 1.162-1.159 2.147-2.174 2.19-2.255.14-.27.07-.685-.149-.877a.781.781 0 00-.814-.132' }) })),
    code: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M13.604 3.326a1.043 1.043 0 00-.209.194c-.085.117-4.155 16.361-4.155 16.582 0 .374.372.657.864.658.217 0 .411-.133.527-.361.11-.218 4.129-16.289 4.129-16.513 0-.331-.329-.6-.773-.635-.212-.016-.266-.006-.383.075M5.74 7.279c-.103.051-.934.855-2.307 2.23-2.362 2.368-2.303 2.296-2.196 2.661.043.148.338.458 2.236 2.357 2.404 2.404 2.332 2.344 2.692 2.236.218-.065.533-.38.598-.598.106-.354.133-.322-1.876-2.335L3.062 12l1.825-1.83c1.996-2.001 1.982-1.983 1.88-2.322-.091-.304-.499-.648-.77-.648a.775.775 0 00-.257.079m11.989.006c-.209.103-.435.36-.496.563-.102.339-.116.321 1.88 2.322L20.938 12l-1.825 1.83c-2.009 2.013-1.982 1.981-1.876 2.335.065.218.38.533.598.598.36.108.288.168 2.692-2.236 1.898-1.899 2.193-2.209 2.236-2.357.107-.365.166-.293-2.197-2.661-1.422-1.426-2.201-2.178-2.309-2.23-.207-.101-.316-.099-.528.006' }) })),
    columns: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M4.617 4.281c-.589.073-1.099.331-1.552.783a2.742 2.742 0 00-.696 1.116l-.109.32v11l.109.32c.151.445.362.783.695 1.116.333.333.672.544 1.116.695l.32.109h3l.32-.109a2.95 2.95 0 00.978-.553L9 18.907l.202.171c.296.25.616.431.978.553l.32.109h3l.32-.109a2.95 2.95 0 00.978-.553l.202-.171.202.171c.296.25.616.431.978.553l.32.109h3l.32-.109a2.743 2.743 0 001.116-.695c.333-.333.544-.671.695-1.116l.109-.32v-11l-.109-.32a2.742 2.742 0 00-.696-1.116c-.487-.486-.967-.713-1.667-.789-.608-.066-2.656-.024-2.968.061a3.06 3.06 0 00-1.05.547l-.25.206-.25-.206a3.058 3.058 0 00-1.07-.553c-.225-.061-.45-.07-1.68-.07s-1.455.009-1.68.07c-.367.1-.778.312-1.07.553L9 5.089l-.25-.206a3.355 3.355 0 00-.53-.344c-.515-.253-.623-.268-2.04-.281-.704-.007-1.408.004-1.563.023m2.911 1.592c.239.118.481.36.599.599l.093.188v10.68l-.093.189c-.132.268-.416.534-.674.63-.2.075-.311.081-1.453.081-1.142 0-1.253-.006-1.453-.081-.258-.096-.542-.362-.674-.63l-.093-.189-.011-5.26c-.009-3.917 0-5.304.035-5.43.06-.221.261-.501.466-.652.313-.23.35-.235 1.77-.226 1.27.008 1.304.01 1.488.101m6 0c.239.118.481.36.599.599l.093.188v10.68l-.093.189c-.132.268-.416.534-.674.63-.2.075-.311.081-1.453.081-1.142 0-1.253-.006-1.453-.081-.258-.096-.542-.362-.674-.63l-.093-.189-.011-5.26c-.009-3.917 0-5.304.035-5.43.06-.221.261-.501.466-.652.313-.23.35-.235 1.77-.226 1.27.008 1.304.01 1.488.101m6 0c.239.118.481.36.599.599l.093.188v10.68l-.093.189c-.132.268-.416.534-.674.63-.2.075-.311.081-1.453.081-1.142 0-1.253-.006-1.453-.081-.258-.096-.542-.362-.674-.63l-.093-.189-.011-5.26c-.009-3.917 0-5.304.035-5.43.06-.221.261-.501.466-.652.313-.23.35-.235 1.77-.226 1.27.008 1.304.01 1.488.101' }) })),
    connection: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M6.09375 6.1875C6.4375 6.4375 6.46875 6.90625 6.21875 7.25C5.125 8.53125 4.5 10.1875 4.5 12C4.5 13.8438 5.125 15.5 6.21875 16.7812C6.46875 17.0938 6.4375 17.5938 6.09375 17.8438C5.78125 18.125 5.3125 18.0625 5.0625 17.75C3.75 16.1875 3 14.1875 3 12C3 9.84375 3.75 7.84375 5.0625 6.28125C5.3125 5.96875 5.78125 5.90625 6.09375 6.1875ZM17.875 6.1875C18.1875 5.90625 18.6562 5.96875 18.9375 6.28125C20.2188 7.84375 21 9.84375 21 12C21 14.1875 20.2188 16.1875 18.9375 17.75C18.6562 18.0625 18.1875 18.0938 17.875 17.8438C17.5625 17.5938 17.5 17.0938 17.7812 16.7812C18.8438 15.5 19.5 13.8438 19.5 12C19.5 10.1875 18.8438 8.53125 17.7812 7.25C17.5 6.90625 17.5625 6.4375 17.875 6.1875ZM10.75 12C10.75 11.5625 10.9688 11.1562 11.375 10.9375C11.75 10.7188 12.2188 10.7188 12.625 10.9375C13 11.1562 13.25 11.5625 13.25 12C13.25 12.4688 13 12.875 12.625 13.0938C12.2188 13.3125 11.75 13.3125 11.375 13.0938C10.9688 12.875 10.75 12.4688 10.75 12ZM8.8125 9.5625C8.3125 10.25 8 11.0938 8 12C8 12.9375 8.3125 13.7812 8.8125 14.4688C9.09375 14.7812 9.03125 15.25 8.6875 15.5312C8.375 15.7812 7.90625 15.7188 7.65625 15.375C6.90625 14.4688 6.5 13.2812 6.5 12C6.5 10.75 6.90625 9.5625 7.65625 8.625C7.90625 8.3125 8.375 8.25 8.6875 8.5C9.03125 8.75 9.09375 9.21875 8.8125 9.5625ZM16.3438 8.625C17.0625 9.5625 17.5 10.75 17.5 12C17.5 13.2812 17.0625 14.4688 16.3438 15.375C16.0625 15.7188 15.5938 15.7812 15.2812 15.5312C14.9375 15.2812 14.9062 14.7812 15.1562 14.4688C15.6875 13.7812 16 12.9375 16 12C16 11.0938 15.6875 10.25 15.1562 9.5625C14.9062 9.21875 14.9375 8.75 15.2812 8.5C15.5938 8.25 16.0625 8.3125 16.3438 8.625Z' }) })),
    connectionSlash: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M3.1875 4.1875L14.7812 13.25C14.9062 12.875 15 12.4375 15 12C15 11.0938 14.6875 10.25 14.1562 9.5625C13.9062 9.21875 13.9375 8.75 14.2812 8.5C14.5938 8.25 15.0625 8.3125 15.3438 8.625C16.0625 9.5625 16.5 10.75 16.5 12C16.5 12.8125 16.3125 13.5625 16.0312 14.2188L17.625 15.5C18.1875 14.4375 18.5 13.2812 18.5 12C18.5 10.1875 17.8438 8.53125 16.7812 7.25C16.5 6.90625 16.5625 6.4375 16.875 6.1875C17.1875 5.90625 17.6562 5.96875 17.9375 6.28125C19.2188 7.84375 20 9.84375 20 12C20 13.625 19.5625 15.125 18.8438 16.4375L21.6875 18.6875C22.0312 18.9375 22.0938 19.4062 21.8125 19.7188C21.5625 20.0625 21.0938 20.125 20.7812 19.8438L2.28125 5.34375C1.9375 5.09375 1.875 4.625 2.15625 4.3125C2.40625 3.96875 2.875 3.90625 3.1875 4.1875ZM5.84375 10.0625L7.09375 11.0312C7.03125 11.3438 7 11.6875 7 12C7 12.9375 7.3125 13.7812 7.8125 14.4688C8.09375 14.7812 8.03125 15.2812 7.6875 15.5312C7.375 15.7812 6.90625 15.7188 6.65625 15.375C5.90625 14.4688 5.5 13.2812 5.5 12C5.5 11.3125 5.625 10.6562 5.84375 10.0625ZM3.03125 7.8125L4.21875 8.78125C3.75 9.75 3.5 10.8438 3.5 12C3.5 13.8438 4.125 15.5 5.21875 16.7812C5.46875 17.0938 5.4375 17.5938 5.09375 17.8438C4.78125 18.0938 4.3125 18.0625 4.0625 17.75C2.75 16.1875 2 14.1875 2 12C2 10.5 2.34375 9.0625 3.03125 7.8125Z' }) })),
    cross: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M5.695 5.316c-.332.194-.551.564-.476.802.058.181.521.668 3.076 3.232L10.936 12l-2.641 2.65c-1.452 1.458-2.734 2.763-2.847 2.902-.299.363-.315.512-.088.82.213.291.526.465.738.412.188-.047.616-.452 3.252-3.079L12 13.064l2.65 2.641c2.636 2.627 3.064 3.032 3.252 3.079.212.053.525-.121.738-.412.227-.308.211-.457-.088-.82-.113-.139-1.395-1.445-2.848-2.903l-2.642-2.651 2.502-2.509c3.167-3.177 3.235-3.251 3.236-3.483 0-.314-.497-.806-.814-.806-.053 0-.212.084-.352.186-.14.103-1.464 1.393-2.944 2.867l-2.689 2.681L9.33 8.277C7.862 6.815 6.557 5.532 6.431 5.426c-.299-.253-.451-.276-.736-.11' }) })),
    cubeTransparent: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.78 2.295c-.309.1-2.254 1.105-2.376 1.227a.578.578 0 00-.147.616c.078.258.236.486.393.567.27.14.413.099 1.419-.401L12 3.842l.931.462c1.006.5 1.149.541 1.419.401.157-.081.315-.309.393-.567a.58.58 0 00-.149-.618c-.15-.15-2.31-1.231-2.514-1.258a.794.794 0 00-.3.033M4.843 5.74c-.554.275-1.03.5-1.057.5-.106 0-.383.221-.468.373-.089.158-.09.175-.082 1.583.004.783.025 1.491.047 1.572a.642.642 0 00.382.434c.216.071.669.033.804-.067.245-.183.27-.281.284-1.125.007-.424.02-.77.027-.77.008 0 .256.119.551.264.586.287.779.325 1.019.201.264-.136.485-.628.409-.909-.058-.215-.222-.361-.658-.583-.21-.106-.381-.203-.381-.215 0-.012.164-.102.364-.2.2-.098.424-.237.498-.308.246-.239.256-.534.032-.923-.133-.228-.301-.327-.558-.327-.182 0-.319.056-1.213.5m12.77-.422c-.144.087-.306.344-.369.583-.096.364.09.612.672.897.2.098.364.188.364.2 0 .012-.171.109-.381.215-.436.222-.6.368-.658.583-.076.281.145.773.409.909.24.124.433.086 1.019-.201.295-.145.543-.264.551-.264.007 0 .02.347.027.77.014.844.039.942.284 1.125.135.1.588.138.804.067a.642.642 0 00.382-.434c.022-.081.043-.789.047-1.572.008-1.408.007-1.425-.082-1.583-.085-.152-.362-.373-.468-.373-.027 0-.503-.225-1.057-.5-.894-.444-1.031-.5-1.213-.5a.65.65 0 00-.331.078m-8 4c-.248.151-.445.625-.37.893.067.245.263.385 1.151.827l.842.418.012 1.162c.011 1.078.018 1.172.092 1.298.148.251.262.304.66.304s.512-.053.66-.304c.074-.126.081-.22.092-1.298l.012-1.162.842-.418c.479-.238.899-.474.976-.549.246-.238.256-.532.031-.922-.132-.228-.299-.327-.557-.327-.18 0-.314.055-1.13.459l-.926.458-.926-.458c-.816-.404-.95-.459-1.13-.459a.65.65 0 00-.331.078m-5.968 4.497a.612.612 0 00-.363.415c-.055.2-.056 2.779 0 2.979.081.291.188.365 1.413.977 1.257.627 1.374.664 1.655.519.157-.081.315-.309.393-.567a.578.578 0 00-.147-.616c-.067-.067-.508-.315-.979-.552l-.857-.43v-1.08c0-1.138-.02-1.303-.179-1.492-.163-.193-.619-.268-.936-.153m16 0a.612.612 0 00-.363.415c-.024.087-.042.606-.042 1.23v1.08l-.857.43c-.471.237-.912.485-.979.552a.578.578 0 00-.147.616c.078.258.236.486.393.567.281.145.398.108 1.655-.519 1.225-.612 1.332-.686 1.413-.977.025-.089.042-.69.042-1.489 0-.799-.017-1.4-.042-1.489-.088-.318-.336-.474-.743-.468a1.247 1.247 0 00-.33.052m-8 4a.612.612 0 00-.363.415c-.023.083-.042.461-.042.84 0 .38-.007.69-.016.69-.009 0-.256-.117-.55-.26-.599-.292-.82-.33-1.061-.182-.247.151-.445.625-.371.892.068.247.247.374 1.174.837.486.243.989.506 1.116.585.197.121.268.142.468.142s.271-.021.468-.142c.127-.079.63-.342 1.116-.585.93-.464 1.107-.591 1.174-.84.072-.268-.124-.739-.371-.889-.241-.148-.462-.11-1.061.182-.294.143-.541.26-.55.26-.009 0-.016-.31-.016-.69 0-.743-.03-.924-.179-1.102-.163-.193-.619-.268-.936-.153' }) })),
    database: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.149 2.283C8.3 2.412 5.673 3.331 4.332 4.668a3.778 3.778 0 00-.978 1.574l-.094.298v10.92l.094.298c.433 1.381 1.673 2.444 3.714 3.184 2.96 1.074 6.904 1.074 9.864 0 1.794-.651 2.988-1.567 3.526-2.706.303-.641.282-.184.282-6.236 0-5.069-.005-5.437-.071-5.68-.543-1.987-3.007-3.45-6.629-3.938-.378-.051-2.038-.154-2.18-.135-.022.003-.342.019-.711.036m2.611 1.574c2.219.288 3.953.964 4.847 1.888.308.317.377.412.504.683.092.195.109.286.109.572 0 .464-.134.749-.564 1.199-.925.969-2.528 1.611-4.856 1.948-.72.104-2.88.104-3.6 0-2.536-.367-4.249-1.115-5.119-2.235a2.303 2.303 0 01-.192-.34C4.797 7.377 4.78 7.286 4.78 7s.017-.377.109-.572c.127-.271.196-.366.504-.683.919-.95 2.864-1.686 5.027-1.902.242-.024.503-.051.58-.06.347-.039 2.289.013 2.76.074M5.5 10.222c2.343 1.384 6.122 1.885 9.46 1.255 1.584-.299 3.166-.922 4.072-1.603l.212-.16-.012 1.313-.012 1.313-.126.267c-.255.537-.993 1.17-1.836 1.575-.988.474-1.982.752-3.458.965-.72.104-2.88.104-3.6 0-2.536-.367-4.249-1.115-5.119-2.235a2.303 2.303 0 01-.192-.34l-.109-.232-.012-1.313-.012-1.313.212.16c.117.087.356.244.532.348m0 5c2.343 1.384 6.122 1.885 9.46 1.255 1.584-.299 3.166-.922 4.072-1.603l.212-.16-.012 1.313-.012 1.313-.126.267c-.255.537-.993 1.17-1.836 1.575-.988.474-1.982.752-3.458.965-.72.104-2.88.104-3.6 0-2.536-.367-4.249-1.115-5.119-2.235a2.303 2.303 0 01-.192-.34l-.109-.232-.012-1.313-.012-1.313.212.16c.117.087.356.244.532.348' }) })),
    documentAdd: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M6.617 2.283c-.583.068-1.098.327-1.552.781a2.742 2.742 0 00-.696 1.116l-.109.32v15l.109.32c.151.445.362.783.695 1.116.333.333.671.544 1.116.695l.32.109h11l.32-.109a2.736 2.736 0 001.116-.695c.333-.333.544-.671.695-1.116l.109-.32v-5.18c0-5.604.01-5.346-.213-5.759-.065-.12-1.079-1.163-3.003-3.089-2.728-2.732-2.92-2.916-3.174-3.034a2.145 2.145 0 00-.54-.161c-.341-.043-5.811-.038-6.193.006m8.853 4.248l2.771 2.771-.011 5.019-.01 5.019-.093.189c-.132.268-.416.534-.674.63-.213.08-.3.081-5.453.081-5.153 0-5.24-.001-5.453-.081-.258-.096-.542-.362-.674-.63l-.093-.189-.011-7.26c-.009-5.436 0-7.303.035-7.43.093-.34.433-.7.782-.828.127-.046.677-.057 3.134-.059l2.979-.003 2.771 2.771m-3.671 2.745c-.212.043-.39.165-.468.322-.062.125-.072.293-.083 1.389l-.012 1.247-1.248.013c-1.235.013-1.25.014-1.417.11-.221.126-.308.308-.31.643-.001.332.101.542.322.657.147.078.235.084 1.405.095l1.248.012.012 1.248c.011 1.17.017 1.258.095 1.405.115.22.325.323.657.323s.542-.103.657-.323c.078-.147.084-.235.095-1.405l.012-1.248 1.248-.012c1.17-.011 1.258-.017 1.405-.095.221-.115.323-.325.322-.657-.002-.335-.089-.517-.31-.643-.167-.096-.182-.097-1.417-.11l-1.248-.013-.012-1.247c-.011-1.102-.02-1.264-.083-1.39-.123-.246-.516-.391-.87-.321' }) })),
    documentCopy: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M9.617 2.283c-.583.068-1.098.327-1.552.781a2.681 2.681 0 00-.692 1.116c-.098.296-.107.385-.124 1.19l-.018.87h-.605c-1.362.001-1.915.179-2.561.824a2.742 2.742 0 00-.696 1.116l-.109.32v11l.109.32c.151.445.362.783.695 1.116.333.333.671.544 1.116.695l.32.109h9l.32-.109a2.736 2.736 0 001.116-.695c.336-.336.547-.676.691-1.116.098-.296.107-.385.124-1.186l.018-.865.865-.018c.801-.017.89-.026 1.186-.124.44-.144.78-.355 1.116-.691.333-.333.544-.671.695-1.116l.109-.32v-3.68c0-3.974.006-3.853-.213-4.259-.064-.118-.927-1.011-2.503-2.589-2.245-2.249-2.422-2.416-2.674-2.534a2.145 2.145 0 00-.54-.161c-.34-.043-4.811-.038-5.193.006m7.353 3.748l2.271 2.271-.01 3.519-.011 3.519-.093.189c-.132.268-.416.534-.674.63-.212.079-.302.081-4.453.081-4.151 0-4.241-.002-4.453-.081-.258-.096-.542-.362-.674-.63l-.093-.189-.011-5.26c-.009-3.917 0-5.304.035-5.43.093-.34.433-.7.782-.828.126-.046.607-.057 2.634-.059l2.479-.003 2.271 2.271M7.249 11.63l.011 3.87.109.32c.151.445.362.783.695 1.116.333.333.672.544 1.116.695l.32.109 2.872.012 2.873.011-.013.789c-.011.731-.019.802-.105.977-.132.268-.416.534-.674.63-.212.079-.302.081-4.453.081-4.151 0-4.241-.002-4.453-.081-.258-.096-.542-.362-.674-.63l-.093-.189-.011-5.26c-.009-3.917 0-5.304.035-5.43.093-.34.433-.7.782-.828.111-.041.364-.057.903-.059l.748-.003.012 3.87' }) })),
    dotsVertical: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.701 3.285c-.334.048-.639.213-.932.502a1.65 1.65 0 00-.491 1.483c.069.401.204.66.498.954.294.294.553.429.954.498.326.056.699.004 1.023-.143.279-.127.699-.547.826-.826.295-.651.189-1.388-.275-1.902-.417-.46-.975-.658-1.603-.566m0 7c-.334.048-.639.213-.932.502a1.65 1.65 0 00-.491 1.483c.069.401.204.66.498.954.294.294.553.429.954.498.326.056.699.004 1.023-.143.279-.127.699-.547.826-.826.295-.651.189-1.388-.275-1.902-.417-.46-.975-.658-1.603-.566m0 7c-.334.048-.639.213-.932.502a1.65 1.65 0 00-.491 1.483c.069.401.204.66.498.954.294.294.553.429.954.498.326.056.699.004 1.023-.143.279-.127.699-.547.826-.826.295-.651.189-1.388-.275-1.902-.417-.46-.975-.658-1.603-.566' }) })),
    calendar: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M7.375 2.75C7.73047 2.75 8.03125 3.05078 8.03125 3.40625V4.5H11.9688V3.40625C11.9688 3.05078 12.2422 2.75 12.625 2.75C12.9805 2.75 13.2812 3.05078 13.2812 3.40625V4.5H14.375C15.332 4.5 16.125 5.29297 16.125 6.25V6.6875V8V15C16.125 15.9844 15.332 16.75 14.375 16.75H5.625C4.64062 16.75 3.875 15.9844 3.875 15V8V6.6875V6.25C3.875 5.29297 4.64062 4.5 5.625 4.5H6.71875V3.40625C6.71875 3.05078 6.99219 2.75 7.375 2.75ZM14.8125 8H5.1875V15C5.1875 15.2461 5.37891 15.4375 5.625 15.4375H14.375C14.5938 15.4375 14.8125 15.2461 14.8125 15V8ZM6.9375 9.75H13.0625C13.2812 9.75 13.5 9.96875 13.5 10.1875V11.9375C13.5 12.1836 13.2812 12.375 13.0625 12.375H6.9375C6.69141 12.375 6.5 12.1836 6.5 11.9375V10.1875C6.5 9.96875 6.69141 9.75 6.9375 9.75Z' }) })),
    calendarLight: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M4.33333 3.66667V1M9.66667 3.66667V1M3.66667 6.33333H10.3333M2.33333 13H11.6667C12.403 13 13 12.403 13 11.6667V3.66667C13 2.93029 12.403 2.33333 11.6667 2.33333H2.33333C1.59695 2.33333 1 2.93029 1 3.66667V11.6667C1 12.403 1.59695 13 2.33333 13Z', stroke: 'currentColor', strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }) })),
    diff: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, width: '16', height: '16', viewBox: '0 0 16 16', fill: 'none', children: jsx("path", { d: 'M4.625 13C4.625 13.2109 4.78906 13.375 5 13.375H11C11.1875 13.375 11.375 13.2109 11.375 13V6.25H9.5C9.07812 6.25 8.75 5.92188 8.75 5.5V3.625H5C4.78906 3.625 4.625 3.8125 4.625 4V13ZM5 2.5H8.86719C9.26562 2.5 9.64062 2.66406 9.92188 2.94531L12.0547 5.07812C12.3359 5.35938 12.5 5.73438 12.5 6.13281V13C12.5 13.8438 11.8203 14.5 11 14.5H5C4.15625 14.5 3.5 13.8438 3.5 13V4C3.5 3.17969 4.15625 2.5 5 2.5ZM8.5625 7.1875V8.125H9.5C9.80469 8.125 10.0625 8.38281 10.0625 8.6875C10.0625 9.01562 9.80469 9.25 9.5 9.25H8.5625V10.1875C8.5625 10.5156 8.30469 10.75 8 10.75C7.67188 10.75 7.4375 10.5156 7.4375 10.1875V9.25H6.5C6.17188 9.25 5.9375 9.01562 5.9375 8.6875C5.9375 8.38281 6.17188 8.125 6.5 8.125H7.4375V7.1875C7.4375 6.88281 7.67188 6.625 8 6.625C8.30469 6.625 8.5625 6.88281 8.5625 7.1875ZM6.5 11.5H9.5C9.80469 11.5 10.0625 11.7578 10.0625 12.0625C10.0625 12.3906 9.80469 12.625 9.5 12.625H6.5C6.17188 12.625 5.9375 12.3906 5.9375 12.0625C5.9375 11.7578 6.17188 11.5 6.5 11.5Z' }) })),
    download: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.799 3.276c-.212.043-.39.165-.468.322-.067.133-.072.465-.082 5.36l-.01 5.218-1.45-1.444c-1.597-1.592-1.607-1.599-1.954-1.495-.218.065-.533.38-.598.598-.107.356-.15.303 2.077 2.549a281.982 281.982 0 012.13 2.161c.061.069.199.15.33.195.223.075.229.075.452 0a.873.873 0 00.33-.195c.057-.065 1.016-1.037 2.13-2.161 2.227-2.246 2.184-2.193 2.077-2.549-.065-.218-.38-.533-.598-.598-.347-.104-.357-.097-1.954 1.495l-1.45 1.444-.01-5.218c-.01-4.917-.015-5.226-.082-5.361-.123-.246-.516-.391-.87-.321m-8 12c-.212.043-.39.165-.468.322-.061.123-.071.26-.071 1.002 0 .962.042 1.233.281 1.83a3.802 3.802 0 002.029 2.029c.746.299.333.281 6.43.281 6.097 0 5.684.018 6.43-.281a3.802 3.802 0 002.029-2.029c.239-.597.281-.868.281-1.83 0-.989-.022-1.079-.307-1.239-.232-.13-.634-.13-.866 0-.276.155-.301.251-.331 1.259-.015.502-.047.949-.075 1.04-.151.495-.64 1.084-1.101 1.327-.507.267-.177.253-6.06.253s-5.553.014-6.06-.253c-.461-.243-.95-.832-1.101-1.327-.028-.091-.06-.538-.075-1.04-.029-.996-.057-1.106-.315-1.249a1.077 1.077 0 00-.65-.095' }) })),
    edit: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M18.617 2.283c-.336.04-.728.175-1.047.361-.173.101-1.338 1.241-4.737 4.635-4.063 4.057-4.512 4.518-4.552 4.672-.03.115-.041.681-.033 1.74.011 1.496.016 1.576.095 1.726a.59.59 0 00.24.24c.15.079.23.084 1.726.095 1.062.008 1.625-.003 1.74-.033.154-.04.617-.491 4.673-4.552 4.879-4.885 4.683-4.671 4.906-5.347.091-.277.105-.387.105-.82 0-.432-.014-.543-.105-.82-.425-1.294-1.642-2.06-3.011-1.897m.911 1.59c.239.117.481.359.599.599.134.272.133.785-.003 1.068-.076.161-.93 1.036-4.339 4.45l-4.244 4.25H9.76V12.459l4.21-4.203c2.316-2.313 4.268-4.244 4.338-4.292.226-.153.414-.203.732-.193.217.008.352.036.488.102m-13.911.41c-.585.07-1.098.328-1.552.781a2.742 2.742 0 00-.696 1.116l-.109.32v12l.109.32c.151.445.362.783.695 1.116.333.333.671.544 1.116.695l.32.109h12l.32-.109a2.736 2.736 0 001.116-.695c.333-.333.544-.671.695-1.116l.109-.32v-2.88c0-3.251.016-3.077-.307-3.259-.232-.13-.634-.13-.866 0-.321.18-.304.023-.327 3.179l-.02 2.8-.093.189c-.132.268-.416.534-.674.63-.213.08-.298.081-5.953.081s-5.74-.001-5.953-.081c-.258-.096-.542-.362-.674-.63l-.093-.189V6.66l.093-.188a1.43 1.43 0 01.599-.599l.188-.093 2.8-.02c2.732-.02 2.804-.022 2.957-.103.221-.115.323-.325.322-.657-.002-.335-.089-.517-.31-.643l-.169-.097-2.68-.006c-1.474-.003-2.808.01-2.963.029' }) })),
    enter: (domProps) => (jsx("svg", { ...baseSvgProps, viewBox: '-2 -2 16 16', ...domProps, children: jsx("path", { d: 'M11.25 1.125C11.25 0.91875 11.4188 0.75 11.625 0.75C11.8313 0.75 12 0.91875 12 1.125V5.25C12 6.28594 11.161 7.125 10.125 7.125H1.27974L3.63989 9.48516C3.78521 9.63047 3.78521 9.86953 3.63989 10.0148C3.49458 10.1602 3.25552 10.1602 3.11021 10.0148L0.110205 7.01484C-0.0351074 6.86953 -0.0351074 6.63047 0.110205 6.48516L3.11021 3.48516C3.25552 3.33984 3.49458 3.33984 3.63989 3.48516C3.78521 3.63047 3.78521 3.86953 3.63989 4.01484L1.27974 6.375H10.125C10.7461 6.375 11.25 5.87109 11.25 5.25V1.125Z', fill: '#303744' }) })),
    eye: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.36 4.282c-.968.056-1.812.218-2.724.519A10.771 10.771 0 003.009 9.12C2.436 9.986 1.72 11.585 1.72 12c0 .386.66 1.901 1.187 2.724 1.623 2.535 4.11 4.243 7.006 4.812.809.159 1.213.197 2.087.197.874 0 1.278-.038 2.087-.197a10.729 10.729 0 007.549-5.792c.332-.674.644-1.519.644-1.744 0-.225-.312-1.07-.644-1.744A10.839 10.839 0 0017.22 5.61c-1.729-.971-3.829-1.448-5.86-1.328m2.02 1.576c2.648.417 4.892 1.866 6.375 4.117.31.471.793 1.425.908 1.795.069.221.069.239 0 .46-.115.37-.598 1.324-.908 1.795-1.758 2.668-4.604 4.215-7.755 4.215-3.125 0-5.954-1.524-7.721-4.16-.299-.446-.78-1.384-.918-1.79-.097-.284-.097-.285-.025-.517.116-.373.598-1.326.909-1.798A9.915 9.915 0 016.18 7.816c.677-.555 1.791-1.188 2.62-1.491a9.982 9.982 0 012.24-.523c.48-.052 1.861-.02 2.34.056m-1.785 2.424c-.46.05-.773.142-1.215.357-1.06.514-1.74 1.36-2.03 2.521a4.03 4.03 0 000 1.68c.183.733.493 1.287 1.008 1.802.73.73 1.606 1.092 2.642 1.092 1.036 0 1.912-.362 2.642-1.092.73-.73 1.092-1.606 1.092-2.642 0-1.589-.926-2.924-2.441-3.515-.441-.173-1.171-.26-1.698-.203m.961 1.54c.378.089.707.281 1.024.598.454.454.659.945.659 1.58 0 .635-.205 1.126-.659 1.58-.456.456-.944.66-1.58.66-.636 0-1.124-.204-1.58-.66-.454-.454-.659-.945-.659-1.58 0-.635.205-1.126.659-1.58.31-.31.646-.509 1.005-.597a2.87 2.87 0 011.131-.001' }) })),
    eyeSlash: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M2.729 2.285c-.209.103-.435.36-.496.563-.109.363-.802-.363 9.24 9.679 10.078 10.078 9.314 9.35 9.692 9.236.218-.065.533-.38.598-.598.105-.35.108-.346-1.617-2.078l-1.566-1.572.199-.168c1.263-1.063 2.183-2.222 2.859-3.603.352-.718.642-1.507.642-1.747 0-.222-.314-1.072-.644-1.741a10.75 10.75 0 00-6.272-5.455c-1.11-.367-2.123-.527-3.344-.528-1.835-.002-3.376.362-4.931 1.165l-.389.2-1.66-1.657c-1.903-1.9-1.901-1.899-2.311-1.696m10.308 3.536c2.757.308 5.165 1.796 6.717 4.152.315.478.757 1.35.903 1.78l.094.276-.193.468a9.291 9.291 0 01-2.676 3.63l-.379.316-1.188-1.188-1.187-1.187.113-.184c.45-.735.62-1.869.408-2.724-.287-1.16-.969-2.007-2.029-2.521a3.21 3.21 0 00-1.255-.356 3.597 3.597 0 00-2.029.376l-.411.206-1.051-1.051c-.578-.578-1.042-1.058-1.032-1.068.094-.086.9-.419 1.403-.579 1.126-.36 2.525-.488 3.792-.346M3.7 8.275c-.184.115-.305.261-.679.821-.591.887-1.301 2.473-1.301 2.907 0 .383.663 1.902 1.187 2.721 1.789 2.795 4.549 4.529 7.893 4.961.644.083 2.042.062 2.72-.04.899-.136 1.1-.274 1.1-.759a.864.864 0 00-.1-.462c-.176-.342-.405-.402-1.08-.282-.478.084-1.891.121-2.385.062-2.848-.342-5.201-1.774-6.776-4.124-.3-.447-.78-1.384-.92-1.794l-.098-.288.094-.269c.172-.497.605-1.322 1.01-1.927.518-.772.551-.949.247-1.286-.274-.303-.652-.403-.912-.241m8.856 1.547c.378.089.707.281 1.024.598.454.454.659.945.659 1.58 0 .299-.08.732-.164.889-.04.075-.168-.042-1.538-1.412-.948-.948-1.481-1.509-1.457-1.533.076-.076.588-.179.9-.181.176-.001.435.025.576.059' }) })),
    fileCircleInfo: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M5 18.5H11.875C12.25 19.0938 12.7188 19.5938 13.2812 20C13.1875 20 13.0938 20 13 20H5C3.875 20 3 19.125 3 18V6C3 4.90625 3.875 4 5 4H10.1562C10.6875 4 11.1875 4.21875 11.5625 4.59375L14.4062 7.4375C14.7812 7.8125 15 8.3125 15 8.84375V10.2188C14.4375 10.375 13.9375 10.5938 13.5 10.9062V9H11C10.4375 9 10 8.5625 10 8V5.5H5C4.71875 5.5 4.5 5.75 4.5 6V18C4.5 18.2812 4.71875 18.5 5 18.5ZM16.5 11C18.0938 11 19.5625 11.875 20.375 13.25C21.1875 14.6562 21.1875 16.375 20.375 17.75C19.5625 19.1562 18.0938 20 16.5 20C14.875 20 13.4062 19.1562 12.5938 17.75C11.7812 16.375 11.7812 14.6562 12.5938 13.25C13.4062 11.875 14.875 11 16.5 11ZM16.5 14C16.9062 14 17.25 13.6875 17.25 13.25C17.25 12.8438 16.9062 12.5 16.5 12.5C16.0625 12.5 15.75 12.8438 15.75 13.25C15.75 13.6875 16.0625 14 16.5 14ZM15.5 15.5C15.5 15.7812 15.7188 16 16 16V17.5C15.7188 17.5 15.5 17.75 15.5 18C15.5 18.2812 15.7188 18.5 16 18.5H16.5H17C17.25 18.5 17.5 18.2812 17.5 18C17.5 17.75 17.25 17.5 17 17.5V15.5C17 15.25 16.75 15 16.5 15H16C15.7188 15 15.5 15.25 15.5 15.5Z' }) })),
    fileCode: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M8 18.5H16C16.25 18.5 16.5 18.2812 16.5 18V9H14C13.4375 9 13 8.5625 13 8V5.5H8C7.71875 5.5 7.5 5.75 7.5 6V18C7.5 18.2812 7.71875 18.5 8 18.5ZM8 4H13.1562C13.6875 4 14.1875 4.21875 14.5625 4.59375L17.4062 7.4375C17.7812 7.8125 18 8.3125 18 8.84375V18C18 19.125 17.0938 20 16 20H8C6.875 20 6 19.125 6 18V6C6 4.90625 6.875 4 8 4ZM11.0312 13.0312H11L10.0312 14L11 14.9688C11.3125 15.2812 11.3125 15.75 11 16.0312C10.7188 16.3438 10.25 16.3438 9.96875 16.0312L8.46875 14.5312C8.15625 14.25 8.15625 13.7812 8.46875 13.4688L9.96875 12C10.25 11.6875 10.7188 11.6875 11.0312 12C11.3125 12.2812 11.3125 12.75 11.0312 13.0312ZM14.0312 11.9688L15.5312 13.4688C15.8125 13.7812 15.8125 14.25 15.5312 14.5312L14.0312 16.0312C13.7188 16.3438 13.25 16.3438 12.9688 16.0312C12.6562 15.75 12.6562 15.2812 12.9688 14.9688L13.9375 14L12.9688 13.0312C12.6562 12.75 12.6562 12.2812 12.9688 11.9688C13.25 11.6875 13.7188 11.6875 14.0312 11.9688Z' }) })),
    filterList: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M5.28125 6H13.6875C14.4062 6 15 6.59375 15 7.3125C15 7.625 14.875 7.9375 14.6562 8.1875L11.75 11.3125V17C11.75 17.5625 11.2812 18 10.7188 18C10.5312 18 10.3125 17.9688 10.1562 17.8438L7.8125 16.2812C7.4375 16.0625 7.25 15.6562 7.25 15.25V11.3125L4.34375 8.1875C4.09375 7.9375 4 7.625 4 7.3125C4 6.59375 4.5625 6 5.28125 6ZM8.53125 10.5C8.65625 10.6562 8.75 10.8125 8.75 11V15.125L10.25 16.0938V11C10.25 10.8125 10.3125 10.6562 10.4375 10.5L13.2188 7.5H5.75L8.53125 10.5ZM14.75 16.25H19.25C19.6562 16.25 20 16.5938 20 17C20 17.4375 19.6562 17.75 19.25 17.75H14.75C14.3125 17.75 14 17.4375 14 17C14 16.5938 14.3125 16.25 14.75 16.25ZM14 12C14 11.5938 14.3125 11.25 14.75 11.25H19.25C19.6562 11.25 20 11.5938 20 12C20 12.4375 19.6562 12.75 19.25 12.75H14.75C14.3125 12.75 14 12.4375 14 12ZM16.75 6.25H19.25C19.6562 6.25 20 6.59375 20 7C20 7.4375 19.6562 7.75 19.25 7.75H16.75C16.3125 7.75 16 7.4375 16 7C16 6.59375 16.3125 6.25 16.75 6.25Z' }) })),
    folder: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M4.617 4.283c-.584.069-1.098.328-1.552.781a2.742 2.742 0 00-.696 1.116l-.109.32v11l.109.32c.151.445.362.783.695 1.116.333.333.671.544 1.116.695l.32.109h15l.32-.109a2.736 2.736 0 001.116-.695c.333-.333.544-.671.695-1.116l.109-.32v-9l-.109-.32a2.742 2.742 0 00-.696-1.116c-.472-.471-.961-.709-1.606-.783-.2-.023-1.558-.04-3.189-.041h-2.841l-.919-.923c-.506-.507-.974-.953-1.04-.99-.109-.061-.398-.067-3.28-.072-1.738-.003-3.288.009-3.443.028m7.003 2.4c.506.507.974.953 1.04.99.109.061.423.069 3.4.087l3.28.02.188.093c.239.118.481.36.599.599l.093.188v8.68l-.093.189c-.132.268-.416.534-.674.63-.214.08-.294.081-7.453.081-7.159 0-7.239-.001-7.453-.081-.258-.096-.542-.362-.674-.63l-.093-.189-.011-5.26c-.009-3.917 0-5.304.035-5.43.093-.34.433-.7.782-.828.127-.046.677-.057 3.134-.059l2.981-.003.919.923' }) })),
    gear: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.7 2.281c-.347.04-.563.107-.877.271-.57.299-.963.779-1.186 1.451-.154.465-.29.649-.574.782-.312.145-.589.131-.93-.048-.402-.212-.64-.292-.995-.338-.905-.115-1.833.324-2.35 1.112-.207.317-.29.518-.37.896-.115.551-.045.982.267 1.643.192.406.204.451.185.666-.042.458-.279.733-.764.885-1.051.329-1.676 1.038-1.827 2.071a2.503 2.503 0 00.395 1.717c.332.484.728.774 1.328.973.603.201.824.435.868.922.019.215.007.26-.185.666-.312.661-.382 1.092-.267 1.643.08.378.163.579.37.896.435.664 1.303 1.151 2.051 1.151.329 0 .78-.12 1.159-.308.473-.235.722-.266 1.036-.131.301.13.445.32.603.795.073.22.195.496.271.612a2.487 2.487 0 003.452.731c.501-.326.798-.723 1.003-1.343.158-.475.302-.665.603-.795.31-.133.558-.102 1.039.133.384.187.833.306 1.156.306.287 0 .738-.12 1.078-.286a2.576 2.576 0 001.341-1.747c.117-.569.049-.992-.265-1.657-.192-.406-.204-.451-.185-.666.044-.487.265-.721.868-.922.618-.204 1.016-.502 1.341-1.002a2.483 2.483 0 00-.385-3.179c-.268-.248-.626-.444-1.06-.58-.485-.152-.722-.427-.764-.885-.019-.215-.007-.26.185-.666.413-.873.423-1.504.039-2.289-.302-.615-.935-1.135-1.574-1.294-.389-.096-.581-.111-.918-.068-.355.046-.593.126-.995.338-.341.179-.618.193-.93.048-.284-.133-.42-.317-.574-.782a3.404 3.404 0 00-.288-.637c-.503-.769-1.435-1.195-2.375-1.085m.624 1.525a.977.977 0 01.476.364c.041.067.128.276.194.465.171.49.303.705.628 1.028.213.21.372.324.622.446.428.208.687.269 1.136.267.428-.002.698-.074 1.197-.32.546-.269.886-.236 1.244.123.359.358.392.698.123 1.244-.252.51-.319.768-.32 1.217-.002 1.089.653 1.987 1.721 2.359.438.153.574.232.705.408.129.173.19.362.19.584 0 .477-.26.806-.76.963-1.161.366-1.858 1.268-1.856 2.406.001.449.068.707.32 1.217.139.281.176.4.176.56-.001.398-.31.827-.674.937-.295.088-.485.059-.88-.133-.49-.239-.78-.31-1.246-.307a2.375 2.375 0 00-1.698.7c-.321.316-.44.51-.623 1.015-.172.473-.228.569-.408.703-.438.325-1.125.215-1.391-.222a3.673 3.673 0 01-.201-.485c-.369-1.06-1.243-1.705-2.319-1.711-.466-.003-.756.068-1.246.307-.56.272-.895.24-1.255-.12-.359-.358-.392-.698-.123-1.244.252-.51.319-.768.32-1.217.002-1.134-.699-2.042-1.856-2.406-.5-.157-.76-.486-.76-.963 0-.222.061-.411.19-.584.131-.176.267-.255.705-.408 1.068-.372 1.723-1.27 1.721-2.359-.001-.449-.068-.707-.32-1.217-.269-.546-.236-.886.123-1.244.358-.359.698-.392 1.244-.123.51.252.768.319 1.217.32 1.082.002 1.984-.651 2.354-1.705.068-.193.151-.403.185-.469.074-.144.293-.324.471-.389.169-.061.502-.065.674-.007m-.729 4.476c-.46.05-.773.142-1.215.357-1.06.514-1.74 1.36-2.03 2.521a4.03 4.03 0 000 1.68c.183.733.493 1.287 1.008 1.802.73.73 1.606 1.092 2.642 1.092 1.036 0 1.912-.362 2.642-1.092.73-.73 1.092-1.606 1.092-2.642 0-1.589-.926-2.924-2.441-3.515-.441-.173-1.171-.26-1.698-.203m.961 1.54c.378.089.707.281 1.024.598.454.454.659.945.659 1.58 0 .635-.205 1.126-.659 1.58-.456.456-.944.66-1.58.66-.636 0-1.124-.204-1.58-.66-.454-.454-.659-.945-.659-1.58 0-.635.205-1.126.659-1.58.31-.31.646-.509 1.005-.597a2.87 2.87 0 011.131-.001' }) })),
    github: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M9.40625 16.4375C9.40625 16.5 9.34375 16.5312 9.25 16.5312C9.15625 16.5625 9.09375 16.5 9.09375 16.4375C9.09375 16.375 9.15625 16.3125 9.25 16.3125C9.34375 16.3125 9.40625 16.375 9.40625 16.4375ZM8.4375 16.2812C8.46875 16.2188 8.5625 16.1875 8.65625 16.2188C8.75 16.25 8.78125 16.3125 8.78125 16.375C8.75 16.4375 8.65625 16.4688 8.59375 16.4375C8.5 16.4375 8.4375 16.3438 8.4375 16.2812ZM9.84375 16.25C9.90625 16.2188 10 16.2812 10 16.3438C10.0312 16.4062 9.96875 16.4375 9.875 16.4688C9.78125 16.5 9.6875 16.4688 9.6875 16.4062C9.6875 16.3125 9.75 16.25 9.84375 16.25ZM11.875 4.25C16.2188 4.25 19.75 7.5625 19.75 11.875C19.75 15.3438 17.625 18.3125 14.5 19.3438C14.0938 19.4375 13.9375 19.1875 13.9375 18.9688C13.9375 18.7188 13.9688 17.4062 13.9688 16.375C13.9688 15.625 13.7188 15.1562 13.4375 14.9062C15.1875 14.7188 17.0312 14.4688 17.0312 11.4688C17.0312 10.5938 16.7188 10.1875 16.2188 9.625C16.2812 9.40625 16.5625 8.59375 16.125 7.5C15.4688 7.28125 13.9688 8.34375 13.9688 8.34375C13.3438 8.15625 12.6875 8.09375 12 8.09375C11.3438 8.09375 10.6875 8.15625 10.0625 8.34375C10.0625 8.34375 8.53125 7.3125 7.90625 7.5C7.46875 8.59375 7.71875 9.40625 7.8125 9.625C7.3125 10.1875 7.0625 10.5938 7.0625 11.4688C7.0625 14.4688 8.84375 14.7188 10.5938 14.9062C10.3438 15.125 10.1562 15.4688 10.0938 15.9688C9.625 16.1875 8.5 16.5312 7.8125 15.3125C7.375 14.5625 6.59375 14.5 6.59375 14.5C5.84375 14.5 6.5625 15 6.5625 15C7.0625 15.2188 7.40625 16.125 7.40625 16.125C7.875 17.5312 10.0625 17.0625 10.0625 17.0625C10.0625 17.7188 10.0625 18.7812 10.0625 19C10.0625 19.1875 9.9375 19.4375 9.53125 19.375C6.40625 18.3125 4.25 15.3438 4.25 11.875C4.25 7.5625 7.5625 4.25 11.875 4.25ZM7.28125 15.0312C7.3125 15 7.375 15.0312 7.4375 15.0625C7.5 15.125 7.5 15.2188 7.46875 15.25C7.40625 15.2812 7.34375 15.25 7.28125 15.2188C7.25 15.1562 7.21875 15.0625 7.28125 15.0312ZM6.9375 14.7812C6.96875 14.75 7 14.75 7.0625 14.7812C7.125 14.8125 7.15625 14.8438 7.15625 14.875C7.125 14.9375 7.0625 14.9375 7 14.9062C6.9375 14.875 6.90625 14.8438 6.9375 14.7812ZM7.9375 15.9062C8 15.8438 8.09375 15.875 8.15625 15.9375C8.21875 16 8.21875 16.0938 8.1875 16.125C8.15625 16.1875 8.0625 16.1562 8 16.0938C7.90625 16.0312 7.90625 15.9375 7.9375 15.9062ZM7.59375 15.4375C7.65625 15.4062 7.71875 15.4375 7.78125 15.5C7.8125 15.5625 7.8125 15.6562 7.78125 15.6875C7.71875 15.7188 7.65625 15.6875 7.59375 15.625C7.53125 15.5625 7.53125 15.4688 7.59375 15.4375Z' }) })),
    googleDrive: (domProps) => (jsxs("svg", { ...baseSvgProps, ...domProps, height: '2168', preserveAspectRatio: 'xMidYMid', width: '2500', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 256 221.4', children: [jsxs("linearGradient", { id: 'a', x1: '0%', y1: '0%', y2: '100%', children: [jsx("stop", { offset: '0', stopColor: '#f6c338' }), jsx("stop", { offset: '.523', stopColor: '#ffd351' }), jsx("stop", { offset: '1', stopColor: '#f6c338' })] }), jsxs("linearGradient", { id: 'b', x1: '100%', x2: '0%', y1: '0%', y2: '100%', children: [jsx("stop", { offset: '0', stopColor: '#286ee6' }), jsx("stop", { offset: '.521', stopColor: '#4286fb' }), jsx("stop", { offset: '1', stopColor: '#286ee6' })] }), jsxs("linearGradient", { id: 'c', x1: '65.289%', x2: '35.995%', y1: '0%', y2: '100%', children: [jsx("stop", { offset: '0', stopColor: '#069b5a' }), jsx("stop", { offset: '.531', stopColor: '#11aa62' }), jsx("stop", { offset: '1', stopColor: '#069b5a' })] }), jsx("path", { d: 'M83.3 0h89L256 144.3h-89.2z', fill: 'url(#a)' }), jsx("path", { d: 'M256 144.3l-44.6 77.1h-167l44.7-77.1z', fill: 'url(#b)' }), jsx("path", { d: 'M44.4 221.4L0 144.3 83.3 0 128 77.3z', fill: 'url(#c)' }), jsx("path", { d: 'M44.4 221.4l83.1-77.1H89.1zM256 144.3h-89.1l-19.6-33.8zM83.3 0L109 110l19-32.7z', opacity: '.1' })] })),
    grid: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M5.617 3.283c-.583.068-1.098.327-1.552.781a2.721 2.721 0 00-.696 1.116l-.109.32v3l.109.32c.151.444.362.783.695 1.116.333.333.672.544 1.116.695l.32.109h3l.32-.109a2.743 2.743 0 001.116-.695c.333-.333.544-.672.695-1.116l.109-.32v-3l-.109-.32a2.721 2.721 0 00-.696-1.116c-.472-.471-.961-.709-1.606-.783-.41-.047-2.303-.045-2.712.002m10 0c-.583.068-1.098.327-1.552.781a2.721 2.721 0 00-.696 1.116l-.109.32v3l.109.32c.151.444.362.783.695 1.116.333.333.672.544 1.116.695l.32.109h3l.32-.109a2.743 2.743 0 001.116-.695c.333-.333.544-.672.695-1.116l.109-.32v-3l-.109-.32a2.721 2.721 0 00-.696-1.116c-.472-.471-.961-.709-1.606-.783-.41-.047-2.303-.045-2.712.002m-7.089 1.59c.239.118.481.36.599.599.092.185.093.208.093 1.528 0 1.322-.001 1.342-.093 1.529-.132.268-.416.534-.674.63-.2.075-.311.081-1.453.081-1.142 0-1.253-.006-1.453-.081-.258-.096-.542-.362-.674-.63-.091-.184-.093-.223-.105-1.449-.008-.882.002-1.311.035-1.43.062-.221.262-.501.467-.652.313-.23.35-.235 1.77-.226 1.27.008 1.304.01 1.488.101m10 0c.239.118.481.36.599.599.092.185.093.208.093 1.528 0 1.322-.001 1.342-.093 1.529-.132.268-.416.534-.674.63-.2.075-.311.081-1.453.081-1.142 0-1.253-.006-1.453-.081-.258-.096-.542-.362-.674-.63-.091-.184-.093-.223-.105-1.449-.008-.882.002-1.311.035-1.43.062-.221.262-.501.467-.652.313-.23.35-.235 1.77-.226 1.27.008 1.304.01 1.488.101m-12.911 8.41c-.583.068-1.098.327-1.552.781a2.721 2.721 0 00-.696 1.116l-.109.32v3l.109.32c.151.444.362.783.695 1.116.333.333.672.544 1.116.695l.32.109h3l.32-.109a2.743 2.743 0 001.116-.695c.333-.333.544-.672.695-1.116l.109-.32v-3l-.109-.32a2.721 2.721 0 00-.696-1.116c-.472-.471-.961-.709-1.606-.783-.41-.047-2.303-.045-2.712.002m10 0c-.583.068-1.098.327-1.552.781a2.721 2.721 0 00-.696 1.116l-.109.32v3l.109.32c.151.444.362.783.695 1.116.333.333.672.544 1.116.695l.32.109h3l.32-.109a2.743 2.743 0 001.116-.695c.333-.333.544-.672.695-1.116l.109-.32v-3l-.109-.32a2.721 2.721 0 00-.696-1.116c-.472-.471-.961-.709-1.606-.783-.41-.047-2.303-.045-2.712.002m-7.089 1.59c.239.118.481.36.599.599.092.185.093.208.093 1.528 0 1.322-.001 1.342-.093 1.529-.132.268-.416.534-.674.63-.2.075-.311.081-1.453.081-1.142 0-1.253-.006-1.453-.081-.258-.096-.542-.362-.674-.63-.091-.184-.093-.223-.105-1.449-.008-.882.002-1.311.035-1.43.062-.221.262-.501.467-.652.313-.23.35-.235 1.77-.226 1.27.008 1.304.01 1.488.101m10 0c.239.118.481.36.599.599.092.185.093.208.093 1.528 0 1.322-.001 1.342-.093 1.529-.132.268-.416.534-.674.63-.2.075-.311.081-1.453.081-1.142 0-1.253-.006-1.453-.081-.258-.096-.542-.362-.674-.63-.091-.184-.093-.223-.105-1.449-.008-.882.002-1.311.035-1.43.062-.221.262-.501.467-.652.313-.23.35-.235 1.77-.226 1.27.008 1.304.01 1.488.101' }) })),
    history: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M5.5 7.34375C6.9375 5.34375 9.3125 4 12 4C16.4062 4 20 7.59375 20 12C20 16.4375 16.4062 20 12 20C10.3438 20 8.84375 19.5312 7.5625 18.6875C7.21875 18.4688 7.125 18 7.375 17.6562C7.59375 17.3125 8.0625 17.2188 8.40625 17.4375C9.4375 18.125 10.6562 18.5 12 18.5C15.5625 18.5 18.5 15.5938 18.5 12C18.5 8.4375 15.5625 5.5 12 5.5C9.6875 5.5 7.65625 6.71875 6.5 8.5H8.25C8.65625 8.5 9 8.84375 9 9.25C9 9.6875 8.65625 10 8.25 10H4.75C4.3125 10 4 9.6875 4 9.25V5.75C4 5.34375 4.3125 5 4.75 5C5.15625 5 5.5 5.34375 5.5 5.75V7.34375ZM12 8H11.9688C12.4062 8 12.7188 8.34375 12.7188 8.75V11.7188L14.75 13.75C15.0625 14.0312 15.0625 14.5 14.75 14.7812C14.4688 15.0938 14 15.0938 13.7188 14.7812L11.4688 12.5312C11.3125 12.4062 11.25 12.2188 11.25 12V8.75C11.25 8.34375 11.5625 8 12 8Z' }) })),
    hourglass: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M6.75 4H17.25C17.6562 4 18 4.34375 18 4.75C18 5.1875 17.6562 5.5 17.25 5.5H17V6.09375C17 7.375 16.5 8.5625 15.5938 9.46875L13.0312 12L15.5938 14.5625C16.5 15.4375 17 16.6562 17 17.9062V18.5H17.25C17.6562 18.5 18 18.8438 18 19.25C18 19.6875 17.6562 20 17.25 20H6.75C6.3125 20 6 19.6875 6 19.25C6 18.8438 6.3125 18.5 6.75 18.5H7V17.9062C7 16.6562 7.5 15.4375 8.375 14.5625L10.9375 12L8.375 9.46875C7.5 8.5625 7 7.375 7 6.09375V5.5H6.75C6.3125 5.5 6 5.1875 6 4.75C6 4.34375 6.3125 4 6.75 4ZM12 13.0625L9.4375 15.625C8.84375 16.2188 8.5 17.0625 8.5 17.9062V18.5H15.5V17.9062C15.5 17.0625 15.1562 16.2188 14.5312 15.625L12 13.0625ZM12 10.9375V10.9688L14.5312 8.40625C15.1562 7.78125 15.5 6.96875 15.5 6.09375V5.5H8.5V6.09375C8.5 6.96875 8.84375 7.78125 9.4375 8.40625L12 10.9375Z' }) })),
    info: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.32 2.28A9.74 9.74 0 003.258 7.7c-.46.94-.762 1.914-.924 2.98-.097.636-.097 2.004 0 2.64.446 2.941 2.052 5.409 4.533 6.968 1.075.676 2.441 1.17 3.813 1.378.636.097 2.004.097 2.64 0 2.1-.319 3.932-1.206 5.405-2.618 1.601-1.534 2.6-3.479 2.941-5.728.097-.636.097-2.004 0-2.64-.443-2.919-2.04-5.389-4.49-6.941-.824-.522-2.118-1.053-3.056-1.253a10.872 10.872 0 00-2.8-.206m2 1.578a8.277 8.277 0 014.628 2.435c1.176 1.231 1.913 2.713 2.2 4.423.1.593.1 1.975 0 2.568-.612 3.649-3.463 6.426-7.08 6.895-3.771.489-7.369-1.653-8.767-5.219a9.164 9.164 0 01-.449-1.676c-.1-.593-.1-1.975 0-2.568.299-1.783 1.066-3.282 2.324-4.54 1.389-1.388 2.977-2.138 5.064-2.391.313-.038 1.715.011 2.08.073m-1.521 3.418c-.37.075-.536.299-.538.724-.002.508.236.74.759.74.325 0 .535-.102.65-.314.094-.173.094-.679 0-.852-.129-.24-.514-.371-.871-.298m-1 3.999c-.371.078-.536.3-.538.725-.002.486.213.709.719.75l.257.021.011 1.744c.012 1.674.015 1.751.095 1.902.15.287.278.323 1.157.323.69 0 .774-.008.917-.083.221-.115.323-.325.322-.657-.002-.482-.202-.691-.709-.743l-.267-.028-.011-1.744c-.014-1.978-.009-1.95-.323-2.127-.157-.089-.216-.096-.829-.104-.363-.005-.723.004-.801.021' }) })),
    key: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, xmlns: 'http://www.w3.org/2000/svg', children: jsx("path", { d: 'M10.5 9.5C10.5 9.84375 10.5312 10.1562 10.5938 10.4688C10.6562 10.7188 10.5938 10.9688 10.4062 11.1562L5.5 16.0625V18.5H7.5V17.25C7.5 16.8438 7.8125 16.5 8.25 16.5H9.5V15.25C9.5 14.8438 9.8125 14.5 10.25 14.5H11.9375L12.8438 13.5938C13.0312 13.4062 13.2812 13.3438 13.5312 13.4062C13.8438 13.4688 14.1562 13.5 14.5 13.5C16.6875 13.5 18.5 11.7188 18.5 9.5C18.5 7.3125 16.6875 5.5 14.5 5.5C12.2812 5.5 10.5 7.3125 10.5 9.5ZM14.5 4C17.5312 4 20 6.46875 20 9.5C20 12.5625 17.5312 15 14.5 15C14.1875 15 13.9062 15 13.625 14.9375L12.7812 15.7812C12.625 15.9375 12.4375 16 12.25 16H11V17.25C11 17.6875 10.6562 18 10.25 18H9V19.25C9 19.6875 8.65625 20 8.25 20H4.75C4.3125 20 4 19.6875 4 19.25V15.75C4 15.5625 4.0625 15.375 4.21875 15.2188L9.0625 10.375C9 10.0938 9 9.8125 9 9.5C9 6.46875 11.4375 4 14.5 4ZM15.5 9.5C14.9375 9.5 14.5 9.0625 14.5 8.5C14.5 7.96875 14.9375 7.5 15.5 7.5C16.0312 7.5 16.5 7.96875 16.5 8.5C16.5 9.0625 16.0312 9.5 15.5 9.5Z' }) })),
    lightningBolt: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M12.807 2.279a.822.822 0 00-.27.147c-.075.063-2.189 2.624-4.697 5.693-3.505 4.286-4.572 5.616-4.605 5.738-.062.231.013.444.227.651a.98.98 0 00.326.209c.101.028 1.218.043 3.301.043h3.149l.011 3.25c.011 3.196.012 3.253.094 3.407.112.215.326.323.637.321a.874.874 0 00.37-.071c.085-.045 1.711-2.002 4.745-5.71 3.718-4.544 4.625-5.675 4.665-5.816.081-.292-.064-.585-.392-.789l-.148-.092-3.229-.011-3.229-.011-.011-3.249c-.01-3.026-.016-3.259-.082-3.392-.123-.247-.531-.397-.862-.318m-.464 8.138a.59.59 0 00.24.24c.153.081.225.083 2.983.103l2.827.02-3.315 4.052-3.316 4.052-.011-2.572c-.012-2.906.002-2.769-.322-2.955l-.169-.097-2.826-.02-2.827-.02 3.307-4.041 3.306-4.041.02 2.561c.019 2.49.022 2.565.103 2.718' }) })),
    link: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M16.527 2.284c-.729.065-1.519.349-2.18.782-.335.22-1.911 1.757-2.005 1.956a.57.57 0 00.017.535c.102.202.376.433.575.487.299.08.438-.011 1.306-.864.975-.958 1.205-1.118 1.868-1.309.45-.129 1.334-.129 1.784 0a3.325 3.325 0 012.237 2.237c.129.45.129 1.334 0 1.784a2.929 2.929 0 01-.47.968c-.095.132-1.204 1.266-2.466 2.521-2.372 2.358-2.447 2.425-2.995 2.646-.552.223-1.462.274-2.058.116a3.512 3.512 0 01-1.1-.561c-.552-.455-.639-.512-.813-.531-.449-.051-.94.503-.822.928.087.315.796.925 1.46 1.256.713.356 1.32.497 2.135.497 1.04 0 1.942-.286 2.76-.875.387-.278 4.876-4.773 5.131-5.137.562-.803.841-1.705.841-2.72 0-1.34-.488-2.488-1.45-3.413A4.65 4.65 0 0017.4 2.281a9.017 9.017 0 00-.48-.035c-.011.003-.188.02-.393.038m-6 6c-.727.065-1.515.347-2.18.781-.375.245-4.88 4.725-5.204 5.175-.589.818-.876 1.723-.876 2.76 0 1.292.439 2.372 1.343 3.306.914.943 2.062 1.426 3.39 1.426 1.016 0 1.92-.28 2.72-.842.324-.227 1.857-1.74 1.939-1.914.152-.32-.014-.693-.427-.954-.144-.091-.418-.092-.592-.002-.076.039-.5.425-.94.856-.812.794-1.028.96-1.5 1.15-.7.283-1.7.283-2.4 0a3.064 3.064 0 01-.988-.642c-.483-.45-.774-.91-.941-1.492-.129-.45-.129-1.334 0-1.784.108-.375.239-.646.471-.968.21-.293 4.606-4.681 4.858-4.849.287-.192.572-.323.908-.42.259-.074.411-.089.892-.089.481 0 .633.015.892.089.509.146.854.344 1.316.754.392.347.611.409.909.256.34-.173.559-.567.479-.859-.137-.495-1.389-1.345-2.356-1.6-.299-.079-1.22-.202-1.32-.176-.011.003-.188.02-.393.038' }) })),
    list: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M4.77419 5H6.32258C6.74194 5 7.09677 5.35484 7.09677 5.77419V7.32258C7.09677 7.77419 6.74194 8.09677 6.32258 8.09677H4.77419C4.32259 8.09677 4 7.77419 4 7.32258V5.77419C4 5.35484 4.32259 5 4.77419 5ZM9.41935 5.77419H19.2258C19.6452 5.77419 20 6.12903 20 6.54839C20 6.99999 19.6452 7.32258 19.2258 7.32258H9.41935C8.96775 7.32258 8.64516 6.99999 8.64516 6.54839C8.64516 6.12903 8.96775 5.77419 9.41935 5.77419ZM9.41935 10.9355H19.2258C19.6452 10.9355 20 11.2903 20 11.7097C20 12.1613 19.6452 12.4839 19.2258 12.4839H9.41935C8.96775 12.4839 8.64516 12.1613 8.64516 11.7097C8.64516 11.2903 8.96775 10.9355 9.41935 10.9355ZM9.41935 16.0968H19.2258C19.6452 16.0968 20 16.4516 20 16.871C20 17.3225 19.6452 17.6452 19.2258 17.6452H9.41935C8.96775 17.6452 8.64516 17.3225 8.64516 16.871C8.64516 16.4516 8.96775 16.0968 9.41935 16.0968ZM4 10.9355C4 10.5161 4.32259 10.1613 4.77419 10.1613H6.32258C6.74194 10.1613 7.09677 10.5161 7.09677 10.9355V12.4839C7.09677 12.9355 6.74194 13.2581 6.32258 13.2581H4.77419C4.32259 13.2581 4 12.9355 4 12.4839V10.9355ZM4.77419 15.3226H6.32258C6.74194 15.3226 7.09677 15.6774 7.09677 16.0968V17.6452C7.09677 18.0967 6.74194 18.4194 6.32258 18.4194H4.77419C4.32259 18.4194 4 18.0967 4 17.6452V16.0968C4 15.6774 4.32259 15.3226 4.77419 15.3226Z' }) })),
    listTimeline: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M10.8438 7.5H16.5V6.5H10.8438L10.3438 7L10.8438 7.5ZM8.59375 7.375C8.40625 7.1875 8.40625 6.84375 8.59375 6.65625L9.9375 5.3125C10.125 5.125 10.375 5 10.6562 5H17C17.5312 5 18 5.46875 18 6V8C18 8.5625 17.5312 9 17 9H10.6562C10.375 9 10.125 8.90625 9.9375 8.71875L8.59375 7.375ZM6 8C5.4375 8 5 7.5625 5 7C5 6.46875 5.4375 6 6 6C6.53125 6 7 6.46875 7 7C7 7.5625 6.53125 8 6 8ZM6 13C5.4375 13 5 12.5625 5 12C5 11.4688 5.4375 11 6 11C6.53125 11 7 11.4688 7 12C7 12.5625 6.53125 13 6 13ZM5 17C5 16.4688 5.4375 16 6 16C6.53125 16 7 16.4688 7 17C7 17.5625 6.53125 18 6 18C5.4375 18 5 17.5625 5 17ZM10.8438 17.5H16.5V16.5H10.8438L10.3438 17L10.8438 17.5ZM8.59375 17.375C8.40625 17.1875 8.40625 16.8438 8.59375 16.6562L9.9375 15.3125C10.125 15.125 10.375 15 10.6562 15H17C17.5312 15 18 15.4688 18 16V18C18 18.5625 17.5312 19 17 19H10.6562C10.375 19 10.125 18.9062 9.9375 18.7188L8.59375 17.375ZM10.3438 12L10.8438 12.5H18.5V11.5H10.8438L10.3438 12ZM9.9375 13.7188L8.59375 12.375C8.40625 12.1875 8.40625 11.8438 8.59375 11.6562L9.9375 10.3125C10.125 10.125 10.375 10 10.6562 10H19C19.5312 10 20 10.4688 20 11V13C20 13.5625 19.5312 14 19 14H10.6562C10.375 14 10.125 13.9062 9.9375 13.7188Z' }) })),
    lock: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.544 2.283c-1.955.173-3.655 1.626-4.14 3.538-.137.543-.163.977-.164 2.729v1.69h-.61c-1.366.001-1.918.178-2.565.824a2.742 2.742 0 00-.696 1.116l-.109.32v7l.109.32c.151.445.362.783.695 1.116.333.333.671.544 1.116.695l.32.109h13l.32-.109a2.736 2.736 0 001.116-.695c.333-.333.544-.671.695-1.116l.109-.32v-7l-.109-.32a2.742 2.742 0 00-.696-1.116c-.647-.646-1.199-.823-2.565-.824h-.61V8.55c-.001-.93-.019-1.852-.041-2.05a4.774 4.774 0 00-3.563-4.101c-.244-.062-1.152-.175-1.236-.153-.011.003-.18.019-.376.037m1.37 1.595c.508.146.893.372 1.321.78.436.416.725.877.892 1.428.085.283.089.366.103 2.224l.015 1.93h-6.49l.015-1.93c.014-1.858.018-1.941.103-2.224.158-.52.382-.898.785-1.321a3.113 3.113 0 011.775-.967c.321-.058 1.152-.013 1.481.08m5.614 7.995c.239.118.481.36.599.599l.093.188v6.68l-.093.189c-.132.268-.416.534-.674.63-.213.08-.297.081-6.453.081-6.156 0-6.24-.001-6.453-.081-.258-.096-.542-.362-.674-.63l-.093-.189-.012-3.26c-.008-2.399.001-3.305.036-3.43.093-.34.433-.7.782-.828.131-.048 1.114-.056 6.454-.049l6.3.007.188.093m-6.729 2.403c-.212.043-.39.165-.468.322-.063.127-.071.278-.071 1.402 0 1.196.004 1.268.083 1.417.115.22.325.323.657.323s.542-.103.657-.323c.079-.149.083-.221.083-1.417 0-1.13-.007-1.275-.071-1.403-.123-.246-.516-.391-.87-.321' }) })),
    mail: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M5.7 4.276c-1.295.024-1.326.026-1.607.129-.382.14-.785.414-1.101.749a2.573 2.573 0 0 0-.619 1.026l-.113.32-.011 5.48-.011 5.48.152.4c.19.499.372.776.744 1.129.343.326.597.478 1.079.647l.353.124H19.437l.383-.137c.467-.167.716-.32 1.069-.657.35-.334.563-.667.735-1.148l.139-.389-.012-5.464L21.74 6.5l-.117-.334a2.913 2.913 0 0 0-1.456-1.645c-.518-.258-.17-.245-6.967-.258a706.793 706.793 0 0 0-7.5.013m13.828 1.608c.228.117.442.325.565.55.095.175.111.259.133.694l.025.494-3.368 2.233c-4.172 2.765-4.433 2.931-4.688 2.966-.385.053-.54.001-1.16-.388a398.554 398.554 0 0 1-3.929-2.587L3.752 7.62l.018-.46c.02-.531.098-.761.342-1.013.303-.312.334-.321 1.226-.352.441-.015 3.779-.019 7.418-.009 6.506.018 6.618.02 6.772.098M7.094 11.633c3.723 2.47 3.643 2.42 4.01 2.546.778.269 1.616.18 2.312-.244.134-.081 1.708-1.12 3.498-2.307 2.568-1.704 3.263-2.147 3.293-2.104.025.036.032 1.471.02 3.939-.018 3.876-.019 3.884-.104 4.052a1.46 1.46 0 0 1-.58.598l-.203.107H4.66l-.188-.094c-.219-.108-.469-.365-.594-.61l-.088-.172-.021-3.826c-.019-3.513-.012-4.038.056-4.038.013 0 1.484.969 3.269 2.153' }) })),
    objectGroup: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M4.5 7.625C4.1875 7.34375 4 6.96875 4 6.5C4 5.6875 4.65625 5 5.5 5C5.9375 5 6.34375 5.21875 6.59375 5.5H17.375C17.6562 5.21875 18.0312 5 18.5 5C19.3125 5 20 5.6875 20 6.5C20 6.96875 19.7812 7.34375 19.5 7.625V16.4062C19.7812 16.6562 20 17.0625 20 17.5C20 18.3438 19.3125 19 18.5 19C18.0312 19 17.6562 18.8125 17.375 18.5H6.59375C6.34375 18.8125 5.9375 19 5.5 19C4.65625 19 4 18.3438 4 17.5C4 17.0625 4.1875 16.6562 4.5 16.4062V7.625ZM6.90625 7C6.75 7.4375 6.40625 7.78125 6 7.9375V16.0938C6.40625 16.25 6.75 16.5938 6.90625 17H17.0625C17.2188 16.5938 17.5625 16.25 18 16.0938V7.9375C17.5625 7.78125 17.2188 7.4375 17.0625 7H6.90625ZM7 9C7 8.46875 7.4375 8 8 8H12C12.5312 8 13 8.46875 13 9V12C13 12.5625 12.5312 13 12 13H8C7.4375 13 7 12.5625 7 12V9ZM11 14H12C13.0938 14 14 13.125 14 12V11H16C16.5312 11 17 11.4688 17 12V15C17 15.5625 16.5312 16 16 16H12C11.4375 16 11 15.5625 11 15V14Z' }) })),
    palette: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M18.5 12.0938C18.5 12.0625 18.5 12.0312 18.5 12C18.5 8.4375 15.5625 5.5 12 5.5C8.40625 5.5 5.5 8.4375 5.5 12C5.5 15.5938 8.40625 18.5 12 18.5C12.0625 18.5 12.1562 18.5 12.25 18.5C12.2812 18.5 12.2812 18.5 12.3125 18.5C12.3125 18.5 12.3438 18.4688 12.375 18.4375C12.4375 18.375 12.5 18.25 12.5 18.0625C12.5 18.0312 12.4688 17.9062 12.3125 17.5312C12.2812 17.5 12.2812 17.4375 12.25 17.4062C12.125 17.0938 11.9062 16.625 11.8125 16.125C11.75 15.9375 11.75 15.7188 11.75 15.5C11.75 13.8438 13.0938 12.5 14.75 12.5H17.8125C18.0312 12.5 18.25 12.4375 18.3438 12.3438C18.4688 12.25 18.5 12.1562 18.5 12.0938ZM20 12.0938C19.9688 13.25 18.9375 14 17.8125 14H14.75C13.9062 14 13.25 14.6875 13.25 15.5C13.25 15.625 13.25 15.7188 13.2812 15.8125C13.3438 16.1562 13.4688 16.4375 13.5938 16.75C13.7812 17.1875 14 17.625 14 18.0625C14 19.0625 13.3125 19.9688 12.3125 20C12.2188 20 12.0938 20 12 20C7.5625 20 4 16.4375 4 12C4 7.59375 7.5625 4 12 4C16.4062 4 20 7.59375 20 12C20 12.0312 20 12.0625 20 12.0938ZM9 12C9 12.5625 8.53125 13 8 13C7.4375 13 7 12.5625 7 12C7 11.4688 7.4375 11 8 11C8.53125 11 9 11.4688 9 12ZM9 10C8.4375 10 8 9.5625 8 9C8 8.46875 8.4375 8 9 8C9.53125 8 10 8.46875 10 9C10 9.5625 9.53125 10 9 10ZM13 8C13 8.5625 12.5312 9 12 9C11.4375 9 11 8.5625 11 8C11 7.46875 11.4375 7 12 7C12.5312 7 13 7.46875 13 8ZM15 10C14.4375 10 14 9.5625 14 9C14 8.46875 14.4375 8 15 8C15.5312 8 16 8.46875 16 9C16 9.5625 15.5312 10 15 10Z' }) })),
    pen: (domProps) => (jsxs("svg", { ...baseSvgProps, ...domProps, children: [jsx("path", { d: 'M5.125 15.2812C5.25 14.8438 5.5 14.4375 5.8125 14.125L15.3125 4.625C16.0938 3.84375 17.375 3.84375 18.1562 4.625L19.375 5.84375C19.4688 5.9375 19.5625 6.0625 19.625 6.15625C20.1562 6.9375 20.0625 8 19.375 8.6875L9.875 18.1875C9.84375 18.2188 9.78125 18.25 9.75 18.3125C9.4375 18.5625 9.09375 18.75 8.71875 18.875L6.28125 19.5938L4.9375 20C4.6875 20.0625 4.40625 20 4.21875 19.7812C4 19.5938 3.9375 19.3125 4.03125 19.0625L4.40625 17.7188L5.125 15.2812ZM6.5625 15.7188L6.34375 16.4375L5.84375 18.1562L7.5625 17.6562L8.28125 17.4375C8.5 17.375 8.65625 17.2812 8.8125 17.125L15.9688 9.96875L14.0312 8.03125L6.875 15.1875C6.84375 15.1875 6.84375 15.2188 6.8125 15.25C6.6875 15.375 6.625 15.5312 6.5625 15.7188Z' }), ' '] })),
    penSlash: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M1.39062 2.64062L6.6875 6.76562L10.4844 2.96875C11.0703 2.38281 12.0312 2.38281 12.6172 2.96875L13.5312 3.88281C13.6016 3.95312 13.6719 4.04688 13.7188 4.11719C14.1172 4.70312 14.0469 5.5 13.5312 6.01562L10.0859 9.4375L15.2656 13.5156C15.5234 13.7031 15.5703 14.0547 15.3594 14.2891C15.1719 14.5469 14.8203 14.5938 14.5859 14.3828L0.710938 3.50781C0.453125 3.32031 0.40625 2.96875 0.617188 2.73438C0.804688 2.47656 1.15625 2.42969 1.39062 2.64062ZM7.57812 7.46875L9.19531 8.75781L10.9766 6.97656L9.52344 5.52344L7.57812 7.46875ZM4.15625 10.8906C4.13281 10.8906 4.13281 10.9141 4.10938 10.9375C4.01562 11.0312 3.96875 11.1484 3.92188 11.2891L3.75781 11.8281L3.38281 13.1172L4.67188 12.7422L5.21094 12.5781C5.35156 12.5312 5.49219 12.4609 5.60938 12.3438L7.60156 10.3516L8.49219 11.0547L6.40625 13.1406C6.38281 13.1641 6.33594 13.1875 6.3125 13.2344C6.07812 13.4219 5.82031 13.5625 5.53906 13.6562L3.71094 14.1953L2.70312 14.4766C2.51562 14.5469 2.30469 14.5 2.16406 14.3359C2 14.1953 1.95312 13.9844 2.02344 13.7969L2.30469 12.7891L2.84375 10.9609C2.9375 10.6328 3.125 10.3281 3.35938 10.0938L5.07031 8.38281L5.96094 9.08594L4.15625 10.8906Z' }) })),
    planetRinged: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M18.5 5C18.5 4.96875 18.4688 4.96875 18.4688 4.96875H18.4375V5C18.4375 5.03125 18.4375 5.03125 18.4375 5.03125C18.4688 5.03125 18.4688 5.03125 18.5 5.03125C18.5 5 18.5 5 18.5 5ZM18.3125 5.6875C17.9375 5.8125 17.4688 6.03125 16.9062 6.375C16.5 6 16.0312 5.6875 15.5625 5.4375C17.5625 4.15625 19.125 3.65625 19.7188 4.28125C20.4375 4.96875 19.6562 6.9375 17.9375 9.375C18.2812 10.1875 18.5 11.0625 18.5 12C18.5 15.5938 15.5625 18.5 12 18.5C11.0625 18.5 10.1562 18.3125 9.34375 17.9688C6.90625 19.6875 4.9375 20.4375 4.25 19.75C3.625 19.1562 4.125 17.5938 5.40625 15.5938C5.65625 16.0625 5.96875 16.5312 6.34375 16.9375C6 17.5 5.78125 17.9688 5.65625 18.3438C6.03125 18.2188 6.53125 17.9688 7.15625 17.5938C7.40625 17.4688 7.6875 17.2812 7.9375 17.0938C6.4375 15.9062 5.5 14.0625 5.5 12C5.5 8.4375 8.40625 5.5 12 5.5C14.0625 5.5 15.875 6.46875 17.0938 7.96875C17.25 7.6875 17.4375 7.4375 17.5938 7.1875C17.9375 6.5625 18.1875 6.0625 18.3125 5.6875ZM16.1562 9.25C15.2812 7.90625 13.7188 7 12 7C9.21875 7 7 9.25 7 12C7 13.75 7.875 15.2812 9.21875 16.1875C10.4062 15.3125 11.6562 14.2188 12.9062 12.9375C14.1875 11.6875 15.2812 10.4062 16.1562 9.25ZM10.7812 16.875C11.1875 16.9688 11.5625 17 12 17C14.75 17 17 14.7812 17 12C17 11.5938 16.9375 11.2188 16.8438 10.8125C16 11.8438 15.0625 12.9375 13.9688 14C12.9062 15.0625 11.8125 16.0312 10.7812 16.875ZM4.96875 18.5C4.96875 18.5312 4.96875 18.5312 5 18.5312C5 18.5 5 18.5 5 18.4688C5 18.4688 5 18.4688 4.96875 18.4688H4.9375V18.5C4.9375 18.5 4.9375 18.5312 4.96875 18.5ZM5.46875 19C5.46875 19.0312 5.46875 19.0312 5.46875 19.0625H5.5C5.53125 19.0625 5.53125 19.0625 5.53125 19.0625C5.5625 19.0312 5.5625 19.0312 5.53125 19C5.53125 19 5.53125 19 5.5 19C5.5 19 5.5 19 5.46875 19ZM19 5.5C18.9688 5.53125 18.9688 5.53125 18.9688 5.53125C18.9688 5.5625 18.9688 5.5625 18.9688 5.5625C19 5.59375 19 5.59375 19.0312 5.5625C19.0312 5.5625 19.0312 5.5625 19.0312 5.53125V5.5C19 5.5 19 5.5 19 5.5Z' }) })),
    pin: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M15.58 3.076c-.317.148-.812.79-1.016 1.321-.157.408-.21.729-.2 1.216l.008.407-2.776 2.191c-1.527 1.206-2.87 2.265-2.984 2.354l-.209.162-.402-.143c-1.007-.358-2.011-.411-2.918-.155-.544.153-1.225.556-1.653.978-.354.349-.418.608-.24.973.032.066.925.988 1.983 2.05l1.925 1.929-1.586 1.591c-1.727 1.732-1.669 1.657-1.622 2.072.052.459.572.742 1.021.557.101-.042.645-.557 1.699-1.61l1.55-1.548 1.81 1.808c1.237 1.235 1.857 1.827 1.959 1.869.183.076.432.08.602.008.255-.107.798-.767 1.058-1.286.319-.636.432-1.209.399-2.03-.021-.543-.114-1.045-.266-1.445-.035-.091-.032-.134.013-.2.031-.047 1.082-1.442 2.335-3.1l2.277-3.015.537-.01c.556-.01.729-.045 1.206-.245.317-.133.619-.332.909-.601.353-.327.444-.543.36-.861-.04-.155-.301-.43-2.532-2.667-1.69-1.695-2.538-2.518-2.647-2.569a.67.67 0 00-.6-.001m3.86 5.332c0 .054-.34.121-.606.119-.616-.006-1.236-.331-1.918-1.007-.727-.722-1.045-1.322-1.049-1.98-.001-.176.022-.39.051-.475l.052-.155 1.735 1.735c.954.954 1.735 1.748 1.735 1.763m-4.193-.492c.287.386.841.935 1.253 1.244.176.132.334.24.35.24.017 0 .03.018.03.04 0 .022-.889 1.218-1.975 2.657l-1.974 2.617-.381-.507a12.308 12.308 0 00-2.351-2.385c-.186-.143-.339-.276-.339-.296 0-.02 1.143-.938 2.54-2.04 2.139-1.687 2.546-1.993 2.58-1.939.022.036.142.202.267.369m-8.464 3.886c1.095.193 2.35.94 3.512 2.091 1.688 1.672 2.481 3.448 2.129 4.77-.062.232-.223.617-.259.617-.037 0-7.165-7.135-7.165-7.172 0-.054.42-.229.688-.287a3.27 3.27 0 011.095-.019' }) })),
    plus: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M11.614 3.344c-.28.138-.31.208-.34.789-.015.29-.028 2.005-.03 3.811l-.004 3.284-3.758.021c-3.583.02-3.763.024-3.885.096-.265.155-.388.477-.32.84a.646.646 0 0 0 .327.475c.133.078.221.08 3.883.093l3.746.014.014 3.746c.013 3.696.014 3.749.095 3.887a.708.708 0 0 0 .496.335c.353.057.664-.071.82-.335.081-.138.082-.192.095-3.887l.014-3.746 3.746-.014c3.662-.013 3.75-.015 3.883-.093a.646.646 0 0 0 .327-.475c.068-.363-.055-.685-.32-.84-.122-.072-.302-.076-3.882-.096l-3.754-.021-.013-3.744c-.014-3.673-.016-3.747-.095-3.884-.163-.282-.717-.418-1.045-.256' }) })),
    questionCircle: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.32 2.28A9.74 9.74 0 003.258 7.7c-.46.94-.762 1.914-.924 2.98-.097.636-.097 2.004 0 2.64.446 2.941 2.052 5.409 4.533 6.968 1.075.676 2.441 1.17 3.813 1.378.636.097 2.004.097 2.64 0 2.1-.319 3.932-1.206 5.405-2.618 1.601-1.534 2.6-3.479 2.941-5.728.097-.636.097-2.004 0-2.64-.443-2.919-2.04-5.389-4.49-6.941-.824-.522-2.118-1.053-3.056-1.253a10.872 10.872 0 00-2.8-.206m2 1.578a8.277 8.277 0 014.628 2.435c1.176 1.231 1.913 2.713 2.2 4.423.1.593.1 1.975 0 2.568-.612 3.649-3.463 6.426-7.08 6.895-3.771.489-7.369-1.653-8.767-5.219a9.164 9.164 0 01-.449-1.676c-.1-.593-.1-1.975 0-2.568.299-1.783 1.066-3.282 2.324-4.54 1.389-1.388 2.977-2.138 5.064-2.391.313-.038 1.715.011 2.08.073m-1.88 2.425c-1.257.107-2.4.619-3.2 1.433-.512.52-.843 1.141-.783 1.465.064.338.494.602.952.583.155-.006.356-.2.554-.534.429-.727 1.275-1.244 2.31-1.415a5.172 5.172 0 011.85.078c.89.229 1.646.774 1.963 1.415.165.332.198.795.084 1.156-.194.61-.77 1.164-1.533 1.474a6.26 6.26 0 01-.665.203c-.52.131-.891.315-1.146.57-.395.393-.558.761-.563 1.269-.005.521.226.76.737.76.46 0 .687-.196.745-.642.036-.283.158-.399.499-.476 1.042-.237 1.827-.649 2.479-1.299.708-.708 1.017-1.417 1.009-2.323-.005-.73-.218-1.348-.67-1.949-.589-.784-1.696-1.444-2.797-1.669-.287-.059-1.173-.147-1.365-.135-.044.002-.251.019-.46.036m.359 9.993c-.37.075-.536.299-.538.724-.002.508.236.74.759.74.325 0 .535-.102.65-.314.094-.173.094-.679 0-.852-.129-.24-.514-.371-.871-.298' }) })),
    search: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M9.369 2.283A7.858 7.858 0 005.1 4c-.382.314-1.038.996-1.307 1.361-1.118 1.512-1.669 3.403-1.52 5.209.06.726.164 1.233.391 1.905a7.348 7.348 0 001.773 2.898c.688.706 1.238 1.115 2.079 1.543a7.763 7.763 0 004.054.811 7.259 7.259 0 001.905-.391 7.634 7.634 0 002.158-1.128l.294-.22 2.866 2.863c3.148 3.143 3.007 3.021 3.372 2.912.218-.065.533-.38.598-.598.109-.365.231-.224-2.912-3.372l-2.863-2.866.22-.294c1.104-1.468 1.671-3.412 1.518-5.203a7.384 7.384 0 00-.39-1.905 7.37 7.37 0 00-1.754-2.88c-.702-.724-1.295-1.159-2.162-1.587a7.541 7.541 0 00-2.869-.777c-.577-.044-.579-.044-1.182.002m1.771 1.575c.198.036.575.137.838.225a6.283 6.283 0 014.168 4.802c.098.521.098 1.709 0 2.23a6.723 6.723 0 01-.853 2.195c-.514.808-1.278 1.566-2.04 2.024a6.854 6.854 0 01-2.019.793c-.355.078-.531.091-1.234.091s-.879-.013-1.234-.091a6.842 6.842 0 01-2.019-.793c-.629-.376-1.388-1.088-1.839-1.723a6.706 6.706 0 01-1.055-2.491c-.097-.523-.097-1.713-.001-2.232.488-2.633 2.625-4.69 5.268-5.07.481-.07 1.529-.049 2.02.04' }) })),
    selector: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.74 4.279c-.103.051-.934.855-2.307 2.23-2.359 2.364-2.304 2.298-2.196 2.656.065.218.38.533.598.598.354.106.322.133 2.335-1.876L12 6.062l1.83 1.825c2.013 2.009 1.981 1.982 2.335 1.876.218-.065.533-.38.598-.598.108-.358.163-.292-2.197-2.656-1.422-1.426-2.201-2.178-2.309-2.23-.205-.1-.316-.099-.517 0M7.729 14.285c-.209.103-.435.36-.496.563-.103.344-.151.288 2.24 2.679 2.408 2.407 2.33 2.343 2.697 2.236.148-.043.458-.338 2.357-2.236 2.404-2.404 2.344-2.332 2.236-2.692-.065-.218-.38-.533-.598-.598-.354-.106-.322-.133-2.335 1.876L12 17.938l-1.81-1.807C8.396 14.339 8.237 14.2 7.991 14.2a.8.8 0 00-.262.085' }) })),
    sidebar: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M11 6.5V17.5H18C18.25 17.5 18.5 17.2812 18.5 17V7C18.5 6.75 18.25 6.5 18 6.5H11ZM4 7C4 5.90625 4.875 5 6 5H18C19.0938 5 20 5.90625 20 7V17C20 18.125 19.0938 19 18 19H6C4.875 19 4 18.125 4 17V7ZM6 7.75C6 8.1875 6.3125 8.5 6.75 8.5H8.25C8.65625 8.5 9 8.1875 9 7.75C9 7.34375 8.65625 7 8.25 7H6.75C6.3125 7 6 7.34375 6 7.75ZM6.75 10C6.3125 10 6 10.3438 6 10.75C6 11.1875 6.3125 11.5 6.75 11.5H8.25C8.65625 11.5 9 11.1875 9 10.75C9 10.3438 8.65625 10 8.25 10H6.75ZM6 13.75C6 14.1875 6.3125 14.5 6.75 14.5H8.25C8.65625 14.5 9 14.1875 9 13.75C9 13.3438 8.65625 13 8.25 13H6.75C6.3125 13 6 13.3438 6 13.75Z' }) })),
    sink: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M12.75 6.75V13H15V12.25C15 11.3125 15.7812 10.5 16.75 10.5H18.5C18.9062 10.5 19.25 10.8438 19.25 11.25C19.25 11.6875 18.9062 12 18.5 12H16.75C16.5938 12 16.5 12.125 16.5 12.25V13H19.25C19.6562 13 20 13.3438 20 13.75C20 14.1875 19.6562 14.5 19.25 14.5H12H4.75C4.3125 14.5 4 14.1875 4 13.75C4 13.3438 4.3125 13 4.75 13H7.5V12.25C7.5 12.125 7.375 12 7.25 12H5.75C5.3125 12 5 11.6875 5 11.25C5 10.8438 5.3125 10.5 5.75 10.5H7.25C8.1875 10.5 9 11.3125 9 12.25V13H11.25V6.75C11.25 5.25 12.4688 4 14 4C15.5 4 16.75 5.25 16.75 6.75V7.5C16.75 7.9375 16.4062 8.25 16 8.25C15.5625 8.25 15.25 7.9375 15.25 7.5V6.75C15.25 6.0625 14.6875 5.5 14 5.5C13.2812 5.5 12.75 6.0625 12.75 6.75ZM5 15.5H6.5V16.25C6.5 17.5 7.5 18.5 8.75 18.5H15.25C16.4688 18.5 17.5 17.5 17.5 16.25V15.5H19V16.25C19 18.3438 17.3125 20 15.25 20H8.75C6.65625 20 5 18.3438 5 16.25V15.5Z' }) })),
    spaceShip: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M6.39551 9.50391L5.93066 9.94141C5.82129 9.83203 5.7666 9.69531 5.73926 9.55859C5.73926 9.39453 5.71191 9.23047 5.73926 9.09375C4.8916 9.3125 4.23535 9.61328 3.74316 9.94141C3.08691 10.4062 2.89551 10.7891 2.89551 11.0898C2.89551 11.3086 2.97754 11.582 3.30566 11.8828C3.63379 12.2109 4.15332 12.5117 4.83691 12.7852C6.2041 13.332 8.14551 13.6875 10.333 13.6875C12.4932 13.6875 14.4346 13.332 15.8018 12.7852C16.4854 12.5117 16.9775 12.2109 17.3057 11.8828C17.6338 11.582 17.7432 11.3086 17.7432 11.0898C17.7432 10.7891 17.5518 10.4062 16.8955 9.94141C16.4033 9.61328 15.7197 9.3125 14.8994 9.09375C14.8994 9.23047 14.8994 9.39453 14.8994 9.55859C14.8721 9.69531 14.8174 9.83203 14.708 9.94141L14.2432 9.50391C14.708 9.94141 14.708 9.94141 14.708 9.94141V9.96875H14.6807C14.6807 9.99609 14.6533 10.0234 14.626 10.0508C14.5713 10.0781 14.5166 10.1328 14.4072 10.2148C14.2432 10.3516 13.9697 10.5156 13.6143 10.6797C12.9033 10.9805 11.8369 11.3086 10.3057 11.3086C8.80176 11.3086 7.73535 10.9805 7.02441 10.6797C6.66895 10.5156 6.39551 10.3516 6.23145 10.2148C6.12207 10.1328 6.06738 10.0781 6.0127 10.0508C5.98535 10.0234 5.95801 9.99609 5.95801 9.96875C5.93066 9.96875 5.93066 9.96875 5.93066 9.96875V9.94141C5.93066 9.94141 5.93066 9.94141 6.39551 9.50391ZM14.6807 7.67188C15.8564 7.94531 16.8682 8.35547 17.6338 8.875C18.4268 9.39453 19.083 10.1602 19.083 11.0898C19.083 11.7734 18.7275 12.375 18.2354 12.8398C17.7432 13.3047 17.0596 13.6875 16.2939 14.0156C14.7354 14.6445 12.6299 15 10.333 15C8.03613 15 5.90332 14.6445 4.34473 14.0156C3.5791 13.6875 2.89551 13.3047 2.40332 12.8398C1.91113 12.375 1.58301 11.7734 1.58301 11.0898C1.58301 10.1602 2.21191 9.39453 3.00488 8.875C3.77051 8.35547 4.78223 7.94531 5.95801 7.67188C6.58691 5.78516 8.33691 4.5 10.333 4.5C12.3018 4.5 14.0518 5.78516 14.6807 7.67188ZM13.6143 9.17578C13.6143 7.26172 12.1104 5.8125 10.333 5.8125C8.55566 5.8125 7.02441 7.26172 7.05176 9.17578C7.16113 9.25781 7.3252 9.36719 7.57129 9.47656C8.09082 9.72266 8.99316 9.99609 10.333 9.99609C11.6455 9.99609 12.5479 9.72266 13.0674 9.47656C13.3135 9.36719 13.4775 9.25781 13.6143 9.17578ZM5.73926 11.2812C5.73926 11.6641 5.43848 11.9375 5.08301 11.9375C4.7002 11.9375 4.42676 11.6641 4.42676 11.2812C4.42676 10.9258 4.7002 10.625 5.08301 10.625C5.43848 10.625 5.73926 10.9258 5.73926 11.2812ZM10.9893 12.375C10.9893 12.7578 10.6885 13.0312 10.333 13.0312C9.9502 13.0312 9.67676 12.7578 9.67676 12.375C9.67676 12.0195 9.9502 11.7188 10.333 11.7188C10.6885 11.7188 10.9893 12.0195 10.9893 12.375ZM15.583 11.9375C15.2002 11.9375 14.9268 11.6641 14.9268 11.2812C14.9268 10.9258 15.2002 10.625 15.583 10.625C15.9385 10.625 16.2393 10.9258 16.2393 11.2812C16.2393 11.6641 15.9385 11.9375 15.583 11.9375Z' }) })),
    sparkles: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M4.799 2.276c-.212.043-.39.165-.468.322-.059.117-.073.273-.084.888l-.013.745-.747.015c-.7.014-.758.021-.916.111-.221.126-.308.307-.31.643-.001.332.101.542.322.657.139.074.242.084.904.096l.747.013.013.747c.015.863.054.997.336 1.144.216.114.618.114.834 0 .282-.147.321-.281.336-1.144l.013-.747.747-.013c.662-.012.765-.022.904-.096.221-.115.323-.325.322-.657-.002-.336-.089-.517-.31-.643-.158-.09-.216-.097-.916-.111l-.747-.015-.013-.745c-.015-.85-.049-.974-.304-1.115a1.077 1.077 0 00-.65-.095m7.813.042a.765.765 0 00-.2.187c-.04.059-.576 1.611-1.192 3.447L10.1 9.291l-2.754 1.031c-1.759.658-2.79 1.065-2.855 1.124-.335.309-.33.915.008 1.137.057.037 1.34.531 2.852 1.097l2.749 1.029 1.122 3.351c1.071 3.197 1.129 3.356 1.267 3.482.336.308.878.285 1.099-.047.04-.059.576-1.611 1.192-3.447l1.12-3.339 2.76-1.033c2.481-.928 2.773-1.047 2.887-1.171.204-.221.276-.627.154-.864a.717.717 0 00-.187-.205c-.07-.05-1.362-.553-2.871-1.118L15.9 9.291l-1.12-3.343c-1.225-3.656-1.169-3.522-1.533-3.646-.246-.084-.48-.078-.635.016m1.203 5.507c.692 2.078.812 2.405.928 2.533.121.134.296.208 2.094.881 1.08.404 1.963.747 1.963.761 0 .014-.832.337-1.85.718a72.392 72.392 0 00-1.995.766.915.915 0 00-.246.193c-.073.086-.33.805-.895 2.502-.436 1.309-.803 2.381-.814 2.381-.011 0-.378-1.072-.814-2.381-.565-1.697-.822-2.416-.895-2.502a.915.915 0 00-.246-.193c-.08-.041-.977-.385-1.995-.766-1.017-.381-1.85-.704-1.85-.718 0-.014.883-.357 1.963-.761 1.798-.673 1.973-.747 2.094-.881.116-.128.236-.455.928-2.533.437-1.312.804-2.385.815-2.385.011 0 .378 1.073.815 2.385m-8.016 8.451c-.212.043-.39.165-.468.322-.059.117-.073.273-.084.888l-.013.745-.747.015c-.7.014-.758.021-.916.111-.221.126-.308.307-.31.643-.001.332.101.542.322.657.139.074.242.084.904.096l.747.013.013.747c.012.662.022.765.096.904.115.22.325.323.657.323s.542-.103.657-.323c.074-.139.084-.242.096-.904l.013-.747.747-.013c.662-.012.765-.022.904-.096.221-.115.323-.325.322-.657-.002-.336-.089-.517-.31-.643-.158-.09-.216-.097-.916-.111l-.747-.015-.013-.745c-.015-.85-.049-.974-.304-1.115a1.077 1.077 0 00-.65-.095' }) })),
    table: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M4.617 5.283c-.583.068-1.098.327-1.552.781a2.742 2.742 0 00-.696 1.116l-.109.32v9l.109.32c.151.445.362.783.695 1.116.333.333.671.544 1.116.695l.32.109h15l.32-.109a2.736 2.736 0 001.116-.695c.333-.333.544-.671.695-1.116l.109-.32v-9l-.109-.32a2.742 2.742 0 00-.696-1.116c-.472-.471-.961-.709-1.606-.783-.426-.049-14.293-.047-14.712.002m14.911 1.59c.239.118.481.36.599.599.086.174.094.247.105.978l.013.79H3.76v-.735c0-.806.027-.948.236-1.233.14-.19.38-.373.59-.45.131-.048 1.254-.056 7.454-.049l7.3.007.188.093M11.24 12v1.24H3.76v-2.48h7.48V12m9 0v1.24h-7.48v-2.48h7.48V12m-9 4v1.24H8.002c-3.15 0-3.245-.002-3.455-.081-.258-.096-.542-.362-.674-.63-.086-.175-.094-.246-.105-.979l-.013-.79H11.24V16m8.992-.45c-.011.733-.019.804-.105.979-.132.268-.416.534-.674.63-.21.079-.305.081-3.455.081H12.76v-2.48H20.245l-.013.79' }) })),
    tableDot: (domProps) => (jsxs("svg", { ...baseSvgProps, ...domProps, children: [jsx("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M16.0558 5.25049C16.019 5.49498 16 5.74526 16 6C16 6.2642 16.0205 6.52361 16.06 6.77674L12.04 6.77288C5.84001 6.76588 4.71701 6.77388 4.58601 6.82188C4.37601 6.89888 4.13601 7.08188 3.99601 7.27188C3.78701 7.55688 3.76001 7.69888 3.76001 8.50488V9.23988H17.1916C17.7867 9.93874 18.5707 10.4717 19.4647 10.7599H12.76V13.2399H20.24V11.9999V10.9426C20.4878 10.9804 20.7416 11 21 11C21.2514 11 21.4985 10.9814 21.74 10.9456V16.4999L21.631 16.8199C21.48 17.2649 21.269 17.6029 20.936 17.9359C20.626 18.2548 20.243 18.4934 19.82 18.6309L19.5 18.7399H4.50001L4.18001 18.6309C3.73501 18.4799 3.39701 18.2689 3.06401 17.9359C2.73101 17.6029 2.52001 17.2649 2.36901 16.8199L2.26001 16.4999V7.49988L2.36901 7.17988C2.50703 6.75693 2.74591 6.37391 3.06501 6.06388C3.51901 5.60988 4.03401 5.35088 4.61701 5.28288C4.91062 5.24855 11.8075 5.23729 16.0558 5.25049ZM11.24 13.2399V11.9999V10.7599H3.76001V13.2399H11.24ZM11.24 17.2399V15.9999V14.7599H3.75501L3.76801 15.5499C3.77901 16.2829 3.78701 16.3539 3.87301 16.5289C4.00501 16.7969 4.28901 17.0629 4.54701 17.1589C4.75701 17.2379 4.85201 17.2399 8.00201 17.2399H11.24ZM20.127 16.5289C20.213 16.3539 20.221 16.2829 20.232 15.5499L20.245 14.7599H12.76V17.2399H15.998C19.148 17.2399 19.243 17.2379 19.453 17.1589C19.711 17.0629 19.995 16.7969 20.127 16.5289Z' }), jsx("path", { d: 'M18 6C18 4.34315 19.3431 3 21 3V3C22.6569 3 24 4.34315 24 6V6C24 7.65685 22.6569 9 21 9V9C19.3431 9 18 7.65685 18 6V6Z', className: 'table-dot-dot' })] })),
    trash: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M9.701 2.285c-.332.048-.638.212-.925.495-.483.477-.534.695-.535 2.288L8.24 6.236l-2.25.012-2.25.012-.169.097c-.221.126-.308.308-.31.643-.002.495.208.706.749.754l.289.026.406 5.72c.251 3.543.431 5.849.473 6.06.196 1 .967 1.818 1.983 2.106.245.07.514.074 4.819.074 3.731 0 4.6-.01 4.78-.055 1.031-.257 1.826-1.056 2.053-2.065.041-.178.213-2.382.475-6.065l.412-5.786.285-.018c.537-.035.756-.252.754-.751-.002-.335-.089-.517-.31-.643l-.169-.097-2.25-.012-2.25-.012-.001-1.168c-.001-1.593-.052-1.811-.535-2.288-.296-.292-.592-.445-.964-.498-.342-.049-4.22-.047-4.559.003m4.466 1.541c.068.061.073.154.073 1.24V6.24H9.76V5.073c0-1.029.008-1.175.066-1.24.063-.069.183-.073 2.167-.073 1.899 0 2.108.006 2.174.066m4.009 4.124c-.01.105-.198 2.706-.417 5.78l-.397 5.59-.108.222c-.12.245-.32.446-.582.586l-.172.092h-9l-.172-.092a1.327 1.327 0 01-.583-.589l-.111-.226-.394-5.546c-.217-3.051-.405-5.65-.417-5.777l-.022-.23h12.395l-.02.19m-8.377 2.326c-.212.043-.39.165-.468.322-.066.132-.071.366-.071 3.402 0 3.216.001 3.262.083 3.417.115.22.325.323.657.323s.542-.103.657-.323c.082-.155.083-.201.083-3.417 0-3.05-.005-3.269-.071-3.403-.123-.246-.516-.391-.87-.321m4 0c-.212.043-.39.165-.468.322-.066.132-.071.366-.071 3.402 0 3.216.001 3.262.083 3.417.115.22.325.323.657.323s.542-.103.657-.323c.082-.155.083-.201.083-3.417 0-3.05-.005-3.269-.071-3.403-.123-.246-.516-.391-.87-.321' }) })),
    truck: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M13 5.5H6C5.71875 5.5 5.5 5.75 5.5 6V7H9.5C9.75 7 10 7.25 10 7.5C10 7.78125 9.75 8 9.5 8H2.5C2.21875 8 2 7.78125 2 7.5C2 7.25 2.21875 7 2.5 7H4V6C4 4.90625 4.875 4 6 4H13C14.0938 4 15 4.90625 15 6V7H16.3125C16.7812 7 17.2188 7.1875 17.5625 7.53125L20.4688 10.4375C20.8125 10.7812 21 11.2188 21 11.6875V15.5H21.25C21.6562 15.5 22 15.8438 22 16.25C22 16.6875 21.6562 17 21.25 17H20C20 18.6562 18.6562 20 17 20C15.3438 20 14 18.6562 14 17H13.75H13H12H10C10 18.6562 8.65625 20 7 20C5.34375 20 4 18.6562 4 17V15.5V13H5.5V14.4062C5.9375 14.1562 6.4375 14 7 14C8.09375 14 9.0625 14.625 9.59375 15.5H12H13C13.25 15.5 13.5 15.2812 13.5 15V6C13.5 5.75 13.25 5.5 13 5.5ZM19.4062 11.5L16.5 8.59375C16.4375 8.53125 16.375 8.5 16.3125 8.5H15V11.5H19.4375H19.4062ZM8.5 17C8.5 16.4688 8.1875 16 7.75 15.7188C7.28125 15.4375 6.6875 15.4375 6.25 15.7188C5.78125 16 5.5 16.4688 5.5 17C5.5 17.5625 5.78125 18.0312 6.25 18.3125C6.6875 18.5938 7.28125 18.5938 7.75 18.3125C8.1875 18.0312 8.5 17.5625 8.5 17ZM17 18.5C17.5312 18.5 18 18.2188 18.2812 17.75C18.5625 17.3125 18.5625 16.7188 18.2812 16.25C18 15.8125 17.5312 15.5 17 15.5C16.4375 15.5 15.9688 15.8125 15.6875 16.25C15.4062 16.7188 15.4062 17.3125 15.6875 17.75C15.9688 18.2188 16.4375 18.5 17 18.5ZM3.5 9H10.5C10.75 9 11 9.25 11 9.5C11 9.78125 10.75 10 10.5 10H3.5C3.21875 10 3 9.78125 3 9.5C3 9.25 3.21875 9 3.5 9ZM2.5 11H9.5C9.75 11 10 11.25 10 11.5C10 11.7812 9.75 12 9.5 12H2.5C2.21875 12 2 11.7812 2 11.5C2 11.25 2.21875 11 2.5 11Z' }) })),
    ufo: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M7.5 11.7188L6.96875 12.2188C6.84375 12.0938 6.78125 11.9375 6.75 11.7812C6.75 11.5938 6.71875 11.4062 6.75 11.25C5.78125 11.5 5.03125 11.8438 4.46875 12.2188C3.71875 12.75 3.5 13.1875 3.5 13.5312C3.5 13.7812 3.59375 14.0938 3.96875 14.4375C4.34375 14.8125 4.9375 15.1562 5.71875 15.4688C7.28125 16.0938 9.5 16.5 12 16.5C14.4688 16.5 16.6875 16.0938 18.25 15.4688C19.0312 15.1562 19.5938 14.8125 19.9688 14.4375C20.3438 14.0938 20.4688 13.7812 20.4688 13.5312C20.4688 13.1875 20.25 12.75 19.5 12.2188C18.9375 11.8438 18.1562 11.5 17.2188 11.25C17.2188 11.4062 17.2188 11.5938 17.2188 11.7812C17.1875 11.9375 17.125 12.0938 17 12.2188L16.4688 11.7188C17 12.2188 17 12.2188 17 12.2188V12.25H16.9688C16.9688 12.2812 16.9375 12.3125 16.9062 12.3438C16.8438 12.375 16.7812 12.4375 16.6562 12.5312C16.4688 12.6875 16.1562 12.875 15.75 13.0625C14.9375 13.4062 13.7188 13.7812 11.9688 13.7812C10.25 13.7812 9.03125 13.4062 8.21875 13.0625C7.8125 12.875 7.5 12.6875 7.3125 12.5312C7.1875 12.4375 7.125 12.375 7.0625 12.3438C7.03125 12.3125 7 12.2812 7 12.25C6.96875 12.25 6.96875 12.25 6.96875 12.25V12.2188C6.96875 12.2188 6.96875 12.2188 7.5 11.7188ZM16.9688 9.625C18.3125 9.9375 19.4688 10.4062 20.3438 11C21.25 11.5938 22 12.4688 22 13.5312C22 14.3125 21.5938 15 21.0312 15.5312C20.4688 16.0625 19.6875 16.5 18.8125 16.875C17.0312 17.5938 14.625 18 12 18C9.375 18 6.9375 17.5938 5.15625 16.875C4.28125 16.5 3.5 16.0625 2.9375 15.5312C2.375 15 2 14.3125 2 13.5312C2 12.4688 2.71875 11.5938 3.625 11C4.5 10.4062 5.65625 9.9375 7 9.625C7.71875 7.46875 9.71875 6 12 6C14.25 6 16.25 7.46875 16.9688 9.625ZM15.75 11.3438C15.75 9.15625 14.0312 7.5 12 7.5C9.96875 7.5 8.21875 9.15625 8.25 11.3438C8.375 11.4375 8.5625 11.5625 8.84375 11.6875C9.4375 11.9688 10.4688 12.2812 12 12.2812C13.5 12.2812 14.5312 11.9688 15.125 11.6875C15.4062 11.5625 15.5938 11.4375 15.75 11.3438ZM6.75 13.75C6.75 14.1875 6.40625 14.5 6 14.5C5.5625 14.5 5.25 14.1875 5.25 13.75C5.25 13.3438 5.5625 13 6 13C6.40625 13 6.75 13.3438 6.75 13.75ZM12.75 15C12.75 15.4375 12.4062 15.75 12 15.75C11.5625 15.75 11.25 15.4375 11.25 15C11.25 14.5938 11.5625 14.25 12 14.25C12.4062 14.25 12.75 14.5938 12.75 15ZM18 14.5C17.5625 14.5 17.25 14.1875 17.25 13.75C17.25 13.3438 17.5625 13 18 13C18.4062 13 18.75 13.3438 18.75 13.75C18.75 14.1875 18.4062 14.5 18 14.5Z' }) })),
    upload: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.646 3.323c-.135.068-.246.143-.246.168 0 .024-.925.972-2.056 2.107-2.26 2.267-2.214 2.21-2.107 2.567.065.218.38.533.598.598.347.104.357.097 1.954-1.495l1.45-1.444.01 5.218c.011 5.185.012 5.219.094 5.375.115.22.325.323.657.323s.542-.103.657-.323c.082-.156.083-.19.094-5.375l.01-5.218 1.45 1.444c1.597 1.592 1.607 1.599 1.954 1.495.218-.065.533-.38.598-.598.107-.357.153-.3-2.107-2.567C13.525 4.463 12.6 3.515 12.6 3.491c0-.063-.471-.291-.6-.291-.059 0-.218.055-.354.123M3.799 15.276c-.212.043-.39.165-.468.322-.061.123-.071.26-.071 1.002 0 .962.042 1.233.281 1.83a3.802 3.802 0 002.029 2.029c.746.299.333.281 6.43.281 6.097 0 5.684.018 6.43-.281a3.802 3.802 0 002.029-2.029c.239-.597.281-.868.281-1.83 0-.989-.022-1.079-.307-1.239-.232-.13-.634-.13-.866 0-.276.155-.301.251-.331 1.259-.015.502-.047.949-.075 1.04-.151.495-.64 1.084-1.101 1.327-.507.267-.177.253-6.06.253s-5.553.014-6.06-.253c-.461-.243-.95-.832-1.101-1.327-.028-.091-.06-.538-.075-1.04-.029-.996-.057-1.106-.315-1.249a1.077 1.077 0 00-.65-.095' }) })),
    user: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.544 2.283C9.6 2.455 7.927 3.872 7.417 5.779A4.736 4.736 0 008.034 9.6c.286.441.925 1.08 1.366 1.366a4.73 4.73 0 005.2 0c.441-.286 1.08-.925 1.366-1.366 1.211-1.871.99-4.275-.541-5.871a4.626 4.626 0 00-3.029-1.448 8.87 8.87 0 00-.476-.035c-.011.003-.18.019-.376.037m1.37 1.595c.508.146.893.372 1.321.78.446.425.733.89.894 1.45.129.45.129 1.334 0 1.784-.167.582-.458 1.042-.941 1.492-.633.588-1.319.856-2.188.856-.869 0-1.555-.268-2.188-.856-.483-.45-.774-.91-.941-1.492-.129-.45-.129-1.334 0-1.784.152-.53.375-.91.787-1.343a3.113 3.113 0 011.775-.967c.321-.058 1.152-.013 1.481.08m-1.545 9.405A7.858 7.858 0 007.1 15a8.533 8.533 0 00-1.695 1.932 8.499 8.499 0 00-1.003 2.528c-.125.611-.187 1.484-.126 1.758.061.273.21.434.459.497.131.033 2.121.045 7.265.045s7.134-.012 7.265-.045c.428-.108.536-.409.461-1.289a7.38 7.38 0 00-.39-1.901 7.37 7.37 0 00-1.754-2.88c-.702-.724-1.295-1.159-2.162-1.587a7.541 7.541 0 00-2.869-.777c-.577-.044-.579-.044-1.182.002m1.771 1.575c1.892.343 3.574 1.62 4.465 3.391.192.382.448 1.138.513 1.512.024.142.054.309.066.369l.022.11H5.796l.024-.15c.407-2.527 2.207-4.513 4.67-5.153.702-.182 1.884-.217 2.65-.079' }) })),
    userAdd: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M9.22 2.286a4.566 4.566 0 0 0-2.467 1.048c-.748.641-1.22 1.401-1.481 2.385-.099.375-.141 1.298-.078 1.704.42 2.689 3.032 4.41 5.64 3.716a4.404 4.404 0 0 0 1.956-1.113c.754-.724 1.164-1.51 1.346-2.583.115-.679.059-1.315-.185-2.083a3.946 3.946 0 0 0-.979-1.645c-.772-.812-1.675-1.273-2.766-1.412-.538-.069-.523-.068-.986-.017m1.22 1.571c.331.09.912.394 1.16.606.45.385.776.892.966 1.499.121.388.131 1.191.018 1.598-.244.889-.985 1.714-1.834 2.041-.636.246-1.537.25-2.154.01A3.14 3.14 0 0 1 6.734 7.52c-.099-.373-.089-1.118.021-1.531a2.7 2.7 0 0 1 .749-1.283c.53-.532.942-.762 1.596-.89.338-.066 1.023-.045 1.34.041m7.425 4.104c-.139.042-.289.176-.378.339-.056.102-.068.299-.08 1.287l-.014 1.168-1.167.012c-1.081.012-1.176.019-1.302.093-.248.146-.304.264-.304.64 0 .362.045.465.275.638.105.078.172.083 1.308.095l1.197.012.003 1.008c.003 1.124.027 1.379.142 1.538.293.402 1.064.372 1.275-.051.073-.147.081-.255.093-1.326l.013-1.166 1.214-.014c1.151-.013 1.22-.018 1.324-.096.383-.286.366-1.046-.028-1.278-.126-.074-.222-.081-1.326-.094l-1.19-.014-.003-1.026c-.004-1.296-.019-1.418-.207-1.589a.893.893 0 0 0-.845-.176m-8.824 4.722a6.436 6.436 0 0 0-4.185 2.147c-1.137 1.292-1.66 2.853-1.608 4.79.021.772.061.888.346 1.028l.186.091 4.9.012c2.695.007 5.381-.001 5.968-.019l1.068-.032.136-.132c.197-.191.228-.346.228-1.124 0-1.125-.115-1.844-.426-2.66a6.488 6.488 0 0 0-3.302-3.541 6.518 6.518 0 0 0-3.311-.56m1.105 1.517c1.14.087 2.137.556 2.974 1.398.877.882 1.37 1.971 1.428 3.152l.024.49H4.76v-.178c0-.355.091-1.009.187-1.342a5.934 5.934 0 0 1 .7-1.469c.742-1.081 2.115-1.92 3.353-2.049.442-.046.567-.046 1.146-.002' }) })),
    userGroup: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.595 3.282c-.46.05-.773.142-1.215.357-1.06.514-1.74 1.36-2.03 2.521a4.03 4.03 0 000 1.68c.183.733.493 1.287 1.008 1.802.73.73 1.606 1.092 2.642 1.092 1.036 0 1.912-.362 2.642-1.092.73-.73 1.092-1.606 1.092-2.642 0-1.589-.926-2.924-2.441-3.515-.441-.173-1.171-.26-1.698-.203m.961 1.54c.378.089.707.281 1.024.598.454.454.659.945.659 1.58 0 .635-.205 1.126-.659 1.58-.456.456-.944.66-1.58.66-.636 0-1.124-.204-1.58-.66-.454-.454-.659-.945-.659-1.58 0-.635.205-1.126.659-1.58.31-.31.646-.509 1.005-.597a2.87 2.87 0 011.131-.001M4.617 7.283c-.585.069-1.098.328-1.552.781a2.687 2.687 0 00-.693 1.116c-.091.277-.105.387-.105.82 0 .433.014.543.105.82.146.44.357.781.692 1.116.335.335.676.546 1.116.692.277.091.387.105.82.105.433 0 .543-.014.82-.105.44-.146.781-.357 1.116-.692.335-.335.546-.676.692-1.116.091-.277.105-.387.105-.82 0-.432-.014-.543-.105-.82-.425-1.294-1.642-2.06-3.011-1.897m14 0c-.585.069-1.098.328-1.552.781a2.687 2.687 0 00-.693 1.116c-.091.277-.105.387-.105.82 0 .433.014.543.105.82.146.44.357.781.692 1.116.335.335.676.546 1.116.692.277.091.387.105.82.105.433 0 .543-.014.82-.105.44-.146.781-.357 1.116-.692.335-.335.546-.676.692-1.116.091-.277.105-.387.105-.82 0-.432-.014-.543-.105-.82-.425-1.294-1.642-2.06-3.011-1.897M5.528 8.873c.239.117.481.359.599.599.133.27.133.787 0 1.057-.464.943-1.795.943-2.252 0a1.425 1.425 0 01-.074-.871c.097-.348.43-.703.785-.838.232-.088.708-.061.942.053m14 0c.239.117.481.359.599.599.133.27.133.787 0 1.057-.464.943-1.795.943-2.252 0a1.425 1.425 0 01-.074-.871c.097-.348.43-.703.785-.838.232-.088.708-.061.942.053M11.5 12.281a5.396 5.396 0 00-2 .547 5.898 5.898 0 00-2.207 1.864l-.147.208-.446-.223c-.685-.344-1.343-.469-2.065-.394a3.21 3.21 0 00-1.255.356c-1.073.52-1.771 1.402-2.046 2.581-.064.279-.074.495-.074 1.68 0 1.297.004 1.367.083 1.517a.59.59 0 00.24.24l.157.083h20.52l.157-.083a.59.59 0 00.24-.24c.079-.15.083-.22.083-1.517 0-1.185-.01-1.401-.074-1.68-.275-1.179-.973-2.061-2.046-2.581a3.21 3.21 0 00-1.255-.356c-.722-.075-1.38.05-2.065.394l-.446.223-.147-.208c-.872-1.23-2.299-2.131-3.718-2.349-.5-.076-1.055-.1-1.489-.062m1.52 1.593c.867.218 1.714.755 2.26 1.433.244.304.56.814.56.904 0 .023.046.138.102.257.224.473.268.753.288 1.802l.018.97H7.752l.018-.97c.02-1.049.064-1.329.288-1.802.056-.119.102-.235.102-.258 0-.078.284-.547.511-.845.589-.771 1.555-1.354 2.559-1.544.433-.082 1.36-.055 1.79.053m-7.249 2.02c.3.114.709.368.709.44 0 .025-.035.192-.078.37-.111.462-.162 1.041-.162 1.84v.696H2.76l.001-.77c0-1.146.117-1.508.659-2.05.492-.493.947-.669 1.66-.644.329.012.479.037.691.118m13.785-.072c.378.089.707.281 1.024.598.542.542.659.904.659 2.05l.001.77h-3.48v-.696c0-.808-.052-1.398-.162-1.831a3.09 3.09 0 01-.078-.366c0-.128.639-.47 1.02-.546a2.943 2.943 0 011.016.021' }) })),
    userRemove: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M8.72 2.266c-.785.083-1.392.258-1.951.56-2.065 1.117-3.011 3.531-2.244 5.725.254.728.57 1.215 1.18 1.822A4.526 4.526 0 0 0 9 11.733c1.3 0 2.394-.459 3.334-1.399.935-.936 1.397-2.036 1.398-3.334 0-1.282-.473-2.421-1.391-3.342a4.599 4.599 0 0 0-1.991-1.194c-.466-.135-1.287-.235-1.63-.198m.999 1.579c1.081.163 2.238 1.314 2.44 2.429.064.351.057 1.177-.013 1.509-.208.994-1.106 1.96-2.14 2.304-.368.122-.415.128-1.006.128s-.638-.006-1.006-.128c-1.024-.34-1.907-1.28-2.138-2.277-.082-.355-.08-1.273.004-1.634.224-.97 1.125-1.934 2.101-2.252.496-.161 1.048-.186 1.758-.079m5.834 7.431c-.839.022-.916.03-1.02.108-.191.142-.26.306-.262.613-.002.318.075.49.28.628.117.079.202.089.99.115a118.1 118.1 0 0 0 3.292.013c2.326-.015 2.437-.02 2.565-.095a.85.85 0 0 0 .212-.183c.168-.226.168-.724 0-.95-.182-.244-.084-.235-2.73-.255a151.486 151.486 0 0 0-3.327.006m-7.567 2.067a6.746 6.746 0 0 0-2.793 1.104C3.685 15.49 2.71 17 2.36 18.832c-.073.379-.088.613-.093 1.44-.007.923-.002.997.073 1.124.176.299.183.3 1.393.336.598.017 3.427.026 6.287.019 5.088-.012 5.203-.014 5.359-.092.259-.128.329-.274.36-.749.034-.527-.037-1.842-.121-2.23-.319-1.476-1.106-2.829-2.175-3.74-1.069-.911-2.247-1.438-3.616-1.619-.429-.056-1.412-.045-1.841.022m2.094 1.536c1.515.309 2.875 1.357 3.594 2.77.336.66.507 1.317.552 2.121l.026.47H3.76v-.271c0-.854.257-1.807.688-2.549a5.282 5.282 0 0 1 3.892-2.617c.426-.059 1.257-.022 1.74.076' }) })),
    userSecret: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M12 4.5C12.1875 4.5 12.3125 4.4375 12.4688 4.3125C12.6875 4.1875 12.9375 4 13.5 4C14.4375 4 15.125 5.375 15.5625 6.8125C17.0312 7.09375 18 7.53125 18 8C18 8.4375 17.2812 8.8125 16.1875 9.09375C16.2188 9.3125 16.25 9.53125 16.25 9.75C16.25 10.1875 16.1562 10.625 16.0625 11H17.5625C17.8125 11 18 11.1875 18 11.4375C18 11.5 17.9688 11.5312 17.9688 11.5938L16.75 14.625C18.0938 15.625 19 17.25 19 19.0938C19 19.5938 18.5625 20 18.0625 20H13.75H10.25H5.90625C5.40625 20 5 19.5938 5 19.0938C5 17.25 5.875 15.625 7.21875 14.625L6.03125 11.5938C6 11.5312 6 11.5 6 11.4375C6 11.1875 6.1875 11 6.40625 11H7.9375C7.8125 10.625 7.75 10.1875 7.75 9.75C7.75 9.53125 7.75 9.3125 7.78125 9.09375C6.6875 8.8125 6 8.4375 6 8C6 7.53125 6.9375 7.09375 8.4375 6.8125C8.875 5.375 9.53125 4 10.5 4C11.0625 4 11.2812 4.1875 11.5 4.3125C11.6562 4.4375 11.7812 4.5 12 4.5ZM13.375 18.5H17.4375C17.2812 17.4062 16.6875 16.4688 15.8438 15.8125C15.3125 15.4062 15.0938 14.6875 15.3438 14.0625L15.9688 12.5H15.2188C14.6875 13.125 14 13.5938 13.1875 13.8438L12.6875 14.6562C12.5625 14.875 12.5312 15.1562 12.5938 15.4062L13.375 18.5ZM10.7812 13.8438C9.96875 13.5938 9.28125 13.125 8.75 12.5H8L8.625 14.0625C8.875 14.6875 8.65625 15.4062 8.125 15.8125C7.28125 16.4688 6.6875 17.4062 6.53125 18.5H10.625L11.375 15.4062C11.4375 15.1562 11.4062 14.875 11.2812 14.6562L10.7812 13.8438ZM12 12.5C13.1875 12.5 14.1875 11.75 14.5625 10.6875C14.3438 10.9062 14.0625 11 13.75 11H13.3438C12.8438 11 12.375 10.6875 12.2188 10.1875C12.125 9.96875 11.8438 9.96875 11.75 10.1875C11.5938 10.6875 11.125 11 10.625 11H10.25C9.90625 11 9.625 10.9062 9.40625 10.6875C9.78125 11.75 10.7812 12.5 12 12.5Z' }) })),
    wandSparkles: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { d: 'M18.2188 5.5625L5.625 16.9688C5.53125 17.0625 5.5 17.1562 5.5 17.2812C5.5 17.4062 5.53125 17.5 5.59375 17.5625L6.4375 18.4062C6.5 18.4688 6.59375 18.5 6.71875 18.5C6.84375 18.5 6.9375 18.4688 7.03125 18.375L18.4375 5.78125C18.4688 5.75 18.5 5.71875 18.5 5.65625C18.5 5.59375 18.4062 5.5 18.3438 5.5C18.3125 5.5 18.25 5.53125 18.2188 5.5625ZM18.3438 4C19.25 4 20 4.75 20 5.65625C20 6.0625 19.8438 6.46875 19.5625 6.78125L18.125 8.375C18.0312 8.46875 18 8.59375 18 8.71875V9.5C18 9.78125 17.75 10 17.5 10H16.8438C16.7188 10 16.5625 10.0625 16.4688 10.1875L8.125 19.375C7.78125 19.7812 7.25 20 6.71875 20C6.21875 20 5.71875 19.8125 5.375 19.4375L4.5625 18.625C4.1875 18.2812 4 17.7812 4 17.2812C4 16.75 4.21875 16.2188 4.625 15.875L6.8125 13.875C6.9375 13.7812 7 13.625 7 13.5V12.5C7 12.25 7.21875 12 7.5 12H8.65625C8.78125 12 8.90625 11.9688 9 11.875L17.2188 4.4375C17.5312 4.15625 17.9375 4 18.3438 4ZM17.5 13C17.5938 13 17.6875 13.0938 17.7188 13.1875L18.1875 14.8125L19.8125 15.2812C19.9062 15.3125 20 15.4062 20 15.5C20 15.625 19.9062 15.7188 19.8125 15.75L18.1875 16.2188L17.7188 17.8438C17.6875 17.9375 17.5938 18 17.5 18C17.375 18 17.2812 17.9375 17.25 17.8438L16.7812 16.2188L15.1562 15.75C15.0625 15.7188 15 15.625 15 15.5C15 15.4062 15.0625 15.3125 15.1562 15.2812L16.7812 14.8125L17.25 13.1875C17.2812 13.0938 17.375 13 17.5 13ZM6.71875 6.1875L7.1875 7.8125L8.8125 8.28125C8.90625 8.3125 9 8.40625 9 8.5C9 8.625 8.90625 8.71875 8.8125 8.75L7.1875 9.21875L6.71875 10.8438C6.6875 10.9375 6.59375 11 6.5 11C6.375 11 6.28125 10.9375 6.25 10.8438L5.78125 9.21875L4.15625 8.75C4.0625 8.71875 4 8.625 4 8.5C4 8.40625 4.0625 8.3125 4.15625 8.28125L5.78125 7.8125L6.25 6.1875C6.28125 6.09375 6.375 6 6.5 6C6.59375 6 6.6875 6.09375 6.71875 6.1875ZM10.5 4C10.5938 4 10.6875 4.09375 10.7188 4.21875L10.9375 5.0625L11.7812 5.28125C11.9062 5.3125 12 5.40625 12 5.5C12 5.625 11.9062 5.71875 11.7812 5.75L10.9375 5.96875L10.7188 6.8125C10.6875 6.9375 10.5938 7 10.5 7C10.375 7 10.2812 6.9375 10.25 6.8125L10.0312 5.96875L9.1875 5.75C9.0625 5.71875 9 5.625 9 5.5C9 5.40625 9.0625 5.3125 9.1875 5.28125L10.0312 5.0625L10.25 4.21875C10.2812 4.09375 10.375 4 10.5 4Z' }) })),
    xCircle: (domProps) => (jsx("svg", { ...baseSvgProps, ...domProps, children: jsx("path", { fillRule: 'evenodd', d: 'M11.32 2.28A9.74 9.74 0 003.258 7.7c-.46.94-.762 1.914-.924 2.98-.097.636-.097 2.004 0 2.64.446 2.941 2.052 5.409 4.533 6.968 1.075.676 2.441 1.17 3.813 1.378.636.097 2.004.097 2.64 0 2.1-.319 3.932-1.206 5.405-2.618 1.601-1.534 2.6-3.479 2.941-5.728.097-.636.097-2.004 0-2.64-.443-2.919-2.04-5.389-4.49-6.941-.824-.522-2.118-1.053-3.056-1.253a10.872 10.872 0 00-2.8-.206m2 1.578a8.277 8.277 0 014.628 2.435c1.176 1.231 1.913 2.713 2.2 4.423.1.593.1 1.975 0 2.568-.612 3.649-3.463 6.426-7.08 6.895-3.771.489-7.369-1.653-8.767-5.219a9.164 9.164 0 01-.449-1.676c-.1-.593-.1-1.975 0-2.568.299-1.783 1.066-3.282 2.324-4.54 1.389-1.388 2.977-2.138 5.064-2.391.313-.038 1.715.011 2.08.073M9.729 9.285c-.209.103-.435.36-.496.563-.093.31-.028.407.879 1.322l.824.83-.824.83c-.916.923-.973 1.01-.875 1.335.065.218.38.533.598.598.325.098.412.041 1.335-.875l.83-.824.83.824c.923.916 1.01.973 1.335.875.218-.065.533-.38.598-.598.098-.325.041-.412-.875-1.335l-.824-.83.824-.83c.916-.923.973-1.01.875-1.335-.065-.218-.38-.533-.598-.598-.325-.098-.412-.041-1.335.876l-.831.824-.81-.807c-.973-.969-1.082-1.032-1.46-.845' }) })),
};

const UnstyledIcon = (props) => {
    const _Icon = Icons[props.name];
    return jsx(_Icon, { ...props });
};
const Icon = styled(UnstyledIcon) `
  fill: ${({ color }) => color || 'currentColor'};
  flex-shrink: 0;
  font-size: ${({ size = 24 }) => size}px;
  height: 1em;
  width: 1em;
`;

const useIsTruncated = (refs) => {
    const [isTruncated, setIsTruncated] = useState([]);
    useEffect(() => {
        const truncations = refs.map((ref) => {
            return ref.current
                ? ref.current.scrollWidth > ref.current.clientWidth ||
                    ref.current.scrollHeight > ref.current.clientHeight
                : false;
        });
        if (isTruncated !== truncations)
            setIsTruncated(truncations);
    }, [...refs]);
    return isTruncated;
};

const proxima = css `
  font-family: 'Proxima Nova', 'Helvetica', sans-serif;
  -webkit-font-smoothing: antialiased;
`;
const ptSerif = css `
  font-family: 'PT Serif', Georgia, serif;
`;
const ptMono = css `
  font-family: 'PT Mono', serif !important;
  -webkit-font-smoothing: antialiased;
`;
const truncated = css `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const getFont = (type, important) => {
    switch (type) {
        case 'h1':
            return css `
        ${proxima};

        font-size: 56px;
        font-weight: 600;
        line-height: 80px;
      `;
        case 'h2':
            return css `
        ${proxima};

        font-size: 40px;
        font-weight: 600;
        line-height: 56px;
      `;
        case 'h3':
            return css `
        ${proxima};

        font-size: 32px;
        font-weight: 600;
        line-height: 48px;
      `;
        case 'h4':
            return css `
        ${proxima};

        font-size: 24px;
        font-weight: 600;
        line-height: 32px;
      `;
        case 'h5':
            return css `
        ${proxima};

        font-size: 18px;
        font-weight: 600;
        line-height: 24px;
      `;
        case 'b0':
            return css `
        ${proxima};

        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
      `;
        case 'b1':
            return css `
        ${proxima};

        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
      `;
        case 'b2':
            return css `
        ${proxima};

        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
      `;
        case 'b3':
            return css `
        ${proxima};

        font-size: 11px;
        font-weight: 400;
        line-height: 16px;
      `;
        case 'actionSm':
            return css `
        ${proxima};

        font-size: 12px;
        font-weight: 600;
        letter-spacing: 0.01em;
        line-height: 16px;
      `;
        case 'actionMd':
            return css `
        ${proxima};

        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0.01em;
        line-height: 24px;
      `;
        case 'actionLg':
            return css `
        ${proxima};

        font-size: 16px ${important && ' !important'};
        font-weight: 600 ${important && ' !important'};
        line-height: 24px ${important && ' !important'};
      `;
        case 'it1':
            return css `
        ${proxima};

        font-size: 14px;
        font-style: italic;
        font-weight: 400;
        line-height: 24px;
      `;
        case 'it2':
            return css `
        ${proxima};

        font-size: 12px;
        font-style: italic;
        font-weight: 400;
        line-height: 16px;
      `;
        case 'it3':
            return css `
        ${proxima};

        font-size: 11px;
        font-style: italic;
        font-weight: 400;
        line-height: 16px;
      `;
        case 'h1Serif':
            return css `
        ${ptSerif};

        font-size: 56px;
        font-weight: 700;
        letter-spacing: -0.015em;
        line-height: 80px;
      `;
        case 'h2Serif':
            return css `
        ${ptSerif};

        font-size: 40px;
        font-weight: 700;
        letter-spacing: -0.015em;
        line-height: 56px;
      `;
        case 'h3Serif':
            return css `
        ${ptSerif};

        font-size: 32px;
        font-weight: 700;
        line-height: 36px;
      `;
        case 'h4Serif':
            return css `
        ${ptSerif};

        font-size: 24px;
        font-weight: 700;
        line-height: 32px;
      `;
        case 'h5Serif':
            return css `
        ${ptSerif};

        font-size: 18px;
        font-weight: 700;
        line-height: 24px;
      `;
        case 'b0Serif':
            return css `
        ${ptSerif};

        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
      `;
        case 'b0Mono':
            return css `
        ${ptMono};

        font-size: 15px;
        font-weight: 400;
        line-height: 24px;
      `;
        case 'b1Mono':
            return css `
        ${ptMono};

        font-size: 13px;
        font-weight: 400;
        line-height: 24px;
      `;
        case 'b2Mono':
            return css `
        ${ptMono};

        font-size: 11px;
        font-weight: 400;
        line-height: 16px;
      `;
        case 'b3Mono':
            return css `
        ${ptMono};

        font-size: 10px;
        font-weight: 400;
        line-height: 16px;
      `;
        default:
            return;
    }
};

const Container$5 = styled.div `
  ${({ type }) => getFont(type)}
  ${({ truncate }) => (truncate ? truncated : '')}
  color: ${({ color }) => color};
  overflow-wrap: break-word;
`;
const TruncatedContainer = (props) => {
    const textRef = useRef(null);
    const [textTruncated] = useIsTruncated([textRef]);
    return (jsx(Container$5, { ref: textRef, title: textTruncated ? props.children?.toString() : undefined, ...props }));
};
const Typography = ({ children, color = Colors$1.MidnightBrand, truncate = false, type = 'b0', ...otherProps }) => {
    const ContainerComponent = truncate ? TruncatedContainer : Container$5;
    return (jsx(ContainerComponent, { type: type, color: color, truncate: truncate, className: 'ff-ds', ...otherProps, children: children }));
};

var BadgeVariant;
(function (BadgeVariant) {
    BadgeVariant[BadgeVariant["Jade"] = 0] = "Jade";
    BadgeVariant[BadgeVariant["Pigeon"] = 1] = "Pigeon";
    BadgeVariant[BadgeVariant["Electric"] = 2] = "Electric";
    BadgeVariant[BadgeVariant["Sky"] = 3] = "Sky";
    BadgeVariant[BadgeVariant["Blue"] = 4] = "Blue";
    BadgeVariant[BadgeVariant["Brown"] = 5] = "Brown";
    BadgeVariant[BadgeVariant["Pink"] = 6] = "Pink";
    BadgeVariant[BadgeVariant["Indigo"] = 7] = "Indigo";
    BadgeVariant[BadgeVariant["Purple"] = 8] = "Purple";
    BadgeVariant[BadgeVariant["Pinata"] = 9] = "Pinata";
})(BadgeVariant || (BadgeVariant = {}));
var BadgeRadiusSize;
(function (BadgeRadiusSize) {
    BadgeRadiusSize[BadgeRadiusSize["Small"] = 0] = "Small";
})(BadgeRadiusSize || (BadgeRadiusSize = {}));
const getBadgeStyles = (variant) => {
    switch (variant) {
        case BadgeVariant.Electric: {
            return `
        background-color: ${Colors$1.Electric100};
        color: ${Colors$1.Electric900};
      `;
        }
        case BadgeVariant.Brown: {
            return `
        background-color: ${Colors$1.LightBrown};
        color: ${Colors$1.Brown};
      `;
        }
        case BadgeVariant.Pink: {
            return `
        background-color: ${Colors$1.LightPink};
        color: ${Colors$1.Pink};
      `;
        }
        case BadgeVariant.Blue: {
            return `
        background-color: ${Colors$1.LightBlue};
        color: ${Colors$1.DarkBlue};
      `;
        }
        case BadgeVariant.Indigo: {
            return `
        background-color: ${Colors$1.LightIndigo};
        color: ${Colors$1.Indigo};
      `;
        }
        case BadgeVariant.Purple: {
            return `
        background-color: ${Colors$1.LightPurple};
        color: ${Colors$1.Purple};
      `;
        }
        case BadgeVariant.Sky: {
            return `
        background-color: ${Colors$1.Sky100};
        color: ${Colors$1.Sky900};
      `;
        }
        case BadgeVariant.Jade: {
            return `
        background-color: ${Colors$1.Jade100};
        color: ${Colors$1.Jade900};
      `;
        }
        case BadgeVariant.Pinata: {
            return `
        background-color: ${Colors$1.Pinata100};
        color: ${Colors$1.Pinata900};
      `;
        }
        default: {
            return `
        background-color: ${Colors$1.Pigeon100};
        color: ${Colors$1.MidnightBrand};
      `;
        }
    }
};
const BadgeContainer = styled.span `
  display: inline-flex;
  align-items: center;
  padding: ${({ customPadding }) => customPadding ?? '2px 10px'};
  border-radius: ${({ radiusSize }) => radiusSize === BadgeRadiusSize.Small ? '4px' : '10px'};
  gap: 8px;
  ${getFont('actionSm')}
  ${({ variant }) => getBadgeStyles(variant)}
`;
const Badge = ({ label, variant, iconRight, iconLeft, customPadding, radiusSize, }) => {
    return (jsxs(BadgeContainer, { variant: variant, customPadding: customPadding, radiusSize: radiusSize, "data-testid": 'badge', className: 'amp-badge', children: [iconLeft && jsx(Icon, { name: iconLeft, size: 16 }), label, iconRight && jsx(Icon, { name: iconRight })] }));
};

const getVariantStyles = (variant) => {
    switch (variant) {
        case 'warning':
            return css `
        background-color: ${Colors$1.Sunflower200};
        border: 1px solid ${Colors$1.Sunflower900};
      `;
        case 'error':
            return css `
        background-color: ${Colors$1.Pinata100};
        border: 1px solid ${Colors$1.Pinata900};
      `;
        case 'success':
            return css `
        background-color: ${Colors$1.Jade100};
        border: 1px solid ${Colors$1.Jade900};
      `;
        case 'info':
            return css `
        background-color: ${Colors$1.Electric100};
        border: 1px solid ${Colors$1.Electric700};
      `;
    }
};
const Container$4 = styled.div `
  ${({ variant }) => getVariantStyles(variant)}

  border-radius: 2px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 16px;
  width: 100%;
`;
const HeaderRow = styled.div `
  align-items: center;
  display: flex;
  justify-content: space-between;

  svg {
    cursor: pointer;
  }
`;
const Banner = ({ message, title, onClose, variant, ...props }) => {
    return (jsxs(Container$4, { variant: variant, "data-testid": props['data-testid'], children: [title || onClose ? (jsxs(HeaderRow, { children: [jsx(Typography, { type: 'actionMd', children: title }), !!onClose && jsx(Icon, { name: 'cross', size: 16, onClick: onClose })] })) : null, message ? jsx(Typography, { type: 'b1', children: message }) : null] }));
};

const BreadcrumbsWrap = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  color: ${Colors$1.Pigeon600};
  margin-right: 4px;

  svg {
    margin-right: 4px;
    stroke: ${Colors$1.Pigeon600};
    fill: none;
  }
`;
const Breadcrumbs = ({ items }) => {
    return (jsx(BreadcrumbsWrap, { children: items.map((item, index) => (jsxs(Fragment, { children: [item.render(item.itemProps), index !== items.length - 1 && (jsx(Icon, { "data-testid": 'chevron-right', name: 'chevronRight', size: 12, color: Colors$1.Pigeon600 }))] }))) }));
};
styled.div `
  display: flex;
  align-items: center;
  gap: 4px;
  margin-right: 4px;
`;

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
function $458b0a5536c1a7cf$export$40bfa8c7b0832715(value, defaultValue, onChange) {
    let [stateValue, setStateValue] = (useState)(value || defaultValue);
    let ref = (useRef)(value !== undefined);
    let wasControlled = ref.current;
    let isControlled = value !== undefined;
    // Internal state reference for useCallback
    let stateRef = (useRef)(stateValue);
    if (wasControlled !== isControlled) console.warn(`WARN: A component changed from ${wasControlled ? "controlled" : "uncontrolled"} to ${isControlled ? "controlled" : "uncontrolled"}.`);
    ref.current = isControlled;
    let setValue = (useCallback)((value, ...args)=>{
        let onChangeCaller = (value, ...onChangeArgs)=>{
            if (onChange) {
                if (!Object.is(stateRef.current, value)) onChange(value, ...onChangeArgs);
            }
            if (!isControlled) stateRef.current = value;
        };
        if (typeof value === "function") {
            console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320");
            // this supports functional updates https://reactjs.org/docs/hooks-reference.html#functional-updates
            // when someone using useControlledState calls setControlledState(myFunc)
            // this will call our useState setState with a function as well which invokes myFunc and calls onChange with the value from myFunc
            // if we're in an uncontrolled state, then we also return the value of myFunc which to setState looks as though it was just called with myFunc from the beginning
            // otherwise we just return the controlled value, which won't cause a rerender because React knows to bail out when the value is the same
            let updateFunction = (oldValue, ...functionArgs)=>{
                let interceptedValue = value(isControlled ? stateRef.current : oldValue, ...functionArgs);
                onChangeCaller(interceptedValue, ...args);
                if (!isControlled) return interceptedValue;
                return oldValue;
            };
            setStateValue(updateFunction);
        } else {
            if (!isControlled) setStateValue(value);
            onChangeCaller(value, ...args);
        }
    }, [
        isControlled,
        onChange
    ]);
    // If a controlled component's value prop changes, we need to update stateRef
    if (isControlled) stateRef.current = value;
    else value = stateValue;
    return [
        value,
        setValue
    ];
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Takes a value and forces it to the closest min/max if it's outside. Also forces it to the closest valid step.
 */ function $9446cca9a3875146$export$7d15b64cf5a3a4c4(value, min = -Infinity, max = Infinity) {
    let newValue = Math.min(Math.max(value, min), max);
    return newValue;
}
function $9446cca9a3875146$export$cb6e0bb50bc19463(value, min, max, step) {
    let remainder = (value - (isNaN(min) ? 0 : min)) % step;
    let snappedValue = Math.abs(remainder) * 2 >= step ? value + Math.sign(remainder) * (step - Math.abs(remainder)) : value - remainder;
    if (!isNaN(min)) {
        if (snappedValue < min) snappedValue = min;
        else if (!isNaN(max) && snappedValue > max) snappedValue = min + Math.floor((max - min) / step) * step;
    } else if (!isNaN(max) && snappedValue > max) snappedValue = Math.floor(max / step) * step;
    // correct floating point behavior by rounding to step precision
    let string = step.toString();
    let index = string.indexOf(".");
    let precision = index >= 0 ? string.length - index : 0;
    if (precision > 0) {
        let pow = Math.pow(10, precision);
        snappedValue = Math.round(snappedValue * pow) / pow;
    }
    return snappedValue;
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule

// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $704cf1d3b684cc5c$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $704cf1d3b684cc5c$var$SSRContext = /*#__PURE__*/ (React__default).createContext($704cf1d3b684cc5c$var$defaultContext);
let $704cf1d3b684cc5c$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
function $704cf1d3b684cc5c$export$619500959fc48b26(defaultId) {
    let ctx = (useContext)($704cf1d3b684cc5c$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $704cf1d3b684cc5c$var$defaultContext && !$704cf1d3b684cc5c$var$canUseDOM) console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (useMemo)(()=>defaultId || `react-aria${ctx.prefix}-${++ctx.current}`, [
        defaultId
    ]);
}
function $704cf1d3b684cc5c$export$535bd6ca7f90a273() {
    let cur = (useContext)($704cf1d3b684cc5c$var$SSRContext);
    let isInSSRContext = cur !== $704cf1d3b684cc5c$var$defaultContext;
    let [isSSR, setIsSSR] = (useState)(isInSSRContext);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof window !== "undefined" && isInSSRContext) // This if statement technically breaks the rules of hooks, but is safe
    // because the condition never changes after mounting.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return isSSR;
}

function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
const $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c = typeof window !== "undefined" ? (React__default).useLayoutEffect : ()=>{};



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

function $1dbecbe27a04f9af$export$14d238f342723f25(defaultValue) {
    let [value, setValue] = (useState)(defaultValue);
    let valueRef = (useRef)(value);
    let effect = (useRef)(null);
    valueRef.current = value;
    // Store the function in a ref so we can always access the current version
    // which has the proper `value` in scope.
    let nextRef = (useRef)(null);
    nextRef.current = ()=>{
        // Run the generator to the next yield.
        let newValue = effect.current.next();
        // If the generator is done, reset the effect.
        if (newValue.done) {
            effect.current = null;
            return;
        }
        // If the value is the same as the current value,
        // then continue to the next yield. Otherwise,
        // set the value in state and wait for the next layout effect.
        if (value === newValue.value) nextRef.current();
        else setValue(newValue.value);
    };
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(()=>{
        // If there is an effect currently running, continue to the next yield.
        if (effect.current) nextRef.current();
    });
    let queue = (useCallback)((fn)=>{
        effect.current = fn(valueRef.current);
        nextRef.current();
    }, [
        effect,
        nextRef
    ]);
    return [
        value,
        queue
    ];
}


let $bdb11010cef70236$var$idsUpdaterMap = new Map();
function $bdb11010cef70236$export$f680877a34711e37(defaultId) {
    let [value, setValue] = (useState)(defaultId);
    let nextId = (useRef)(null);
    let res = ($704cf1d3b684cc5c$export$619500959fc48b26)(value);
    let updateValue = (useCallback)((val)=>{
        nextId.current = val;
    }, []);
    $bdb11010cef70236$var$idsUpdaterMap.set(res, updateValue);
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(()=>{
        let r = res;
        return ()=>{
            $bdb11010cef70236$var$idsUpdaterMap.delete(r);
        };
    }, [
        res
    ]);
    // This cannot cause an infinite loop because the ref is updated first.
    // eslint-disable-next-line
    (useEffect)(()=>{
        let newId = nextId.current;
        if (newId) {
            nextId.current = null;
            setValue(newId);
        }
    });
    return res;
}
function $bdb11010cef70236$export$cd8c9cb68f842629(idA, idB) {
    if (idA === idB) return idA;
    let setIdA = $bdb11010cef70236$var$idsUpdaterMap.get(idA);
    if (setIdA) {
        setIdA(idB);
        return idB;
    }
    let setIdB = $bdb11010cef70236$var$idsUpdaterMap.get(idB);
    if (setIdB) {
        setIdB(idA);
        return idA;
    }
    return idB;
}
function $bdb11010cef70236$export$b4cc09c592e8fdb8(depArray = []) {
    let id = $bdb11010cef70236$export$f680877a34711e37();
    let [resolvedId, setResolvedId] = ($1dbecbe27a04f9af$export$14d238f342723f25)(id);
    let updateId = (useCallback)(()=>{
        setResolvedId(function*() {
            yield id;
            yield document.getElementById(id) ? id : undefined;
        });
    }, [
        id,
        setResolvedId
    ]);
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(updateId, [
        id,
        updateId,
        ...depArray
    ]);
    return resolvedId;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Calls all functions in the order they were chained with the same arguments.
 */ function $ff5963eb1fccf552$export$e08e3b67e392101e(...callbacks) {
    return (...args)=>{
        for (let callback of callbacks)if (typeof callback === "function") callback(...args);
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


function $3ef42575df84b30b$export$9d1611c77c2fe928(...args) {
    // Start with a base clone of the first argument. This is a lot faster than starting
    // with an empty object and adding properties as we go.
    let result = {
        ...args[0]
    };
    for(let i = 1; i < args.length; i++){
        let props = args[i];
        for(let key in props){
            let a = result[key];
            let b = props[key];
            // Chain events
            if (typeof a === "function" && typeof b === "function" && // This is a lot faster than a regex.
            key[0] === "o" && key[1] === "n" && key.charCodeAt(2) >= /* 'A' */ 65 && key.charCodeAt(2) <= /* 'Z' */ 90) result[key] = ($ff5963eb1fccf552$export$e08e3b67e392101e)(a, b);
            else if ((key === "className" || key === "UNSAFE_className") && typeof a === "string" && typeof b === "string") result[key] = (clsx)(a, b);
            else if (key === "id" && a && b) result.id = ($bdb11010cef70236$export$cd8c9cb68f842629)(a, b);
            else result[key] = b !== undefined ? b : a;
        }
    }
    return result;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $65484d02dcb7eb3e$var$DOMPropNames = new Set([
    "id"
]);
const $65484d02dcb7eb3e$var$labelablePropNames = new Set([
    "aria-label",
    "aria-labelledby",
    "aria-describedby",
    "aria-details"
]);
const $65484d02dcb7eb3e$var$propRe = /^(data-.*)$/;
function $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, opts = {}) {
    let { labelable: labelable , propNames: propNames  } = opts;
    let filteredProps = {};
    for(const prop in props)if (Object.prototype.hasOwnProperty.call(props, prop) && ($65484d02dcb7eb3e$var$DOMPropNames.has(prop) || labelable && $65484d02dcb7eb3e$var$labelablePropNames.has(prop) || (propNames === null || propNames === void 0 ? void 0 : propNames.has(prop)) || $65484d02dcb7eb3e$var$propRe.test(prop))) filteredProps[prop] = props[prop];
    return filteredProps;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7215afc6de606d6b$export$de79e2c695e052f3(element) {
    if ($7215afc6de606d6b$var$supportsPreventScroll()) element.focus({
        preventScroll: true
    });
    else {
        let scrollableElements = $7215afc6de606d6b$var$getScrollableElements(element);
        element.focus();
        $7215afc6de606d6b$var$restoreScrollPosition(scrollableElements);
    }
}
let $7215afc6de606d6b$var$supportsPreventScrollCached = null;
function $7215afc6de606d6b$var$supportsPreventScroll() {
    if ($7215afc6de606d6b$var$supportsPreventScrollCached == null) {
        $7215afc6de606d6b$var$supportsPreventScrollCached = false;
        try {
            var focusElem = document.createElement("div");
            focusElem.focus({
                get preventScroll () {
                    $7215afc6de606d6b$var$supportsPreventScrollCached = true;
                    return true;
                }
            });
        } catch (e) {
        // Ignore
        }
    }
    return $7215afc6de606d6b$var$supportsPreventScrollCached;
}
function $7215afc6de606d6b$var$getScrollableElements(element) {
    var parent = element.parentNode;
    var scrollableElements = [];
    var rootScrollingElement = document.scrollingElement || document.documentElement;
    while(parent instanceof HTMLElement && parent !== rootScrollingElement){
        if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
            element: parent,
            scrollTop: parent.scrollTop,
            scrollLeft: parent.scrollLeft
        });
        parent = parent.parentNode;
    }
    if (rootScrollingElement instanceof HTMLElement) scrollableElements.push({
        element: rootScrollingElement,
        scrollTop: rootScrollingElement.scrollTop,
        scrollLeft: rootScrollingElement.scrollLeft
    });
    return scrollableElements;
}
function $7215afc6de606d6b$var$restoreScrollPosition(scrollableElements) {
    for (let { element: element , scrollTop: scrollTop , scrollLeft: scrollLeft  } of scrollableElements){
        element.scrollTop = scrollTop;
        element.scrollLeft = scrollLeft;
    }
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We store a global list of elements that are currently transitioning,
// mapped to a set of CSS properties that are transitioning for that element.
// This is necessary rather than a simple count of transitions because of browser
// bugs, e.g. Chrome sometimes fires both transitionend and transitioncancel rather
// than one or the other. So we need to track what's actually transitioning so that
// we can ignore these duplicate events.
let $bbed8b41f857bcc0$var$transitionsByElement = new Map();
// A list of callbacks to call once there are no transitioning elements.
let $bbed8b41f857bcc0$var$transitionCallbacks = new Set();
function $bbed8b41f857bcc0$var$setupGlobalEvents() {
    if (typeof window === "undefined") return;
    let onTransitionStart = (e)=>{
        // Add the transitioning property to the list for this element.
        let transitions = $bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
        if (!transitions) {
            transitions = new Set();
            $bbed8b41f857bcc0$var$transitionsByElement.set(e.target, transitions);
            // The transitioncancel event must be registered on the element itself, rather than as a global
            // event. This enables us to handle when the node is deleted from the document while it is transitioning.
            // In that case, the cancel event would have nowhere to bubble to so we need to handle it directly.
            e.target.addEventListener("transitioncancel", onTransitionEnd);
        }
        transitions.add(e.propertyName);
    };
    let onTransitionEnd = (e)=>{
        // Remove property from list of transitioning properties.
        let properties = $bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
        if (!properties) return;
        properties.delete(e.propertyName);
        // If empty, remove transitioncancel event, and remove the element from the list of transitioning elements.
        if (properties.size === 0) {
            e.target.removeEventListener("transitioncancel", onTransitionEnd);
            $bbed8b41f857bcc0$var$transitionsByElement.delete(e.target);
        }
        // If no transitioning elements, call all of the queued callbacks.
        if ($bbed8b41f857bcc0$var$transitionsByElement.size === 0) {
            for (let cb of $bbed8b41f857bcc0$var$transitionCallbacks)cb();
            $bbed8b41f857bcc0$var$transitionCallbacks.clear();
        }
    };
    document.body.addEventListener("transitionrun", onTransitionStart);
    document.body.addEventListener("transitionend", onTransitionEnd);
}
if (typeof document !== "undefined") {
    if (document.readyState !== "loading") $bbed8b41f857bcc0$var$setupGlobalEvents();
    else document.addEventListener("DOMContentLoaded", $bbed8b41f857bcc0$var$setupGlobalEvents);
}
function $bbed8b41f857bcc0$export$24490316f764c430(fn) {
    // Wait one frame to see if an animation starts, e.g. a transition on mount.
    requestAnimationFrame(()=>{
        // If no transitions are running, call the function immediately.
        // Otherwise, add it to a list of callbacks to run at the end of the animation.
        if ($bbed8b41f857bcc0$var$transitionsByElement.size === 0) fn();
        else $bbed8b41f857bcc0$var$transitionCallbacks.add(fn);
    });
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
function $03deb23ff14920c4$export$4eaf04e54aa8eed6() {
    let globalListeners = (useRef)(new Map());
    let addGlobalListener = (useCallback)((eventTarget, type, listener, options)=>{
        // Make sure we remove the listener after it is called with the `once` option.
        let fn = (options === null || options === void 0 ? void 0 : options.once) ? (...args)=>{
            globalListeners.current.delete(listener);
            listener(...args);
        } : listener;
        globalListeners.current.set(listener, {
            type: type,
            eventTarget: eventTarget,
            fn: fn,
            options: options
        });
        eventTarget.addEventListener(type, listener, options);
    }, []);
    let removeGlobalListener = (useCallback)((eventTarget, type, listener, options)=>{
        var _globalListeners_current_get;
        let fn = ((_globalListeners_current_get = globalListeners.current.get(listener)) === null || _globalListeners_current_get === void 0 ? void 0 : _globalListeners_current_get.fn) || listener;
        eventTarget.removeEventListener(type, fn, options);
        globalListeners.current.delete(listener);
    }, []);
    let removeAllGlobalListeners = (useCallback)(()=>{
        globalListeners.current.forEach((value, key)=>{
            removeGlobalListener(value.eventTarget, value.type, key, value.options);
        });
    }, [
        removeGlobalListener
    ]);
    // eslint-disable-next-line arrow-body-style
    (useEffect)(()=>{
        return removeAllGlobalListeners;
    }, [
        removeAllGlobalListeners
    ]);
    return {
        addGlobalListener: addGlobalListener,
        removeGlobalListener: removeGlobalListener,
        removeAllGlobalListeners: removeAllGlobalListeners
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
function $313b98861ee5dd6c$export$d6875122194c7b44(props, defaultLabel) {
    let { id: id , "aria-label": label , "aria-labelledby": labelledBy  } = props;
    // If there is both an aria-label and aria-labelledby,
    // combine them by pointing to the element itself.
    id = ($bdb11010cef70236$export$f680877a34711e37)(id);
    if (labelledBy && label) {
        let ids = new Set([
            ...labelledBy.trim().split(/\s+/),
            id
        ]);
        labelledBy = [
            ...ids
        ].join(" ");
    } else if (labelledBy) labelledBy = labelledBy.trim().split(/\s+/).join(" ");
    // If no labels are provided, use the default
    if (!label && !labelledBy && defaultLabel) label = defaultLabel;
    return {
        id: id,
        "aria-label": label,
        "aria-labelledby": labelledBy
    };
}




function $9daab02d461809db$var$hasResizeObserver() {
    return typeof window.ResizeObserver !== "undefined";
}
function $9daab02d461809db$export$683480f191c0e3ea(options) {
    const { ref: ref , onResize: onResize  } = options;
    (useEffect)(()=>{
        let element = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!element) return;
        if (!$9daab02d461809db$var$hasResizeObserver()) {
            window.addEventListener("resize", onResize, false);
            return ()=>{
                window.removeEventListener("resize", onResize, false);
            };
        } else {
            const resizeObserverInstance = new window.ResizeObserver((entries)=>{
                if (!entries.length) return;
                onResize();
            });
            resizeObserverInstance.observe(element);
            return ()=>{
                if (element) resizeObserverInstance.unobserve(element);
            };
        }
    }, [
        onResize,
        ref
    ]);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
function $e7801be82b4b2a53$export$4debdb1a3f0fa79e(context, ref) {
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(()=>{
        if (context && context.ref && ref) {
            context.ref.current = ref.current;
            return ()=>{
                context.ref.current = null;
            };
        }
    }, [
        context,
        ref
    ]);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $62d8ded9296f3872$export$cfa2225e87938781(node) {
    while(node && !$62d8ded9296f3872$var$isScrollable(node))node = node.parentElement;
    return node || document.scrollingElement || document.documentElement;
}
function $62d8ded9296f3872$var$isScrollable(node) {
    let style = window.getComputedStyle(node);
    return /(auto|scroll)/.test(style.overflow + style.overflowX + style.overflowY);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

let $ef06256079686ba0$var$descriptionId = 0;
const $ef06256079686ba0$var$descriptionNodes = new Map();
function $ef06256079686ba0$export$f8aeda7b10753fa1(description) {
    let [id, setId] = (useState)(undefined);
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(()=>{
        if (!description) return;
        let desc = $ef06256079686ba0$var$descriptionNodes.get(description);
        if (!desc) {
            let id = `react-aria-description-${$ef06256079686ba0$var$descriptionId++}`;
            setId(id);
            let node = document.createElement("div");
            node.id = id;
            node.style.display = "none";
            node.textContent = description;
            document.body.appendChild(node);
            desc = {
                refCount: 0,
                element: node
            };
            $ef06256079686ba0$var$descriptionNodes.set(description, desc);
        } else setId(desc.element.id);
        desc.refCount++;
        return ()=>{
            if (--desc.refCount === 0) {
                desc.element.remove();
                $ef06256079686ba0$var$descriptionNodes.delete(description);
            }
        };
    }, [
        description
    ]);
    return {
        "aria-describedby": description ? id : undefined
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c87311424ea30a05$var$testUserAgent(re) {
    var _window_navigator_userAgentData;
    if (typeof window === "undefined" || window.navigator == null) return false;
    return ((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.brands.some((brand)=>re.test(brand.brand))) || re.test(window.navigator.userAgent);
}
function $c87311424ea30a05$var$testPlatform(re) {
    var _window_navigator_userAgentData;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) || window.navigator.platform) : false;
}
function $c87311424ea30a05$export$9ac100e40613ea10() {
    return $c87311424ea30a05$var$testPlatform(/^Mac/i);
}
function $c87311424ea30a05$export$186c6964ca17d99() {
    return $c87311424ea30a05$var$testPlatform(/^iPhone/i);
}
function $c87311424ea30a05$export$7bef049ce92e4224() {
    return $c87311424ea30a05$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $c87311424ea30a05$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
}
function $c87311424ea30a05$export$fedb369cb70207f1() {
    return $c87311424ea30a05$export$186c6964ca17d99() || $c87311424ea30a05$export$7bef049ce92e4224();
}
function $c87311424ea30a05$export$e1865c3bedcd822b() {
    return $c87311424ea30a05$export$9ac100e40613ea10() || $c87311424ea30a05$export$fedb369cb70207f1();
}
function $c87311424ea30a05$export$a11b0059900ceec8() {
    return $c87311424ea30a05$var$testUserAgent(/Android/i);
}


/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
function $e9faafb641e167db$export$90fc3a17d93f704c(ref, event, handler, options) {
    let handlerRef = (useRef)(handler);
    handlerRef.current = handler;
    let isDisabled = handler == null;
    (useEffect)(()=>{
        if (isDisabled) return;
        let element = ref.current;
        let handler = (e)=>handlerRef.current.call(this, e);
        element.addEventListener(event, handler, options);
        return ()=>{
            element.removeEventListener(event, handler, options);
        };
    }, [
        ref,
        event,
        options,
        isDisabled
    ]);
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Scrolls `scrollView` so that `element` is visible.
 * Similar to `element.scrollIntoView({block: 'nearest'})` (not supported in Edge),
 * but doesn't affect parents above `scrollView`.
 */ function $2f04cbc44ee30ce0$export$53a0910f038337bd(scrollView, element) {
    let offsetX = $2f04cbc44ee30ce0$var$relativeOffset(scrollView, element, "left");
    let offsetY = $2f04cbc44ee30ce0$var$relativeOffset(scrollView, element, "top");
    let width = element.offsetWidth;
    let height = element.offsetHeight;
    let x = scrollView.scrollLeft;
    let y = scrollView.scrollTop;
    let maxX = x + scrollView.offsetWidth;
    let maxY = y + scrollView.offsetHeight;
    if (offsetX <= x) x = offsetX;
    else if (offsetX + width > maxX) x += offsetX + width - maxX;
    if (offsetY <= y) y = offsetY;
    else if (offsetY + height > maxY) y += offsetY + height - maxY;
    scrollView.scrollLeft = x;
    scrollView.scrollTop = y;
}
/**
 * Computes the offset left or top from child to ancestor by accumulating
 * offsetLeft or offsetTop through intervening offsetParents.
 */ function $2f04cbc44ee30ce0$var$relativeOffset(ancestor, child, axis) {
    const prop = axis === "left" ? "offsetLeft" : "offsetTop";
    let sum = 0;
    while(child.offsetParent){
        sum += child[prop];
        if (child.offsetParent === ancestor) break;
        else if (child.offsetParent.contains(ancestor)) {
            // If the ancestor is not `position:relative`, then we stop at
            // _its_ offset parent, and we subtract off _its_ offset, so that
            // we end up with the proper offset from child to ancestor.
            sum -= ancestor[prop];
            break;
        }
        child = child.offsetParent;
    }
    return sum;
}



/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
function $6a7db85432448f7f$export$60278871457622de(event) {
    // JAWS/NVDA with Firefox.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    // Android TalkBack's detail value varies depending on the event listener providing the event so we have specific logic here instead
    // If pointerType is defined, event is from a click listener. For events from mousedown listener, detail === 0 is a sufficient check
    // to detect TalkBack virtual clicks.
    if (($c87311424ea30a05$export$a11b0059900ceec8)() && event.pointerType) return event.type === "click" && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $6a7db85432448f7f$export$29bf1b5f2c56cf63(event) {
    // If the pointer size is zero, then we assume it's from a screen reader.
    // Android TalkBack double tap will sometimes return a event with width and height of 1
    // and pointerType === 'mouse' so we need to check for a specific combination of event attributes.
    // Cannot use "event.pressure === 0" as the sole check due to Safari pointer events always returning pressure === 0
    // instead of .5, see https://bugs.webkit.org/show_bug.cgi?id=206216. event.pointerType === 'mouse' is to distingush
    // Talkback double tap from Windows Firefox touch screen press
    return event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse";
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
// Note that state only matters here for iOS. Non-iOS gets user-select: none applied to the target element
// rather than at the document level so we just need to apply/remove user-select: none for each pressed element individually
let $14c0b72509d70225$var$state = "default";
let $14c0b72509d70225$var$savedUserSelect = "";
let $14c0b72509d70225$var$modifiedElementMap = new WeakMap();
function $14c0b72509d70225$export$16a4697467175487(target) {
    if (($c87311424ea30a05$export$fedb369cb70207f1)()) {
        if ($14c0b72509d70225$var$state === "default") {
            $14c0b72509d70225$var$savedUserSelect = document.documentElement.style.webkitUserSelect;
            document.documentElement.style.webkitUserSelect = "none";
        }
        $14c0b72509d70225$var$state = "disabled";
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        // If not iOS, store the target's original user-select and change to user-select: none
        // Ignore state since it doesn't apply for non iOS
        $14c0b72509d70225$var$modifiedElementMap.set(target, target.style.userSelect);
        target.style.userSelect = "none";
    }
}
function $14c0b72509d70225$export$b0d6fa1ab32e3295(target) {
    if (($c87311424ea30a05$export$fedb369cb70207f1)()) {
        // If the state is already default, there's nothing to do.
        // If it is restoring, then there's no need to queue a second restore.
        if ($14c0b72509d70225$var$state !== "disabled") return;
        $14c0b72509d70225$var$state = "restoring";
        // There appears to be a delay on iOS where selection still might occur
        // after pointer up, so wait a bit before removing user-select.
        setTimeout(()=>{
            // Wait for any CSS transitions to complete so we don't recompute style
            // for the whole page in the middle of the animation and cause jank.
            ($bbed8b41f857bcc0$export$24490316f764c430)(()=>{
                // Avoid race conditions
                if ($14c0b72509d70225$var$state === "restoring") {
                    if (document.documentElement.style.webkitUserSelect === "none") document.documentElement.style.webkitUserSelect = $14c0b72509d70225$var$savedUserSelect || "";
                    $14c0b72509d70225$var$savedUserSelect = "";
                    $14c0b72509d70225$var$state = "default";
                }
            });
        }, 300);
    } else if (target instanceof HTMLElement || target instanceof SVGElement) // If not iOS, restore the target's original user-select if any
    // Ignore state since it doesn't apply for non iOS
    {
        if (target && $14c0b72509d70225$var$modifiedElementMap.has(target)) {
            let targetOldUserSelect = $14c0b72509d70225$var$modifiedElementMap.get(target);
            if (target.style.userSelect === "none") target.style.userSelect = targetOldUserSelect;
            if (target.getAttribute("style") === "") target.removeAttribute("style");
            $14c0b72509d70225$var$modifiedElementMap.delete(target);
        }
    }
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
const $ae1eeba8b9eafd08$export$5165eccb35aaadb5 = (React__default).createContext(null);
$ae1eeba8b9eafd08$export$5165eccb35aaadb5.displayName = "PressResponderContext";



function $f6c31cce2adf654f$var$usePressResponderContext(props) {
    // Consume context from <PressResponder> and merge with props.
    let context = (useContext)(($ae1eeba8b9eafd08$export$5165eccb35aaadb5));
    if (context) {
        let { register: register , ...contextProps } = context;
        props = ($3ef42575df84b30b$export$9d1611c77c2fe928)(contextProps, props);
        register();
    }
    ($e7801be82b4b2a53$export$4debdb1a3f0fa79e)(context, props.ref);
    return props;
}
function $f6c31cce2adf654f$export$45712eceda6fad21(props) {
    let { onPress: onPress , onPressChange: onPressChange , onPressStart: onPressStart , onPressEnd: onPressEnd , onPressUp: onPressUp , isDisabled: isDisabled , isPressed: isPressedProp , preventFocusOnPress: preventFocusOnPress , shouldCancelOnPointerExit: shouldCancelOnPointerExit , allowTextSelectionOnPress: allowTextSelectionOnPress , // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ref: _ , ...domProps } = $f6c31cce2adf654f$var$usePressResponderContext(props);
    let propsRef = (useRef)(null);
    propsRef.current = {
        onPress: onPress,
        onPressChange: onPressChange,
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onPressUp: onPressUp,
        isDisabled: isDisabled,
        shouldCancelOnPointerExit: shouldCancelOnPointerExit
    };
    let [isPressed, setPressed] = (useState)(false);
    let ref = (useRef)({
        isPressed: false,
        ignoreEmulatedMouseEvents: false,
        ignoreClickAfterPress: false,
        didFirePressStart: false,
        activePointerId: null,
        target: null,
        isOverTarget: false,
        pointerType: null
    });
    let { addGlobalListener: addGlobalListener , removeAllGlobalListeners: removeAllGlobalListeners  } = ($03deb23ff14920c4$export$4eaf04e54aa8eed6)();
    let pressProps = (useMemo)(()=>{
        let state = ref.current;
        let triggerPressStart = (originalEvent, pointerType)=>{
            let { onPressStart: onPressStart , onPressChange: onPressChange , isDisabled: isDisabled  } = propsRef.current;
            if (isDisabled || state.didFirePressStart) return;
            if (onPressStart) onPressStart({
                type: "pressstart",
                pointerType: pointerType,
                target: originalEvent.currentTarget,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
            if (onPressChange) onPressChange(true);
            state.didFirePressStart = true;
            setPressed(true);
        };
        let triggerPressEnd = (originalEvent, pointerType, wasPressed = true)=>{
            let { onPressEnd: onPressEnd , onPressChange: onPressChange , onPress: onPress , isDisabled: isDisabled  } = propsRef.current;
            if (!state.didFirePressStart) return;
            state.ignoreClickAfterPress = true;
            state.didFirePressStart = false;
            if (onPressEnd) onPressEnd({
                type: "pressend",
                pointerType: pointerType,
                target: originalEvent.currentTarget,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
            if (onPressChange) onPressChange(false);
            setPressed(false);
            if (onPress && wasPressed && !isDisabled) onPress({
                type: "press",
                pointerType: pointerType,
                target: originalEvent.currentTarget,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
        };
        let triggerPressUp = (originalEvent, pointerType)=>{
            let { onPressUp: onPressUp , isDisabled: isDisabled  } = propsRef.current;
            if (isDisabled) return;
            if (onPressUp) onPressUp({
                type: "pressup",
                pointerType: pointerType,
                target: originalEvent.currentTarget,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
        };
        let cancel = (e)=>{
            if (state.isPressed) {
                if (state.isOverTarget) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                state.isPressed = false;
                state.isOverTarget = false;
                state.activePointerId = null;
                state.pointerType = null;
                removeAllGlobalListeners();
                if (!allowTextSelectionOnPress) ($14c0b72509d70225$export$b0d6fa1ab32e3295)(state.target);
            }
        };
        let pressProps = {
            onKeyDown (e) {
                if ($f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && e.currentTarget.contains(e.target)) {
                    if ($f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                    e.stopPropagation();
                    // If the event is repeating, it may have started on a different element
                    // after which focus moved to the current element. Ignore these events and
                    // only handle the first key down event.
                    if (!state.isPressed && !e.repeat) {
                        state.target = e.currentTarget;
                        state.isPressed = true;
                        triggerPressStart(e, "keyboard");
                        // Focus may move before the key up event, so register the event on the document
                        // instead of the same element where the key down event occurred.
                        addGlobalListener(document, "keyup", onKeyUp, false);
                    }
                } else if (e.key === "Enter" && $f6c31cce2adf654f$var$isHTMLAnchorLink(e.currentTarget)) // If the target is a link, we won't have handled this above because we want the default
                // browser behavior to open the link when pressing Enter. But we still need to prevent
                // default so that elements above do not also handle it (e.g. table row).
                e.stopPropagation();
            },
            onKeyUp (e) {
                if ($f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && !e.repeat && e.currentTarget.contains(e.target)) triggerPressUp($f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard");
            },
            onClick (e) {
                if (e && !e.currentTarget.contains(e.target)) return;
                if (e && e.button === 0) {
                    e.stopPropagation();
                    if (isDisabled) e.preventDefault();
                    // If triggered from a screen reader or by using element.click(),
                    // trigger as if it were a keyboard click.
                    if (!state.ignoreClickAfterPress && !state.ignoreEmulatedMouseEvents && (state.pointerType === "virtual" || ($6a7db85432448f7f$export$60278871457622de)(e.nativeEvent))) {
                        // Ensure the element receives focus (VoiceOver on iOS does not do this)
                        if (!isDisabled && !preventFocusOnPress) ($7215afc6de606d6b$export$de79e2c695e052f3)(e.currentTarget);
                        triggerPressStart(e, "virtual");
                        triggerPressUp(e, "virtual");
                        triggerPressEnd(e, "virtual");
                    }
                    state.ignoreEmulatedMouseEvents = false;
                    state.ignoreClickAfterPress = false;
                }
            }
        };
        let onKeyUp = (e)=>{
            if (state.isPressed && $f6c31cce2adf654f$var$isValidKeyboardEvent(e, state.target)) {
                if ($f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                e.stopPropagation();
                state.isPressed = false;
                let target = e.target;
                triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard", state.target.contains(target));
                removeAllGlobalListeners();
                // If the target is a link, trigger the click method to open the URL,
                // but defer triggering pressEnd until onClick event handler.
                if (state.target instanceof HTMLElement && state.target.contains(target) && ($f6c31cce2adf654f$var$isHTMLAnchorLink(state.target) || state.target.getAttribute("role") === "link")) state.target.click();
            }
        };
        if (typeof PointerEvent !== "undefined") {
            pressProps.onPointerDown = (e)=>{
                // Only handle left clicks, and ignore events that bubbled through portals.
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // iOS safari fires pointer events from VoiceOver with incorrect coordinates/target.
                // Ignore and let the onClick handler take care of it instead.
                // https://bugs.webkit.org/show_bug.cgi?id=222627
                // https://bugs.webkit.org/show_bug.cgi?id=223202
                if (($6a7db85432448f7f$export$29bf1b5f2c56cf63)(e.nativeEvent)) {
                    state.pointerType = "virtual";
                    return;
                }
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on pointer down and handle focusing the pressable element ourselves.
                if ($f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                state.pointerType = e.pointerType;
                e.stopPropagation();
                if (!state.isPressed) {
                    state.isPressed = true;
                    state.isOverTarget = true;
                    state.activePointerId = e.pointerId;
                    state.target = e.currentTarget;
                    if (!isDisabled && !preventFocusOnPress) ($7215afc6de606d6b$export$de79e2c695e052f3)(e.currentTarget);
                    if (!allowTextSelectionOnPress) ($14c0b72509d70225$export$16a4697467175487)(state.target);
                    triggerPressStart(e, state.pointerType);
                    addGlobalListener(document, "pointermove", onPointerMove, false);
                    addGlobalListener(document, "pointerup", onPointerUp, false);
                    addGlobalListener(document, "pointercancel", onPointerCancel, false);
                }
            };
            pressProps.onMouseDown = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (e.button === 0) {
                    // Chrome and Firefox on touch Windows devices require mouse down events
                    // to be canceled in addition to pointer events, or an extra asynchronous
                    // focus event will be fired.
                    if ($f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                    e.stopPropagation();
                }
            };
            pressProps.onPointerUp = (e)=>{
                // iOS fires pointerup with zero width and height, so check the pointerType recorded during pointerdown.
                if (!e.currentTarget.contains(e.target) || state.pointerType === "virtual") return;
                // Only handle left clicks
                // Safari on iOS sometimes fires pointerup events, even
                // when the touch isn't over the target, so double check.
                if (e.button === 0 && $f6c31cce2adf654f$var$isOverTarget(e, e.currentTarget)) triggerPressUp(e, state.pointerType || e.pointerType);
            };
            // Safari on iOS < 13.2 does not implement pointerenter/pointerleave events correctly.
            // Use pointer move events instead to implement our own hit testing.
            // See https://bugs.webkit.org/show_bug.cgi?id=199803
            let onPointerMove = (e)=>{
                if (e.pointerId !== state.activePointerId) return;
                if ($f6c31cce2adf654f$var$isOverTarget(e, state.target)) {
                    if (!state.isOverTarget) {
                        state.isOverTarget = true;
                        triggerPressStart($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    }
                } else if (state.isOverTarget) {
                    state.isOverTarget = false;
                    triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    if (propsRef.current.shouldCancelOnPointerExit) cancel(e);
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0) {
                    if ($f6c31cce2adf654f$var$isOverTarget(e, state.target)) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    else if (state.isOverTarget) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    state.isPressed = false;
                    state.isOverTarget = false;
                    state.activePointerId = null;
                    state.pointerType = null;
                    removeAllGlobalListeners();
                    if (!allowTextSelectionOnPress) ($14c0b72509d70225$export$b0d6fa1ab32e3295)(state.target);
                }
            };
            let onPointerCancel = (e)=>{
                cancel(e);
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.
                cancel(e);
            };
        } else {
            pressProps.onMouseDown = (e)=>{
                // Only handle left clicks
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on mouse down and handle focusing the pressable element ourselves.
                if ($f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                e.stopPropagation();
                if (state.ignoreEmulatedMouseEvents) return;
                state.isPressed = true;
                state.isOverTarget = true;
                state.target = e.currentTarget;
                state.pointerType = ($6a7db85432448f7f$export$60278871457622de)(e.nativeEvent) ? "virtual" : "mouse";
                if (!isDisabled && !preventFocusOnPress) ($7215afc6de606d6b$export$de79e2c695e052f3)(e.currentTarget);
                triggerPressStart(e, state.pointerType);
                addGlobalListener(document, "mouseup", onMouseUp, false);
            };
            pressProps.onMouseEnter = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed && !state.ignoreEmulatedMouseEvents) {
                    state.isOverTarget = true;
                    triggerPressStart(e, state.pointerType);
                }
            };
            pressProps.onMouseLeave = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed && !state.ignoreEmulatedMouseEvents) {
                    state.isOverTarget = false;
                    triggerPressEnd(e, state.pointerType, false);
                    if (propsRef.current.shouldCancelOnPointerExit) cancel(e);
                }
            };
            pressProps.onMouseUp = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.ignoreEmulatedMouseEvents && e.button === 0) triggerPressUp(e, state.pointerType);
            };
            let onMouseUp = (e)=>{
                // Only handle left clicks
                if (e.button !== 0) return;
                state.isPressed = false;
                removeAllGlobalListeners();
                if (state.ignoreEmulatedMouseEvents) {
                    state.ignoreEmulatedMouseEvents = false;
                    return;
                }
                if ($f6c31cce2adf654f$var$isOverTarget(e, state.target)) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                else if (state.isOverTarget) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                state.isOverTarget = false;
            };
            pressProps.onTouchStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                let touch = $f6c31cce2adf654f$var$getTouchFromEvent(e.nativeEvent);
                if (!touch) return;
                state.activePointerId = touch.identifier;
                state.ignoreEmulatedMouseEvents = true;
                state.isOverTarget = true;
                state.isPressed = true;
                state.target = e.currentTarget;
                state.pointerType = "touch";
                // Due to browser inconsistencies, especially on mobile browsers, we prevent default
                // on the emulated mouse event and handle focusing the pressable element ourselves.
                if (!isDisabled && !preventFocusOnPress) ($7215afc6de606d6b$export$de79e2c695e052f3)(e.currentTarget);
                if (!allowTextSelectionOnPress) ($14c0b72509d70225$export$16a4697467175487)(state.target);
                triggerPressStart(e, state.pointerType);
                addGlobalListener(window, "scroll", onScroll, true);
            };
            pressProps.onTouchMove = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (!state.isPressed) return;
                let touch = $f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                if (touch && $f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
                    if (!state.isOverTarget) {
                        state.isOverTarget = true;
                        triggerPressStart(e, state.pointerType);
                    }
                } else if (state.isOverTarget) {
                    state.isOverTarget = false;
                    triggerPressEnd(e, state.pointerType, false);
                    if (propsRef.current.shouldCancelOnPointerExit) cancel(e);
                }
            };
            pressProps.onTouchEnd = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (!state.isPressed) return;
                let touch = $f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                if (touch && $f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
                    triggerPressUp(e, state.pointerType);
                    triggerPressEnd(e, state.pointerType);
                } else if (state.isOverTarget) triggerPressEnd(e, state.pointerType, false);
                state.isPressed = false;
                state.activePointerId = null;
                state.isOverTarget = false;
                state.ignoreEmulatedMouseEvents = true;
                if (!allowTextSelectionOnPress) ($14c0b72509d70225$export$b0d6fa1ab32e3295)(state.target);
                removeAllGlobalListeners();
            };
            pressProps.onTouchCancel = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed) cancel(e);
            };
            let onScroll = (e)=>{
                if (state.isPressed && e.target.contains(state.target)) cancel({
                    currentTarget: state.target,
                    shiftKey: false,
                    ctrlKey: false,
                    metaKey: false,
                    altKey: false
                });
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                cancel(e);
            };
        }
        return pressProps;
    }, [
        addGlobalListener,
        isDisabled,
        preventFocusOnPress,
        removeAllGlobalListeners,
        allowTextSelectionOnPress
    ]);
    // Remove user-select: none in case component unmounts immediately after pressStart
    // eslint-disable-next-line arrow-body-style
    (useEffect)(()=>{
        return ()=>{
            if (!allowTextSelectionOnPress) // eslint-disable-next-line react-hooks/exhaustive-deps
            ($14c0b72509d70225$export$b0d6fa1ab32e3295)(ref.current.target);
        };
    }, [
        allowTextSelectionOnPress
    ]);
    return {
        isPressed: isPressedProp || isPressed,
        pressProps: ($3ef42575df84b30b$export$9d1611c77c2fe928)(domProps, pressProps)
    };
}
function $f6c31cce2adf654f$var$isHTMLAnchorLink(target) {
    return target.tagName === "A" && target.hasAttribute("href");
}
function $f6c31cce2adf654f$var$isValidKeyboardEvent(event, currentTarget) {
    const { key: key , code: code  } = event;
    const element = currentTarget;
    const role = element.getAttribute("role");
    // Accessibility for keyboards. Space and Enter only.
    // "Spacebar" is for IE 11
    return (key === "Enter" || key === " " || key === "Spacebar" || code === "Space") && !(element instanceof HTMLInputElement && !$f6c31cce2adf654f$var$isValidInputKey(element, key) || element instanceof HTMLTextAreaElement || element.isContentEditable) && // A link with a valid href should be handled natively,
    // unless it also has role='button' and was triggered using Space.
    (!$f6c31cce2adf654f$var$isHTMLAnchorLink(element) || role === "button" && key !== "Enter") && // An element with role='link' should only trigger with Enter key
    !(role === "link" && key !== "Enter");
}
function $f6c31cce2adf654f$var$getTouchFromEvent(event) {
    const { targetTouches: targetTouches  } = event;
    if (targetTouches.length > 0) return targetTouches[0];
    return null;
}
function $f6c31cce2adf654f$var$getTouchById(event, pointerId) {
    const changedTouches = event.changedTouches;
    for(let i = 0; i < changedTouches.length; i++){
        const touch = changedTouches[i];
        if (touch.identifier === pointerId) return touch;
    }
    return null;
}
function $f6c31cce2adf654f$var$createEvent(target, e) {
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey
    };
}
function $f6c31cce2adf654f$var$getPointClientRect(point) {
    let offsetX = point.width / 2 || point.radiusX || 0;
    let offsetY = point.height / 2 || point.radiusY || 0;
    return {
        top: point.clientY - offsetY,
        right: point.clientX + offsetX,
        bottom: point.clientY + offsetY,
        left: point.clientX - offsetX
    };
}
function $f6c31cce2adf654f$var$areRectanglesOverlapping(a, b) {
    // check if they cannot overlap on x axis
    if (a.left > b.right || b.left > a.right) return false;
    // check if they cannot overlap on y axis
    if (a.top > b.bottom || b.top > a.bottom) return false;
    return true;
}
function $f6c31cce2adf654f$var$isOverTarget(point, target) {
    let rect = target.getBoundingClientRect();
    let pointRect = $f6c31cce2adf654f$var$getPointClientRect(point);
    return $f6c31cce2adf654f$var$areRectanglesOverlapping(rect, pointRect);
}
function $f6c31cce2adf654f$var$shouldPreventDefault(target) {
    // We cannot prevent default if the target is a draggable element.
    return !(target instanceof HTMLElement) || !target.draggable;
}
function $f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(target, key) {
    if (target instanceof HTMLInputElement) return !$f6c31cce2adf654f$var$isValidInputKey(target, key);
    if (target instanceof HTMLButtonElement) return target.type !== "submit";
    return true;
}
const $f6c31cce2adf654f$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
function $f6c31cce2adf654f$var$isValidInputKey(target, key) {
    // Only space should toggle checkboxes and radios, not enter.
    return target.type === "checkbox" || target.type === "radio" ? key === " " : $f6c31cce2adf654f$var$nonTextInputTypes.has(target.type);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

class $8a9cb279dc87e130$export$905e7fc544a71f36 {
    isDefaultPrevented() {
        return this.nativeEvent.defaultPrevented;
    }
    preventDefault() {
        this.defaultPrevented = true;
        this.nativeEvent.preventDefault();
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.isPropagationStopped = ()=>true;
    }
    isPropagationStopped() {
        return false;
    }
    persist() {}
    constructor(type, nativeEvent){
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
}
function $8a9cb279dc87e130$export$715c682d09d639cc(onBlur) {
    let stateRef = (useRef)({
        isFocused: false,
        onBlur: onBlur,
        observer: null
    });
    stateRef.current.onBlur = onBlur;
    // Clean up MutationObserver on unmount. See below.
    // eslint-disable-next-line arrow-body-style
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    // This function is called during a React onFocus event.
    return (useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e.target;
            let onBlurHandler = (e)=>{
                var // For backward compatibility, dispatch a (fake) React synthetic event.
                _stateRef_current, _stateRef_current_onBlur;
                stateRef.current.isFocused = false;
                if (target.disabled) (_stateRef_current_onBlur = (_stateRef_current = stateRef.current).onBlur) === null || _stateRef_current_onBlur === void 0 ? void 0 : _stateRef_current_onBlur.call(_stateRef_current, new $8a9cb279dc87e130$export$905e7fc544a71f36("blur", e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener("focusout", onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    stateRef.current.observer.disconnect();
                    target.dispatchEvent(new FocusEvent("blur"));
                    target.dispatchEvent(new FocusEvent("focusout", {
                        bubbles: true
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    "disabled"
                ]
            });
        }
    }, []);
}


function $a1ea59d68270f0dd$export$f8168d8dd8fd66e6(props) {
    let { isDisabled: isDisabled , onFocus: onFocusProp , onBlur: onBlurProp , onFocusChange: onFocusChange  } = props;
    const onBlur = (useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    const onSyntheticFocus = ($8a9cb279dc87e130$export$715c682d09d639cc)(onBlur);
    const onFocus = (useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : null
        }
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions


let $507fabe10e71c6fb$var$currentModality = null;
let $507fabe10e71c6fb$var$changeHandlers = new Set();
let $507fabe10e71c6fb$var$hasSetupGlobalListeners = false;
let $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !($c87311424ea30a05$export$9ac100e40613ea10)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($507fabe10e71c6fb$var$isValidKey(e)) {
        $507fabe10e71c6fb$var$currentModality = "keyboard";
        $507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $507fabe10e71c6fb$var$handlePointerEvent(e) {
    $507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $507fabe10e71c6fb$var$handleClickEvent(e) {
    if (($6a7db85432448f7f$export$60278871457622de)(e)) {
        $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$507fabe10e71c6fb$var$hasEventBeforeFocus && !$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $507fabe10e71c6fb$var$currentModality = "virtual";
        $507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $507fabe10e71c6fb$var$setupGlobalFocusEvents() {
    if (typeof window === "undefined" || $507fabe10e71c6fb$var$hasSetupGlobalListeners) return;
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = HTMLElement.prototype.focus;
    HTMLElement.prototype.focus = function() {
        $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    document.addEventListener("keydown", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
    document.addEventListener("keyup", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
    document.addEventListener("click", $507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    window.addEventListener("focus", $507fabe10e71c6fb$var$handleFocusEvent, true);
    window.addEventListener("blur", $507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        document.addEventListener("pointerdown", $507fabe10e71c6fb$var$handlePointerEvent, true);
        document.addEventListener("pointermove", $507fabe10e71c6fb$var$handlePointerEvent, true);
        document.addEventListener("pointerup", $507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        document.addEventListener("mousedown", $507fabe10e71c6fb$var$handlePointerEvent, true);
        document.addEventListener("mousemove", $507fabe10e71c6fb$var$handlePointerEvent, true);
        document.addEventListener("mouseup", $507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $507fabe10e71c6fb$var$hasSetupGlobalListeners = true;
}
if (typeof document !== "undefined") {
    if (document.readyState !== "loading") $507fabe10e71c6fb$var$setupGlobalFocusEvents();
    else document.addEventListener("DOMContentLoaded", $507fabe10e71c6fb$var$setupGlobalFocusEvents);
}
function $507fabe10e71c6fb$export$b9b3dfddab17db27() {
    return $507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $507fabe10e71c6fb$export$630ff653c5ada6a9() {
    return $507fabe10e71c6fb$var$currentModality;
}
function $507fabe10e71c6fb$export$8397ddfc504fdb9a(modality) {
    $507fabe10e71c6fb$var$currentModality = modality;
    $507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $507fabe10e71c6fb$export$98e20ec92f614cfe() {
    $507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (useState)($507fabe10e71c6fb$var$currentModality);
    (useEffect)(()=>{
        let handler = ()=>{
            setModality($507fabe10e71c6fb$var$currentModality);
        };
        $507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return modality;
}
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    return !(isTextInput && modality === "keyboard" && e instanceof KeyboardEvent && !$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $507fabe10e71c6fb$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$507fabe10e71c6fb$var$isKeyboardFocusEvent(opts === null || opts === void 0 ? void 0 : opts.isTextInput, modality, e)) return;
            fn($507fabe10e71c6fb$export$b9b3dfddab17db27());
        };
        $507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions


function $9ab94262bd0047c7$export$420e68273165f4ec(props) {
    let { isDisabled: isDisabled , onBlurWithin: onBlurWithin , onFocusWithin: onFocusWithin , onFocusWithinChange: onFocusWithinChange  } = props;
    let state = (useRef)({
        isFocusWithin: false
    });
    let onBlur = (useCallback)((e)=>{
        // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
        // when moving focus inside the element. Only trigger if the currentTarget doesn't
        // include the relatedTarget (where focus is moving).
        if (state.current.isFocusWithin && !e.currentTarget.contains(e.relatedTarget)) {
            state.current.isFocusWithin = false;
            if (onBlurWithin) onBlurWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(false);
        }
    }, [
        onBlurWithin,
        onFocusWithinChange,
        state
    ]);
    let onSyntheticFocus = ($8a9cb279dc87e130$export$715c682d09d639cc)(onBlur);
    let onFocus = (useCallback)((e)=>{
        if (!state.current.isFocusWithin) {
            if (onFocusWithin) onFocusWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(true);
            state.current.isFocusWithin = true;
            onSyntheticFocus(e);
        }
    }, [
        onFocusWithin,
        onFocusWithinChange,
        onSyntheticFocus
    ]);
    if (isDisabled) return {
        focusWithinProps: {
            onFocus: null,
            onBlur: null
        }
    };
    return {
        focusWithinProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions

// iOS fires onPointerEnter twice: once with pointerType="touch" and again with pointerType="mouse".
// We want to ignore these emulated events so they do not trigger hover behavior.
// See https://bugs.webkit.org/show_bug.cgi?id=214609.
let $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
let $6179b936705e76d3$var$hoverCount = 0;
function $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents() {
    $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = true;
    // Clear globalIgnoreEmulatedMouseEvents after a short timeout. iOS fires onPointerEnter
    // with pointerType="mouse" immediately after onPointerUp and before onFocus. On other
    // devices that don't have this quirk, we don't want to ignore a mouse hover sometime in
    // the distant future because a user previously touched the element.
    setTimeout(()=>{
        $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
    }, 50);
}
function $6179b936705e76d3$var$handleGlobalPointerEvent(e) {
    if (e.pointerType === "touch") $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $6179b936705e76d3$var$setupGlobalTouchEvents() {
    if (typeof document === "undefined") return;
    if (typeof PointerEvent !== "undefined") document.addEventListener("pointerup", $6179b936705e76d3$var$handleGlobalPointerEvent);
    else document.addEventListener("touchend", $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    $6179b936705e76d3$var$hoverCount++;
    return ()=>{
        $6179b936705e76d3$var$hoverCount--;
        if ($6179b936705e76d3$var$hoverCount > 0) return;
        if (typeof PointerEvent !== "undefined") document.removeEventListener("pointerup", $6179b936705e76d3$var$handleGlobalPointerEvent);
        else document.removeEventListener("touchend", $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    };
}
function $6179b936705e76d3$export$ae780daf29e6d456(props) {
    let { onHoverStart: onHoverStart , onHoverChange: onHoverChange , onHoverEnd: onHoverEnd , isDisabled: isDisabled  } = props;
    let [isHovered, setHovered] = (useState)(false);
    let state = (useRef)({
        isHovered: false,
        ignoreEmulatedMouseEvents: false,
        pointerType: "",
        target: null
    }).current;
    (useEffect)($6179b936705e76d3$var$setupGlobalTouchEvents, []);
    let { hoverProps: hoverProps , triggerHoverEnd: triggerHoverEnd  } = (useMemo)(()=>{
        let triggerHoverStart = (event, pointerType)=>{
            state.pointerType = pointerType;
            if (isDisabled || pointerType === "touch" || state.isHovered || !event.currentTarget.contains(event.target)) return;
            state.isHovered = true;
            let target = event.currentTarget;
            state.target = target;
            if (onHoverStart) onHoverStart({
                type: "hoverstart",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(true);
            setHovered(true);
        };
        let triggerHoverEnd = (event, pointerType)=>{
            state.pointerType = "";
            state.target = null;
            if (pointerType === "touch" || !state.isHovered) return;
            state.isHovered = false;
            let target = event.currentTarget;
            if (onHoverEnd) onHoverEnd({
                type: "hoverend",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(false);
            setHovered(false);
        };
        let hoverProps = {};
        if (typeof PointerEvent !== "undefined") {
            hoverProps.onPointerEnter = (e)=>{
                if ($6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && e.pointerType === "mouse") return;
                triggerHoverStart(e, e.pointerType);
            };
            hoverProps.onPointerLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, e.pointerType);
            };
        } else {
            hoverProps.onTouchStart = ()=>{
                state.ignoreEmulatedMouseEvents = true;
            };
            hoverProps.onMouseEnter = (e)=>{
                if (!state.ignoreEmulatedMouseEvents && !$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents) triggerHoverStart(e, "mouse");
                state.ignoreEmulatedMouseEvents = false;
            };
            hoverProps.onMouseLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, "mouse");
            };
        }
        return {
            hoverProps: hoverProps,
            triggerHoverEnd: triggerHoverEnd
        };
    }, [
        onHoverStart,
        onHoverChange,
        onHoverEnd,
        isDisabled,
        state
    ]);
    (useEffect)(()=>{
        // Call the triggerHoverEnd as soon as isDisabled changes to true
        // Safe to call triggerHoverEnd, it will early return if we aren't currently hovering
        if (isDisabled) triggerHoverEnd({
            currentTarget: state.target
        }, state.pointerType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDisabled
    ]);
    return {
        hoverProps: hoverProps,
        isHovered: isHovered
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions

function $e0b6e0b68ec7f50f$export$872b660ac5a1ff98(props) {
    let { ref: ref , onInteractOutside: onInteractOutside , isDisabled: isDisabled , onInteractOutsideStart: onInteractOutsideStart  } = props;
    let stateRef = (useRef)({
        isPointerDown: false,
        ignoreEmulatedMouseEvents: false,
        onInteractOutside: onInteractOutside,
        onInteractOutsideStart: onInteractOutsideStart
    });
    let state = stateRef.current;
    state.onInteractOutside = onInteractOutside;
    state.onInteractOutsideStart = onInteractOutsideStart;
    (useEffect)(()=>{
        if (isDisabled) return;
        let onPointerDown = (e)=>{
            if ($e0b6e0b68ec7f50f$var$isValidEvent(e, ref) && state.onInteractOutside) {
                if (state.onInteractOutsideStart) state.onInteractOutsideStart(e);
                state.isPointerDown = true;
            }
        };
        // Use pointer events if available. Otherwise, fall back to mouse and touch events.
        if (typeof PointerEvent !== "undefined") {
            let onPointerUp = (e)=>{
                if (state.isPointerDown && state.onInteractOutside && $e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) {
                    state.isPointerDown = false;
                    state.onInteractOutside(e);
                }
            };
            // changing these to capture phase fixed combobox
            document.addEventListener("pointerdown", onPointerDown, true);
            document.addEventListener("pointerup", onPointerUp, true);
            return ()=>{
                document.removeEventListener("pointerdown", onPointerDown, true);
                document.removeEventListener("pointerup", onPointerUp, true);
            };
        } else {
            let onMouseUp = (e)=>{
                if (state.ignoreEmulatedMouseEvents) state.ignoreEmulatedMouseEvents = false;
                else if (state.isPointerDown && state.onInteractOutside && $e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) {
                    state.isPointerDown = false;
                    state.onInteractOutside(e);
                }
            };
            let onTouchEnd = (e)=>{
                state.ignoreEmulatedMouseEvents = true;
                if (state.onInteractOutside && state.isPointerDown && $e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) {
                    state.isPointerDown = false;
                    state.onInteractOutside(e);
                }
            };
            document.addEventListener("mousedown", onPointerDown, true);
            document.addEventListener("mouseup", onMouseUp, true);
            document.addEventListener("touchstart", onPointerDown, true);
            document.addEventListener("touchend", onTouchEnd, true);
            return ()=>{
                document.removeEventListener("mousedown", onPointerDown, true);
                document.removeEventListener("mouseup", onMouseUp, true);
                document.removeEventListener("touchstart", onPointerDown, true);
                document.removeEventListener("touchend", onTouchEnd, true);
            };
        }
    }, [
        ref,
        state,
        isDisabled
    ]);
}
function $e0b6e0b68ec7f50f$var$isValidEvent(event, ref) {
    if (event.button > 0) return false;
    // if the event target is no longer in the document
    if (event.target) {
        const ownerDocument = event.target.ownerDocument;
        if (!ownerDocument || !ownerDocument.documentElement.contains(event.target)) return false;
    }
    return ref.current && !ref.current.contains(event.target);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $93925083ecbb358c$export$48d1ea6320830260(handler) {
    if (!handler) return;
    let shouldStopPropagation = true;
    return (e)=>{
        let event = {
            ...e,
            preventDefault () {
                e.preventDefault();
            },
            isDefaultPrevented () {
                return e.isDefaultPrevented();
            },
            stopPropagation () {
                console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
            },
            continuePropagation () {
                shouldStopPropagation = false;
            }
        };
        handler(event);
        if (shouldStopPropagation) e.stopPropagation();
    };
}


function $46d819fcbaf35654$export$8f71654801c2f7cd(props) {
    return {
        keyboardProps: props.isDisabled ? {} : {
            onKeyDown: ($93925083ecbb358c$export$48d1ea6320830260)(props.onKeyDown),
            onKeyUp: ($93925083ecbb358c$export$48d1ea6320830260)(props.onKeyUp)
        }
    };
}



/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

function $7d0a636d7a4dcefd$export$2123ff2b87c81ca(props, ref) {
    let { onScroll: onScroll , isDisabled: isDisabled  } = props;
    let onScrollHandler = (useCallback)((e)=>{
        // If the ctrlKey is pressed, this is a zoom event, do nothing.
        if (e.ctrlKey) return;
        // stop scrolling the page
        e.preventDefault();
        e.stopPropagation();
        if (onScroll) onScroll({
            deltaX: e.deltaX,
            deltaY: e.deltaY
        });
    }, [
        onScroll
    ]);
    ($e9faafb641e167db$export$90fc3a17d93f704c)(ref, "wheel", isDisabled ? null : onScrollHandler);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


const $8a26561d2877236e$var$DEFAULT_THRESHOLD = 500;
function $8a26561d2877236e$export$c24ed0104d07eab9(props) {
    let { isDisabled: isDisabled , onLongPressStart: onLongPressStart , onLongPressEnd: onLongPressEnd , onLongPress: onLongPress , threshold: threshold = $8a26561d2877236e$var$DEFAULT_THRESHOLD , accessibilityDescription: accessibilityDescription  } = props;
    const timeRef = (useRef)(null);
    let { addGlobalListener: addGlobalListener , removeGlobalListener: removeGlobalListener  } = ($03deb23ff14920c4$export$4eaf04e54aa8eed6)();
    let { pressProps: pressProps  } = ($f6c31cce2adf654f$export$45712eceda6fad21)({
        isDisabled: isDisabled,
        onPressStart (e) {
            if (e.pointerType === "mouse" || e.pointerType === "touch") {
                if (onLongPressStart) onLongPressStart({
                    ...e,
                    type: "longpressstart"
                });
                timeRef.current = setTimeout(()=>{
                    // Prevent other usePress handlers from also handling this event.
                    e.target.dispatchEvent(new PointerEvent("pointercancel", {
                        bubbles: true
                    }));
                    if (onLongPress) onLongPress({
                        ...e,
                        type: "longpress"
                    });
                    timeRef.current = null;
                }, threshold);
                // Prevent context menu, which may be opened on long press on touch devices
                if (e.pointerType === "touch") {
                    let onContextMenu = (e)=>{
                        e.preventDefault();
                    };
                    addGlobalListener(e.target, "contextmenu", onContextMenu, {
                        once: true
                    });
                    addGlobalListener(window, "pointerup", ()=>{
                        // If no contextmenu event is fired quickly after pointerup, remove the handler
                        // so future context menu events outside a long press are not prevented.
                        setTimeout(()=>{
                            removeGlobalListener(e.target, "contextmenu", onContextMenu);
                        }, 30);
                    }, {
                        once: true
                    });
                }
            }
        },
        onPressEnd (e) {
            if (timeRef.current) clearTimeout(timeRef.current);
            if (onLongPressEnd && (e.pointerType === "mouse" || e.pointerType === "touch")) onLongPressEnd({
                ...e,
                type: "longpressend"
            });
        }
    });
    let descriptionProps = ($ef06256079686ba0$export$f8aeda7b10753fa1)(onLongPress && !isDisabled ? accessibilityDescription : null);
    return {
        longPressProps: ($3ef42575df84b30b$export$9d1611c77c2fe928)(pressProps, descriptionProps)
    };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

function $6a99195332edec8b$export$80f3e147d781571c(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    if (($507fabe10e71c6fb$export$630ff653c5ada6a9)() === "virtual") {
        let lastFocusedElement = document.activeElement;
        ($bbed8b41f857bcc0$export$24490316f764c430)(()=>{
            // If focus did not move and the element is still in the document, focus it.
            if (document.activeElement === lastFocusedElement && document.contains(element)) ($7215afc6de606d6b$export$de79e2c695e052f3)(element);
        });
    } else ($7215afc6de606d6b$export$de79e2c695e052f3)(element);
}


/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $645f2e67b85a24c9$var$isStyleVisible(element) {
    if (!(element instanceof HTMLElement) && !(element instanceof SVGElement)) return false;
    let { display: display , visibility: visibility  } = element.style;
    let isVisible = display !== "none" && visibility !== "hidden" && visibility !== "collapse";
    if (isVisible) {
        const { getComputedStyle: getComputedStyle  } = element.ownerDocument.defaultView;
        let { display: computedDisplay , visibility: computedVisibility  } = getComputedStyle(element);
        isVisible = computedDisplay !== "none" && computedVisibility !== "hidden" && computedVisibility !== "collapse";
    }
    return isVisible;
}
function $645f2e67b85a24c9$var$isAttributeVisible(element, childElement) {
    return !element.hasAttribute("hidden") && (element.nodeName === "DETAILS" && childElement && childElement.nodeName !== "SUMMARY" ? element.hasAttribute("open") : true);
}
function $645f2e67b85a24c9$export$e989c0fffaa6b27a(element, childElement) {
    return element.nodeName !== "#comment" && $645f2e67b85a24c9$var$isStyleVisible(element) && $645f2e67b85a24c9$var$isAttributeVisible(element, childElement) && (!element.parentElement || $645f2e67b85a24c9$export$e989c0fffaa6b27a(element.parentElement, element));
}




const $9bf71ea28793e738$var$FocusContext = /*#__PURE__*/ (React__default).createContext(null);
let $9bf71ea28793e738$var$activeScope = null;
function $9bf71ea28793e738$export$20e40289641fbbb6(props) {
    let { children: children , contain: contain , restoreFocus: restoreFocus , autoFocus: autoFocus  } = props;
    let startRef = (useRef)();
    let endRef = (useRef)();
    let scopeRef = (useRef)([]);
    let ctx = (useContext)($9bf71ea28793e738$var$FocusContext);
    var _ctx_scopeRef;
    // The parent scope is based on the JSX tree, using context.
    // However, if a new scope mounts outside the active scope (e.g. DialogContainer launched from a menu),
    // we want the parent scope to be the active scope instead.
    let ctxParent = (_ctx_scopeRef = ctx === null || ctx === void 0 ? void 0 : ctx.scopeRef) !== null && _ctx_scopeRef !== void 0 ? _ctx_scopeRef : null;
    let parentScope = (useMemo)(()=>$9bf71ea28793e738$var$activeScope && $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope) && !$9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope, ctxParent) ? $9bf71ea28793e738$var$activeScope : ctxParent, [
        ctxParent
    ]);
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(()=>{
        // Find all rendered nodes between the sentinels and add them to the scope.
        let node = startRef.current.nextSibling;
        let nodes = [];
        while(node && node !== endRef.current){
            nodes.push(node);
            node = node.nextSibling;
        }
        scopeRef.current = nodes;
    }, [
        children,
        parentScope
    ]);
    // add to the focus scope tree in render order because useEffects/useLayoutEffects run children first whereas render runs parent first
    // which matters when constructing a tree
    if ($9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(parentScope) && !$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef)) $9bf71ea28793e738$export$d06fae2ee68b101e.addTreeNode(scopeRef, parentScope);
    let node = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
    node.contain = contain;
    $9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restoreFocus, contain);
    $9bf71ea28793e738$var$useFocusContainment(scopeRef, contain);
    $9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain);
    $9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus);
    // this layout effect needs to run last so that focusScopeTree cleanup happens at the last moment possible
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(()=>{
        if (scopeRef) return ()=>{
            // Scope may have been re-parented.
            let parentScope = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef).parent.scopeRef;
            // Restore the active scope on unmount if this scope or a descendant scope is active.
            // Parent effect cleanups run before children, so we need to check if the
            // parent scope actually still exists before restoring the active scope to it.
            if ((scopeRef === $9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope(scopeRef, $9bf71ea28793e738$var$activeScope)) && (!parentScope || $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(parentScope))) $9bf71ea28793e738$var$activeScope = parentScope;
            $9bf71ea28793e738$export$d06fae2ee68b101e.removeTreeNode(scopeRef);
        };
    }, [
        scopeRef,
        parentScope
    ]);
    let focusManager = $9bf71ea28793e738$var$createFocusManagerForScope(scopeRef);
    return /*#__PURE__*/ (React__default).createElement($9bf71ea28793e738$var$FocusContext.Provider, {
        value: {
            scopeRef: scopeRef,
            focusManager: focusManager
        }
    }, /*#__PURE__*/ (React__default).createElement("span", {
        "data-focus-scope-start": true,
        hidden: true,
        ref: startRef
    }), children, /*#__PURE__*/ (React__default).createElement("span", {
        "data-focus-scope-end": true,
        hidden: true,
        ref: endRef
    }));
}
function $9bf71ea28793e738$var$createFocusManagerForScope(scopeRef) {
    return {
        focusNext (opts = {}) {
            let scope = scopeRef.current;
            let { from: from , tabbable: tabbable , wrap: wrap , accept: accept  } = opts;
            let node = from || document.activeElement;
            let sentinel = scope[0].previousElementSibling;
            let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa($9bf71ea28793e738$var$getScopeRoot(scope), {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = sentinel;
                nextNode = walker.nextNode();
            }
            if (nextNode) $9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = {}) {
            let scope = scopeRef.current;
            let { from: from , tabbable: tabbable , wrap: wrap , accept: accept  } = opts;
            let node = from || document.activeElement;
            let sentinel = scope[scope.length - 1].nextElementSibling;
            let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa($9bf71ea28793e738$var$getScopeRoot(scope), {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = sentinel;
                previousNode = walker.previousNode();
            }
            if (previousNode) $9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        },
        focusFirst (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable , accept: accept  } = opts;
            let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa($9bf71ea28793e738$var$getScopeRoot(scope), {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[0].previousElementSibling;
            let nextNode = walker.nextNode();
            if (nextNode) $9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable , accept: accept  } = opts;
            let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa($9bf71ea28793e738$var$getScopeRoot(scope), {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[scope.length - 1].nextElementSibling;
            let previousNode = walker.previousNode();
            if (previousNode) $9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        }
    };
}
const $9bf71ea28793e738$var$focusableElements = [
    "input:not([disabled]):not([type=hidden])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[contenteditable]"
];
const $9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR = $9bf71ea28793e738$var$focusableElements.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
$9bf71ea28793e738$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const $9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR = $9bf71ea28793e738$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $9bf71ea28793e738$var$getScopeRoot(scope) {
    return scope[0].parentElement;
}
function $9bf71ea28793e738$var$shouldContainFocus(scopeRef) {
    let scope = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.contain) return false;
        scope = scope.parent;
    }
    return true;
}
function $9bf71ea28793e738$var$useFocusContainment(scopeRef, contain) {
    let focusedNode = (useRef)();
    let raf = (useRef)(null);
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(()=>{
        let scope = scopeRef.current;
        if (!contain) {
            // if contain was changed, then we should cancel any ongoing waits to pull focus back into containment
            if (raf.current) {
                cancelAnimationFrame(raf.current);
                raf.current = null;
            }
            return;
        }
        // Handle the Tab key to contain focus within the scope
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$9bf71ea28793e738$var$shouldContainFocus(scopeRef)) return;
            let focusedElement = document.activeElement;
            let scope = scopeRef.current;
            if (!$9bf71ea28793e738$var$isElementInScope(focusedElement, scope)) return;
            let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa($9bf71ea28793e738$var$getScopeRoot(scope), {
                tabbable: true
            }, scope);
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nextElement) {
                walker.currentNode = e.shiftKey ? scope[scope.length - 1].nextElementSibling : scope[0].previousElementSibling;
                nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            }
            e.preventDefault();
            if (nextElement) $9bf71ea28793e738$var$focusElement(nextElement, true);
        };
        let onFocus = (e)=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope, scopeRef)) && $9bf71ea28793e738$var$isElementInScope(e.target, scopeRef.current)) {
                $9bf71ea28793e738$var$activeScope = scopeRef;
                focusedNode.current = e.target;
            } else if ($9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$9bf71ea28793e738$var$isElementInChildScope(e.target, scopeRef)) {
                // If a focus event occurs outside the active scope (e.g. user tabs from browser location bar),
                // restore focus to the previously focused node or the first tabbable element in the active scope.
                if (focusedNode.current) focusedNode.current.focus();
                else if ($9bf71ea28793e738$var$activeScope) $9bf71ea28793e738$var$focusFirstInScope($9bf71ea28793e738$var$activeScope.current);
            } else if ($9bf71ea28793e738$var$shouldContainFocus(scopeRef)) focusedNode.current = e.target;
        };
        let onBlur = (e)=>{
            // Firefox doesn't shift focus back to the Dialog properly without this
            raf.current = requestAnimationFrame(()=>{
                // Use document.activeElement instead of e.relatedTarget so we can tell if user clicked into iframe
                if ($9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$9bf71ea28793e738$var$isElementInChildScope(document.activeElement, scopeRef)) {
                    $9bf71ea28793e738$var$activeScope = scopeRef;
                    if (document.body.contains(e.target)) {
                        focusedNode.current = e.target;
                        focusedNode.current.focus();
                    } else if ($9bf71ea28793e738$var$activeScope) $9bf71ea28793e738$var$focusFirstInScope($9bf71ea28793e738$var$activeScope.current);
                }
            });
        };
        document.addEventListener("keydown", onKeyDown, false);
        document.addEventListener("focusin", onFocus, false);
        scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        scope.forEach((element)=>element.addEventListener("focusout", onBlur, false));
        return ()=>{
            document.removeEventListener("keydown", onKeyDown, false);
            document.removeEventListener("focusin", onFocus, false);
            scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
            scope.forEach((element)=>element.removeEventListener("focusout", onBlur, false));
        };
    }, [
        scopeRef,
        contain
    ]);
    // eslint-disable-next-line arrow-body-style
    (useEffect)(()=>{
        return ()=>{
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, [
        raf
    ]);
}
function $9bf71ea28793e738$var$isElementInAnyScope(element) {
    return $9bf71ea28793e738$var$isElementInChildScope(element);
}
function $9bf71ea28793e738$var$isElementInScope(element, scope) {
    return scope.some((node)=>node.contains(element));
}
function $9bf71ea28793e738$var$isElementInChildScope(element, scope = null) {
    // node.contains in isElementInScope covers child scopes that are also DOM children,
    // but does not cover child scopes in portals.
    for (let { scopeRef: s  } of $9bf71ea28793e738$export$d06fae2ee68b101e.traverse($9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scope))){
        if ($9bf71ea28793e738$var$isElementInScope(element, s.current)) return true;
    }
    return false;
}
function $9bf71ea28793e738$export$1258395f99bf9cbf(element) {
    return $9bf71ea28793e738$var$isElementInChildScope(element, $9bf71ea28793e738$var$activeScope);
}
function $9bf71ea28793e738$var$isAncestorScope(ancestor, scope) {
    var _focusScopeTree_getTreeNode;
    let parent = (_focusScopeTree_getTreeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scope)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : _focusScopeTree_getTreeNode.parent;
    while(parent){
        if (parent.scopeRef === ancestor) return true;
        parent = parent.parent;
    }
    return false;
}
function $9bf71ea28793e738$var$focusElement(element, scroll = false) {
    if (element != null && !scroll) try {
        (0, $6a99195332edec8b$export$80f3e147d781571c)(element);
    } catch (err) {
    // ignore
    }
    else if (element != null) try {
        element.focus();
    } catch (err1) {
    // ignore
    }
}
function $9bf71ea28793e738$var$focusFirstInScope(scope, tabbable = true) {
    let sentinel = scope[0].previousElementSibling;
    let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa($9bf71ea28793e738$var$getScopeRoot(scope), {
        tabbable: tabbable
    }, scope);
    walker.currentNode = sentinel;
    let nextNode = walker.nextNode();
    // If the scope does not contain a tabbable element, use the first focusable element.
    if (tabbable && !nextNode) {
        walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa($9bf71ea28793e738$var$getScopeRoot(scope), {
            tabbable: false
        }, scope);
        walker.currentNode = sentinel;
        nextNode = walker.nextNode();
    }
    $9bf71ea28793e738$var$focusElement(nextNode);
}
function $9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus) {
    const autoFocusRef = (React__default).useRef(autoFocus);
    (useEffect)(()=>{
        if (autoFocusRef.current) {
            $9bf71ea28793e738$var$activeScope = scopeRef;
            if (!$9bf71ea28793e738$var$isElementInScope(document.activeElement, $9bf71ea28793e738$var$activeScope.current)) $9bf71ea28793e738$var$focusFirstInScope(scopeRef.current);
        }
        autoFocusRef.current = false;
    }, [
        scopeRef
    ]);
}
function $9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restore, contain) {
    // tracks the active scope, in case restore and contain are both false.
    // if either are true, this is tracked in useRestoreFocus or useFocusContainment.
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(()=>{
        if (restore || contain) return;
        let scope = scopeRef.current;
        let onFocus = (e)=>{
            let target = e.target;
            if ($9bf71ea28793e738$var$isElementInScope(target, scopeRef.current)) $9bf71ea28793e738$var$activeScope = scopeRef;
            else if (!$9bf71ea28793e738$var$isElementInAnyScope(target)) $9bf71ea28793e738$var$activeScope = null;
        };
        document.addEventListener("focusin", onFocus, false);
        scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            document.removeEventListener("focusin", onFocus, false);
            scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    }, [
        scopeRef,
        restore,
        contain
    ]);
}
function $9bf71ea28793e738$var$shouldRestoreFocus(scopeRef) {
    let scope = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.nodeToRestore) return false;
        scope = scope.parent;
    }
    return (scope === null || scope === void 0 ? void 0 : scope.scopeRef) === scopeRef;
}
function $9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain) {
    // create a ref during render instead of useLayoutEffect so the active element is saved before a child with autoFocus=true mounts.
    const nodeToRestoreRef = (useRef)(typeof document !== "undefined" ? document.activeElement : null);
    // restoring scopes should all track if they are active regardless of contain, but contain already tracks it plus logic to contain the focus
    // restoring-non-containing scopes should only care if they become active so they can perform the restore
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(()=>{
        let scope = scopeRef.current;
        if (!restoreFocus || contain) return;
        let onFocus = ()=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if (!$9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope, scopeRef)) $9bf71ea28793e738$var$activeScope = scopeRef;
        };
        document.addEventListener("focusin", onFocus, false);
        scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            document.removeEventListener("focusin", onFocus, false);
            scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scopeRef,
        contain
    ]);
    // useLayoutEffect instead of useEffect so the active element is saved synchronously instead of asynchronously.
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(()=>{
        if (!restoreFocus) return;
        $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef).nodeToRestore = nodeToRestoreRef.current;
        // Handle the Tab key so that tabbing out of the scope goes to the next element
        // after the node that had focus when the scope mounted. This is important when
        // using portals for overlays, so that focus goes to the expected element when
        // tabbing out of the overlay.
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey) return;
            let focusedElement = document.activeElement;
            if (!$9bf71ea28793e738$var$isElementInScope(focusedElement, scopeRef.current)) return;
            let nodeToRestore = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef).nodeToRestore;
            // Create a DOM tree walker that matches all tabbable elements
            let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(document.body, {
                tabbable: true
            });
            // Find the next tabbable element after the currently focused element
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!document.body.contains(nodeToRestore) || nodeToRestore === document.body) {
                nodeToRestore = null;
                $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef).nodeToRestore = null;
            }
            // If there is no next element, or it is outside the current scope, move focus to the
            // next element after the node to restore to instead.
            if ((!nextElement || !$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current)) && nodeToRestore) {
                walker.currentNode = nodeToRestore;
                // Skip over elements within the scope, in case the scope immediately follows the node to restore.
                do nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
                while ($9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current));
                e.preventDefault();
                e.stopPropagation();
                if (nextElement) $9bf71ea28793e738$var$focusElement(nextElement, true);
                else // If there is no next element and the nodeToRestore isn't within a FocusScope (i.e. we are leaving the top level focus scope)
                // then move focus to the body.
                // Otherwise restore focus to the nodeToRestore (e.g menu within a popover -> tabbing to close the menu should move focus to menu trigger)
                if (!$9bf71ea28793e738$var$isElementInAnyScope(nodeToRestore)) focusedElement.blur();
                else $9bf71ea28793e738$var$focusElement(nodeToRestore, true);
            }
        };
        if (!contain) document.addEventListener("keydown", onKeyDown, true);
        return ()=>{
            if (!contain) document.removeEventListener("keydown", onKeyDown, true);
            let nodeToRestore = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef).nodeToRestore;
            // if we already lost focus to the body and this was the active scope, then we should attempt to restore
            if (restoreFocus && nodeToRestore && // eslint-disable-next-line react-hooks/exhaustive-deps
            ($9bf71ea28793e738$var$isElementInScope(document.activeElement, scopeRef.current) || document.activeElement === document.body && $9bf71ea28793e738$var$shouldRestoreFocus(scopeRef))) {
                // freeze the focusScopeTree so it persists after the raf, otherwise during unmount nodes are removed from it
                let clonedTree = $9bf71ea28793e738$export$d06fae2ee68b101e.clone();
                requestAnimationFrame(()=>{
                    // Only restore focus if we've lost focus to the body, the alternative is that focus has been purposefully moved elsewhere
                    if (document.activeElement === document.body) {
                        // look up the tree starting with our scope to find a nodeToRestore still in the DOM
                        let treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.nodeToRestore && document.body.contains(treeNode.nodeToRestore)) {
                                $9bf71ea28793e738$var$focusElement(treeNode.nodeToRestore);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                        // If no nodeToRestore was found, focus the first element in the nearest
                        // ancestor scope that is still in the tree.
                        treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.scopeRef && $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(treeNode.scopeRef)) {
                                $9bf71ea28793e738$var$focusFirstInScope(treeNode.scopeRef.current, true);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                    }
                });
            }
        };
    }, [
        scopeRef,
        restoreFocus,
        contain
    ]);
}
function $9bf71ea28793e738$export$2d6ec8fc375ceafa(root, opts, scope) {
    let selector = (opts === null || opts === void 0 ? void 0 : opts.tabbable) ? $9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR : $9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR;
    let walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
        acceptNode (node) {
            var _opts_from;
            // Skip nodes inside the starting node.
            if (opts === null || opts === void 0 ? void 0 : (_opts_from = opts.from) === null || _opts_from === void 0 ? void 0 : _opts_from.contains(node)) return NodeFilter.FILTER_REJECT;
            if (node.matches(selector) && ($645f2e67b85a24c9$export$e989c0fffaa6b27a)(node) && (!scope || $9bf71ea28793e738$var$isElementInScope(node, scope)) && (!(opts === null || opts === void 0 ? void 0 : opts.accept) || opts.accept(node))) return NodeFilter.FILTER_ACCEPT;
            return NodeFilter.FILTER_SKIP;
        }
    });
    if (opts === null || opts === void 0 ? void 0 : opts.from) walker.currentNode = opts.from;
    return walker;
}
class $9bf71ea28793e738$var$Tree {
    get size() {
        return this.fastMap.size;
    }
    getTreeNode(data) {
        return this.fastMap.get(data);
    }
    addTreeNode(scopeRef, parent, nodeToRestore) {
        let parentNode = this.fastMap.get(parent !== null && parent !== void 0 ? parent : null);
        let node = new $9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        });
        parentNode.addChild(node);
        node.parent = parentNode;
        this.fastMap.set(scopeRef, node);
        if (nodeToRestore) node.nodeToRestore = nodeToRestore;
    }
    removeTreeNode(scopeRef) {
        // never remove the root
        if (scopeRef === null) return;
        let node = this.fastMap.get(scopeRef);
        let parentNode = node.parent;
        // when we remove a scope, check if any sibling scopes are trying to restore focus to something inside the scope we're removing
        // if we are, then replace the siblings restore with the restore from the scope we're removing
        for (let current of this.traverse())if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef.current && $9bf71ea28793e738$var$isElementInScope(current.nodeToRestore, node.scopeRef.current)) current.nodeToRestore = node.nodeToRestore;
        let children = node.children;
        parentNode.removeChild(node);
        if (children.length > 0) children.forEach((child)=>parentNode.addChild(child));
        this.fastMap.delete(node.scopeRef);
    }
    // Pre Order Depth First
    *traverse(node = this.root) {
        if (node.scopeRef != null) yield node;
        if (node.children.length > 0) for (let child of node.children)yield* this.traverse(child);
    }
    clone() {
        let newTree = new $9bf71ea28793e738$var$Tree();
        for (let node of this.traverse())newTree.addTreeNode(node.scopeRef, node.parent.scopeRef, node.nodeToRestore);
        return newTree;
    }
    constructor(){
        (_defineProperty)(this, "fastMap", new Map());
        this.root = new $9bf71ea28793e738$var$TreeNode({
            scopeRef: null
        });
        this.fastMap.set(null, this.root);
    }
}
class $9bf71ea28793e738$var$TreeNode {
    addChild(node) {
        this.children.push(node);
        node.parent = this;
    }
    removeChild(node) {
        this.children.splice(this.children.indexOf(node), 1);
        node.parent = undefined;
    }
    constructor(props){
        (_defineProperty)(this, "children", []);
        (_defineProperty)(this, "contain", false);
        this.scopeRef = props.scopeRef;
    }
}
let $9bf71ea28793e738$export$d06fae2ee68b101e = new $9bf71ea28793e738$var$Tree();


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 





function $f7dceffc5ad7768b$export$4e328f61c538687f(props = {}) {
    let { autoFocus: autoFocus = false , isTextInput: isTextInput , within: within  } = props;
    let state = (useRef)({
        isFocused: false,
        isFocusVisible: autoFocus || ($507fabe10e71c6fb$export$b9b3dfddab17db27)()
    });
    let [isFocused, setFocused] = (useState)(false);
    let [isFocusVisibleState, setFocusVisible] = (useState)(()=>state.current.isFocused && state.current.isFocusVisible);
    let updateState = (useCallback)(()=>setFocusVisible(state.current.isFocused && state.current.isFocusVisible), []);
    let onFocusChange = (useCallback)((isFocused)=>{
        state.current.isFocused = isFocused;
        setFocused(isFocused);
        updateState();
    }, [
        updateState
    ]);
    ($507fabe10e71c6fb$export$ec71b4b83ac08ec3)((isFocusVisible)=>{
        state.current.isFocusVisible = isFocusVisible;
        updateState();
    }, [], {
        isTextInput: isTextInput
    });
    let { focusProps: focusProps  } = ($a1ea59d68270f0dd$export$f8168d8dd8fd66e6)({
        isDisabled: within,
        onFocusChange: onFocusChange
    });
    let { focusWithinProps: focusWithinProps  } = ($9ab94262bd0047c7$export$420e68273165f4ec)({
        isDisabled: !within,
        onFocusWithinChange: onFocusChange
    });
    return {
        isFocused: isFocused,
        isFocusVisible: state.current.isFocused && isFocusVisibleState,
        focusProps: within ? focusWithinProps : focusProps
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 



let $e6afbd83fe6ebbd2$var$FocusableContext = /*#__PURE__*/ (React__default).createContext(null);
function $e6afbd83fe6ebbd2$var$useFocusableContext(ref) {
    let context = (useContext)($e6afbd83fe6ebbd2$var$FocusableContext) || {};
    ($e7801be82b4b2a53$export$4debdb1a3f0fa79e)(context, ref);
    // eslint-disable-next-line
    let { ref: _ , ...otherProps } = context;
    return otherProps;
}
function $e6afbd83fe6ebbd2$export$4c014de7c8940b4c(props, domRef) {
    let { focusProps: focusProps  } = ($a1ea59d68270f0dd$export$f8168d8dd8fd66e6)(props);
    let { keyboardProps: keyboardProps  } = ($46d819fcbaf35654$export$8f71654801c2f7cd)(props);
    let interactions = ($3ef42575df84b30b$export$9d1611c77c2fe928)(focusProps, keyboardProps);
    let domProps = $e6afbd83fe6ebbd2$var$useFocusableContext(domRef);
    let interactionProps = props.isDisabled ? {} : domProps;
    let autoFocusRef = (useRef)(props.autoFocus);
    (useEffect)(()=>{
        if (autoFocusRef.current && domRef.current) ($6a99195332edec8b$export$80f3e147d781571c)(domRef.current);
        autoFocusRef.current = false;
    }, [
        domRef
    ]);
    return {
        focusableProps: ($3ef42575df84b30b$export$9d1611c77c2fe928)({
            ...interactions,
            tabIndex: props.excludeFromTabOrder && !props.isDisabled ? -1 : undefined
        }, interactionProps)
    };
}

/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $5b160d28a433310d$export$c17fa47878dc55b6 {
    /** Returns a localized string for the given key and locale. */ getStringForLocale(key, locale) {
        let strings = this.strings[locale];
        if (!strings) {
            strings = $5b160d28a433310d$var$getStringsForLocale(locale, this.strings, this.defaultLocale);
            this.strings[locale] = strings;
        }
        let string = strings[key];
        if (!string) throw new Error(`Could not find intl message ${key} in ${locale} locale`);
        return string;
    }
    constructor(messages, defaultLocale = "en-US"){
        // Clone messages so we don't modify the original object.
        this.strings = {
            ...messages
        };
        this.defaultLocale = defaultLocale;
    }
}
function $5b160d28a433310d$var$getStringsForLocale(locale, strings, defaultLocale = "en-US") {
    // If there is an exact match, use it.
    if (strings[locale]) return strings[locale];
    // Attempt to find the closest match by language.
    // For example, if the locale is fr-CA (French Canadian), but there is only
    // an fr-FR (France) set of strings, use that.
    // This could be replaced with Intl.LocaleMatcher once it is supported.
    // https://github.com/tc39/proposal-intl-localematcher
    let language = $5b160d28a433310d$var$getLanguage(locale);
    if (strings[language]) return strings[language];
    for(let key in strings){
        if (key.startsWith(language + "-")) return strings[key];
    }
    // Nothing close, use english.
    return strings[defaultLocale];
}
function $5b160d28a433310d$var$getLanguage(locale) {
    // @ts-ignore
    if (Intl.Locale) // @ts-ignore
    return new Intl.Locale(locale).language;
    return locale.split("-")[0];
}


/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $6db58dc88e78b024$var$pluralRulesCache = new Map();
const $6db58dc88e78b024$var$numberFormatCache = new Map();
class $6db58dc88e78b024$export$2f817fcdc4b89ae0 {
    /** Formats a localized string for the given key with the provided variables. */ format(key, variables) {
        let message = this.strings.getStringForLocale(key, this.locale);
        return typeof message === "function" ? message(variables, this) : message;
    }
    plural(count, options, type = "cardinal") {
        let opt = options["=" + count];
        if (opt) return typeof opt === "function" ? opt() : opt;
        let key = this.locale + ":" + type;
        let pluralRules = $6db58dc88e78b024$var$pluralRulesCache.get(key);
        if (!pluralRules) {
            pluralRules = new Intl.PluralRules(this.locale, {
                type: type
            });
            $6db58dc88e78b024$var$pluralRulesCache.set(key, pluralRules);
        }
        let selected = pluralRules.select(count);
        opt = options[selected] || options.other;
        return typeof opt === "function" ? opt() : opt;
    }
    number(value) {
        let numberFormat = $6db58dc88e78b024$var$numberFormatCache.get(this.locale);
        if (!numberFormat) {
            numberFormat = new Intl.NumberFormat(this.locale);
            $6db58dc88e78b024$var$numberFormatCache.set(this.locale, numberFormat);
        }
        return numberFormat.format(value);
    }
    select(options, value) {
        let opt = options[value] || options.other;
        return typeof opt === "function" ? opt() : opt;
    }
    constructor(locale, strings){
        this.locale = locale;
        this.strings = strings;
    }
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $488c6ddbf4ef74c2$var$formatterCache = new Map();
let $488c6ddbf4ef74c2$var$supportsSignDisplay = false;
try {
    // @ts-ignore
    $488c6ddbf4ef74c2$var$supportsSignDisplay = new Intl.NumberFormat("de-DE", {
        signDisplay: "exceptZero"
    }).resolvedOptions().signDisplay === "exceptZero";
// eslint-disable-next-line no-empty
} catch (e) {}
let $488c6ddbf4ef74c2$var$supportsUnit = false;
try {
    // @ts-ignore
    $488c6ddbf4ef74c2$var$supportsUnit = new Intl.NumberFormat("de-DE", {
        style: "unit",
        unit: "degree"
    }).resolvedOptions().style === "unit";
// eslint-disable-next-line no-empty
} catch (e1) {}
// Polyfill for units since Safari doesn't support them yet. See https://bugs.webkit.org/show_bug.cgi?id=215438.
// Currently only polyfilling the unit degree in narrow format for ColorSlider in our supported locales.
// Values were determined by switching to each locale manually in Chrome.
const $488c6ddbf4ef74c2$var$UNITS = {
    degree: {
        narrow: {
            default: "\xb0",
            "ja-JP": " 度",
            "zh-TW": "度",
            "sl-SI": " \xb0"
        }
    }
};
class $488c6ddbf4ef74c2$export$cc77c4ff7e8673c5 {
    /** Formats a number value as a string, according to the locale and options provided to the constructor. */ format(value) {
        let res = "";
        if (!$488c6ddbf4ef74c2$var$supportsSignDisplay && this.options.signDisplay != null) res = $488c6ddbf4ef74c2$export$711b50b3c525e0f2(this.numberFormatter, this.options.signDisplay, value);
        else res = this.numberFormatter.format(value);
        if (this.options.style === "unit" && !$488c6ddbf4ef74c2$var$supportsUnit) {
            var _UNITS_unit;
            let { unit: unit , unitDisplay: unitDisplay = "short" , locale: locale  } = this.resolvedOptions();
            let values = (_UNITS_unit = $488c6ddbf4ef74c2$var$UNITS[unit]) === null || _UNITS_unit === void 0 ? void 0 : _UNITS_unit[unitDisplay];
            res += values[locale] || values.default;
        }
        return res;
    }
    /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */ formatToParts(value) {
        // TODO: implement signDisplay for formatToParts
        // @ts-ignore
        return this.numberFormatter.formatToParts(value);
    }
    /** Formats a number range as a string. */ formatRange(start, end) {
        // @ts-ignore
        if (typeof this.numberFormatter.formatRange === "function") // @ts-ignore
        return this.numberFormatter.formatRange(start, end);
        if (end < start) throw new RangeError("End date must be >= start date");
        // Very basic fallback for old browsers.
        return `${this.format(start)} – ${this.format(end)}`;
    }
    /** Formats a number range as an array of parts. */ formatRangeToParts(start, end) {
        // @ts-ignore
        if (typeof this.numberFormatter.formatRangeToParts === "function") // @ts-ignore
        return this.numberFormatter.formatRangeToParts(start, end);
        if (end < start) throw new RangeError("End date must be >= start date");
        let startParts = this.numberFormatter.formatToParts(start);
        let endParts = this.numberFormatter.formatToParts(end);
        return [
            ...startParts.map((p)=>({
                    ...p,
                    source: "startRange"
                })),
            {
                type: "literal",
                value: " – ",
                source: "shared"
            },
            ...endParts.map((p)=>({
                    ...p,
                    source: "endRange"
                }))
        ];
    }
    /** Returns the resolved formatting options based on the values passed to the constructor. */ resolvedOptions() {
        let options = this.numberFormatter.resolvedOptions();
        if (!$488c6ddbf4ef74c2$var$supportsSignDisplay && this.options.signDisplay != null) options = {
            ...options,
            signDisplay: this.options.signDisplay
        };
        if (!$488c6ddbf4ef74c2$var$supportsUnit && this.options.style === "unit") options = {
            ...options,
            style: "unit",
            unit: this.options.unit,
            unitDisplay: this.options.unitDisplay
        };
        return options;
    }
    constructor(locale, options = {}){
        this.numberFormatter = $488c6ddbf4ef74c2$var$getCachedNumberFormatter(locale, options);
        this.options = options;
    }
}
function $488c6ddbf4ef74c2$var$getCachedNumberFormatter(locale, options = {}) {
    let { numberingSystem: numberingSystem  } = options;
    if (numberingSystem && locale.indexOf("-u-nu-") === -1) locale = `${locale}-u-nu-${numberingSystem}`;
    if (options.style === "unit" && !$488c6ddbf4ef74c2$var$supportsUnit) {
        var _UNITS_unit;
        let { unit: unit , unitDisplay: unitDisplay = "short"  } = options;
        if (!unit) throw new Error('unit option must be provided with style: "unit"');
        if (!((_UNITS_unit = $488c6ddbf4ef74c2$var$UNITS[unit]) === null || _UNITS_unit === void 0 ? void 0 : _UNITS_unit[unitDisplay])) throw new Error(`Unsupported unit ${unit} with unitDisplay = ${unitDisplay}`);
        options = {
            ...options,
            style: "decimal"
        };
    }
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    if ($488c6ddbf4ef74c2$var$formatterCache.has(cacheKey)) return $488c6ddbf4ef74c2$var$formatterCache.get(cacheKey);
    let numberFormatter = new Intl.NumberFormat(locale, options);
    $488c6ddbf4ef74c2$var$formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
function $488c6ddbf4ef74c2$export$711b50b3c525e0f2(numberFormat, signDisplay, num) {
    if (signDisplay === "auto") return numberFormat.format(num);
    else if (signDisplay === "never") return numberFormat.format(Math.abs(num));
    else {
        let needsPositiveSign = false;
        if (signDisplay === "always") needsPositiveSign = num > 0 || Object.is(num, 0);
        else if (signDisplay === "exceptZero") {
            if (Object.is(num, -0) || Object.is(num, 0)) num = Math.abs(num);
            else needsPositiveSign = num > 0;
        }
        if (needsPositiveSign) {
            let negative = numberFormat.format(-num);
            let noSign = numberFormat.format(num);
            // ignore RTL/LTR marker character
            let minus = negative.replace(noSign, "").replace(/\u200e|\u061C/, "");
            if ([
                ...minus
            ].length !== 1) console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case");
            let positive = negative.replace(noSign, "!!!").replace(minus, "+").replace("!!!", noSign);
            return positive;
        } else return numberFormat.format(num);
    }
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $6c7bd7858deea686$var$CURRENCY_SIGN_REGEX = new RegExp("^.*\\(.*\\).*$");
const $6c7bd7858deea686$var$NUMBERING_SYSTEMS = [
    "latn",
    "arab",
    "hanidec"
];
class $6c7bd7858deea686$export$cd11ab140839f11d {
    /**
   * Parses the given string to a number. Returns NaN if a valid number could not be parsed.
   */ parse(value) {
        return $6c7bd7858deea686$var$getNumberParserImpl(this.locale, this.options, value).parse(value);
    }
    /**
   * Returns whether the given string could potentially be a valid number. This should be used to
   * validate user input as the user types. If a `minValue` or `maxValue` is provided, the validity
   * of the minus/plus sign characters can be checked.
   */ isValidPartialNumber(value, minValue, maxValue) {
        return $6c7bd7858deea686$var$getNumberParserImpl(this.locale, this.options, value).isValidPartialNumber(value, minValue, maxValue);
    }
    /**
   * Returns a numbering system for which the given string is valid in the current locale.
   * If no numbering system could be detected, the default numbering system for the current
   * locale is returned.
   */ getNumberingSystem(value) {
        return $6c7bd7858deea686$var$getNumberParserImpl(this.locale, this.options, value).options.numberingSystem;
    }
    constructor(locale, options = {}){
        this.locale = locale;
        this.options = options;
    }
}
const $6c7bd7858deea686$var$numberParserCache = new Map();
function $6c7bd7858deea686$var$getNumberParserImpl(locale, options, value) {
    // First try the default numbering system for the provided locale
    let defaultParser = $6c7bd7858deea686$var$getCachedNumberParser(locale, options);
    // If that doesn't match, and the locale doesn't include a hard coded numbering system,
    // try each of the other supported numbering systems until we find one that matches.
    if (!locale.includes("-nu-") && !defaultParser.isValidPartialNumber(value)) {
        for (let numberingSystem of $6c7bd7858deea686$var$NUMBERING_SYSTEMS)if (numberingSystem !== defaultParser.options.numberingSystem) {
            let parser = $6c7bd7858deea686$var$getCachedNumberParser(locale + (locale.includes("-u-") ? "-nu-" : "-u-nu-") + numberingSystem, options);
            if (parser.isValidPartialNumber(value)) return parser;
        }
    }
    return defaultParser;
}
function $6c7bd7858deea686$var$getCachedNumberParser(locale, options) {
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    let parser = $6c7bd7858deea686$var$numberParserCache.get(cacheKey);
    if (!parser) {
        parser = new $6c7bd7858deea686$var$NumberParserImpl(locale, options);
        $6c7bd7858deea686$var$numberParserCache.set(cacheKey, parser);
    }
    return parser;
}
// The actual number parser implementation. Instances of this class are cached
// based on the locale, options, and detected numbering system.
class $6c7bd7858deea686$var$NumberParserImpl {
    parse(value) {
        // to parse the number, we need to remove anything that isn't actually part of the number, for example we want '-10.40' not '-10.40 USD'
        let fullySanitizedValue = this.sanitize(value);
        // Remove group characters, and replace decimal points and numerals with ASCII values.
        fullySanitizedValue = $6c7bd7858deea686$var$replaceAll(fullySanitizedValue, this.symbols.group, "").replace(this.symbols.decimal, ".").replace(this.symbols.minusSign, "-").replace(this.symbols.numeral, this.symbols.index);
        let newValue = fullySanitizedValue ? +fullySanitizedValue : NaN;
        if (isNaN(newValue)) return NaN;
        // accounting will always be stripped to a positive number, so if it's accounting and has a () around everything, then we need to make it negative again
        if (this.options.currencySign === "accounting" && $6c7bd7858deea686$var$CURRENCY_SIGN_REGEX.test(value)) newValue = -1 * newValue;
        // when reading the number, if it's a percent, then it should be interpreted as being divided by 100
        if (this.options.style === "percent") {
            newValue /= 100;
            var _this_options_maximumFractionDigits;
            // after dividing to get the percent value, javascript may get .0210999999 instead of .0211, so fix the number of fraction digits
            newValue = +newValue.toFixed(((_this_options_maximumFractionDigits = this.options.maximumFractionDigits) !== null && _this_options_maximumFractionDigits !== void 0 ? _this_options_maximumFractionDigits : 0) + 2);
        }
        return newValue;
    }
    sanitize(value) {
        // Remove literals and whitespace, which are allowed anywhere in the string
        value = value.replace(this.symbols.literals, "");
        // Replace the ASCII minus sign with the minus sign used in the current locale
        // so that both are allowed in case the user's keyboard doesn't have the locale's minus sign.
        value = value.replace("-", this.symbols.minusSign);
        // In arab numeral system, their decimal character is 1643, but most keyboards don't type that
        // instead they use the , (44) character or apparently the (1548) character.
        if (this.options.numberingSystem === "arab") {
            value = value.replace(",", this.symbols.decimal);
            value = value.replace(String.fromCharCode(1548), this.symbols.decimal);
            value = $6c7bd7858deea686$var$replaceAll(value, ".", this.symbols.group);
        }
        // fr-FR group character is char code 8239, but that's not a key on the french keyboard,
        // so allow 'period' as a group char and replace it with a space
        if (this.options.locale === "fr-FR") value = $6c7bd7858deea686$var$replaceAll(value, ".", String.fromCharCode(8239));
        return value;
    }
    isValidPartialNumber(value, minValue = -Infinity, maxValue = Infinity) {
        value = this.sanitize(value);
        // Remove minus or plus sign, which must be at the start of the string.
        if (value.startsWith(this.symbols.minusSign) && minValue < 0) value = value.slice(this.symbols.minusSign.length);
        else if (this.symbols.plusSign && value.startsWith(this.symbols.plusSign) && maxValue > 0) value = value.slice(this.symbols.plusSign.length);
        // Numbers cannot start with a group separator
        if (value.startsWith(this.symbols.group)) return false;
        // Remove numerals, groups, and decimals
        value = $6c7bd7858deea686$var$replaceAll(value, this.symbols.group, "").replace(this.symbols.numeral, "").replace(this.symbols.decimal, "");
        // The number is valid if there are no remaining characters
        return value.length === 0;
    }
    constructor(locale, options = {}){
        this.formatter = new Intl.NumberFormat(locale, options);
        this.options = this.formatter.resolvedOptions();
        this.symbols = $6c7bd7858deea686$var$getSymbols(this.formatter, this.options, options);
    }
}
const $6c7bd7858deea686$var$nonLiteralParts = new Set([
    "decimal",
    "fraction",
    "integer",
    "minusSign",
    "plusSign",
    "group"
]);
function $6c7bd7858deea686$var$getSymbols(formatter, intlOptions, originalOptions) {
    var _allParts_find, _posAllParts_find, _allParts_find1, _allParts_find2;
    // Note: some locale's don't add a group symbol until there is a ten thousands place
    let allParts = formatter.formatToParts(-10000.111);
    let posAllParts = formatter.formatToParts(10000.111);
    let singularParts = formatter.formatToParts(1);
    var _allParts_find_value;
    let minusSign = (_allParts_find_value = (_allParts_find = allParts.find((p)=>p.type === "minusSign")) === null || _allParts_find === void 0 ? void 0 : _allParts_find.value) !== null && _allParts_find_value !== void 0 ? _allParts_find_value : "-";
    let plusSign = (_posAllParts_find = posAllParts.find((p)=>p.type === "plusSign")) === null || _posAllParts_find === void 0 ? void 0 : _posAllParts_find.value;
    // Safari does not support the signDisplay option, but our number parser polyfills it.
    // If no plus sign was returned, but the original options contained signDisplay, default to the '+' character.
    // @ts-ignore
    if (!plusSign && ((originalOptions === null || originalOptions === void 0 ? void 0 : originalOptions.signDisplay) === "exceptZero" || (originalOptions === null || originalOptions === void 0 ? void 0 : originalOptions.signDisplay) === "always")) plusSign = "+";
    let decimal = (_allParts_find1 = allParts.find((p)=>p.type === "decimal")) === null || _allParts_find1 === void 0 ? void 0 : _allParts_find1.value;
    let group = (_allParts_find2 = allParts.find((p)=>p.type === "group")) === null || _allParts_find2 === void 0 ? void 0 : _allParts_find2.value;
    // this set is also for a regex, it's all literals that might be in the string we want to eventually parse that
    // don't contribute to the numerical value
    let pluralLiterals = allParts.filter((p)=>!$6c7bd7858deea686$var$nonLiteralParts.has(p.type)).map((p)=>$6c7bd7858deea686$var$escapeRegex(p.value));
    let singularLiterals = singularParts.filter((p)=>!$6c7bd7858deea686$var$nonLiteralParts.has(p.type)).map((p)=>$6c7bd7858deea686$var$escapeRegex(p.value));
    let sortedLiterals = [
        ...new Set([
            ...singularLiterals,
            ...pluralLiterals
        ])
    ].sort((a, b)=>b.length - a.length);
    let literals = sortedLiterals.length === 0 ? new RegExp("[\\p{White_Space}]", "gu") : new RegExp(`${sortedLiterals.join("|")}|[\\p{White_Space}]`, "gu");
    // These are for replacing non-latn characters with the latn equivalent
    let numerals = [
        ...new Intl.NumberFormat(intlOptions.locale, {
            useGrouping: false
        }).format(9876543210)
    ].reverse();
    let indexes = new Map(numerals.map((d, i)=>[
            d,
            i
        ]));
    let numeral = new RegExp(`[${numerals.join("")}]`, "g");
    let index = (d)=>String(indexes.get(d));
    return {
        minusSign: minusSign,
        plusSign: plusSign,
        decimal: decimal,
        group: group,
        literals: literals,
        numeral: numeral,
        index: index
    };
}
function $6c7bd7858deea686$var$replaceAll(str, find, replace) {
    // @ts-ignore
    if (str.replaceAll) // @ts-ignore
    return str.replaceAll(find, replace);
    return str.split(find).join(replace);
}
function $6c7bd7858deea686$var$escapeRegex(string) {
    return string.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // https://en.wikipedia.org/wiki/Right-to-left
const $148a7a147e38ea7f$var$RTL_SCRIPTS = new Set([
    "Arab",
    "Syrc",
    "Samr",
    "Mand",
    "Thaa",
    "Mend",
    "Nkoo",
    "Adlm",
    "Rohg",
    "Hebr"
]);
const $148a7a147e38ea7f$var$RTL_LANGS = new Set([
    "ae",
    "ar",
    "arc",
    "bcc",
    "bqi",
    "ckb",
    "dv",
    "fa",
    "glk",
    "he",
    "ku",
    "mzn",
    "nqo",
    "pnb",
    "ps",
    "sd",
    "ug",
    "ur",
    "yi"
]);
function $148a7a147e38ea7f$export$702d680b21cbd764(locale) {
    // If the Intl.Locale API is available, use it to get the script for the locale.
    // This is more accurate than guessing by language, since languages can be written in multiple scripts.
    // @ts-ignore
    if (Intl.Locale) {
        // @ts-ignore
        let script = new Intl.Locale(locale).maximize().script;
        return $148a7a147e38ea7f$var$RTL_SCRIPTS.has(script);
    }
    // If not, just guess by the language (first part of the locale)
    let lang = locale.split("-")[0];
    return $148a7a147e38ea7f$var$RTL_LANGS.has(lang);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


function $1e5a04cdaf7d1af8$export$f09106e7c6677ec5() {
    // @ts-ignore
    let locale = typeof navigator !== "undefined" && (navigator.language || navigator.userLanguage) || "en-US";
    try {
        // @ts-ignore
        Intl.DateTimeFormat.supportedLocalesOf([
            locale
        ]);
    } catch (_err) {
        locale = "en-US";
    }
    return {
        locale: locale,
        direction: ($148a7a147e38ea7f$export$702d680b21cbd764)(locale) ? "rtl" : "ltr"
    };
}
let $1e5a04cdaf7d1af8$var$currentLocale = $1e5a04cdaf7d1af8$export$f09106e7c6677ec5();
let $1e5a04cdaf7d1af8$var$listeners = new Set();
function $1e5a04cdaf7d1af8$var$updateLocale() {
    $1e5a04cdaf7d1af8$var$currentLocale = $1e5a04cdaf7d1af8$export$f09106e7c6677ec5();
    for (let listener of $1e5a04cdaf7d1af8$var$listeners)listener($1e5a04cdaf7d1af8$var$currentLocale);
}
function $1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a() {
    let isSSR = ($704cf1d3b684cc5c$export$535bd6ca7f90a273)();
    let [defaultLocale, setDefaultLocale] = (useState)($1e5a04cdaf7d1af8$var$currentLocale);
    (useEffect)(()=>{
        if ($1e5a04cdaf7d1af8$var$listeners.size === 0) window.addEventListener("languagechange", $1e5a04cdaf7d1af8$var$updateLocale);
        $1e5a04cdaf7d1af8$var$listeners.add(setDefaultLocale);
        return ()=>{
            $1e5a04cdaf7d1af8$var$listeners.delete(setDefaultLocale);
            if ($1e5a04cdaf7d1af8$var$listeners.size === 0) window.removeEventListener("languagechange", $1e5a04cdaf7d1af8$var$updateLocale);
        };
    }, []);
    // We cannot determine the browser's language on the server, so default to
    // en-US. This will be updated after hydration on the client to the correct value.
    if (isSSR) return {
        locale: "en-US",
        direction: "ltr"
    };
    return defaultLocale;
}



const $18f2051aff69b9bf$var$I18nContext = /*#__PURE__*/ (React__default).createContext(null);
function $18f2051aff69b9bf$export$43bb16f9c6d9e3f7() {
    let defaultLocale = ($1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a)();
    let context = (useContext)($18f2051aff69b9bf$var$I18nContext);
    return context || defaultLocale;
}


/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


const $fca6afa0e843324b$var$cache = new WeakMap();
function $fca6afa0e843324b$var$getCachedDictionary(strings) {
    let dictionary = $fca6afa0e843324b$var$cache.get(strings);
    if (!dictionary) {
        dictionary = new ($5b160d28a433310d$export$c17fa47878dc55b6)(strings);
        $fca6afa0e843324b$var$cache.set(strings, dictionary);
    }
    return dictionary;
}
function $fca6afa0e843324b$export$f12b703ca79dfbb1(strings) {
    let { locale: locale  } = ($18f2051aff69b9bf$export$43bb16f9c6d9e3f7)();
    let dictionary = (useMemo)(()=>$fca6afa0e843324b$var$getCachedDictionary(strings), [
        strings
    ]);
    return (useMemo)(()=>new ($6db58dc88e78b024$export$2f817fcdc4b89ae0)(locale, dictionary), [
        locale,
        dictionary
    ]);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


function $a916eb452884faea$export$b7a616150fdb9f44(options = {}) {
    let { locale: locale  } = ($18f2051aff69b9bf$export$43bb16f9c6d9e3f7)();
    return (useMemo)(()=>new ($488c6ddbf4ef74c2$export$cc77c4ff7e8673c5)(locale, options), [
        locale,
        options
    ]);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
let $325a3faab7a68acd$var$cache = new Map();
function $325a3faab7a68acd$export$a16aca283550c30d(options) {
    let { locale: locale  } = ($18f2051aff69b9bf$export$43bb16f9c6d9e3f7)();
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    if ($325a3faab7a68acd$var$cache.has(cacheKey)) return $325a3faab7a68acd$var$cache.get(cacheKey);
    let formatter = new Intl.Collator(locale, options);
    $325a3faab7a68acd$var$cache.set(cacheKey, formatter);
    return formatter;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
function $bb77f239b46e8c72$export$3274cf84b703fff(options) {
    let collator = ($325a3faab7a68acd$export$a16aca283550c30d)({
        usage: "search",
        ...options
    });
    // TODO(later): these methods don't currently support the ignorePunctuation option.
    return {
        startsWith (string, substring) {
            if (substring.length === 0) return true;
            // Normalize both strings so we can slice safely
            // TODO: take into account the ignorePunctuation option as well...
            string = string.normalize("NFC");
            substring = substring.normalize("NFC");
            return collator.compare(string.slice(0, substring.length), substring) === 0;
        },
        endsWith (string, substring) {
            if (substring.length === 0) return true;
            string = string.normalize("NFC");
            substring = substring.normalize("NFC");
            return collator.compare(string.slice(-substring.length), substring) === 0;
        },
        contains (string, substring) {
            if (substring.length === 0) return true;
            string = string.normalize("NFC");
            substring = substring.normalize("NFC");
            let scan = 0;
            let sliceLen = substring.length;
            for(; scan + sliceLen <= string.length; scan++){
                let slice = string.slice(scan, scan + sliceLen);
                if (collator.compare(substring, slice) === 0) return true;
            }
            return false;
        }
    };
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var ErrorKind;
(function (ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */
    ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */
    ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */
    ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */
    ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */
    ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */
    ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */
    ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */
    ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */
    ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */
    ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */
    ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */
    ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */
    ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */
    ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */
    ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */
    ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */
    ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})(ErrorKind || (ErrorKind = {}));

var TYPE;
(function (TYPE) {
    /**
     * Raw text
     */
    TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */
    TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */
    TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */
    TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */
    TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */
    TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */
    TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */
    TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */
    TYPE[TYPE["tag"] = 8] = "tag";
})(TYPE || (TYPE = {}));
var SKELETON_TYPE;
(function (SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})(SKELETON_TYPE || (SKELETON_TYPE = {}));
/**
 * Type Guards
 */
function isLiteralElement(el) {
    return el.type === TYPE.literal;
}
function isArgumentElement(el) {
    return el.type === TYPE.argument;
}
function isNumberElement(el) {
    return el.type === TYPE.number;
}
function isDateElement(el) {
    return el.type === TYPE.date;
}
function isTimeElement(el) {
    return el.type === TYPE.time;
}
function isSelectElement(el) {
    return el.type === TYPE.select;
}
function isPluralElement(el) {
    return el.type === TYPE.plural;
}
function isPoundElement(el) {
    return el.type === TYPE.pound;
}
function isTagElement(el) {
    return el.type === TYPE.tag;
}
function isNumberSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.number);
}
function isDateTimeSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.dateTime);
}

// @generated from regex-gen.ts
var SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;

/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */
var DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
/**
 * Parse Date time skeleton into Intl.DateTimeFormatOptions
 * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * @public
 * @param skeleton skeleton string
 */
function parseDateTimeSkeleton(skeleton) {
    var result = {};
    skeleton.replace(DATE_TIME_REGEX, function (match) {
        var len = match.length;
        switch (match[0]) {
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = ['numeric', '2-digit'][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) {
                    throw new RangeError('`e..eee` (weekday) patterns are not supported');
                }
                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
                break;
            case 'c':
                if (len < 4) {
                    throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                }
                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
                break;
            // Period
            case 'a': // AM, PM
                result.hour12 = true;
                break;
            case 'b': // am, pm, noon, midnight
            case 'B': // flexible day periods
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = ['numeric', '2-digit'][len - 1];
                break;
            // Second
            case 's':
                result.second = ['numeric', '2-digit'][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z': // 1..3, 4: specific non-location format
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
            case 'O': // 1, 4: miliseconds in day short, long
            case 'v': // 1, 4: generic non-location format
            case 'V': // 1, 2, 3, 4: time zone ID or city
            case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
            case 'x': // 1, 2, 3, 4: The ISO8601 varios formats
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

// @generated from regex-gen.ts
var WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

function parseNumberSkeletonFromString(skeleton) {
    if (skeleton.length === 0) {
        throw new Error('Number skeleton cannot be empty');
    }
    // Parse the skeleton
    var stringTokens = skeleton
        .split(WHITE_SPACE_REGEX)
        .filter(function (x) { return x.length > 0; });
    var tokens = [];
    for (var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++) {
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) {
            throw new Error('Invalid number skeleton');
        }
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for (var _a = 0, options_1 = options; _a < options_1.length; _a++) {
            var option = options_1[_a];
            if (option.length === 0) {
                throw new Error('Invalid number skeleton');
            }
        }
        tokens.push({ stem: stem, options: options });
    }
    return tokens;
}
function icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') {
        result.roundingPriority = 'morePrecision';
    }
    else if (str[str.length - 1] === 's') {
        result.roundingPriority = 'lessPrecision';
    }
    str.replace(SIGNIFICANT_PRECISION_REGEX, function (_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        }
        // @@@+ case
        else if (g2 === '+') {
            result.minimumSignificantDigits = g1.length;
        }
        // .### case
        else if (g1[0] === '#') {
            result.maximumSignificantDigits = g1.length;
        }
        // .@@## or .@@@ case
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits =
                g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function parseSign(str) {
    switch (str) {
        case 'sign-auto':
            return {
                signDisplay: 'auto',
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting',
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always',
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting',
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero',
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting',
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never',
            };
    }
}
function parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering',
        };
        stem = stem.slice(2);
    }
    else if (stem[0] === 'E') {
        result = {
            notation: 'scientific',
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        }
        else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!CONCISE_INTEGER_WIDTH_REGEX.test(stem)) {
            throw new Error('Malformed concise eng/scientific notation');
        }
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function parseNotationOptions(opt) {
    var result = {};
    var signOpts = parseSign(opt);
    if (signOpts) {
        return signOpts;
    }
    return result;
}
/**
 * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
 */
function parseNumberSkeleton(tokens) {
    var result = {};
    for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
        var token = tokens_1[_i];
        switch (token.stem) {
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = __assign(__assign(__assign({}, result), { notation: 'scientific' }), token.options.reduce(function (all, opt) { return (__assign(__assign({}, all), parseNotationOptions(opt))); }, {}));
                continue;
            case 'engineering':
                result = __assign(__assign(__assign({}, result), { notation: 'engineering' }), token.options.reduce(function (all, opt) { return (__assign(__assign({}, all), parseNotationOptions(opt))); }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) {
                    throw new RangeError('integer-width stems only accept a single optional option');
                }
                token.options[0].replace(INTEGER_WIDTH_REGEX, function (_, g1, g2, g3, g4, g5) {
                    if (g1) {
                        result.minimumIntegerDigits = g2.length;
                    }
                    else if (g3 && g4) {
                        throw new Error('We currently do not support maximum integer digits');
                    }
                    else if (g5) {
                        throw new Error('We currently do not support exact integer digits');
                    }
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if (CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if (FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) {
                throw new RangeError('Fraction-precision stems only accept a single optional option');
            }
            token.stem.replace(FRACTION_PRECISION_REGEX, function (_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') {
                    result.minimumFractionDigits = g1.length;
                }
                // .### case
                else if (g3 && g3[0] === '#') {
                    result.maximumFractionDigits = g3.length;
                }
                // .00## case
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                }
                else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') {
                result = __assign(__assign({}, result), { trailingZeroDisplay: 'stripIfInteger' });
            }
            else if (opt) {
                result = __assign(__assign({}, result), parseSignificantPrecision(opt));
            }
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if (SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = __assign(__assign({}, result), parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = parseSign(token.stem);
        if (signOpts) {
            result = __assign(__assign({}, result), signOpts);
        }
        var conciseScientificAndEngineeringOpts = parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) {
            result = __assign(__assign({}, result), conciseScientificAndEngineeringOpts);
        }
    }
    return result;
}

// @generated from time-data-gen.ts
// prettier-ignore  
var timeData = {
    "AX": [
        "H"
    ],
    "BQ": [
        "H"
    ],
    "CP": [
        "H"
    ],
    "CZ": [
        "H"
    ],
    "DK": [
        "H"
    ],
    "FI": [
        "H"
    ],
    "ID": [
        "H"
    ],
    "IS": [
        "H"
    ],
    "ML": [
        "H"
    ],
    "NE": [
        "H"
    ],
    "RU": [
        "H"
    ],
    "SE": [
        "H"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "AS": [
        "h",
        "H"
    ],
    "BT": [
        "h",
        "H"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "GH": [
        "h",
        "H"
    ],
    "IN": [
        "h",
        "H"
    ],
    "LS": [
        "h",
        "H"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PW": [
        "h",
        "H"
    ],
    "SO": [
        "h",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WS": [
        "h",
        "H"
    ],
    "001": [
        "H",
        "h"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ]
};

/**
 * Returns the best matching date time pattern if a date time skeleton
 * pattern is provided with a locale. Follows the Unicode specification:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#table-mapping-requested-time-skeletons-to-patterns
 * @param skeleton date time skeleton pattern that possibly includes j, J or C
 * @param locale
 */
function getBestPattern(skeleton, locale) {
    var skeletonCopy = '';
    for (var patternPos = 0; patternPos < skeleton.length; patternPos++) {
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while (patternPos + 1 < skeleton.length &&
                skeleton.charAt(patternPos + 1) === patternChar) {
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') {
                dayPeriodLen = 0;
            }
            while (dayPeriodLen-- > 0) {
                skeletonCopy += dayPeriodChar;
            }
            while (hourLen-- > 0) {
                skeletonCopy = hourChar + skeletonCopy;
            }
        }
        else if (patternChar === 'J') {
            skeletonCopy += 'H';
        }
        else {
            skeletonCopy += patternChar;
        }
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */
function getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined &&
        // @ts-ignore hourCycle(s) is not identified yet
        locale.hourCycles &&
        // @ts-ignore
        locale.hourCycles.length) {
        // @ts-ignore
        hourCycle = locale.hourCycles[0];
    }
    if (hourCycle) {
        switch (hourCycle) {
            case 'h24':
                return 'k';
            case 'h23':
                return 'H';
            case 'h12':
                return 'h';
            case 'h11':
                return 'K';
            default:
                throw new Error('Invalid hourCycle');
        }
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') {
        regionTag = locale.maximize().region;
    }
    var hourCycles = timeData[regionTag || ''] ||
        timeData[languageTag || ''] ||
        timeData["".concat(languageTag, "-001")] ||
        timeData['001'];
    return hourCycles[0];
}

var _a;
var SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat(SPACE_SEPARATOR_REGEX.source, "*"));
var SPACE_SEPARATOR_END_REGEX = new RegExp("".concat(SPACE_SEPARATOR_REGEX.source, "*$"));
function createLocation(start, end) {
    return { start: start, end: end };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var hasNativeStartsWith = !!String.prototype.startsWith;
var hasNativeFromCodePoint = !!String.fromCodePoint;
var hasNativeFromEntries = !!Object.fromEntries;
var hasNativeCodePointAt = !!String.prototype.codePointAt;
var hasTrimStart = !!String.prototype.trimStart;
var hasTrimEnd = !!String.prototype.trimEnd;
var hasNativeIsSafeInteger = !!Number.isSafeInteger;
var isSafeInteger = hasNativeIsSafeInteger
    ? Number.isSafeInteger
    : function (n) {
        return (typeof n === 'number' &&
            isFinite(n) &&
            Math.floor(n) === n &&
            Math.abs(n) <= 0x1fffffffffffff);
    };
// IE11 does not support y and u.
var REGEX_SUPPORTS_U_AND_Y = true;
try {
    var re = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */
    REGEX_SUPPORTS_U_AND_Y = ((_a = re.exec('a')) === null || _a === void 0 ? void 0 : _a[0]) === 'a';
}
catch (_) {
    REGEX_SUPPORTS_U_AND_Y = false;
}
var startsWith = hasNativeStartsWith
    ? // Native
        function startsWith(s, search, position) {
            return s.startsWith(search, position);
        }
    : // For IE11
        function startsWith(s, search, position) {
            return s.slice(position, position + search.length) === search;
        };
var fromCodePoint = hasNativeFromCodePoint
    ? String.fromCodePoint
    : // IE11
        function fromCodePoint() {
            var codePoints = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                codePoints[_i] = arguments[_i];
            }
            var elements = '';
            var length = codePoints.length;
            var i = 0;
            var code;
            while (length > i) {
                code = codePoints[i++];
                if (code > 0x10ffff)
                    throw RangeError(code + ' is not a valid code point');
                elements +=
                    code < 0x10000
                        ? String.fromCharCode(code)
                        : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, (code % 0x400) + 0xdc00);
            }
            return elements;
        };
var fromEntries = 
// native
hasNativeFromEntries
    ? Object.fromEntries
    : // Ponyfill
        function fromEntries(entries) {
            var obj = {};
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var _a = entries_1[_i], k = _a[0], v = _a[1];
                obj[k] = v;
            }
            return obj;
        };
var codePointAt = hasNativeCodePointAt
    ? // Native
        function codePointAt(s, index) {
            return s.codePointAt(index);
        }
    : // IE 11
        function codePointAt(s, index) {
            var size = s.length;
            if (index < 0 || index >= size) {
                return undefined;
            }
            var first = s.charCodeAt(index);
            var second;
            return first < 0xd800 ||
                first > 0xdbff ||
                index + 1 === size ||
                (second = s.charCodeAt(index + 1)) < 0xdc00 ||
                second > 0xdfff
                ? first
                : ((first - 0xd800) << 10) + (second - 0xdc00) + 0x10000;
        };
var trimStart = hasTrimStart
    ? // Native
        function trimStart(s) {
            return s.trimStart();
        }
    : // Ponyfill
        function trimStart(s) {
            return s.replace(SPACE_SEPARATOR_START_REGEX, '');
        };
var trimEnd = hasTrimEnd
    ? // Native
        function trimEnd(s) {
            return s.trimEnd();
        }
    : // Ponyfill
        function trimEnd(s) {
            return s.replace(SPACE_SEPARATOR_END_REGEX, '');
        };
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var matchIdentifierAtIndex;
if (REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var IDENTIFIER_PREFIX_RE_1 = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
}
else {
    // IE11
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var match = [];
        while (true) {
            var c = codePointAt(s, index);
            if (c === undefined || _isWhiteSpace(c) || _isPatternSyntax(c)) {
                break;
            }
            match.push(c);
            index += c >= 0x10000 ? 2 : 1;
        }
        return fromCodePoint.apply(void 0, match);
    };
}
var Parser = /** @class */ (function () {
    function Parser(message, options) {
        if (options === void 0) { options = {}; }
        this.message = message;
        this.position = { offset: 0, line: 1, column: 1 };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function () {
        if (this.offset() !== 0) {
            throw Error('parser can only be used once');
        }
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function (nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while (!this.isEOF()) {
            var char = this.char();
            if (char === 123 /* `{` */) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
            else if (char === 125 /* `}` */ && nestingLevel > 0) {
                break;
            }
            else if (char === 35 /* `#` */ &&
                (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: TYPE.pound,
                    location: createLocation(position, this.clonePosition()),
                });
            }
            else if (char === 60 /* `<` */ &&
                !this.ignoreTag &&
                this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) {
                    break;
                }
                else {
                    return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(this.clonePosition(), this.clonePosition()));
                }
            }
            else if (char === 60 /* `<` */ &&
                !this.ignoreTag &&
                _isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
            else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
        }
        return { val: elements, err: null };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */
    Parser.prototype.parseTag = function (nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) {
            // Self closing tag
            return {
                val: {
                    type: TYPE.literal,
                    value: "<".concat(tagName, "/>"),
                    location: createLocation(startPosition, this.clonePosition()),
                },
                err: null,
            };
        }
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) {
                return childrenResult;
            }
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !_isAlpha(this.char())) {
                    return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                }
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) {
                    return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(closingTagNameStartPosition, this.clonePosition()));
                }
                this.bumpSpace();
                if (!this.bumpIf('>')) {
                    return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                }
                return {
                    val: {
                        type: TYPE.tag,
                        value: tagName,
                        children: children,
                        location: createLocation(startPosition, this.clonePosition()),
                    },
                    err: null,
                };
            }
            else {
                return this.error(ErrorKind.UNCLOSED_TAG, createLocation(startPosition, this.clonePosition()));
            }
        }
        else {
            return this.error(ErrorKind.INVALID_TAG, createLocation(startPosition, this.clonePosition()));
        }
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */
    Parser.prototype.parseTagName = function () {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while (!this.isEOF() && _isPotentialElementNameChar(this.char())) {
            this.bump();
        }
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function (nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while (true) {
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = createLocation(start, this.clonePosition());
        return {
            val: { type: TYPE.literal, value: value, location: location },
            err: null,
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function () {
        if (!this.isEOF() &&
            this.char() === 60 /* `<` */ &&
            (this.ignoreTag ||
                // If at the opening tag or closing tag position, bail.
                !_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */
    Parser.prototype.tryParseQuote = function (parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */) {
            return null;
        }
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch (this.peek()) {
            case 39 /* `'` */:
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35: // '#'
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') {
                    break;
                }
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [this.char()]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while (!this.isEOF()) {
            var ch = this.char();
            if (ch === 39 /* `'` */) {
                if (this.peek() === 39 /* `'` */) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                }
                else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            }
            else {
                codePoints.push(ch);
            }
            this.bump();
        }
        return fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function (nestingLevel, parentArgType) {
        if (this.isEOF()) {
            return null;
        }
        var ch = this.char();
        if (ch === 60 /* `<` */ ||
            ch === 123 /* `{` */ ||
            (ch === 35 /* `#` */ &&
                (parentArgType === 'plural' || parentArgType === 'selectordinal')) ||
            (ch === 125 /* `}` */ && nestingLevel > 0)) {
            return null;
        }
        else {
            this.bump();
            return fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function (nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        if (this.char() === 125 /* `}` */) {
            this.bump();
            return this.error(ErrorKind.EMPTY_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) {
            return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        this.bumpSpace();
        if (this.isEOF()) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        switch (this.char()) {
            // Simple argument: `{name}`
            case 125 /* `}` */: {
                this.bump(); // `}`
                return {
                    val: {
                        type: TYPE.argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: createLocation(openingBracePosition, this.clonePosition()),
                    },
                    err: null,
                };
            }
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */: {
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) {
                    return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
                }
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            }
            default:
                return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */
    Parser.prototype.parseIdentifierIfPossible = function () {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = createLocation(startingPosition, endPosition);
        return { value: value, location: location };
    };
    Parser.prototype.parseArgumentOptions = function (nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch (argType) {
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error(ErrorKind.EXPECT_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time': {
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) {
                        return result;
                    }
                    var style = trimEnd(result.val);
                    if (style.length === 0) {
                        return this.error(ErrorKind.EXPECT_ARGUMENT_STYLE, createLocation(this.clonePosition(), this.clonePosition()));
                    }
                    var styleLocation = createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = { style: style, styleLocation: styleLocation };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) {
                    return argCloseResult;
                }
                var location_1 = createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) {
                            return result;
                        }
                        return {
                            val: { type: TYPE.number, value: value, location: location_1, style: result.val },
                            err: null,
                        };
                    }
                    else {
                        if (skeleton.length === 0) {
                            return this.error(ErrorKind.EXPECT_DATE_TIME_SKELETON, location_1);
                        }
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) {
                            dateTimePattern = getBestPattern(skeleton, this.locale);
                        }
                        var style = {
                            type: SKELETON_TYPE.dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons
                                ? parseDateTimeSkeleton(dateTimePattern)
                                : {},
                        };
                        var type = argType === 'date' ? TYPE.date : TYPE.time;
                        return {
                            val: { type: type, value: value, location: location_1, style: style },
                            err: null,
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number'
                            ? TYPE.number
                            : argType === 'date'
                                ? TYPE.date
                                : TYPE.time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null,
                    },
                    err: null,
                };
            }
            case 'plural':
            case 'selectordinal':
            case 'select': {
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) {
                    return this.error(ErrorKind.EXPECT_SELECT_ARGUMENT_OPTIONS, createLocation(typeEndPosition_1, __assign({}, typeEndPosition_1)));
                }
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) {
                        return this.error(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, createLocation(this.clonePosition(), this.clonePosition()));
                    }
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, ErrorKind.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) {
                        return result;
                    }
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) {
                    return optionsResult;
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) {
                    return argCloseResult;
                }
                var location_2 = createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') {
                    return {
                        val: {
                            type: TYPE.select,
                            value: value,
                            options: fromEntries(optionsResult.val),
                            location: location_2,
                        },
                        err: null,
                    };
                }
                else {
                    return {
                        val: {
                            type: TYPE.plural,
                            value: value,
                            options: fromEntries(optionsResult.val),
                            offset: pluralOffset,
                            pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                            location: location_2,
                        },
                        err: null,
                    };
                }
            }
            default:
                return this.error(ErrorKind.INVALID_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function (openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        this.bump(); // `}`
        return { val: true, err: null };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */
    Parser.prototype.parseSimpleArgStyleIfPossible = function () {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while (!this.isEOF()) {
            var ch = this.char();
            switch (ch) {
                case 39 /* `'` */: {
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) {
                        return this.error(ErrorKind.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, createLocation(apostrophePosition, this.clonePosition()));
                    }
                    this.bump();
                    break;
                }
                case 123 /* `{` */: {
                    nestedBraces += 1;
                    this.bump();
                    break;
                }
                case 125 /* `}` */: {
                    if (nestedBraces > 0) {
                        nestedBraces -= 1;
                    }
                    else {
                        return {
                            val: this.message.slice(startPosition.offset, this.offset()),
                            err: null,
                        };
                    }
                    break;
                }
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null,
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function (skeleton, location) {
        var tokens = [];
        try {
            tokens = parseNumberSkeletonFromString(skeleton);
        }
        catch (e) {
            return this.error(ErrorKind.INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: SKELETON_TYPE.number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons
                    ? parseNumberSkeleton(tokens)
                    : {},
            },
            err: null,
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */
    Parser.prototype.tryParsePluralOrSelectOptions = function (nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while (true) {
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, ErrorKind.INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) {
                        return result;
                    }
                    selectorLocation = createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                }
                else {
                    break;
                }
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) {
                return this.error(parentArgType === 'select'
                    ? ErrorKind.DUPLICATE_SELECT_ARGUMENT_SELECTOR
                    : ErrorKind.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            }
            if (selector === 'other') {
                hasOtherClause = true;
            }
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) {
                return this.error(parentArgType === 'select'
                    ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT
                    : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, createLocation(this.clonePosition(), this.clonePosition()));
            }
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) {
                return fragmentResult;
            }
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) {
                return argCloseResult;
            }
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: createLocation(openingBracePosition, this.clonePosition()),
                },
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            (_a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location);
        }
        if (options.length === 0) {
            return this.error(parentArgType === 'select'
                ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR
                : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, createLocation(this.clonePosition(), this.clonePosition()));
        }
        if (this.requiresOtherClause && !hasOtherClause) {
            return this.error(ErrorKind.MISSING_OTHER_CLAUSE, createLocation(this.clonePosition(), this.clonePosition()));
        }
        return { val: options, err: null };
    };
    Parser.prototype.tryParseDecimalInteger = function (expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) {
            sign = -1;
        }
        var hasDigits = false;
        var decimal = 0;
        while (!this.isEOF()) {
            var ch = this.char();
            if (ch >= 48 /* `0` */ && ch <= 57 /* `9` */) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            }
            else {
                break;
            }
        }
        var location = createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) {
            return this.error(expectNumberError, location);
        }
        decimal *= sign;
        if (!isSafeInteger(decimal)) {
            return this.error(invalidNumberError, location);
        }
        return { val: decimal, err: null };
    };
    Parser.prototype.offset = function () {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function () {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function () {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column,
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */
    Parser.prototype.char = function () {
        var offset = this.position.offset;
        if (offset >= this.message.length) {
            throw Error('out of bound');
        }
        var code = codePointAt(this.message, offset);
        if (code === undefined) {
            throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        }
        return code;
    };
    Parser.prototype.error = function (kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location,
            },
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */
    Parser.prototype.bump = function () {
        if (this.isEOF()) {
            return;
        }
        var code = this.char();
        if (code === 10 /* '\n' */) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        }
        else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */
    Parser.prototype.bumpIf = function (prefix) {
        if (startsWith(this.message, prefix, this.offset())) {
            for (var i = 0; i < prefix.length; i++) {
                this.bump();
            }
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */
    Parser.prototype.bumpUntil = function (pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        }
        else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */
    Parser.prototype.bumpTo = function (targetOffset) {
        if (this.offset() > targetOffset) {
            throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        }
        targetOffset = Math.min(targetOffset, this.message.length);
        while (true) {
            var offset = this.offset();
            if (offset === targetOffset) {
                break;
            }
            if (offset > targetOffset) {
                throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            }
            this.bump();
            if (this.isEOF()) {
                break;
            }
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */
    Parser.prototype.bumpSpace = function () {
        while (!this.isEOF() && _isWhiteSpace(this.char())) {
            this.bump();
        }
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */
    Parser.prototype.peek = function () {
        if (this.isEOF()) {
            return null;
        }
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}());
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */
function _isAlpha(codepoint) {
    return ((codepoint >= 97 && codepoint <= 122) ||
        (codepoint >= 65 && codepoint <= 90));
}
function _isAlphaOrSlash(codepoint) {
    return _isAlpha(codepoint) || codepoint === 47; /* '/' */
}
/** See `parseTag` function docs. */
function _isPotentialElementNameChar(c) {
    return (c === 45 /* '-' */ ||
        c === 46 /* '.' */ ||
        (c >= 48 && c <= 57) /* 0..9 */ ||
        c === 95 /* '_' */ ||
        (c >= 97 && c <= 122) /** a..z */ ||
        (c >= 65 && c <= 90) /* A..Z */ ||
        c == 0xb7 ||
        (c >= 0xc0 && c <= 0xd6) ||
        (c >= 0xd8 && c <= 0xf6) ||
        (c >= 0xf8 && c <= 0x37d) ||
        (c >= 0x37f && c <= 0x1fff) ||
        (c >= 0x200c && c <= 0x200d) ||
        (c >= 0x203f && c <= 0x2040) ||
        (c >= 0x2070 && c <= 0x218f) ||
        (c >= 0x2c00 && c <= 0x2fef) ||
        (c >= 0x3001 && c <= 0xd7ff) ||
        (c >= 0xf900 && c <= 0xfdcf) ||
        (c >= 0xfdf0 && c <= 0xfffd) ||
        (c >= 0x10000 && c <= 0xeffff));
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */
function _isWhiteSpace(c) {
    return ((c >= 0x0009 && c <= 0x000d) ||
        c === 0x0020 ||
        c === 0x0085 ||
        (c >= 0x200e && c <= 0x200f) ||
        c === 0x2028 ||
        c === 0x2029);
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */
function _isPatternSyntax(c) {
    return ((c >= 0x0021 && c <= 0x0023) ||
        c === 0x0024 ||
        (c >= 0x0025 && c <= 0x0027) ||
        c === 0x0028 ||
        c === 0x0029 ||
        c === 0x002a ||
        c === 0x002b ||
        c === 0x002c ||
        c === 0x002d ||
        (c >= 0x002e && c <= 0x002f) ||
        (c >= 0x003a && c <= 0x003b) ||
        (c >= 0x003c && c <= 0x003e) ||
        (c >= 0x003f && c <= 0x0040) ||
        c === 0x005b ||
        c === 0x005c ||
        c === 0x005d ||
        c === 0x005e ||
        c === 0x0060 ||
        c === 0x007b ||
        c === 0x007c ||
        c === 0x007d ||
        c === 0x007e ||
        c === 0x00a1 ||
        (c >= 0x00a2 && c <= 0x00a5) ||
        c === 0x00a6 ||
        c === 0x00a7 ||
        c === 0x00a9 ||
        c === 0x00ab ||
        c === 0x00ac ||
        c === 0x00ae ||
        c === 0x00b0 ||
        c === 0x00b1 ||
        c === 0x00b6 ||
        c === 0x00bb ||
        c === 0x00bf ||
        c === 0x00d7 ||
        c === 0x00f7 ||
        (c >= 0x2010 && c <= 0x2015) ||
        (c >= 0x2016 && c <= 0x2017) ||
        c === 0x2018 ||
        c === 0x2019 ||
        c === 0x201a ||
        (c >= 0x201b && c <= 0x201c) ||
        c === 0x201d ||
        c === 0x201e ||
        c === 0x201f ||
        (c >= 0x2020 && c <= 0x2027) ||
        (c >= 0x2030 && c <= 0x2038) ||
        c === 0x2039 ||
        c === 0x203a ||
        (c >= 0x203b && c <= 0x203e) ||
        (c >= 0x2041 && c <= 0x2043) ||
        c === 0x2044 ||
        c === 0x2045 ||
        c === 0x2046 ||
        (c >= 0x2047 && c <= 0x2051) ||
        c === 0x2052 ||
        c === 0x2053 ||
        (c >= 0x2055 && c <= 0x205e) ||
        (c >= 0x2190 && c <= 0x2194) ||
        (c >= 0x2195 && c <= 0x2199) ||
        (c >= 0x219a && c <= 0x219b) ||
        (c >= 0x219c && c <= 0x219f) ||
        c === 0x21a0 ||
        (c >= 0x21a1 && c <= 0x21a2) ||
        c === 0x21a3 ||
        (c >= 0x21a4 && c <= 0x21a5) ||
        c === 0x21a6 ||
        (c >= 0x21a7 && c <= 0x21ad) ||
        c === 0x21ae ||
        (c >= 0x21af && c <= 0x21cd) ||
        (c >= 0x21ce && c <= 0x21cf) ||
        (c >= 0x21d0 && c <= 0x21d1) ||
        c === 0x21d2 ||
        c === 0x21d3 ||
        c === 0x21d4 ||
        (c >= 0x21d5 && c <= 0x21f3) ||
        (c >= 0x21f4 && c <= 0x22ff) ||
        (c >= 0x2300 && c <= 0x2307) ||
        c === 0x2308 ||
        c === 0x2309 ||
        c === 0x230a ||
        c === 0x230b ||
        (c >= 0x230c && c <= 0x231f) ||
        (c >= 0x2320 && c <= 0x2321) ||
        (c >= 0x2322 && c <= 0x2328) ||
        c === 0x2329 ||
        c === 0x232a ||
        (c >= 0x232b && c <= 0x237b) ||
        c === 0x237c ||
        (c >= 0x237d && c <= 0x239a) ||
        (c >= 0x239b && c <= 0x23b3) ||
        (c >= 0x23b4 && c <= 0x23db) ||
        (c >= 0x23dc && c <= 0x23e1) ||
        (c >= 0x23e2 && c <= 0x2426) ||
        (c >= 0x2427 && c <= 0x243f) ||
        (c >= 0x2440 && c <= 0x244a) ||
        (c >= 0x244b && c <= 0x245f) ||
        (c >= 0x2500 && c <= 0x25b6) ||
        c === 0x25b7 ||
        (c >= 0x25b8 && c <= 0x25c0) ||
        c === 0x25c1 ||
        (c >= 0x25c2 && c <= 0x25f7) ||
        (c >= 0x25f8 && c <= 0x25ff) ||
        (c >= 0x2600 && c <= 0x266e) ||
        c === 0x266f ||
        (c >= 0x2670 && c <= 0x2767) ||
        c === 0x2768 ||
        c === 0x2769 ||
        c === 0x276a ||
        c === 0x276b ||
        c === 0x276c ||
        c === 0x276d ||
        c === 0x276e ||
        c === 0x276f ||
        c === 0x2770 ||
        c === 0x2771 ||
        c === 0x2772 ||
        c === 0x2773 ||
        c === 0x2774 ||
        c === 0x2775 ||
        (c >= 0x2794 && c <= 0x27bf) ||
        (c >= 0x27c0 && c <= 0x27c4) ||
        c === 0x27c5 ||
        c === 0x27c6 ||
        (c >= 0x27c7 && c <= 0x27e5) ||
        c === 0x27e6 ||
        c === 0x27e7 ||
        c === 0x27e8 ||
        c === 0x27e9 ||
        c === 0x27ea ||
        c === 0x27eb ||
        c === 0x27ec ||
        c === 0x27ed ||
        c === 0x27ee ||
        c === 0x27ef ||
        (c >= 0x27f0 && c <= 0x27ff) ||
        (c >= 0x2800 && c <= 0x28ff) ||
        (c >= 0x2900 && c <= 0x2982) ||
        c === 0x2983 ||
        c === 0x2984 ||
        c === 0x2985 ||
        c === 0x2986 ||
        c === 0x2987 ||
        c === 0x2988 ||
        c === 0x2989 ||
        c === 0x298a ||
        c === 0x298b ||
        c === 0x298c ||
        c === 0x298d ||
        c === 0x298e ||
        c === 0x298f ||
        c === 0x2990 ||
        c === 0x2991 ||
        c === 0x2992 ||
        c === 0x2993 ||
        c === 0x2994 ||
        c === 0x2995 ||
        c === 0x2996 ||
        c === 0x2997 ||
        c === 0x2998 ||
        (c >= 0x2999 && c <= 0x29d7) ||
        c === 0x29d8 ||
        c === 0x29d9 ||
        c === 0x29da ||
        c === 0x29db ||
        (c >= 0x29dc && c <= 0x29fb) ||
        c === 0x29fc ||
        c === 0x29fd ||
        (c >= 0x29fe && c <= 0x2aff) ||
        (c >= 0x2b00 && c <= 0x2b2f) ||
        (c >= 0x2b30 && c <= 0x2b44) ||
        (c >= 0x2b45 && c <= 0x2b46) ||
        (c >= 0x2b47 && c <= 0x2b4c) ||
        (c >= 0x2b4d && c <= 0x2b73) ||
        (c >= 0x2b74 && c <= 0x2b75) ||
        (c >= 0x2b76 && c <= 0x2b95) ||
        c === 0x2b96 ||
        (c >= 0x2b97 && c <= 0x2bff) ||
        (c >= 0x2e00 && c <= 0x2e01) ||
        c === 0x2e02 ||
        c === 0x2e03 ||
        c === 0x2e04 ||
        c === 0x2e05 ||
        (c >= 0x2e06 && c <= 0x2e08) ||
        c === 0x2e09 ||
        c === 0x2e0a ||
        c === 0x2e0b ||
        c === 0x2e0c ||
        c === 0x2e0d ||
        (c >= 0x2e0e && c <= 0x2e16) ||
        c === 0x2e17 ||
        (c >= 0x2e18 && c <= 0x2e19) ||
        c === 0x2e1a ||
        c === 0x2e1b ||
        c === 0x2e1c ||
        c === 0x2e1d ||
        (c >= 0x2e1e && c <= 0x2e1f) ||
        c === 0x2e20 ||
        c === 0x2e21 ||
        c === 0x2e22 ||
        c === 0x2e23 ||
        c === 0x2e24 ||
        c === 0x2e25 ||
        c === 0x2e26 ||
        c === 0x2e27 ||
        c === 0x2e28 ||
        c === 0x2e29 ||
        (c >= 0x2e2a && c <= 0x2e2e) ||
        c === 0x2e2f ||
        (c >= 0x2e30 && c <= 0x2e39) ||
        (c >= 0x2e3a && c <= 0x2e3b) ||
        (c >= 0x2e3c && c <= 0x2e3f) ||
        c === 0x2e40 ||
        c === 0x2e41 ||
        c === 0x2e42 ||
        (c >= 0x2e43 && c <= 0x2e4f) ||
        (c >= 0x2e50 && c <= 0x2e51) ||
        c === 0x2e52 ||
        (c >= 0x2e53 && c <= 0x2e7f) ||
        (c >= 0x3001 && c <= 0x3003) ||
        c === 0x3008 ||
        c === 0x3009 ||
        c === 0x300a ||
        c === 0x300b ||
        c === 0x300c ||
        c === 0x300d ||
        c === 0x300e ||
        c === 0x300f ||
        c === 0x3010 ||
        c === 0x3011 ||
        (c >= 0x3012 && c <= 0x3013) ||
        c === 0x3014 ||
        c === 0x3015 ||
        c === 0x3016 ||
        c === 0x3017 ||
        c === 0x3018 ||
        c === 0x3019 ||
        c === 0x301a ||
        c === 0x301b ||
        c === 0x301c ||
        c === 0x301d ||
        (c >= 0x301e && c <= 0x301f) ||
        c === 0x3020 ||
        c === 0x3030 ||
        c === 0xfd3e ||
        c === 0xfd3f ||
        (c >= 0xfe45 && c <= 0xfe46));
}

function pruneLocation(els) {
    els.forEach(function (el) {
        delete el.location;
        if (isSelectElement(el) || isPluralElement(el)) {
            for (var k in el.options) {
                delete el.options[k].location;
                pruneLocation(el.options[k].value);
            }
        }
        else if (isNumberElement(el) && isNumberSkeleton(el.style)) {
            delete el.style.location;
        }
        else if ((isDateElement(el) || isTimeElement(el)) &&
            isDateTimeSkeleton(el.style)) {
            delete el.style.location;
        }
        else if (isTagElement(el)) {
            pruneLocation(el.children);
        }
    });
}
function parse(message, opts) {
    if (opts === void 0) { opts = {}; }
    opts = __assign({ shouldParseSkeletons: true, requiresOtherClause: true }, opts);
    var result = new Parser(message, opts).parse();
    if (result.err) {
        var error = SyntaxError(ErrorKind[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) {
        pruneLocation(result.val);
    }
    return result.val;
}

//
// Main
//
function memoize(fn, options) {
    var cache = options && options.cache ? options.cache : cacheDefault;
    var serializer = options && options.serializer ? options.serializer : serializerDefault;
    var strategy = options && options.strategy ? options.strategy : strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer,
    });
}
//
// Strategy
//
function isPrimitive(value) {
    return (value == null || typeof value === 'number' || typeof value === 'boolean'); // || typeof value === "string" 'unsafe' primitive for our needs
}
function monadic(fn, cache, serializer, arg) {
    var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? monadic : variadic;
    return assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function strategyVariadic(fn, options) {
    return assemble(fn, this, variadic, options.cache.create(), options.serializer);
}
function strategyMonadic(fn, options) {
    return assemble(fn, this, monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var serializerDefault = function () {
    return JSON.stringify(arguments);
};
//
// Cache
//
function ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
ObjectWithoutPrototypeCache.prototype.get = function (key) {
    return this.cache[key];
};
ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
    this.cache[key] = value;
};
var cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new ObjectWithoutPrototypeCache();
    },
};
var strategies = {
    variadic: strategyVariadic,
    monadic: strategyMonadic,
};

var ErrorCode;
(function (ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})(ErrorCode || (ErrorCode = {}));
var FormatError = /** @class */ (function (_super) {
    __extends(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function () {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error));
var InvalidValueError = /** @class */ (function (_super) {
    __extends(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}(FormatError));
var InvalidValueTypeError = /** @class */ (function (_super) {
    __extends(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}(FormatError));
var MissingValueError = /** @class */ (function (_super) {
    __extends(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), ErrorCode.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}(FormatError));

var PART_TYPE;
(function (PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})(PART_TYPE || (PART_TYPE = {}));
function mergeLiteral(parts) {
    if (parts.length < 2) {
        return parts;
    }
    return parts.reduce(function (all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart ||
            lastPart.type !== PART_TYPE.literal ||
            part.type !== PART_TYPE.literal) {
            all.push(part);
        }
        else {
            lastPart.value += part.value;
        }
        return all;
    }, []);
}
function isFormatXMLElementFn(el) {
    return typeof el === 'function';
}
// TODO(skeleton): add skeleton support
function formatToParts(els, locales, formatters, formats, values, currentPluralValue, 
// For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && isLiteralElement(els[0])) {
        return [
            {
                type: PART_TYPE.literal,
                value: els[0].value,
            },
        ];
    }
    var result = [];
    for (var _i = 0, els_1 = els; _i < els_1.length; _i++) {
        var el = els_1[_i];
        // Exit early for string parts.
        if (isLiteralElement(el)) {
            result.push({
                type: PART_TYPE.literal,
                value: el.value,
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if (isPoundElement(el)) {
            if (typeof currentPluralValue === 'number') {
                result.push({
                    type: PART_TYPE.literal,
                    value: formatters.getNumberFormat(locales).format(currentPluralValue),
                });
            }
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) {
            throw new MissingValueError(varName, originalMessage);
        }
        var value = values[varName];
        if (isArgumentElement(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') {
                value =
                    typeof value === 'string' || typeof value === 'number'
                        ? String(value)
                        : '';
            }
            result.push({
                type: typeof value === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                value: value,
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (isDateElement(el)) {
            var style = typeof el.style === 'string'
                ? formats.date[el.style]
                : isDateTimeSkeleton(el.style)
                    ? el.style.parsedOptions
                    : undefined;
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getDateTimeFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if (isTimeElement(el)) {
            var style = typeof el.style === 'string'
                ? formats.time[el.style]
                : isDateTimeSkeleton(el.style)
                    ? el.style.parsedOptions
                    : formats.time.medium;
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getDateTimeFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if (isNumberElement(el)) {
            var style = typeof el.style === 'string'
                ? formats.number[el.style]
                : isNumberSkeleton(el.style)
                    ? el.style.parsedOptions
                    : undefined;
            if (style && style.scale) {
                value =
                    value *
                        (style.scale || 1);
            }
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getNumberFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if (isTagElement(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!isFormatXMLElementFn(formatFn)) {
                throw new InvalidValueTypeError(value_1, 'function', originalMessage);
            }
            var parts = formatToParts(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function (p) { return p.value; }));
            if (!Array.isArray(chunks)) {
                chunks = [chunks];
            }
            result.push.apply(result, chunks.map(function (c) {
                return {
                    type: typeof c === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                    value: c,
                };
            }));
        }
        if (isSelectElement(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) {
                throw new InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
            }
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values));
            continue;
        }
        if (isPluralElement(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) {
                    throw new FormatError("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", ErrorCode.MISSING_INTL_API, originalMessage);
                }
                var rule = formatters
                    .getPluralRules(locales, { type: el.pluralType })
                    .select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) {
                throw new InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
            }
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return mergeLiteral(result);
}

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
// -- MessageFormat --------------------------------------------------------
function mergeConfig(c1, c2) {
    if (!c2) {
        return c1;
    }
    return __assign(__assign(__assign({}, (c1 || {})), (c2 || {})), Object.keys(c1).reduce(function (all, k) {
        all[k] = __assign(__assign({}, c1[k]), (c2[k] || {}));
        return all;
    }, {}));
}
function mergeConfigs(defaultConfig, configs) {
    if (!configs) {
        return defaultConfig;
    }
    return Object.keys(defaultConfig).reduce(function (all, k) {
        all[k] = mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, __assign({}, defaultConfig));
}
function createFastMemoizeCache(store) {
    return {
        create: function () {
            return {
                get: function (key) {
                    return store[key];
                },
                set: function (key, value) {
                    store[key] = value;
                },
            };
        },
    };
}
function createDefaultFormatters(cache) {
    if (cache === void 0) { cache = {
        number: {},
        dateTime: {},
        pluralRules: {},
    }; }
    return {
        getNumberFormat: memoize(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.NumberFormat).bind.apply(_a, __spreadArray([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.number),
            strategy: strategies.variadic,
        }),
        getDateTimeFormat: memoize(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, __spreadArray([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.dateTime),
            strategy: strategies.variadic,
        }),
        getPluralRules: memoize(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.PluralRules).bind.apply(_a, __spreadArray([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.pluralRules),
            strategy: strategies.variadic,
        }),
    };
}
/** @class */ ((function () {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) { locales = IntlMessageFormat.defaultLocale; }
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {},
        };
        this.format = function (values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) {
                return parts[0].value;
            }
            var result = parts.reduce(function (all, part) {
                if (!all.length ||
                    part.type !== PART_TYPE.literal ||
                    typeof all[all.length - 1] !== 'string') {
                    all.push(part.value);
                }
                else {
                    all[all.length - 1] += part.value;
                }
                return all;
            }, []);
            if (result.length <= 1) {
                return result[0] || '';
            }
            return result;
        };
        this.formatToParts = function (values) {
            return formatToParts(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function () {
            var _a;
            return ({
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) ||
                    Intl.NumberFormat.supportedLocalesOf(_this.locales)[0],
            });
        };
        this.getAst = function () { return _this.ast; };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) {
                throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            }
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, {
                ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
                locale: this.resolvedLocale,
            });
        }
        else {
            this.ast = message;
        }
        if (!Array.isArray(this.ast)) {
            throw new TypeError('A message must be provided as a String or AST.');
        }
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters =
            (opts && opts.formatters) || createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function () {
            if (!IntlMessageFormat.memoizedDefaultLocale) {
                IntlMessageFormat.memoizedDefaultLocale =
                    new Intl.NumberFormat().resolvedOptions().locale;
            }
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function (locales) {
        if (typeof Intl.Locale === 'undefined') {
            return;
        }
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) {
            return new Intl.Locale(supportedLocales[0]);
        }
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = parse;
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0,
            },
            currency: {
                style: 'currency',
            },
            percent: {
                style: 'percent',
            },
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit',
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            },
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric',
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short',
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short',
            },
        },
    };
    return IntlMessageFormat;
})());

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 



function $701a24aa0da5b062$export$ea18c227d4417cc3(props, ref) {
    let { elementType: elementType = "button" , isDisabled: isDisabled , onPress: onPress , onPressStart: onPressStart , onPressEnd: onPressEnd , onPressChange: onPressChange , preventFocusOnPress: // @ts-ignore - undocumented
    preventFocusOnPress , allowFocusWhenDisabled: // @ts-ignore - undocumented
    allowFocusWhenDisabled , // @ts-ignore
    onClick: deprecatedOnClick , href: href , target: target , rel: rel , type: type = "button"  } = props;
    let additionalProps;
    if (elementType === "button") additionalProps = {
        type: type,
        disabled: isDisabled
    };
    else additionalProps = {
        role: "button",
        tabIndex: isDisabled ? undefined : 0,
        href: elementType === "a" && isDisabled ? undefined : href,
        target: elementType === "a" ? target : undefined,
        type: elementType === "input" ? type : undefined,
        disabled: elementType === "input" ? isDisabled : undefined,
        "aria-disabled": !isDisabled || elementType === "input" ? undefined : isDisabled,
        rel: elementType === "a" ? rel : undefined
    };
    let { pressProps: pressProps , isPressed: isPressed  } = ($f6c31cce2adf654f$export$45712eceda6fad21)({
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onPressChange: onPressChange,
        onPress: onPress,
        isDisabled: isDisabled,
        preventFocusOnPress: preventFocusOnPress,
        ref: ref
    });
    let { focusableProps: focusableProps  } = ($e6afbd83fe6ebbd2$export$4c014de7c8940b4c)(props, ref);
    if (allowFocusWhenDisabled) focusableProps.tabIndex = isDisabled ? -1 : focusableProps.tabIndex;
    let buttonProps = ($3ef42575df84b30b$export$9d1611c77c2fe928)(focusableProps, pressProps, ($65484d02dcb7eb3e$export$457c3d6518dd4c6f)(props, {
        labelable: true
    }));
    return {
        isPressed: isPressed,
        buttonProps: ($3ef42575df84b30b$export$9d1611c77c2fe928)(additionalProps, buttonProps, {
            "aria-haspopup": props["aria-haspopup"],
            "aria-expanded": props["aria-expanded"],
            "aria-controls": props["aria-controls"],
            "aria-pressed": props["aria-pressed"],
            onClick: (e)=>{
                if (deprecatedOnClick) {
                    deprecatedOnClick(e);
                    console.warn("onClick is deprecated, please use onPress");
                }
            }
        })
    };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /* Inspired by https://github.com/AlmeroSteyn/react-aria-live */ const $319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY = 7000;
let $319e236875307eab$var$liveAnnouncer = null;
function $319e236875307eab$export$a9b970dcc4ae71a9(message, assertiveness = "assertive", timeout = $319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY) {
    if (!$319e236875307eab$var$liveAnnouncer) $319e236875307eab$var$liveAnnouncer = new $319e236875307eab$var$LiveAnnouncer();
    $319e236875307eab$var$liveAnnouncer.announce(message, assertiveness, timeout);
}
// LiveAnnouncer is implemented using vanilla DOM, not React. That's because as of React 18
// ReactDOM.render is deprecated, and the replacement, ReactDOM.createRoot is moved into a
// subpath import `react-dom/client`. That makes it hard for us to support multiple React versions.
// As a global API, we can't use portals without introducing a breaking API change. LiveAnnouncer
// is simple enough to implement without React, so that's what we do here.
// See this discussion for more details: https://github.com/reactwg/react-18/discussions/125#discussioncomment-2382638
class $319e236875307eab$var$LiveAnnouncer {
    createLog(ariaLive) {
        let node = document.createElement("div");
        node.setAttribute("role", "log");
        node.setAttribute("aria-live", ariaLive);
        node.setAttribute("aria-relevant", "additions");
        return node;
    }
    destroy() {
        if (!this.node) return;
        document.body.removeChild(this.node);
        this.node = null;
    }
    announce(message, assertiveness = "assertive", timeout = $319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY) {
        if (!this.node) return;
        let node = document.createElement("div");
        node.textContent = message;
        if (assertiveness === "assertive") this.assertiveLog.appendChild(node);
        else this.politeLog.appendChild(node);
        if (message !== "") setTimeout(()=>{
            node.remove();
        }, timeout);
    }
    clear(assertiveness) {
        if (!this.node) return;
        if (!assertiveness || assertiveness === "assertive") this.assertiveLog.innerHTML = "";
        if (!assertiveness || assertiveness === "polite") this.politeLog.innerHTML = "";
    }
    constructor(){
        this.node = document.createElement("div");
        this.node.dataset.liveAnnouncer = "true";
        // copied from VisuallyHidden
        Object.assign(this.node.style, {
            border: 0,
            clip: "rect(0 0 0 0)",
            clipPath: "inset(50%)",
            height: 1,
            margin: "0 -1px -1px 0",
            overflow: "hidden",
            padding: 0,
            position: "absolute",
            width: 1,
            whiteSpace: "nowrap"
        });
        this.assertiveLog = this.createLog("assertive");
        this.node.appendChild(this.assertiveLog);
        this.politeLog = this.createLog("polite");
        this.node.appendChild(this.politeLog);
        document.body.prepend(this.node);
    }
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
function $d191a55c9702f145$export$8467354a121f1b9f(props) {
    let { id: id , label: label , "aria-labelledby": ariaLabelledby , "aria-label": ariaLabel , labelElementType: labelElementType = "label"  } = props;
    id = ($bdb11010cef70236$export$f680877a34711e37)(id);
    let labelId = ($bdb11010cef70236$export$f680877a34711e37)();
    let labelProps = {};
    if (label) {
        ariaLabelledby = ariaLabelledby ? `${ariaLabelledby} ${labelId}` : labelId;
        labelProps = {
            id: labelId,
            htmlFor: labelElementType === "label" ? id : undefined
        };
    } else if (!ariaLabelledby && !ariaLabel) console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
    let fieldProps = ($313b98861ee5dd6c$export$d6875122194c7b44)({
        id: id,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps
    };
}



function $2baaea4c71418dea$export$294aa081a6c6f55d(props) {
    let { description: description , errorMessage: errorMessage , validationState: validationState  } = props;
    let { labelProps: labelProps , fieldProps: fieldProps  } = ($d191a55c9702f145$export$8467354a121f1b9f)(props);
    let descriptionId = ($bdb11010cef70236$export$b4cc09c592e8fdb8)([
        Boolean(description),
        Boolean(errorMessage),
        validationState
    ]);
    let errorMessageId = ($bdb11010cef70236$export$b4cc09c592e8fdb8)([
        Boolean(description),
        Boolean(errorMessage),
        validationState
    ]);
    fieldProps = ($3ef42575df84b30b$export$9d1611c77c2fe928)(fieldProps, {
        "aria-describedby": [
            descriptionId,
            // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
            errorMessageId,
            props["aria-describedby"]
        ].filter(Boolean).join(" ") || undefined
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps,
        descriptionProps: {
            id: descriptionId
        },
        errorMessageProps: {
            id: errorMessageId
        }
    };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


const $5c3e21d68f1c4674$var$styles = {
    border: 0,
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    margin: "0 -1px -1px 0",
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    width: 1,
    whiteSpace: "nowrap"
};
function $5c3e21d68f1c4674$export$a966af930f325cab(props = {}) {
    let { style: style , isFocusable: isFocusable  } = props;
    let [isFocused, setFocused] = (useState)(false);
    let { focusWithinProps: focusWithinProps  } = ($9ab94262bd0047c7$export$420e68273165f4ec)({
        isDisabled: !isFocusable,
        onFocusWithinChange: (val)=>setFocused(val)
    });
    // If focused, don't hide the element.
    let combinedStyles = (useMemo)(()=>{
        if (isFocused) return style;
        else if (style) return {
            ...$5c3e21d68f1c4674$var$styles,
            ...style
        };
        else return $5c3e21d68f1c4674$var$styles;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isFocused
    ]);
    return {
        visuallyHiddenProps: {
            ...focusWithinProps,
            style: combinedStyles
        }
    };
}
function $5c3e21d68f1c4674$export$439d29a4e110a164(props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { children: children , elementType: Element = "div" , isFocusable: isFocusable , style: style , ...otherProps } = props;
    let { visuallyHiddenProps: visuallyHiddenProps  } = $5c3e21d68f1c4674$export$a966af930f325cab(props);
    return /*#__PURE__*/ (React__default).createElement(Element, ($3ef42575df84b30b$export$9d1611c77c2fe928)(otherProps, visuallyHiddenProps), children);
}

function $parcel$interopDefault$5(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $edcf132a9284368a$var$AXIS = {
    top: "top",
    bottom: "top",
    left: "left",
    right: "left"
};
const $edcf132a9284368a$var$FLIPPED_DIRECTION = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
const $edcf132a9284368a$var$CROSS_AXIS = {
    top: "left",
    left: "top"
};
const $edcf132a9284368a$var$AXIS_SIZE = {
    top: "height",
    left: "width"
};
const $edcf132a9284368a$var$PARSED_PLACEMENT_CACHE = {};
// @ts-ignore
let $edcf132a9284368a$var$visualViewport = typeof window !== "undefined" && window.visualViewport;
function $edcf132a9284368a$var$getContainerDimensions(containerNode) {
    let width = 0, height = 0, top = 0, left = 0;
    let scroll = {};
    if (containerNode.tagName === "BODY") {
        let documentElement = document.documentElement;
        var _visualViewport_width;
        width = (_visualViewport_width = $edcf132a9284368a$var$visualViewport === null || $edcf132a9284368a$var$visualViewport === void 0 ? void 0 : $edcf132a9284368a$var$visualViewport.width) !== null && _visualViewport_width !== void 0 ? _visualViewport_width : documentElement.clientWidth;
        var _visualViewport_height;
        height = (_visualViewport_height = $edcf132a9284368a$var$visualViewport === null || $edcf132a9284368a$var$visualViewport === void 0 ? void 0 : $edcf132a9284368a$var$visualViewport.height) !== null && _visualViewport_height !== void 0 ? _visualViewport_height : documentElement.clientHeight;
        scroll.top = documentElement.scrollTop || containerNode.scrollTop;
        scroll.left = documentElement.scrollLeft || containerNode.scrollLeft;
    } else {
        ({ width: width , height: height , top: top , left: left  } = $edcf132a9284368a$var$getOffset(containerNode));
        scroll.top = containerNode.scrollTop;
        scroll.left = containerNode.scrollLeft;
    }
    return {
        width: width,
        height: height,
        scroll: scroll,
        top: top,
        left: left
    };
}
function $edcf132a9284368a$var$getScroll(node) {
    return {
        top: node.scrollTop,
        left: node.scrollLeft,
        width: node.scrollWidth,
        height: node.scrollHeight
    };
}
function $edcf132a9284368a$var$getDelta(axis, offset, size, containerDimensions, padding) {
    let containerScroll = containerDimensions.scroll[axis];
    let containerHeight = containerDimensions[$edcf132a9284368a$var$AXIS_SIZE[axis]];
    let startEdgeOffset = offset - padding - containerScroll;
    let endEdgeOffset = offset + padding - containerScroll + size;
    if (startEdgeOffset < 0) return -startEdgeOffset;
    else if (endEdgeOffset > containerHeight) return Math.max(containerHeight - endEdgeOffset, -startEdgeOffset);
    else return 0;
}
function $edcf132a9284368a$var$getMargins(node) {
    let style = window.getComputedStyle(node);
    return {
        top: parseInt(style.marginTop, 10) || 0,
        bottom: parseInt(style.marginBottom, 10) || 0,
        left: parseInt(style.marginLeft, 10) || 0,
        right: parseInt(style.marginRight, 10) || 0
    };
}
function $edcf132a9284368a$var$parsePlacement(input) {
    if ($edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input]) return $edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input];
    let [placement, crossPlacement] = input.split(" ");
    let axis = $edcf132a9284368a$var$AXIS[placement] || "right";
    let crossAxis = $edcf132a9284368a$var$CROSS_AXIS[axis];
    if (!$edcf132a9284368a$var$AXIS[crossPlacement]) crossPlacement = "center";
    let size = $edcf132a9284368a$var$AXIS_SIZE[axis];
    let crossSize = $edcf132a9284368a$var$AXIS_SIZE[crossAxis];
    $edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input] = {
        placement: placement,
        crossPlacement: crossPlacement,
        axis: axis,
        crossAxis: crossAxis,
        size: size,
        crossSize: crossSize
    };
    return $edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input];
}
function $edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned) {
    let { placement: placement , crossPlacement: crossPlacement , axis: axis , crossAxis: crossAxis , size: size , crossSize: crossSize  } = placementInfo;
    let position = {};
    // button position
    position[crossAxis] = childOffset[crossAxis];
    if (crossPlacement === "center") //  + (button size / 2) - (overlay size / 2)
    // at this point the overlay center should match the button center
    position[crossAxis] += (childOffset[crossSize] - overlaySize[crossSize]) / 2;
    else if (crossPlacement !== crossAxis) //  + (button size) - (overlay size)
    // at this point the overlay bottom should match the button bottom
    position[crossAxis] += childOffset[crossSize] - overlaySize[crossSize];
     /* else {
    the overlay top should match the button top
  } */ 
    // add the crossOffset from props
    position[crossAxis] += crossOffset;
    // this is button center position - the overlay size + half of the button to align bottom of overlay with button center
    let minViablePosition = childOffset[crossAxis] + childOffset[crossSize] / 2 - overlaySize[crossSize];
    // this is button position of center, aligns top of overlay with button center
    let maxViablePosition = childOffset[crossAxis] + childOffset[crossSize] / 2;
    // clamp it into the range of the min/max positions
    position[crossAxis] = Math.min(Math.max(minViablePosition, position[crossAxis]), maxViablePosition);
    // Floor these so the position isn't placed on a partial pixel, only whole pixels. Shouldn't matter if it was floored or ceiled, so chose one.
    if (placement === axis) {
        // If the container is positioned (non-static), then we use the container's actual
        // height, as `bottom` will be relative to this height.  But if the container is static,
        // then it can only be the `document.body`, and `bottom` will be relative to _its_
        // container, which should be as large as boundaryDimensions.
        const containerHeight = isContainerPositioned ? containerOffsetWithBoundary[size] : boundaryDimensions[size];
        position[$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] = Math.floor(containerHeight - childOffset[axis] + offset);
    } else position[axis] = Math.floor(childOffset[axis] + childOffset[size] + offset);
    return position;
}
function $edcf132a9284368a$var$getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding) {
    return position.top != null ? Math.max(0, boundaryDimensions.height + boundaryDimensions.top + boundaryDimensions.scroll.top // this is the bottom of the boundary
     - (containerOffsetWithBoundary.top + position.top // this is the top of the overlay
    ) - (margins.top + margins.bottom + padding // save additional space for margin and padding
    )) : Math.max(0, childOffset.top + containerOffsetWithBoundary.top // this is the top of the trigger
     - (boundaryDimensions.top + boundaryDimensions.scroll.top // this is the top of the boundary
    ) - (margins.top + margins.bottom + padding // save additional space for margin and padding
    ));
}
function $edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding, placementInfo) {
    let { placement: placement , axis: axis , size: size  } = placementInfo;
    if (placement === axis) return Math.max(0, childOffset[axis] - boundaryDimensions[axis] - boundaryDimensions.scroll[axis] + containerOffsetWithBoundary[axis] - margins[axis] - margins[$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] - padding);
    return Math.max(0, boundaryDimensions[size] + boundaryDimensions[axis] + boundaryDimensions.scroll[axis] - containerOffsetWithBoundary[axis] - childOffset[axis] - childOffset[size] - margins[axis] - margins[$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] - padding);
}
function $edcf132a9284368a$export$6839422d1f33cee9(placementInput, childOffset, overlaySize, scrollSize, margins, padding, flip, boundaryDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, userSetMaxHeight) {
    let placementInfo = $edcf132a9284368a$var$parsePlacement(placementInput);
    let { size: size , crossAxis: crossAxis , crossSize: crossSize , placement: placement , crossPlacement: crossPlacement  } = placementInfo;
    let position = $edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned);
    let normalizedOffset = offset;
    let space = $edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, placementInfo);
    // Check if the scroll size of the overlay is greater than the available space to determine if we need to flip
    if (flip && scrollSize[size] > space) {
        let flippedPlacementInfo = $edcf132a9284368a$var$parsePlacement(`${$edcf132a9284368a$var$FLIPPED_DIRECTION[placement]} ${crossPlacement}`);
        let flippedPosition = $edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, flippedPlacementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned);
        let flippedSpace = $edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, flippedPlacementInfo);
        // If the available space for the flipped position is greater than the original available space, flip.
        if (flippedSpace > space) {
            placementInfo = flippedPlacementInfo;
            position = flippedPosition;
            normalizedOffset = offset;
        }
    }
    let delta = $edcf132a9284368a$var$getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, padding);
    position[crossAxis] += delta;
    let maxHeight = $edcf132a9284368a$var$getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding);
    if (userSetMaxHeight && userSetMaxHeight < maxHeight) maxHeight = userSetMaxHeight;
    overlaySize.height = Math.min(overlaySize.height, maxHeight);
    position = $edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, normalizedOffset, crossOffset, containerOffsetWithBoundary, isContainerPositioned);
    delta = $edcf132a9284368a$var$getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, padding);
    position[crossAxis] += delta;
    let arrowPosition = {};
    arrowPosition[crossAxis] = childOffset[crossAxis] - position[crossAxis] + childOffset[crossSize] / 2;
    return {
        position: position,
        maxHeight: maxHeight,
        arrowOffsetLeft: arrowPosition.left,
        arrowOffsetTop: arrowPosition.top,
        placement: placementInfo.placement
    };
}
function $edcf132a9284368a$export$b3ceb0cbf1056d98(opts) {
    let { placement: placement , targetNode: targetNode , overlayNode: overlayNode , scrollNode: scrollNode , padding: padding , shouldFlip: shouldFlip , boundaryElement: boundaryElement , offset: offset , crossOffset: crossOffset , maxHeight: maxHeight  } = opts;
    let container = overlayNode instanceof HTMLElement && overlayNode.offsetParent || document.body;
    let isBodyContainer = container.tagName === "BODY";
    const containerPositionStyle = window.getComputedStyle(container).position;
    let isContainerPositioned = !!containerPositionStyle && containerPositionStyle !== "static";
    let childOffset = isBodyContainer ? $edcf132a9284368a$var$getOffset(targetNode) : $edcf132a9284368a$var$getPosition(targetNode, container);
    if (!isBodyContainer) {
        let { marginTop: marginTop , marginLeft: marginLeft  } = window.getComputedStyle(targetNode);
        childOffset.top += parseInt(marginTop, 10) || 0;
        childOffset.left += parseInt(marginLeft, 10) || 0;
    }
    let overlaySize = $edcf132a9284368a$var$getOffset(overlayNode);
    let margins = $edcf132a9284368a$var$getMargins(overlayNode);
    overlaySize.width += margins.left + margins.right;
    overlaySize.height += margins.top + margins.bottom;
    let scrollSize = $edcf132a9284368a$var$getScroll(scrollNode);
    let boundaryDimensions = $edcf132a9284368a$var$getContainerDimensions(boundaryElement);
    let containerOffsetWithBoundary = boundaryElement.tagName === "BODY" ? $edcf132a9284368a$var$getOffset(container) : $edcf132a9284368a$var$getPosition(container, boundaryElement);
    return $edcf132a9284368a$export$6839422d1f33cee9(placement, childOffset, overlaySize, scrollSize, margins, padding, shouldFlip, boundaryDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, maxHeight);
}
function $edcf132a9284368a$var$getOffset(node) {
    let { top: top , left: left , width: width , height: height  } = node.getBoundingClientRect();
    let { scrollTop: scrollTop , scrollLeft: scrollLeft , clientTop: clientTop , clientLeft: clientLeft  } = document.documentElement;
    return {
        top: top + scrollTop - clientTop,
        left: left + scrollLeft - clientLeft,
        width: width,
        height: height
    };
}
function $edcf132a9284368a$var$getPosition(node, parent) {
    let style = window.getComputedStyle(node);
    let offset;
    if (style.position === "fixed") {
        let { top: top , left: left , width: width , height: height  } = node.getBoundingClientRect();
        offset = {
            top: top,
            left: left,
            width: width,
            height: height
        };
    } else {
        offset = $edcf132a9284368a$var$getOffset(node);
        let parentOffset = $edcf132a9284368a$var$getOffset(parent);
        let parentStyle = window.getComputedStyle(parent);
        parentOffset.top += (parseInt(parentStyle.borderTopWidth, 10) || 0) - parent.scrollTop;
        parentOffset.left += (parseInt(parentStyle.borderLeftWidth, 10) || 0) - parent.scrollLeft;
        offset.top -= parentOffset.top;
        offset.left -= parentOffset.left;
    }
    offset.top -= parseInt(style.marginTop, 10) || 0;
    offset.left -= parseInt(style.marginLeft, 10) || 0;
    return offset;
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
const $dd149f63282afbbf$export$f6211563215e3b37 = new WeakMap();
function $dd149f63282afbbf$export$18fc8428861184da(opts) {
    let { triggerRef: triggerRef , isOpen: isOpen , onClose: onClose  } = opts;
    (useEffect)(()=>{
        if (!isOpen || onClose === null) return;
        let onScroll = (e)=>{
            // Ignore if scrolling an scrollable region outside the trigger's tree.
            let target = e.target;
            // window is not a Node and doesn't have contain, but window contains everything
            if (!triggerRef.current || target instanceof Node && !target.contains(triggerRef.current)) return;
            let onCloseHandler = onClose || $dd149f63282afbbf$export$f6211563215e3b37.get(triggerRef.current);
            if (onCloseHandler) onCloseHandler();
        };
        window.addEventListener("scroll", onScroll, true);
        return ()=>{
            window.removeEventListener("scroll", onScroll, true);
        };
    }, [
        isOpen,
        onClose,
        triggerRef
    ]);
}




// @ts-ignore
let $2a41e45df1593e64$var$visualViewport = typeof window !== "undefined" && window.visualViewport;
function $2a41e45df1593e64$export$d39e1813b3bdd0e1(props) {
    let { direction: direction  } = ($18f2051aff69b9bf$export$43bb16f9c6d9e3f7)();
    let { targetRef: targetRef , overlayRef: overlayRef , scrollRef: scrollRef = overlayRef , placement: placement = "bottom" , containerPadding: containerPadding = 12 , shouldFlip: shouldFlip = true , boundaryElement: boundaryElement = typeof document !== "undefined" ? document.body : null , offset: offset = 0 , crossOffset: crossOffset = 0 , shouldUpdatePosition: shouldUpdatePosition = true , isOpen: isOpen = true , onClose: onClose , maxHeight: maxHeight  } = props;
    let [position, setPosition] = (useState)({
        position: {},
        arrowOffsetLeft: undefined,
        arrowOffsetTop: undefined,
        maxHeight: undefined,
        placement: undefined
    });
    let deps = [
        shouldUpdatePosition,
        placement,
        overlayRef.current,
        targetRef.current,
        scrollRef.current,
        containerPadding,
        shouldFlip,
        boundaryElement,
        offset,
        crossOffset,
        isOpen,
        direction,
        maxHeight
    ];
    let updatePosition = (useCallback)(()=>{
        if (shouldUpdatePosition === false || !isOpen || !overlayRef.current || !targetRef.current || !scrollRef.current || !boundaryElement) return;
        setPosition(($edcf132a9284368a$export$b3ceb0cbf1056d98)({
            placement: $2a41e45df1593e64$var$translateRTL(placement, direction),
            overlayNode: overlayRef.current,
            targetNode: targetRef.current,
            scrollNode: scrollRef.current,
            padding: containerPadding,
            shouldFlip: shouldFlip,
            boundaryElement: boundaryElement,
            offset: offset,
            crossOffset: crossOffset,
            maxHeight: maxHeight
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    // Update position when anything changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(updatePosition, deps);
    // Update position on window resize
    $2a41e45df1593e64$var$useResize(updatePosition);
    // Update position when the overlay changes size (might need to flip).
    ($9daab02d461809db$export$683480f191c0e3ea)({
        ref: overlayRef,
        onResize: updatePosition
    });
    // Reposition the overlay and do not close on scroll while the visual viewport is resizing.
    // This will ensure that overlays adjust their positioning when the iOS virtual keyboard appears.
    let isResizing = (useRef)(false);
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(()=>{
        let timeout;
        let onResize = ()=>{
            isResizing.current = true;
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                isResizing.current = false;
            }, 500);
            updatePosition();
        };
        $2a41e45df1593e64$var$visualViewport === null || $2a41e45df1593e64$var$visualViewport === void 0 ? void 0 : $2a41e45df1593e64$var$visualViewport.addEventListener("resize", onResize);
        return ()=>{
            $2a41e45df1593e64$var$visualViewport === null || $2a41e45df1593e64$var$visualViewport === void 0 ? void 0 : $2a41e45df1593e64$var$visualViewport.removeEventListener("resize", onResize);
        };
    }, [
        updatePosition
    ]);
    let close = (useCallback)(()=>{
        if (!isResizing.current) onClose();
    }, [
        onClose,
        isResizing
    ]);
    // When scrolling a parent scrollable region of the trigger (other than the body),
    // we hide the popover. Otherwise, its position would be incorrect.
    ($dd149f63282afbbf$export$18fc8428861184da)({
        triggerRef: targetRef,
        isOpen: isOpen,
        onClose: onClose && close
    });
    return {
        overlayProps: {
            style: {
                position: "absolute",
                zIndex: 100000,
                ...position.position,
                maxHeight: position.maxHeight
            }
        },
        placement: position.placement,
        arrowProps: {
            style: {
                left: position.arrowOffsetLeft,
                top: position.arrowOffsetTop
            }
        },
        updatePosition: updatePosition
    };
}
function $2a41e45df1593e64$var$useResize(onResize) {
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(()=>{
        window.addEventListener("resize", onResize, false);
        return ()=>{
            window.removeEventListener("resize", onResize, false);
        };
    }, [
        onResize
    ]);
}
function $2a41e45df1593e64$var$translateRTL(position, direction) {
    if (direction === "rtl") return position.replace("start", "right").replace("end", "left");
    return position.replace("start", "left").replace("end", "right");
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


const $a11501f3d1d39e6c$var$visibleOverlays = [];
function $a11501f3d1d39e6c$export$ea8f71083e90600f(props, ref) {
    let { onClose: onClose , shouldCloseOnBlur: shouldCloseOnBlur , isOpen: isOpen , isDismissable: isDismissable = false , isKeyboardDismissDisabled: isKeyboardDismissDisabled = false , shouldCloseOnInteractOutside: shouldCloseOnInteractOutside  } = props;
    // Add the overlay ref to the stack of visible overlays on mount, and remove on unmount.
    (useEffect)(()=>{
        if (isOpen) $a11501f3d1d39e6c$var$visibleOverlays.push(ref);
        return ()=>{
            let index = $a11501f3d1d39e6c$var$visibleOverlays.indexOf(ref);
            if (index >= 0) $a11501f3d1d39e6c$var$visibleOverlays.splice(index, 1);
        };
    }, [
        isOpen,
        ref
    ]);
    // Only hide the overlay when it is the topmost visible overlay in the stack.
    let onHide = ()=>{
        if ($a11501f3d1d39e6c$var$visibleOverlays[$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref && onClose) onClose();
    };
    let onInteractOutsideStart = (e)=>{
        if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.target)) {
            if ($a11501f3d1d39e6c$var$visibleOverlays[$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref) {
                e.stopPropagation();
                e.preventDefault();
            }
        }
    };
    let onInteractOutside = (e)=>{
        if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.target)) {
            if ($a11501f3d1d39e6c$var$visibleOverlays[$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref) {
                e.stopPropagation();
                e.preventDefault();
            }
            onHide();
        }
    };
    // Handle the escape key
    let onKeyDown = (e)=>{
        if (e.key === "Escape" && !isKeyboardDismissDisabled) {
            e.stopPropagation();
            e.preventDefault();
            onHide();
        }
    };
    // Handle clicking outside the overlay to close it
    ($e0b6e0b68ec7f50f$export$872b660ac5a1ff98)({
        ref: ref,
        onInteractOutside: isDismissable ? onInteractOutside : null,
        onInteractOutsideStart: onInteractOutsideStart
    });
    let { focusWithinProps: focusWithinProps  } = ($9ab94262bd0047c7$export$420e68273165f4ec)({
        isDisabled: !shouldCloseOnBlur,
        onBlurWithin: (e)=>{
            // If focus is moving into a child focus scope (e.g. menu inside a dialog),
            // do not close the outer overlay. At this point, the active scope should
            // still be the outer overlay, since blur events run before focus.
            if (e.relatedTarget && ($9bf71ea28793e738$export$1258395f99bf9cbf)(e.relatedTarget)) return;
            if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.relatedTarget)) onClose();
        }
    });
    let onPointerDownUnderlay = (e)=>{
        // fixes a firefox issue that starts text selection https://bugzilla.mozilla.org/show_bug.cgi?id=1675846
        if (e.target === e.currentTarget) e.preventDefault();
    };
    return {
        overlayProps: {
            onKeyDown: onKeyDown,
            ...focusWithinProps
        },
        underlayProps: {
            onPointerDown: onPointerDownUnderlay
        }
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


function $628037886ba31236$export$f9d5c8beee7d008d(props, state, ref) {
    let { type: type  } = props;
    let { isOpen: isOpen  } = state;
    // Backward compatibility. Share state close function with useOverlayPosition so it can close on scroll
    // without forcing users to pass onClose.
    (useEffect)(()=>{
        if (ref && ref.current) ($dd149f63282afbbf$export$f6211563215e3b37).set(ref.current, state.close);
    });
    // Aria 1.1 supports multiple values for aria-haspopup other than just menus.
    // https://www.w3.org/TR/wai-aria-1.1/#aria-haspopup
    // However, we only add it for menus for now because screen readers often
    // announce it as a menu even for other values.
    let ariaHasPopup = undefined;
    if (type === "menu") ariaHasPopup = true;
    else if (type === "listbox") ariaHasPopup = "listbox";
    let overlayId = ($bdb11010cef70236$export$f680877a34711e37)();
    return {
        triggerProps: {
            "aria-haspopup": ariaHasPopup,
            "aria-expanded": isOpen,
            "aria-controls": isOpen ? overlayId : null,
            onPress: state.toggle
        },
        overlayProps: {
            id: overlayId
        }
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
// @ts-ignore
const $49c51c25361d4cd2$var$visualViewport = typeof window !== "undefined" && window.visualViewport;
// HTML input types that do not cause the software keyboard to appear.
const $49c51c25361d4cd2$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
// The number of active usePreventScroll calls. Used to determine whether to revert back to the original page style/scroll position
let $49c51c25361d4cd2$var$preventScrollCount = 0;
let $49c51c25361d4cd2$var$restore;
function $49c51c25361d4cd2$export$ee0f7cc6afcd1c18(options = {}) {
    let { isDisabled: isDisabled  } = options;
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(()=>{
        if (isDisabled) return;
        $49c51c25361d4cd2$var$preventScrollCount++;
        if ($49c51c25361d4cd2$var$preventScrollCount === 1) {
            if (($c87311424ea30a05$export$fedb369cb70207f1)()) $49c51c25361d4cd2$var$restore = $49c51c25361d4cd2$var$preventScrollMobileSafari();
            else $49c51c25361d4cd2$var$restore = $49c51c25361d4cd2$var$preventScrollStandard();
        }
        return ()=>{
            $49c51c25361d4cd2$var$preventScrollCount--;
            if ($49c51c25361d4cd2$var$preventScrollCount === 0) $49c51c25361d4cd2$var$restore();
        };
    }, [
        isDisabled
    ]);
}
// For most browsers, all we need to do is set `overflow: hidden` on the root element, and
// add some padding to prevent the page from shifting when the scrollbar is hidden.
function $49c51c25361d4cd2$var$preventScrollStandard() {
    return ($ff5963eb1fccf552$export$e08e3b67e392101e)($49c51c25361d4cd2$var$setStyle(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`), $49c51c25361d4cd2$var$setStyle(document.documentElement, "overflow", "hidden"));
}
// Mobile Safari is a whole different beast. Even with overflow: hidden,
// it still scrolls the page in many situations:
//
// 1. When the bottom toolbar and address bar are collapsed, page scrolling is always allowed.
// 2. When the keyboard is visible, the viewport does not resize. Instead, the keyboard covers part of
//    it, so it becomes scrollable.
// 3. When tapping on an input, the page always scrolls so that the input is centered in the visual viewport.
//    This may cause even fixed position elements to scroll off the screen.
// 4. When using the next/previous buttons in the keyboard to navigate between inputs, the whole page always
//    scrolls, even if the input is inside a nested scrollable element that could be scrolled instead.
//
// In order to work around these cases, and prevent scrolling without jankiness, we do a few things:
//
// 1. Prevent default on `touchmove` events that are not in a scrollable element. This prevents touch scrolling
//    on the window.
// 2. Prevent default on `touchmove` events inside a scrollable element when the scroll position is at the
//    top or bottom. This avoids the whole page scrolling instead, but does prevent overscrolling.
// 3. Prevent default on `touchend` events on input elements and handle focusing the element ourselves.
// 4. When focusing an input, apply a transform to trick Safari into thinking the input is at the top
//    of the page, which prevents it from scrolling the page. After the input is focused, scroll the element
//    into view ourselves, without scrolling the whole page.
// 5. Offset the body by the scroll position using a negative margin and scroll to the top. This should appear the
//    same visually, but makes the actual scroll position always zero. This is required to make all of the
//    above work or Safari will still try to scroll the page when focusing an input.
// 6. As a last resort, handle window scroll events, and scroll back to the top. This can happen when attempting
//    to navigate to an input with the next/previous buttons that's outside a modal.
function $49c51c25361d4cd2$var$preventScrollMobileSafari() {
    let scrollable;
    let lastY = 0;
    let onTouchStart = (e)=>{
        // Store the nearest scrollable parent element from the element that the user touched.
        scrollable = ($62d8ded9296f3872$export$cfa2225e87938781)(e.target);
        if (scrollable === document.documentElement && scrollable === document.body) return;
        lastY = e.changedTouches[0].pageY;
    };
    let onTouchMove = (e)=>{
        // Prevent scrolling the window.
        if (scrollable === document.documentElement || scrollable === document.body) {
            e.preventDefault();
            return;
        }
        // Prevent scrolling up when at the top and scrolling down when at the bottom
        // of a nested scrollable area, otherwise mobile Safari will start scrolling
        // the window instead. Unfortunately, this disables bounce scrolling when at
        // the top but it's the best we can do.
        let y = e.changedTouches[0].pageY;
        let scrollTop = scrollable.scrollTop;
        let bottom = scrollable.scrollHeight - scrollable.clientHeight;
        if (scrollTop <= 0 && y > lastY || scrollTop >= bottom && y < lastY) e.preventDefault();
        lastY = y;
    };
    let onTouchEnd = (e)=>{
        let target = e.target;
        // Apply this change if we're not already focused on the target element
        if ($49c51c25361d4cd2$var$willOpenKeyboard(target) && target !== document.activeElement) {
            e.preventDefault();
            // Apply a transform to trick Safari into thinking the input is at the top of the page
            // so it doesn't try to scroll it into view. When tapping on an input, this needs to
            // be done before the "focus" event, so we have to focus the element ourselves.
            target.style.transform = "translateY(-2000px)";
            target.focus();
            requestAnimationFrame(()=>{
                target.style.transform = "";
            });
        }
    };
    let onFocus = (e)=>{
        let target = e.target;
        if ($49c51c25361d4cd2$var$willOpenKeyboard(target)) {
            // Transform also needs to be applied in the focus event in cases where focus moves
            // other than tapping on an input directly, e.g. the next/previous buttons in the
            // software keyboard. In these cases, it seems applying the transform in the focus event
            // is good enough, whereas when tapping an input, it must be done before the focus event. 🤷‍♂️
            target.style.transform = "translateY(-2000px)";
            requestAnimationFrame(()=>{
                target.style.transform = "";
                // This will have prevented the browser from scrolling the focused element into view,
                // so we need to do this ourselves in a way that doesn't cause the whole page to scroll.
                if ($49c51c25361d4cd2$var$visualViewport) {
                    if ($49c51c25361d4cd2$var$visualViewport.height < window.innerHeight) // If the keyboard is already visible, do this after one additional frame
                    // to wait for the transform to be removed.
                    requestAnimationFrame(()=>{
                        $49c51c25361d4cd2$var$scrollIntoView(target);
                    });
                    else // Otherwise, wait for the visual viewport to resize before scrolling so we can
                    // measure the correct position to scroll to.
                    $49c51c25361d4cd2$var$visualViewport.addEventListener("resize", ()=>$49c51c25361d4cd2$var$scrollIntoView(target), {
                        once: true
                    });
                }
            });
        }
    };
    let onWindowScroll = ()=>{
        // Last resort. If the window scrolled, scroll it back to the top.
        // It should always be at the top because the body will have a negative margin (see below).
        window.scrollTo(0, 0);
    };
    // Record the original scroll position so we can restore it.
    // Then apply a negative margin to the body to offset it by the scroll position. This will
    // enable us to scroll the window to the top, which is required for the rest of this to work.
    let scrollX = window.pageXOffset;
    let scrollY = window.pageYOffset;
    let restoreStyles = ($ff5963eb1fccf552$export$e08e3b67e392101e)($49c51c25361d4cd2$var$setStyle(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`), $49c51c25361d4cd2$var$setStyle(document.documentElement, "overflow", "hidden"), $49c51c25361d4cd2$var$setStyle(document.body, "marginTop", `-${scrollY}px`));
    // Scroll to the top. The negative margin on the body will make this appear the same.
    window.scrollTo(0, 0);
    let removeEvents = ($ff5963eb1fccf552$export$e08e3b67e392101e)($49c51c25361d4cd2$var$addEvent(document, "touchstart", onTouchStart, {
        passive: false,
        capture: true
    }), $49c51c25361d4cd2$var$addEvent(document, "touchmove", onTouchMove, {
        passive: false,
        capture: true
    }), $49c51c25361d4cd2$var$addEvent(document, "touchend", onTouchEnd, {
        passive: false,
        capture: true
    }), $49c51c25361d4cd2$var$addEvent(document, "focus", onFocus, true), $49c51c25361d4cd2$var$addEvent(window, "scroll", onWindowScroll));
    return ()=>{
        // Restore styles and scroll the page back to where it was.
        restoreStyles();
        removeEvents();
        window.scrollTo(scrollX, scrollY);
    };
}
// Sets a CSS property on an element, and returns a function to revert it to the previous value.
function $49c51c25361d4cd2$var$setStyle(element, style, value) {
    let cur = element.style[style];
    element.style[style] = value;
    return ()=>{
        element.style[style] = cur;
    };
}
// Adds an event listener to an element, and returns a function to remove it.
function $49c51c25361d4cd2$var$addEvent(target, event, handler, options) {
    target.addEventListener(event, handler, options);
    return ()=>{
        target.removeEventListener(event, handler, options);
    };
}
function $49c51c25361d4cd2$var$scrollIntoView(target) {
    let root = document.scrollingElement || document.documentElement;
    while(target && target !== root){
        // Find the parent scrollable element and adjust the scroll position if the target is not already in view.
        let scrollable = ($62d8ded9296f3872$export$cfa2225e87938781)(target);
        if (scrollable !== document.documentElement && scrollable !== document.body && scrollable !== target) {
            let scrollableTop = scrollable.getBoundingClientRect().top;
            let targetTop = target.getBoundingClientRect().top;
            if (targetTop > scrollableTop + target.clientHeight) scrollable.scrollTop += targetTop - scrollableTop;
        }
        target = scrollable.parentElement;
    }
}
function $49c51c25361d4cd2$var$willOpenKeyboard(target) {
    return target instanceof HTMLInputElement && !$49c51c25361d4cd2$var$nonTextInputTypes.has(target.type) || target instanceof HTMLTextAreaElement || target instanceof HTMLElement && target.isContentEditable;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $61fe14465afefc5e$exports = {};
var $773d5888b972f1cf$exports = {};
$773d5888b972f1cf$exports = {
    "dismiss": `تجاهل`
};


var $d11f19852b941573$exports = {};
$d11f19852b941573$exports = {
    "dismiss": `Отхвърляне`
};


var $b983974c2ee1efb3$exports = {};
$b983974c2ee1efb3$exports = {
    "dismiss": `Odstranit`
};


var $5809cc9d4e92de73$exports = {};
$5809cc9d4e92de73$exports = {
    "dismiss": `Luk`
};


var $c68c2e4fc74398d1$exports = {};
$c68c2e4fc74398d1$exports = {
    "dismiss": `Schließen`
};


var $0898b4c153db2b77$exports = {};
$0898b4c153db2b77$exports = {
    "dismiss": `Απόρριψη`
};


var $6d74810286a15183$exports = {};
$6d74810286a15183$exports = {
    "dismiss": `Dismiss`
};


var $309d73dc65f78055$exports = {};
$309d73dc65f78055$exports = {
    "dismiss": `Descartar`
};


var $44ad94f7205cf593$exports = {};
$44ad94f7205cf593$exports = {
    "dismiss": `Lõpeta`
};


var $7c28f5687f0779a9$exports = {};
$7c28f5687f0779a9$exports = {
    "dismiss": `Hylkää`
};


var $e6d75df4b68bd73a$exports = {};
$e6d75df4b68bd73a$exports = {
    "dismiss": `Rejeter`
};


var $87505c9dab186d0f$exports = {};
$87505c9dab186d0f$exports = {
    "dismiss": `התעלם`
};


var $553439c3ffb3e492$exports = {};
$553439c3ffb3e492$exports = {
    "dismiss": `Odbaci`
};


var $74cf411061b983a2$exports = {};
$74cf411061b983a2$exports = {
    "dismiss": `Elutasítás`
};


var $e933f298574dc435$exports = {};
$e933f298574dc435$exports = {
    "dismiss": `Ignora`
};


var $ac91fc9fe02f71f6$exports = {};
$ac91fc9fe02f71f6$exports = {
    "dismiss": `閉じる`
};


var $52b96f86422025af$exports = {};
$52b96f86422025af$exports = {
    "dismiss": `무시`
};


var $c0d724c3e51dafa6$exports = {};
$c0d724c3e51dafa6$exports = {
    "dismiss": `Atmesti`
};


var $c92899672a3fe72e$exports = {};
$c92899672a3fe72e$exports = {
    "dismiss": `Nerādīt`
};


var $9f576b39d8e7a9d6$exports = {};
$9f576b39d8e7a9d6$exports = {
    "dismiss": `Lukk`
};


var $9d025808aeec81a7$exports = {};
$9d025808aeec81a7$exports = {
    "dismiss": `Negeren`
};


var $fce709921e2c0fa6$exports = {};
$fce709921e2c0fa6$exports = {
    "dismiss": `Zignoruj`
};


var $2599cf0c4ab37f59$exports = {};
$2599cf0c4ab37f59$exports = {
    "dismiss": `Descartar`
};


var $3c220ae7ef8a35fd$exports = {};
$3c220ae7ef8a35fd$exports = {
    "dismiss": `Dispensar`
};


var $93562b5094072f54$exports = {};
$93562b5094072f54$exports = {
    "dismiss": `Revocare`
};


var $cd9e2abd0d06c7b4$exports = {};
$cd9e2abd0d06c7b4$exports = {
    "dismiss": `Пропустить`
};


var $45375701f409adf1$exports = {};
$45375701f409adf1$exports = {
    "dismiss": `Zrušiť`
};


var $27fab53a576de9dd$exports = {};
$27fab53a576de9dd$exports = {
    "dismiss": `Opusti`
};


var $4438748d9952e7c7$exports = {};
$4438748d9952e7c7$exports = {
    "dismiss": `Odbaci`
};


var $0936d7347ef4da4c$exports = {};
$0936d7347ef4da4c$exports = {
    "dismiss": `Avvisa`
};


var $29700c92185d38f8$exports = {};
$29700c92185d38f8$exports = {
    "dismiss": `Kapat`
};


var $662ccaf2be4c25b3$exports = {};
$662ccaf2be4c25b3$exports = {
    "dismiss": `Скасувати`
};


var $d80a27deda7cdb3c$exports = {};
$d80a27deda7cdb3c$exports = {
    "dismiss": `取消`
};


var $2b2734393847c884$exports = {};
$2b2734393847c884$exports = {
    "dismiss": `關閉`
};


$61fe14465afefc5e$exports = {
    "ar-AE": $773d5888b972f1cf$exports,
    "bg-BG": $d11f19852b941573$exports,
    "cs-CZ": $b983974c2ee1efb3$exports,
    "da-DK": $5809cc9d4e92de73$exports,
    "de-DE": $c68c2e4fc74398d1$exports,
    "el-GR": $0898b4c153db2b77$exports,
    "en-US": $6d74810286a15183$exports,
    "es-ES": $309d73dc65f78055$exports,
    "et-EE": $44ad94f7205cf593$exports,
    "fi-FI": $7c28f5687f0779a9$exports,
    "fr-FR": $e6d75df4b68bd73a$exports,
    "he-IL": $87505c9dab186d0f$exports,
    "hr-HR": $553439c3ffb3e492$exports,
    "hu-HU": $74cf411061b983a2$exports,
    "it-IT": $e933f298574dc435$exports,
    "ja-JP": $ac91fc9fe02f71f6$exports,
    "ko-KR": $52b96f86422025af$exports,
    "lt-LT": $c0d724c3e51dafa6$exports,
    "lv-LV": $c92899672a3fe72e$exports,
    "nb-NO": $9f576b39d8e7a9d6$exports,
    "nl-NL": $9d025808aeec81a7$exports,
    "pl-PL": $fce709921e2c0fa6$exports,
    "pt-BR": $2599cf0c4ab37f59$exports,
    "pt-PT": $3c220ae7ef8a35fd$exports,
    "ro-RO": $93562b5094072f54$exports,
    "ru-RU": $cd9e2abd0d06c7b4$exports,
    "sk-SK": $45375701f409adf1$exports,
    "sl-SI": $27fab53a576de9dd$exports,
    "sr-SP": $4438748d9952e7c7$exports,
    "sv-SE": $0936d7347ef4da4c$exports,
    "tr-TR": $29700c92185d38f8$exports,
    "uk-UA": $662ccaf2be4c25b3$exports,
    "zh-CN": $d80a27deda7cdb3c$exports,
    "zh-TW": $2b2734393847c884$exports
};






function $86ea4cb521eb2e37$export$2317d149ed6f78c4(props) {
    let { onDismiss: onDismiss , ...otherProps } = props;
    let stringFormatter = ($fca6afa0e843324b$export$f12b703ca79dfbb1)(((/*@__PURE__*/$parcel$interopDefault$5($61fe14465afefc5e$exports))));
    let labels = ($313b98861ee5dd6c$export$d6875122194c7b44)(otherProps, stringFormatter.format("dismiss"));
    let onClick = ()=>{
        if (onDismiss) onDismiss();
    };
    return /*#__PURE__*/ (React__default).createElement(($5c3e21d68f1c4674$export$439d29a4e110a164), null, /*#__PURE__*/ (React__default).createElement("button", {
        ...labels,
        tabIndex: -1,
        onClick: onClick
    }));
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Keeps a ref count of all hidden elements. Added to when hiding an element, and
// subtracted from when showing it again. When it reaches zero, aria-hidden is removed.
let $5e3802645cc19319$var$refCountMap = new WeakMap();
let $5e3802645cc19319$var$observerStack = [];
function $5e3802645cc19319$export$1c3ebcada18427bf(targets, root = document.body) {
    let visibleNodes = new Set(targets);
    let hiddenNodes = new Set();
    let walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
        acceptNode (node) {
            // If this node is a live announcer, add it to the set of nodes to keep visible.
            if ((node instanceof HTMLElement || node instanceof SVGElement) && node.dataset.liveAnnouncer === "true") visibleNodes.add(node);
            // Skip this node and its children if it is one of the target nodes, or a live announcer.
            // Also skip children of already hidden nodes, as aria-hidden is recursive. An exception is
            // made for elements with role="row" since VoiceOver on iOS has issues hiding elements with role="row".
            // For that case we want to hide the cells inside as well (https://bugs.webkit.org/show_bug.cgi?id=222623).
            if (visibleNodes.has(node) || hiddenNodes.has(node.parentElement) && node.parentElement.getAttribute("role") !== "row") return NodeFilter.FILTER_REJECT;
            // Skip this node but continue to children if one of the targets is inside the node.
            if (targets.some((target)=>node.contains(target))) return NodeFilter.FILTER_SKIP;
            return NodeFilter.FILTER_ACCEPT;
        }
    });
    let hide = (node)=>{
        var _refCountMap_get;
        let refCount = (_refCountMap_get = $5e3802645cc19319$var$refCountMap.get(node)) !== null && _refCountMap_get !== void 0 ? _refCountMap_get : 0;
        // If already aria-hidden, and the ref count is zero, then this element
        // was already hidden and there's nothing for us to do.
        if (node.getAttribute("aria-hidden") === "true" && refCount === 0) return;
        if (refCount === 0) node.setAttribute("aria-hidden", "true");
        hiddenNodes.add(node);
        $5e3802645cc19319$var$refCountMap.set(node, refCount + 1);
    };
    // If there is already a MutationObserver listening from a previous call,
    // disconnect it so the new on takes over.
    if ($5e3802645cc19319$var$observerStack.length) $5e3802645cc19319$var$observerStack[$5e3802645cc19319$var$observerStack.length - 1].disconnect();
    let node = walker.nextNode();
    while(node != null){
        hide(node);
        node = walker.nextNode();
    }
    let observer = new MutationObserver((changes)=>{
        for (let change of changes){
            if (change.type !== "childList" || change.addedNodes.length === 0) continue;
            // If the parent element of the added nodes is not within one of the targets,
            // and not already inside a hidden node, hide all of the new children.
            if (![
                ...visibleNodes,
                ...hiddenNodes
            ].some((node)=>node.contains(change.target))) for (let node of change.addedNodes){
                if ((node instanceof HTMLElement || node instanceof SVGElement) && node.dataset.liveAnnouncer === "true") visibleNodes.add(node);
                else if (node instanceof Element) hide(node);
            }
        }
    });
    observer.observe(root, {
        childList: true,
        subtree: true
    });
    let observerWrapper = {
        observe () {
            observer.observe(root, {
                childList: true,
                subtree: true
            });
        },
        disconnect () {
            observer.disconnect();
        }
    };
    $5e3802645cc19319$var$observerStack.push(observerWrapper);
    return ()=>{
        observer.disconnect();
        for (let node of hiddenNodes){
            let count = $5e3802645cc19319$var$refCountMap.get(node);
            if (count === 1) {
                node.removeAttribute("aria-hidden");
                $5e3802645cc19319$var$refCountMap.delete(node);
            } else $5e3802645cc19319$var$refCountMap.set(node, count - 1);
        }
        // Remove this observer from the stack, and start the previous one.
        if (observerWrapper === $5e3802645cc19319$var$observerStack[$5e3802645cc19319$var$observerStack.length - 1]) {
            $5e3802645cc19319$var$observerStack.pop();
            if ($5e3802645cc19319$var$observerStack.length) $5e3802645cc19319$var$observerStack[$5e3802645cc19319$var$observerStack.length - 1].observe();
        } else $5e3802645cc19319$var$observerStack.splice($5e3802645cc19319$var$observerStack.indexOf(observerWrapper), 1);
    };
}


/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 





function $f2f8a6077418541e$export$542a6fd13ac93354(props, state) {
    let { triggerRef: triggerRef , popoverRef: popoverRef , isNonModal: isNonModal , isKeyboardDismissDisabled: isKeyboardDismissDisabled , ...otherProps } = props;
    let { overlayProps: overlayProps , underlayProps: underlayProps  } = ($a11501f3d1d39e6c$export$ea8f71083e90600f)({
        isOpen: state.isOpen,
        onClose: state.close,
        shouldCloseOnBlur: true,
        isDismissable: !isNonModal,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled
    }, popoverRef);
    let { overlayProps: positionProps , arrowProps: arrowProps , placement: placement  } = ($2a41e45df1593e64$export$d39e1813b3bdd0e1)({
        ...otherProps,
        targetRef: triggerRef,
        overlayRef: popoverRef,
        isOpen: state.isOpen,
        onClose: null
    });
    // Delay preventing scroll until popover is positioned to avoid extra scroll padding.
    // This requires a layout effect so that positioning has been committed to the DOM
    // by the time usePreventScroll measures the element.
    let [isPositioned, setPositioned] = (useState)(false);
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(()=>{
        if (!isNonModal && placement) setPositioned(true);
    }, [
        isNonModal,
        placement
    ]);
    ($49c51c25361d4cd2$export$ee0f7cc6afcd1c18)({
        isDisabled: isNonModal || !isPositioned
    });
    ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(()=>{
        if (state.isOpen && !isNonModal && popoverRef.current) return ($5e3802645cc19319$export$1c3ebcada18427bf)([
            popoverRef.current
        ]);
    }, [
        isNonModal,
        state.isOpen,
        popoverRef
    ]);
    return {
        popoverProps: ($3ef42575df84b30b$export$9d1611c77c2fe928)(overlayProps, positionProps),
        arrowProps: arrowProps,
        underlayProps: underlayProps,
        placement: placement
    };
}


/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 



/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 




const $337b884510726a0d$export$a2200b96afd16271 = /*#__PURE__*/ (React__default).createContext(null);
function $337b884510726a0d$export$c6fdb837b070b4ff(props) {
    let isSSR = ($704cf1d3b684cc5c$export$535bd6ca7f90a273)();
    let { portalContainer: portalContainer = isSSR ? null : document.body  } = props;
    let [contain, setContain] = (useState)(false);
    let contextValue = (useMemo)(()=>({
            contain: contain,
            setContain: setContain
        }), [
        contain,
        setContain
    ]);
    if (!portalContainer) return null;
    let contents = /*#__PURE__*/ (React__default).createElement($337b884510726a0d$export$a2200b96afd16271.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (React__default).createElement(($9bf71ea28793e738$export$20e40289641fbbb6), {
        restoreFocus: true,
        contain: contain
    }, props.children));
    return /*#__PURE__*/ ($k7QOs$reactdom).createPortal(contents, portalContainer);
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

function $feb5ffebff200149$export$d3e3bd3e26688c04(e) {
    // Ctrl + Arrow Up/Arrow Down has a system wide meaning on macOS, so use Alt instead.
    // On Windows and Ubuntu, Alt + Space has a system wide meaning.
    return ($c87311424ea30a05$export$e1865c3bedcd822b)() ? e.altKey : e.ctrlKey;
}
function $feb5ffebff200149$export$16792effe837dba3(e) {
    if (($c87311424ea30a05$export$9ac100e40613ea10)()) return e.metaKey;
    return e.ctrlKey;
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
/**
 * Controls how long to wait before clearing the typeahead buffer.
 */ const $fb3050f43d946246$var$TYPEAHEAD_DEBOUNCE_WAIT_MS = 1000; // 1 second
function $fb3050f43d946246$export$e32c88dfddc6e1d8(options) {
    let { keyboardDelegate: keyboardDelegate , selectionManager: selectionManager , onTypeSelect: onTypeSelect  } = options;
    let state = (useRef)({
        search: "",
        timeout: null
    }).current;
    let onKeyDown = (e)=>{
        let character = $fb3050f43d946246$var$getStringForKey(e.key);
        if (!character || e.ctrlKey || e.metaKey) return;
        // Do not propagate the Spacebar event if it's meant to be part of the search.
        // When we time out, the search term becomes empty, hence the check on length.
        // Trimming is to account for the case of pressing the Spacebar more than once,
        // which should cycle through the selection/deselection of the focused item.
        if (character === " " && state.search.trim().length > 0) {
            e.preventDefault();
            if (!("continuePropagation" in e)) e.stopPropagation();
        }
        state.search += character;
        // Use the delegate to find a key to focus.
        // Prioritize items after the currently focused item, falling back to searching the whole list.
        let key = keyboardDelegate.getKeyForSearch(state.search, selectionManager.focusedKey);
        // If no key found, search from the top.
        if (key == null) key = keyboardDelegate.getKeyForSearch(state.search);
        if (key != null) {
            selectionManager.setFocusedKey(key);
            if (onTypeSelect) onTypeSelect(key);
        }
        clearTimeout(state.timeout);
        state.timeout = setTimeout(()=>{
            state.search = "";
        }, $fb3050f43d946246$var$TYPEAHEAD_DEBOUNCE_WAIT_MS);
    };
    return {
        typeSelectProps: {
            // Using a capturing listener to catch the keydown event before
            // other hooks in order to handle the Spacebar event.
            onKeyDownCapture: keyboardDelegate.getKeyForSearch ? onKeyDown : null
        }
    };
}
function $fb3050f43d946246$var$getStringForKey(key) {
    // If the key is of length 1, it is an ASCII value.
    // Otherwise, if there are no ASCII characters in the key name,
    // it is a Unicode character.
    // See https://www.w3.org/TR/uievents-key/
    if (key.length === 1 || !/^[A-Z]/i.test(key)) return key;
    return "";
}


function $ae20dd8cbca75726$export$d6daf82dcd84e87c(options) {
    let { selectionManager: manager , keyboardDelegate: delegate , ref: ref , autoFocus: autoFocus = false , shouldFocusWrap: shouldFocusWrap = false , disallowEmptySelection: disallowEmptySelection = false , disallowSelectAll: disallowSelectAll = false , selectOnFocus: selectOnFocus = manager.selectionBehavior === "replace" , disallowTypeAhead: disallowTypeAhead = false , shouldUseVirtualFocus: shouldUseVirtualFocus , allowsTabNavigation: allowsTabNavigation = false , isVirtualized: isVirtualized , scrollRef: // If no scrollRef is provided, assume the collection ref is the scrollable region
    scrollRef = ref  } = options;
    let { direction: direction  } = ($18f2051aff69b9bf$export$43bb16f9c6d9e3f7)();
    let onKeyDown = (e)=>{
        // Prevent option + tab from doing anything since it doesn't move focus to the cells, only buttons/checkboxes
        if (e.altKey && e.key === "Tab") e.preventDefault();
        // Keyboard events bubble through portals. Don't handle keyboard events
        // for elements outside the collection (e.g. menus).
        if (!ref.current.contains(e.target)) return;
        const navigateToKey = (key, childFocus)=>{
            if (key != null) {
                manager.setFocusedKey(key, childFocus);
                if (e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(key);
                else if (selectOnFocus && !($feb5ffebff200149$export$d3e3bd3e26688c04)(e)) manager.replaceSelection(key);
            }
        };
        switch(e.key){
            case "ArrowDown":
                if (delegate.getKeyBelow) {
                    var _delegate_getFirstKey, _delegate_getFirstKey1;
                    e.preventDefault();
                    let nextKey = manager.focusedKey != null ? delegate.getKeyBelow(manager.focusedKey) : (_delegate_getFirstKey = delegate.getFirstKey) === null || _delegate_getFirstKey === void 0 ? void 0 : _delegate_getFirstKey.call(delegate);
                    if (nextKey == null && shouldFocusWrap) nextKey = (_delegate_getFirstKey1 = delegate.getFirstKey) === null || _delegate_getFirstKey1 === void 0 ? void 0 : _delegate_getFirstKey1.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "ArrowUp":
                if (delegate.getKeyAbove) {
                    var _delegate_getLastKey, _delegate_getLastKey1;
                    e.preventDefault();
                    let nextKey1 = manager.focusedKey != null ? delegate.getKeyAbove(manager.focusedKey) : (_delegate_getLastKey = delegate.getLastKey) === null || _delegate_getLastKey === void 0 ? void 0 : _delegate_getLastKey.call(delegate);
                    if (nextKey1 == null && shouldFocusWrap) nextKey1 = (_delegate_getLastKey1 = delegate.getLastKey) === null || _delegate_getLastKey1 === void 0 ? void 0 : _delegate_getLastKey1.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey1);
                }
                break;
            case "ArrowLeft":
                if (delegate.getKeyLeftOf) {
                    e.preventDefault();
                    let nextKey2 = delegate.getKeyLeftOf(manager.focusedKey);
                    navigateToKey(nextKey2, direction === "rtl" ? "first" : "last");
                }
                break;
            case "ArrowRight":
                if (delegate.getKeyRightOf) {
                    e.preventDefault();
                    let nextKey3 = delegate.getKeyRightOf(manager.focusedKey);
                    navigateToKey(nextKey3, direction === "rtl" ? "last" : "first");
                }
                break;
            case "Home":
                if (delegate.getFirstKey) {
                    e.preventDefault();
                    let firstKey = delegate.getFirstKey(manager.focusedKey, ($feb5ffebff200149$export$16792effe837dba3)(e));
                    manager.setFocusedKey(firstKey);
                    if (($feb5ffebff200149$export$16792effe837dba3)(e) && e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(firstKey);
                    else if (selectOnFocus) manager.replaceSelection(firstKey);
                }
                break;
            case "End":
                if (delegate.getLastKey) {
                    e.preventDefault();
                    let lastKey = delegate.getLastKey(manager.focusedKey, ($feb5ffebff200149$export$16792effe837dba3)(e));
                    manager.setFocusedKey(lastKey);
                    if (($feb5ffebff200149$export$16792effe837dba3)(e) && e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(lastKey);
                    else if (selectOnFocus) manager.replaceSelection(lastKey);
                }
                break;
            case "PageDown":
                if (delegate.getKeyPageBelow) {
                    e.preventDefault();
                    let nextKey4 = delegate.getKeyPageBelow(manager.focusedKey);
                    navigateToKey(nextKey4);
                }
                break;
            case "PageUp":
                if (delegate.getKeyPageAbove) {
                    e.preventDefault();
                    let nextKey5 = delegate.getKeyPageAbove(manager.focusedKey);
                    navigateToKey(nextKey5);
                }
                break;
            case "a":
                if (($feb5ffebff200149$export$16792effe837dba3)(e) && manager.selectionMode === "multiple" && disallowSelectAll !== true) {
                    e.preventDefault();
                    manager.selectAll();
                }
                break;
            case "Escape":
                e.preventDefault();
                if (!disallowEmptySelection) manager.clearSelection();
                break;
            case "Tab":
                if (!allowsTabNavigation) {
                    // There may be elements that are "tabbable" inside a collection (e.g. in a grid cell).
                    // However, collections should be treated as a single tab stop, with arrow key navigation internally.
                    // We don't control the rendering of these, so we can't override the tabIndex to prevent tabbing.
                    // Instead, we handle the Tab key, and move focus manually to the first/last tabbable element
                    // in the collection, so that the browser default behavior will apply starting from that element
                    // rather than the currently focused one.
                    if (e.shiftKey) ref.current.focus();
                    else {
                        let walker = ($9bf71ea28793e738$export$2d6ec8fc375ceafa)(ref.current, {
                            tabbable: true
                        });
                        let next;
                        let last;
                        do {
                            last = walker.lastChild();
                            if (last) next = last;
                        }while (last);
                        if (next && !next.contains(document.activeElement)) ($7215afc6de606d6b$export$de79e2c695e052f3)(next);
                    }
                    break;
                }
        }
    };
    // Store the scroll position so we can restore it later.
    let scrollPos = (useRef)({
        top: 0,
        left: 0
    });
    ($e9faafb641e167db$export$90fc3a17d93f704c)(scrollRef, "scroll", isVirtualized ? null : ()=>{
        scrollPos.current = {
            top: scrollRef.current.scrollTop,
            left: scrollRef.current.scrollLeft
        };
    });
    let onFocus = (e)=>{
        if (manager.isFocused) {
            // If a focus event bubbled through a portal, reset focus state.
            if (!e.currentTarget.contains(e.target)) manager.setFocused(false);
            return;
        }
        // Focus events can bubble through portals. Ignore these events.
        if (!e.currentTarget.contains(e.target)) return;
        manager.setFocused(true);
        if (manager.focusedKey == null) {
            let navigateToFirstKey = (key)=>{
                if (key != null) {
                    manager.setFocusedKey(key);
                    if (selectOnFocus) manager.replaceSelection(key);
                }
            };
            // If the user hasn't yet interacted with the collection, there will be no focusedKey set.
            // Attempt to detect whether the user is tabbing forward or backward into the collection
            // and either focus the first or last item accordingly.
            let relatedTarget = e.relatedTarget;
            var _manager_lastSelectedKey, _manager_firstSelectedKey;
            if (relatedTarget && e.currentTarget.compareDocumentPosition(relatedTarget) & Node.DOCUMENT_POSITION_FOLLOWING) navigateToFirstKey((_manager_lastSelectedKey = manager.lastSelectedKey) !== null && _manager_lastSelectedKey !== void 0 ? _manager_lastSelectedKey : delegate.getLastKey());
            else navigateToFirstKey((_manager_firstSelectedKey = manager.firstSelectedKey) !== null && _manager_firstSelectedKey !== void 0 ? _manager_firstSelectedKey : delegate.getFirstKey());
        } else if (!isVirtualized) {
            // Restore the scroll position to what it was before.
            scrollRef.current.scrollTop = scrollPos.current.top;
            scrollRef.current.scrollLeft = scrollPos.current.left;
            // Refocus and scroll the focused item into view if it exists within the scrollable region.
            let element = scrollRef.current.querySelector(`[data-key="${manager.focusedKey}"]`);
            if (element) {
                // This prevents a flash of focus on the first/last element in the collection
                ($7215afc6de606d6b$export$de79e2c695e052f3)(element);
                ($2f04cbc44ee30ce0$export$53a0910f038337bd)(scrollRef.current, element);
            }
        }
    };
    let onBlur = (e)=>{
        // Don't set blurred and then focused again if moving focus within the collection.
        if (!e.currentTarget.contains(e.relatedTarget)) manager.setFocused(false);
    };
    const autoFocusRef = (useRef)(autoFocus);
    (useEffect)(()=>{
        if (autoFocusRef.current) {
            let focusedKey = null;
            // Check focus strategy to determine which item to focus
            if (autoFocus === "first") focusedKey = delegate.getFirstKey();
            if (autoFocus === "last") focusedKey = delegate.getLastKey();
            // If there are any selected keys, make the first one the new focus target
            let selectedKeys = manager.selectedKeys;
            if (selectedKeys.size) focusedKey = selectedKeys.values().next().value;
            manager.setFocused(true);
            manager.setFocusedKey(focusedKey);
            // If no default focus key is selected, focus the collection itself.
            if (focusedKey == null && !shouldUseVirtualFocus) ($6a99195332edec8b$export$80f3e147d781571c)(ref.current);
        }
        autoFocusRef.current = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // If not virtualized, scroll the focused element into view when the focusedKey changes.
    // When virtualized, Virtualizer handles this internally.
    (useEffect)(()=>{
        if (!isVirtualized && manager.focusedKey && (scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current)) {
            let element = scrollRef.current.querySelector(`[data-key="${manager.focusedKey}"]`);
            if (element) ($2f04cbc44ee30ce0$export$53a0910f038337bd)(scrollRef.current, element);
        }
    }, [
        isVirtualized,
        scrollRef,
        manager.focusedKey
    ]);
    let handlers = {
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseDown (e) {
            // Ignore events that bubbled through portals.
            if (scrollRef.current === e.target) // Prevent focus going to the collection when clicking on the scrollbar.
            e.preventDefault();
        }
    };
    let { typeSelectProps: typeSelectProps  } = ($fb3050f43d946246$export$e32c88dfddc6e1d8)({
        keyboardDelegate: delegate,
        selectionManager: manager
    });
    if (!disallowTypeAhead) handlers = ($3ef42575df84b30b$export$9d1611c77c2fe928)(typeSelectProps, handlers);
    // If nothing is focused within the collection, make the collection itself tabbable.
    // This will be marshalled to either the first or last item depending on where focus came from.
    // If using virtual focus, don't set a tabIndex at all so that VoiceOver on iOS 14 doesn't try
    // to move real DOM focus to the element anyway.
    let tabIndex;
    if (!shouldUseVirtualFocus) tabIndex = manager.focusedKey == null ? 0 : -1;
    return {
        collectionProps: {
            ...handlers,
            tabIndex: tabIndex
        }
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 




function $880e95eb8b93ba9a$export$ecf600387e221c37(options) {
    let { selectionManager: manager , key: key , ref: ref , shouldSelectOnPressUp: shouldSelectOnPressUp , isVirtualized: isVirtualized , shouldUseVirtualFocus: shouldUseVirtualFocus , focus: focus , isDisabled: isDisabled , onAction: onAction , allowsDifferentPressOrigin: allowsDifferentPressOrigin  } = options;
    let onSelect = (e)=>{
        if (e.pointerType === "keyboard" && ($feb5ffebff200149$export$d3e3bd3e26688c04)(e)) manager.toggleSelection(key);
        else {
            if (manager.selectionMode === "none") return;
            if (manager.selectionMode === "single") {
                if (manager.isSelected(key) && !manager.disallowEmptySelection) manager.toggleSelection(key);
                else manager.replaceSelection(key);
            } else if (e && e.shiftKey) manager.extendSelection(key);
            else if (manager.selectionBehavior === "toggle" || e && (($feb5ffebff200149$export$16792effe837dba3)(e) || e.pointerType === "touch" || e.pointerType === "virtual")) // if touch or virtual (VO) then we just want to toggle, otherwise it's impossible to multi select because they don't have modifier keys
            manager.toggleSelection(key);
            else manager.replaceSelection(key);
        }
    };
    // Focus the associated DOM node when this item becomes the focusedKey
    (useEffect)(()=>{
        let isFocused = key === manager.focusedKey;
        if (isFocused && manager.isFocused && !shouldUseVirtualFocus && document.activeElement !== ref.current) {
            if (focus) focus();
            else ($6a99195332edec8b$export$80f3e147d781571c)(ref.current);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref,
        key,
        manager.focusedKey,
        manager.childFocusStrategy,
        manager.isFocused,
        shouldUseVirtualFocus
    ]);
    isDisabled = isDisabled || manager.isDisabled(key);
    // Set tabIndex to 0 if the element is focused, or -1 otherwise so that only the last focused
    // item is tabbable.  If using virtual focus, don't set a tabIndex at all so that VoiceOver
    // on iOS 14 doesn't try to move real DOM focus to the item anyway.
    let itemProps = {};
    if (!shouldUseVirtualFocus && !isDisabled) itemProps = {
        tabIndex: key === manager.focusedKey ? 0 : -1,
        onFocus (e) {
            if (e.target === ref.current) manager.setFocusedKey(key);
        }
    };
    else if (isDisabled) itemProps.onMouseDown = (e)=>{
        // Prevent focus going to the body when clicking on a disabled item.
        e.preventDefault();
    };
    // With checkbox selection, onAction (i.e. navigation) becomes primary, and occurs on a single click of the row.
    // Clicking the checkbox enters selection mode, after which clicking anywhere on any row toggles selection for that row.
    // With highlight selection, onAction is secondary, and occurs on double click. Single click selects the row.
    // With touch, onAction occurs on single tap, and long press enters selection mode.
    let allowsSelection = !isDisabled && manager.canSelectItem(key);
    let allowsActions = onAction && !isDisabled;
    let hasPrimaryAction = allowsActions && (manager.selectionBehavior === "replace" ? !allowsSelection : manager.isEmpty);
    let hasSecondaryAction = allowsActions && allowsSelection && manager.selectionBehavior === "replace";
    let hasAction = hasPrimaryAction || hasSecondaryAction;
    let modality = (useRef)(null);
    let longPressEnabled = hasAction && allowsSelection;
    let longPressEnabledOnPressStart = (useRef)(false);
    let hadPrimaryActionOnPressStart = (useRef)(false);
    // By default, selection occurs on pointer down. This can be strange if selecting an
    // item causes the UI to disappear immediately (e.g. menus).
    // If shouldSelectOnPressUp is true, we use onPressUp instead of onPressStart.
    // onPress requires a pointer down event on the same element as pointer up. For menus,
    // we want to be able to have the pointer down on the trigger that opens the menu and
    // the pointer up on the menu item rather than requiring a separate press.
    // For keyboard events, selection still occurs on key down.
    let itemPressProps = {};
    if (shouldSelectOnPressUp) {
        itemPressProps.onPressStart = (e)=>{
            modality.current = e.pointerType;
            longPressEnabledOnPressStart.current = longPressEnabled;
            if (e.pointerType === "keyboard" && (!hasAction || $880e95eb8b93ba9a$var$isSelectionKey())) onSelect(e);
        };
        // If allowsDifferentPressOrigin, make selection happen on pressUp (e.g. open menu on press down, selection on menu item happens on press up.)
        // Otherwise, have selection happen onPress (prevents listview row selection when clicking on interactable elements in the row)
        if (!allowsDifferentPressOrigin) itemPressProps.onPress = (e)=>{
            if (hasPrimaryAction || hasSecondaryAction && e.pointerType !== "mouse") {
                if (e.pointerType === "keyboard" && !$880e95eb8b93ba9a$var$isActionKey()) return;
                onAction();
            } else if (e.pointerType !== "keyboard") onSelect(e);
        };
        else {
            itemPressProps.onPressUp = (e)=>{
                if (e.pointerType !== "keyboard") onSelect(e);
            };
            itemPressProps.onPress = hasPrimaryAction ? ()=>onAction() : null;
        }
    } else {
        itemPressProps.onPressStart = (e)=>{
            modality.current = e.pointerType;
            longPressEnabledOnPressStart.current = longPressEnabled;
            hadPrimaryActionOnPressStart.current = hasPrimaryAction;
            // Select on mouse down unless there is a primary action which will occur on mouse up.
            // For keyboard, select on key down. If there is an action, the Space key selects on key down,
            // and the Enter key performs onAction on key up.
            if (e.pointerType === "mouse" && !hasPrimaryAction || e.pointerType === "keyboard" && (!onAction || $880e95eb8b93ba9a$var$isSelectionKey())) onSelect(e);
        };
        itemPressProps.onPress = (e)=>{
            // Selection occurs on touch up. Primary actions always occur on pointer up.
            // Both primary and secondary actions occur on Enter key up. The only exception
            // is secondary actions, which occur on double click with a mouse.
            if (e.pointerType === "touch" || e.pointerType === "pen" || e.pointerType === "virtual" || e.pointerType === "keyboard" && hasAction && $880e95eb8b93ba9a$var$isActionKey() || e.pointerType === "mouse" && hadPrimaryActionOnPressStart.current) {
                if (hasAction) onAction();
                else onSelect(e);
            }
        };
    }
    if (!isVirtualized) itemProps["data-key"] = key;
    itemPressProps.preventFocusOnPress = shouldUseVirtualFocus;
    let { pressProps: pressProps , isPressed: isPressed  } = ($f6c31cce2adf654f$export$45712eceda6fad21)(itemPressProps);
    // Double clicking with a mouse with selectionBehavior = 'replace' performs an action.
    let onDoubleClick = hasSecondaryAction ? (e)=>{
        if (modality.current === "mouse") {
            e.stopPropagation();
            e.preventDefault();
            onAction();
        }
    } : undefined;
    // Long pressing an item with touch when selectionBehavior = 'replace' switches the selection behavior
    // to 'toggle'. This changes the single tap behavior from performing an action (i.e. navigating) to
    // selecting, and may toggle the appearance of a UI affordance like checkboxes on each item.
    let { longPressProps: longPressProps  } = ($8a26561d2877236e$export$c24ed0104d07eab9)({
        isDisabled: !longPressEnabled,
        onLongPress (e) {
            if (e.pointerType === "touch") {
                onSelect(e);
                manager.setSelectionBehavior("toggle");
            }
        }
    });
    // Prevent native drag and drop on long press if we also select on long press.
    // Once the user is in selection mode, they can long press again to drag.
    // Use a capturing listener to ensure this runs before useDrag, regardless of
    // the order the props get merged.
    let onDragStartCapture = (e)=>{
        if (modality.current === "touch" && longPressEnabledOnPressStart.current) e.preventDefault();
    };
    return {
        itemProps: ($3ef42575df84b30b$export$9d1611c77c2fe928)(itemProps, allowsSelection || hasPrimaryAction ? pressProps : {}, longPressEnabled ? longPressProps : {}, {
            onDoubleClick: onDoubleClick,
            onDragStartCapture: onDragStartCapture
        }),
        isPressed: isPressed,
        isSelected: manager.isSelected(key),
        isDisabled: isDisabled,
        allowsSelection: allowsSelection,
        hasAction: hasAction
    };
}
function $880e95eb8b93ba9a$var$isActionKey() {
    let event = window.event;
    return (event === null || event === void 0 ? void 0 : event.key) === "Enter";
}
function $880e95eb8b93ba9a$var$isSelectionKey() {
    let event = window.event;
    return (event === null || event === void 0 ? void 0 : event.key) === " " || (event === null || event === void 0 ? void 0 : event.code) === "Space";
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $2a25aae57d74318e$export$a05409b8bb224a5a {
    getKeyBelow(key) {
        key = this.collection.getKeyAfter(key);
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyAfter(key);
        }
    }
    getKeyAbove(key) {
        key = this.collection.getKeyBefore(key);
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyBefore(key);
        }
    }
    getFirstKey() {
        let key = this.collection.getFirstKey();
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyAfter(key);
        }
    }
    getLastKey() {
        let key = this.collection.getLastKey();
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyBefore(key);
        }
    }
    getItem(key) {
        return this.ref.current.querySelector(`[data-key="${key}"]`);
    }
    getKeyPageAbove(key) {
        let menu = this.ref.current;
        let item = this.getItem(key);
        if (!item) return null;
        let pageY = Math.max(0, item.offsetTop + item.offsetHeight - menu.offsetHeight);
        while(item && item.offsetTop > pageY){
            key = this.getKeyAbove(key);
            item = this.getItem(key);
        }
        return key;
    }
    getKeyPageBelow(key) {
        let menu = this.ref.current;
        let item = this.getItem(key);
        if (!item) return null;
        let pageY = Math.min(menu.scrollHeight, item.offsetTop - item.offsetHeight + menu.offsetHeight);
        while(item && item.offsetTop < pageY){
            key = this.getKeyBelow(key);
            item = this.getItem(key);
        }
        return key;
    }
    getKeyForSearch(search, fromKey) {
        if (!this.collator) return null;
        let collection = this.collection;
        let key = fromKey || this.getFirstKey();
        while(key != null){
            let item = collection.getItem(key);
            let substring = item.textValue.slice(0, search.length);
            if (item.textValue && this.collator.compare(substring, search) === 0) return key;
            key = this.getKeyBelow(key);
        }
        return null;
    }
    constructor(collection, disabledKeys, ref, collator){
        this.collection = collection;
        this.disabledKeys = disabledKeys;
        this.ref = ref;
        this.collator = collator;
    }
}




function $982254629710d113$export$b95089534ab7c1fd(props) {
    let { selectionManager: selectionManager , collection: collection , disabledKeys: disabledKeys , ref: ref , keyboardDelegate: keyboardDelegate , autoFocus: autoFocus , shouldFocusWrap: shouldFocusWrap , isVirtualized: isVirtualized , disallowEmptySelection: disallowEmptySelection , selectOnFocus: selectOnFocus = selectionManager.selectionBehavior === "replace" , disallowTypeAhead: disallowTypeAhead , shouldUseVirtualFocus: shouldUseVirtualFocus , allowsTabNavigation: allowsTabNavigation  } = props;
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let collator = ($325a3faab7a68acd$export$a16aca283550c30d)({
        usage: "search",
        sensitivity: "base"
    });
    let disabledBehavior = selectionManager.disabledBehavior;
    let delegate = (useMemo)(()=>keyboardDelegate || new ($2a25aae57d74318e$export$a05409b8bb224a5a)(collection, disabledBehavior === "selection" ? new Set() : disabledKeys, ref, collator), [
        keyboardDelegate,
        collection,
        disabledKeys,
        ref,
        collator,
        disabledBehavior
    ]);
    let { collectionProps: collectionProps  } = ($ae20dd8cbca75726$export$d6daf82dcd84e87c)({
        ref: ref,
        selectionManager: selectionManager,
        keyboardDelegate: delegate,
        autoFocus: autoFocus,
        shouldFocusWrap: shouldFocusWrap,
        disallowEmptySelection: disallowEmptySelection,
        selectOnFocus: selectOnFocus,
        disallowTypeAhead: disallowTypeAhead,
        shouldUseVirtualFocus: shouldUseVirtualFocus,
        allowsTabNavigation: allowsTabNavigation,
        isVirtualized: isVirtualized,
        scrollRef: ref
    });
    return {
        listProps: collectionProps
    };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
function $c1d7fb2ec91bae71$var$Item(props) {
    return null;
}
$c1d7fb2ec91bae71$var$Item.getCollectionNode = function* getCollectionNode(props, context) {
    let { childItems: childItems , title: title , children: children  } = props;
    let rendered = props.title || props.children;
    let textValue = props.textValue || (typeof rendered === "string" ? rendered : "") || props["aria-label"] || "";
    // suppressTextValueWarning is used in components like Tabs, which don't have type to select support.
    if (!textValue && !(context === null || context === void 0 ? void 0 : context.suppressTextValueWarning)) console.warn("<Item> with non-plain text contents is unsupported by type to select for accessibility. Please add a `textValue` prop.");
    yield {
        type: "item",
        props: props,
        rendered: rendered,
        textValue: textValue,
        "aria-label": props["aria-label"],
        hasChildNodes: $c1d7fb2ec91bae71$var$hasChildItems(props),
        *childNodes () {
            if (childItems) for (let child of childItems)yield {
                type: "item",
                value: child
            };
            else if (title) {
                let items = [];
                (React__default).Children.forEach(children, (child)=>{
                    items.push({
                        type: "item",
                        element: child
                    });
                });
                yield* items;
            }
        }
    };
};
function $c1d7fb2ec91bae71$var$hasChildItems(props) {
    if (props.hasChildItems != null) return props.hasChildItems;
    if (props.childItems) return true;
    if (props.title && (React__default).Children.count(props.children) > 0) return true;
    return false;
}
// We don't want getCollectionNode to show up in the type definition
let $c1d7fb2ec91bae71$export$6d08773d2e66f8f2 = $c1d7fb2ec91bae71$var$Item;


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
function $9fc4852771d079eb$var$Section(props) {
    return null;
}
$9fc4852771d079eb$var$Section.getCollectionNode = function* getCollectionNode(props) {
    let { children: children , title: title , items: items  } = props;
    yield {
        type: "section",
        props: props,
        hasChildNodes: true,
        rendered: title,
        "aria-label": props["aria-label"],
        *childNodes () {
            if (typeof children === "function") {
                if (!items) throw new Error("props.children was a function but props.items is missing");
                for (let item of items)yield {
                    type: "item",
                    value: item,
                    renderer: children
                };
            } else {
                let items1 = [];
                (React__default).Children.forEach(children, (child)=>{
                    items1.push({
                        type: "item",
                        element: child
                    });
                });
                yield* items1;
            }
        }
    };
};
// We don't want getCollectionNode to show up in the type definition
let $9fc4852771d079eb$export$6e2c8f0811a474ce = $9fc4852771d079eb$var$Section;


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

class $eb2240fc39a57fa5$export$bf788dd355e3a401 {
    build(props, context) {
        this.context = context;
        return $eb2240fc39a57fa5$var$iterable(()=>this.iterateCollection(props));
    }
    *iterateCollection(props) {
        let { children: children , items: items  } = props;
        if (typeof children === "function") {
            if (!items) throw new Error("props.children was a function but props.items is missing");
            for (let item of props.items)yield* this.getFullNode({
                value: item
            }, {
                renderer: children
            });
        } else {
            let items1 = [];
            (React__default).Children.forEach(children, (child)=>{
                items1.push(child);
            });
            let index = 0;
            for (let item1 of items1){
                let nodes = this.getFullNode({
                    element: item1,
                    index: index
                }, {});
                for (let node of nodes){
                    index++;
                    yield node;
                }
            }
        }
    }
    getKey(item, partialNode, state, parentKey) {
        if (item.key != null) return item.key;
        if (partialNode.type === "cell" && partialNode.key != null) return `${parentKey}${partialNode.key}`;
        let v = partialNode.value;
        if (v != null) {
            var _v_key;
            let key = (_v_key = v.key) !== null && _v_key !== void 0 ? _v_key : v.id;
            if (key == null) throw new Error("No key found for item");
            return key;
        }
        return parentKey ? `${parentKey}.${partialNode.index}` : `$.${partialNode.index}`;
    }
    getChildState(state, partialNode) {
        return {
            renderer: partialNode.renderer || state.renderer
        };
    }
    *getFullNode(partialNode, state, parentKey, parentNode) {
        // If there's a value instead of an element on the node, and a parent renderer function is available,
        // use it to render an element for the value.
        let element = partialNode.element;
        if (!element && partialNode.value && state && state.renderer) {
            let cached = this.cache.get(partialNode.value);
            if (cached && (!cached.shouldInvalidate || !cached.shouldInvalidate(this.context))) {
                cached.index = partialNode.index;
                cached.parentKey = parentNode ? parentNode.key : null;
                yield cached;
                return;
            }
            element = state.renderer(partialNode.value);
        }
        // If there's an element with a getCollectionNode function on its type, then it's a supported component.
        // Call this function to get a partial node, and recursively build a full node from there.
        if ((React__default).isValidElement(element)) {
            let type = element.type;
            if (typeof type !== "function" && typeof type.getCollectionNode !== "function") {
                let name = typeof element.type === "function" ? element.type.name : element.type;
                throw new Error(`Unknown element <${name}> in collection.`);
            }
            let childNodes = type.getCollectionNode(element.props, this.context);
            let index = partialNode.index;
            let result = childNodes.next();
            while(!result.done && result.value){
                let childNode = result.value;
                partialNode.index = index;
                let nodeKey = childNode.key;
                if (!nodeKey) nodeKey = childNode.element ? null : this.getKey(element, partialNode, state, parentKey);
                let nodes = this.getFullNode({
                    ...childNode,
                    key: nodeKey,
                    index: index,
                    wrapper: $eb2240fc39a57fa5$var$compose(partialNode.wrapper, childNode.wrapper)
                }, this.getChildState(state, childNode), parentKey ? `${parentKey}${element.key}` : element.key, parentNode);
                let children = [
                    ...nodes
                ];
                for (let node of children){
                    // Cache the node based on its value
                    node.value = childNode.value || partialNode.value;
                    if (node.value) this.cache.set(node.value, node);
                    // The partial node may have specified a type for the child in order to specify a constraint.
                    // Verify that the full node that was built recursively matches this type.
                    if (partialNode.type && node.type !== partialNode.type) throw new Error(`Unsupported type <${$eb2240fc39a57fa5$var$capitalize(node.type)}> in <${$eb2240fc39a57fa5$var$capitalize(parentNode.type)}>. Only <${$eb2240fc39a57fa5$var$capitalize(partialNode.type)}> is supported.`);
                    index++;
                    yield node;
                }
                result = childNodes.next(children);
            }
            return;
        }
        // Ignore invalid elements
        if (partialNode.key == null) return;
        // Create full node
        let builder = this;
        let node1 = {
            type: partialNode.type,
            props: partialNode.props,
            key: partialNode.key,
            parentKey: parentNode ? parentNode.key : null,
            value: partialNode.value,
            level: parentNode ? parentNode.level + 1 : 0,
            index: partialNode.index,
            rendered: partialNode.rendered,
            textValue: partialNode.textValue,
            "aria-label": partialNode["aria-label"],
            wrapper: partialNode.wrapper,
            shouldInvalidate: partialNode.shouldInvalidate,
            hasChildNodes: partialNode.hasChildNodes,
            childNodes: $eb2240fc39a57fa5$var$iterable(function*() {
                if (!partialNode.hasChildNodes) return;
                let index = 0;
                for (let child of partialNode.childNodes()){
                    // Ensure child keys are globally unique by prepending the parent node's key
                    if (child.key != null) // TODO: Remove this line entirely and enforce that users always provide unique keys.
                    // Currently this line will have issues when a parent has a key `a` and a child with key `bc`
                    // but another parent has key `ab` and its child has a key `c`. The combined keys would result in both
                    // children having a key of `abc`.
                    child.key = `${node1.key}${child.key}`;
                    child.index = index;
                    let nodes = builder.getFullNode(child, builder.getChildState(state, child), node1.key, node1);
                    for (let node of nodes){
                        index++;
                        yield node;
                    }
                }
            })
        };
        yield node1;
    }
    constructor(){
        (_defineProperty)(this, "cache", new WeakMap());
    }
}
// Wraps an iterator function as an iterable object, and caches the results.
function $eb2240fc39a57fa5$var$iterable(iterator) {
    let cache = [];
    let iterable = null;
    return {
        *[Symbol.iterator] () {
            for (let item of cache)yield item;
            if (!iterable) iterable = iterator();
            for (let item1 of iterable){
                cache.push(item1);
                yield item1;
            }
        }
    };
}
function $eb2240fc39a57fa5$var$compose(outer, inner) {
    if (outer && inner) return (element)=>outer(inner(element));
    if (outer) return outer;
    if (inner) return inner;
}
function $eb2240fc39a57fa5$var$capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
}



function $7613b1592d41b092$export$6cd28814d92fa9c9(props, factory, context, invalidators = []) {
    let builder = (useMemo)(()=>new ($eb2240fc39a57fa5$export$bf788dd355e3a401)(), []);
    let prev = (useRef)(null);
    return (useMemo)(()=>{
        let nodes = builder.build(props, context);
        prev.current = factory(nodes, prev.current);
        return prev.current;
    // Don't invalidate when any prop changes, just the two we care about.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        builder,
        props.children,
        props.items,
        context,
        ...invalidators
    ]);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $453cc9f0df89c0a5$var$cache = new WeakMap();
function $453cc9f0df89c0a5$export$77d5aafae4e095b2(collection) {
    let count = $453cc9f0df89c0a5$var$cache.get(collection);
    if (count != null) return count;
    count = 0;
    for (let item of collection)if (item.type === "section") count += $453cc9f0df89c0a5$export$77d5aafae4e095b2(item.childNodes);
    else count++;
    $453cc9f0df89c0a5$var$cache.set(collection, count);
    return count;
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 * 
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $b1f0cad8af73213b$export$3585ede4d035bf14 = new WeakMap();
function $b1f0cad8af73213b$var$normalizeKey(key) {
    if (typeof key === "string") return key.replace(/\s*/g, "");
    return "" + key;
}
function $b1f0cad8af73213b$export$9145995848b05025(state, itemKey) {
    let data = $b1f0cad8af73213b$export$3585ede4d035bf14.get(state);
    if (!data) throw new Error("Unknown list");
    return `${data.id}-option-${$b1f0cad8af73213b$var$normalizeKey(itemKey)}`;
}






function $c132121280ec012d$export$50eacbbf140a3141(props, state, ref) {
    let domProps = ($65484d02dcb7eb3e$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    let { listProps: listProps  } = ($982254629710d113$export$b95089534ab7c1fd)({
        ...props,
        ref: ref,
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys
    });
    let { focusWithinProps: focusWithinProps  } = ($9ab94262bd0047c7$export$420e68273165f4ec)({
        onFocusWithin: props.onFocus,
        onBlurWithin: props.onBlur,
        onFocusWithinChange: props.onFocusChange
    });
    // Share list id and some props with child options.
    let id = ($bdb11010cef70236$export$f680877a34711e37)(props.id);
    ($b1f0cad8af73213b$export$3585ede4d035bf14).set(state, {
        id: id,
        shouldUseVirtualFocus: props.shouldUseVirtualFocus,
        shouldSelectOnPressUp: props.shouldSelectOnPressUp,
        shouldFocusOnHover: props.shouldFocusOnHover,
        isVirtualized: props.isVirtualized,
        onAction: props.onAction
    });
    let { labelProps: labelProps , fieldProps: fieldProps  } = ($d191a55c9702f145$export$8467354a121f1b9f)({
        ...props,
        id: id,
        // listbox is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: "span"
    });
    return {
        labelProps: labelProps,
        listBoxProps: ($3ef42575df84b30b$export$9d1611c77c2fe928)(domProps, focusWithinProps, state.selectionManager.selectionMode === "multiple" ? {
            "aria-multiselectable": "true"
        } : {}, {
            role: "listbox",
            ...($3ef42575df84b30b$export$9d1611c77c2fe928)(fieldProps, listProps)
        })
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
function $af383d3bef1cfdc9$export$c3f9f39876e4bc7(props) {
    let { heading: heading , "aria-label": ariaLabel  } = props;
    let headingId = ($bdb11010cef70236$export$f680877a34711e37)();
    return {
        itemProps: {
            role: "presentation"
        },
        headingProps: heading ? {
            // Techincally, listbox cannot contain headings according to ARIA.
            // We hide the heading from assistive technology, and only use it
            // as a label for the nested group.
            id: headingId,
            "aria-hidden": true
        } : {},
        groupProps: {
            role: "group",
            "aria-label": ariaLabel,
            "aria-labelledby": heading ? headingId : undefined
        }
    };
}

function $parcel$interopDefault$4(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $9bdd31893c9700c3$exports = {};
var $c0398ad35c3639b7$exports = {};
$c0398ad35c3639b7$exports = {
    "longPressMessage": `اضغط مطولاً أو اضغط على Alt + السهم لأسفل لفتح القائمة`
};


var $7af657c4165927c3$exports = {};
$7af657c4165927c3$exports = {
    "longPressMessage": `Натиснете продължително или натиснете Alt+ стрелка надолу, за да отворите менюто`
};


var $d95d4da6d531ab81$exports = {};
$d95d4da6d531ab81$exports = {
    "longPressMessage": `Dlouhým stiskem nebo stisknutím kláves Alt + šipka dolů otevřete nabídku`
};


var $24ebda9c775dca17$exports = {};
$24ebda9c775dca17$exports = {
    "longPressMessage": `Langt tryk eller tryk på Alt + pil ned for at åbne menuen`
};


var $743e0dfca6cab1e9$exports = {};
$743e0dfca6cab1e9$exports = {
    "longPressMessage": `Drücken Sie lange oder drücken Sie Alt + Nach-unten, um das Menü zu öffnen`
};


var $a2f41026e05f1c84$exports = {};
$a2f41026e05f1c84$exports = {
    "longPressMessage": `Πιέστε παρατεταμένα ή πατήστε Alt + κάτω βέλος για να ανοίξετε το μενού`
};


var $43b800e97c901737$exports = {};
$43b800e97c901737$exports = {
    "longPressMessage": `Long press or press Alt + ArrowDown to open menu`
};


var $442f5f6ac211e29f$exports = {};
$442f5f6ac211e29f$exports = {
    "longPressMessage": `Mantenga pulsado o pulse Alt + flecha abajo para abrir el menú`
};


var $dff280acfeb2d8ac$exports = {};
$dff280acfeb2d8ac$exports = {
    "longPressMessage": `Menüü avamiseks vajutage pikalt või vajutage klahve Alt + allanool`
};


var $51608325613944d7$exports = {};
$51608325613944d7$exports = {
    "longPressMessage": `Avaa valikko painamalla pohjassa tai näppäinyhdistelmällä Alt + Alanuoli`
};


var $c4a1b1eabeaa87be$exports = {};
$c4a1b1eabeaa87be$exports = {
    "longPressMessage": `Appuyez de manière prolongée ou appuyez sur Alt + Flèche vers le bas pour ouvrir le menu.`
};


var $8c74815cdee18d1b$exports = {};
$8c74815cdee18d1b$exports = {
    "longPressMessage": `לחץ לחיצה ארוכה או הקש Alt + ArrowDown כדי לפתוח את התפריט`
};


var $fd0e9ef6a7fe0ec9$exports = {};
$fd0e9ef6a7fe0ec9$exports = {
    "longPressMessage": `Dugo pritisnite ili pritisnite Alt + strelicu prema dolje za otvaranje izbornika`
};


var $a89a74a39eba465a$exports = {};
$a89a74a39eba465a$exports = {
    "longPressMessage": `Nyomja meg hosszan, vagy nyomja meg az Alt + lefele nyíl gombot a menü megnyitásához`
};


var $edc7c66594a0ae8a$exports = {};
$edc7c66594a0ae8a$exports = {
    "longPressMessage": `Premere a lungo o premere Alt + Freccia giù per aprire il menu`
};


var $f1ab51510712db52$exports = {};
$f1ab51510712db52$exports = {
    "longPressMessage": `長押しまたは Alt+下矢印キーでメニューを開く`
};


var $f9b672d9b82fa3d6$exports = {};
$f9b672d9b82fa3d6$exports = {
    "longPressMessage": `길게 누르거나 Alt + 아래쪽 화살표를 눌러 메뉴 열기`
};


var $a385f3910feda499$exports = {};
$a385f3910feda499$exports = {
    "longPressMessage": `Norėdami atidaryti meniu, nuspaudę palaikykite arba paspauskite „Alt + ArrowDown“.`
};


var $4f1bde932c441789$exports = {};
$4f1bde932c441789$exports = {
    "longPressMessage": `Lai atvērtu izvēlni, turiet nospiestu vai nospiediet taustiņu kombināciju Alt + lejupvērstā bultiņa`
};


var $914a51a8a594d5be$exports = {};
$914a51a8a594d5be$exports = {
    "longPressMessage": `Langt trykk eller trykk Alt + PilNed for å åpne menyen`
};


var $89aaf803103bb500$exports = {};
$89aaf803103bb500$exports = {
    "longPressMessage": `Druk lang op Alt + pijl-omlaag of druk op Alt om het menu te openen`
};


var $c685891476dbaaca$exports = {};
$c685891476dbaaca$exports = {
    "longPressMessage": `Naciśnij i przytrzymaj lub naciśnij klawisze Alt + Strzałka w dół, aby otworzyć menu`
};


var $885879b9b10c2959$exports = {};
$885879b9b10c2959$exports = {
    "longPressMessage": `Pressione e segure ou pressione Alt + Seta para baixo para abrir o menu`
};


var $6b39616688a51692$exports = {};
$6b39616688a51692$exports = {
    "longPressMessage": `Prima continuamente ou prima Alt + Seta Para Baixo para abrir o menu`
};


var $f26362aed63f47e2$exports = {};
$f26362aed63f47e2$exports = {
    "longPressMessage": `Apăsați lung sau apăsați pe Alt + săgeată în jos pentru a deschide meniul`
};


var $06cbade644558bf0$exports = {};
$06cbade644558bf0$exports = {
    "longPressMessage": `Нажмите и удерживайте или нажмите Alt + Стрелка вниз, чтобы открыть меню`
};


var $0a391ff68f9d59b1$exports = {};
$0a391ff68f9d59b1$exports = {
    "longPressMessage": `Ponuku otvoríte dlhým stlačením alebo stlačením klávesu Alt + klávesu so šípkou nadol`
};


var $8193cf0e649c7928$exports = {};
$8193cf0e649c7928$exports = {
    "longPressMessage": `Za odprtje menija pritisnite in držite gumb ali pritisnite Alt+puščica navzdol`
};


var $f398debcce5a5c55$exports = {};
$f398debcce5a5c55$exports = {
    "longPressMessage": `Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni`
};


var $9e9fef000aa4c013$exports = {};
$9e9fef000aa4c013$exports = {
    "longPressMessage": `Håll nedtryckt eller tryck på Alt + pil nedåt för att öppna menyn`
};


var $c016c8183bbe3d68$exports = {};
$c016c8183bbe3d68$exports = {
    "longPressMessage": `Menüyü açmak için uzun basın veya Alt + Aşağı Ok tuşuna basın`
};


var $ca4f6c8462244e62$exports = {};
$ca4f6c8462244e62$exports = {
    "longPressMessage": `Довго або звичайно натисніть комбінацію клавіш Alt і стрілка вниз, щоб відкрити меню`
};


var $2d9960c02ccac927$exports = {};
$2d9960c02ccac927$exports = {
    "longPressMessage": `长按或按 Alt + 向下方向键以打开菜单`
};


var $f1b682a4c8c5631c$exports = {};
$f1b682a4c8c5631c$exports = {
    "longPressMessage": `長按或按 Alt+向下鍵以開啟功能表`
};


$9bdd31893c9700c3$exports = {
    "ar-AE": $c0398ad35c3639b7$exports,
    "bg-BG": $7af657c4165927c3$exports,
    "cs-CZ": $d95d4da6d531ab81$exports,
    "da-DK": $24ebda9c775dca17$exports,
    "de-DE": $743e0dfca6cab1e9$exports,
    "el-GR": $a2f41026e05f1c84$exports,
    "en-US": $43b800e97c901737$exports,
    "es-ES": $442f5f6ac211e29f$exports,
    "et-EE": $dff280acfeb2d8ac$exports,
    "fi-FI": $51608325613944d7$exports,
    "fr-FR": $c4a1b1eabeaa87be$exports,
    "he-IL": $8c74815cdee18d1b$exports,
    "hr-HR": $fd0e9ef6a7fe0ec9$exports,
    "hu-HU": $a89a74a39eba465a$exports,
    "it-IT": $edc7c66594a0ae8a$exports,
    "ja-JP": $f1ab51510712db52$exports,
    "ko-KR": $f9b672d9b82fa3d6$exports,
    "lt-LT": $a385f3910feda499$exports,
    "lv-LV": $4f1bde932c441789$exports,
    "nb-NO": $914a51a8a594d5be$exports,
    "nl-NL": $89aaf803103bb500$exports,
    "pl-PL": $c685891476dbaaca$exports,
    "pt-BR": $885879b9b10c2959$exports,
    "pt-PT": $6b39616688a51692$exports,
    "ro-RO": $f26362aed63f47e2$exports,
    "ru-RU": $06cbade644558bf0$exports,
    "sk-SK": $0a391ff68f9d59b1$exports,
    "sl-SI": $8193cf0e649c7928$exports,
    "sr-SP": $f398debcce5a5c55$exports,
    "sv-SE": $9e9fef000aa4c013$exports,
    "tr-TR": $c016c8183bbe3d68$exports,
    "uk-UA": $ca4f6c8462244e62$exports,
    "zh-CN": $2d9960c02ccac927$exports,
    "zh-TW": $f1b682a4c8c5631c$exports
};






function $168583247155ddda$export$dc9c12ed27dd1b49(props, state, ref) {
    let { type: type = "menu" , isDisabled: isDisabled , trigger: trigger = "press"  } = props;
    let menuTriggerId = ($bdb11010cef70236$export$f680877a34711e37)();
    let { triggerProps: triggerProps , overlayProps: overlayProps  } = ($628037886ba31236$export$f9d5c8beee7d008d)({
        type: type
    }, state, ref);
    let onKeyDown = (e)=>{
        if (isDisabled) return;
        if (trigger === "longPress" && !e.altKey) return;
        if (ref && ref.current) switch(e.key){
            case "Enter":
            case " ":
                if (trigger === "longPress") return;
            // fallthrough
            case "ArrowDown":
                // Stop propagation, unless it would already be handled by useKeyboard.
                if (!("continuePropagation" in e)) e.stopPropagation();
                e.preventDefault();
                state.toggle("first");
                break;
            case "ArrowUp":
                if (!("continuePropagation" in e)) e.stopPropagation();
                e.preventDefault();
                state.toggle("last");
                break;
        }
    };
    let stringFormatter = ($fca6afa0e843324b$export$f12b703ca79dfbb1)(((/*@__PURE__*/$parcel$interopDefault$4($9bdd31893c9700c3$exports))));
    let { longPressProps: longPressProps  } = ($8a26561d2877236e$export$c24ed0104d07eab9)({
        isDisabled: isDisabled || trigger !== "longPress",
        accessibilityDescription: stringFormatter.format("longPressMessage"),
        onLongPressStart () {
            state.close();
        },
        onLongPress () {
            state.open("first");
        }
    });
    let pressProps = {
        onPressStart (e) {
            // For consistency with native, open the menu on mouse/key down, but touch up.
            if (e.pointerType !== "touch" && e.pointerType !== "keyboard" && !isDisabled) // If opened with a screen reader, auto focus the first item.
            // Otherwise, the menu itself will be focused.
            state.toggle(e.pointerType === "virtual" ? "first" : null);
        },
        onPress (e) {
            if (e.pointerType === "touch" && !isDisabled) state.toggle();
        }
    };
    // omit onPress from triggerProps since we override it above.
    delete triggerProps.onPress;
    return {
        menuTriggerProps: {
            ...triggerProps,
            ...trigger === "press" ? pressProps : longPressProps,
            id: menuTriggerId,
            onKeyDown: onKeyDown
        },
        menuProps: {
            ...overlayProps,
            "aria-labelledby": menuTriggerId,
            autoFocus: state.focusStrategy || true,
            onClose: state.close
        }
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

const $d5336fe17ce95402$export$6f49b4016bfc8d56 = new WeakMap();
function $d5336fe17ce95402$export$38eaa17faae8f579(props, state, ref) {
    let { shouldFocusWrap: shouldFocusWrap = true , ...otherProps } = props;
    if (!props["aria-label"] && !props["aria-labelledby"]) console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
    let domProps = ($65484d02dcb7eb3e$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    let { listProps: listProps  } = ($982254629710d113$export$b95089534ab7c1fd)({
        ...otherProps,
        ref: ref,
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        shouldFocusWrap: shouldFocusWrap
    });
    $d5336fe17ce95402$export$6f49b4016bfc8d56.set(state, {
        onClose: props.onClose,
        onAction: props.onAction
    });
    return {
        menuProps: ($3ef42575df84b30b$export$9d1611c77c2fe928)(domProps, {
            role: "menu",
            ...listProps
        })
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 




function $a2e5df62f93c7633$export$9d32628fc2aea7da(props, state, ref) {
    let { key: key , closeOnSelect: closeOnSelect , isVirtualized: isVirtualized  } = props;
    var _props_isDisabled;
    let isDisabled = (_props_isDisabled = props.isDisabled) !== null && _props_isDisabled !== void 0 ? _props_isDisabled : state.disabledKeys.has(key);
    var _props_isSelected;
    let isSelected = (_props_isSelected = props.isSelected) !== null && _props_isSelected !== void 0 ? _props_isSelected : state.selectionManager.isSelected(key);
    let isFocused = state.selectionManager.focusedKey === key;
    let data = ($d5336fe17ce95402$export$6f49b4016bfc8d56).get(state);
    let onClose = props.onClose || data.onClose;
    let onAction = props.onAction || data.onAction;
    let role = "menuitem";
    if (state.selectionManager.selectionMode === "single") role = "menuitemradio";
    else if (state.selectionManager.selectionMode === "multiple") role = "menuitemcheckbox";
    let labelId = ($bdb11010cef70236$export$b4cc09c592e8fdb8)();
    let descriptionId = ($bdb11010cef70236$export$b4cc09c592e8fdb8)();
    let keyboardId = ($bdb11010cef70236$export$b4cc09c592e8fdb8)();
    let ariaProps = {
        "aria-disabled": isDisabled,
        role: role,
        "aria-label": props["aria-label"],
        "aria-labelledby": labelId,
        "aria-describedby": [
            descriptionId,
            keyboardId
        ].filter(Boolean).join(" ") || undefined
    };
    if (state.selectionManager.selectionMode !== "none") ariaProps["aria-checked"] = isSelected;
    if (isVirtualized) {
        ariaProps["aria-posinset"] = state.collection.getItem(key).index;
        ariaProps["aria-setsize"] = ($453cc9f0df89c0a5$export$77d5aafae4e095b2)(state.collection);
    }
    let onKeyDown = (e)=>{
        // Ignore repeating events, which may have started on the menu trigger before moving
        // focus to the menu item. We want to wait for a second complete key press sequence.
        if (e.repeat) return;
        switch(e.key){
            case " ":
                if (!isDisabled && state.selectionManager.selectionMode === "none" && closeOnSelect !== false && onClose) onClose();
                break;
            case "Enter":
                // The Enter key should always close on select, except if overridden.
                if (!isDisabled && closeOnSelect !== false && onClose) onClose();
                break;
        }
    };
    let onPressStart = (e)=>{
        if (e.pointerType === "keyboard" && onAction) onAction(key);
    };
    let onPressUp = (e)=>{
        if (e.pointerType !== "keyboard") {
            if (onAction) onAction(key);
            // Pressing a menu item should close by default in single selection mode but not multiple
            // selection mode, except if overridden by the closeOnSelect prop.
            if (onClose && (closeOnSelect !== null && closeOnSelect !== void 0 ? closeOnSelect : state.selectionManager.selectionMode !== "multiple")) onClose();
        }
    };
    let { itemProps: itemProps  } = ($880e95eb8b93ba9a$export$ecf600387e221c37)({
        selectionManager: state.selectionManager,
        key: key,
        ref: ref,
        shouldSelectOnPressUp: true,
        allowsDifferentPressOrigin: true
    });
    let { pressProps: pressProps , isPressed: isPressed  } = ($f6c31cce2adf654f$export$45712eceda6fad21)({
        onPressStart: onPressStart,
        onPressUp: onPressUp,
        isDisabled: isDisabled
    });
    let { hoverProps: hoverProps  } = ($6179b936705e76d3$export$ae780daf29e6d456)({
        isDisabled: isDisabled,
        onHoverStart () {
            if (!($507fabe10e71c6fb$export$b9b3dfddab17db27)()) {
                state.selectionManager.setFocused(true);
                state.selectionManager.setFocusedKey(key);
            }
        }
    });
    return {
        menuItemProps: {
            ...ariaProps,
            ...($3ef42575df84b30b$export$9d1611c77c2fe928)(itemProps, pressProps, hoverProps, {
                onKeyDown: onKeyDown
            })
        },
        labelProps: {
            id: labelId
        },
        descriptionProps: {
            id: descriptionId
        },
        keyboardShortcutProps: {
            id: keyboardId
        },
        isFocused: isFocused,
        isSelected: isSelected,
        isPressed: isPressed,
        isDisabled: isDisabled
    };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


function $2d73ec29415bd339$export$712718f7aec83d5(props, ref) {
    let { inputElementType: inputElementType = "input" , isDisabled: isDisabled = false , isRequired: isRequired = false , isReadOnly: isReadOnly = false , validationState: validationState , type: type = "text" , onChange: onChange = ()=>{}  } = props;
    let { focusableProps: focusableProps  } = ($e6afbd83fe6ebbd2$export$4c014de7c8940b4c)(props, ref);
    let { labelProps: labelProps , fieldProps: fieldProps , descriptionProps: descriptionProps , errorMessageProps: errorMessageProps  } = ($2baaea4c71418dea$export$294aa081a6c6f55d)(props);
    let domProps = ($65484d02dcb7eb3e$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    const inputOnlyProps = {
        type: type,
        pattern: props.pattern
    };
    return {
        labelProps: labelProps,
        inputProps: ($3ef42575df84b30b$export$9d1611c77c2fe928)(domProps, inputElementType === "input" && inputOnlyProps, {
            disabled: isDisabled,
            readOnly: isReadOnly,
            "aria-required": isRequired || undefined,
            "aria-invalid": validationState === "invalid" || undefined,
            "aria-errormessage": props["aria-errormessage"],
            "aria-activedescendant": props["aria-activedescendant"],
            "aria-autocomplete": props["aria-autocomplete"],
            "aria-haspopup": props["aria-haspopup"],
            value: props.value,
            defaultValue: props.value ? undefined : props.defaultValue,
            onChange: (e)=>onChange(e.target.value),
            autoComplete: props.autoComplete,
            maxLength: props.maxLength,
            minLength: props.minLength,
            name: props.name,
            placeholder: props.placeholder,
            inputMode: props.inputMode,
            // Clipboard events
            onCopy: props.onCopy,
            onCut: props.onCut,
            onPaste: props.onPaste,
            // Composition events
            onCompositionEnd: props.onCompositionEnd,
            onCompositionStart: props.onCompositionStart,
            onCompositionUpdate: props.onCompositionUpdate,
            // Selection events
            onSelect: props.onSelect,
            // Input events
            onBeforeInput: props.onBeforeInput,
            onInput: props.onInput,
            ...focusableProps,
            ...fieldProps
        }),
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps
    };
}


/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


function $d841c8010a73d545$var$supportsNativeBeforeInputEvent() {
    return typeof window !== "undefined" && window.InputEvent && // @ts-ignore
    typeof InputEvent.prototype.getTargetRanges === "function";
}
function $d841c8010a73d545$export$4f384c9210e583c3(props, state, inputRef) {
    let stateRef = (useRef)(state);
    stateRef.current = state;
    // All browsers implement the 'beforeinput' event natively except Firefox
    // (currently behind a flag as of Firefox 84). React's polyfill does not
    // run in all cases that the native event fires, e.g. when deleting text.
    // Use the native event if available so that we can prevent invalid deletions.
    // We do not attempt to polyfill this in Firefox since it would be very complicated,
    // the benefit of doing so is fairly minor, and it's going to be natively supported soon.
    (useEffect)(()=>{
        if (!$d841c8010a73d545$var$supportsNativeBeforeInputEvent()) return;
        let input = inputRef.current;
        let onBeforeInput = (e)=>{
            let state = stateRef.current;
            // Compute the next value of the input if the event is allowed to proceed.
            // See https://www.w3.org/TR/input-events-2/#interface-InputEvent-Attributes for a full list of input types.
            let nextValue;
            switch(e.inputType){
                case "historyUndo":
                case "historyRedo":
                    // Explicitly allow undo/redo. e.data is null in this case, but there's no need to validate,
                    // because presumably the input would have already been validated previously.
                    return;
                case "deleteContent":
                case "deleteByCut":
                case "deleteByDrag":
                    nextValue = input.value.slice(0, input.selectionStart) + input.value.slice(input.selectionEnd);
                    break;
                case "deleteContentForward":
                    // This is potentially incorrect, since the browser may actually delete more than a single UTF-16
                    // character. In reality, a full Unicode grapheme cluster consisting of multiple UTF-16 characters
                    // or code points may be deleted. However, in our currently supported locales, there are no such cases.
                    // If we support additional locales in the future, this may need to change.
                    nextValue = input.selectionEnd === input.selectionStart ? input.value.slice(0, input.selectionStart) + input.value.slice(input.selectionEnd + 1) : input.value.slice(0, input.selectionStart) + input.value.slice(input.selectionEnd);
                    break;
                case "deleteContentBackward":
                    nextValue = input.selectionEnd === input.selectionStart ? input.value.slice(0, input.selectionStart - 1) + input.value.slice(input.selectionStart) : input.value.slice(0, input.selectionStart) + input.value.slice(input.selectionEnd);
                    break;
                case "deleteSoftLineBackward":
                case "deleteHardLineBackward":
                    nextValue = input.value.slice(input.selectionStart);
                    break;
                default:
                    if (e.data != null) nextValue = input.value.slice(0, input.selectionStart) + e.data + input.value.slice(input.selectionEnd);
                    break;
            }
            // If we did not compute a value, or the new value is invalid, prevent the event
            // so that the browser does not update the input text, move the selection, or add to
            // the undo/redo stack.
            if (nextValue == null || !state.validate(nextValue)) e.preventDefault();
        };
        input.addEventListener("beforeinput", onBeforeInput, false);
        return ()=>{
            input.removeEventListener("beforeinput", onBeforeInput, false);
        };
    }, [
        inputRef,
        stateRef
    ]);
    let onBeforeInput = !$d841c8010a73d545$var$supportsNativeBeforeInputEvent() ? (e)=>{
        let nextValue = e.target.value.slice(0, e.target.selectionStart) + e.data + e.target.value.slice(e.target.selectionEnd);
        if (!state.validate(nextValue)) e.preventDefault();
    } : null;
    let { labelProps: labelProps , inputProps: textFieldProps , descriptionProps: descriptionProps , errorMessageProps: errorMessageProps  } = ($2d73ec29415bd339$export$712718f7aec83d5)(props, inputRef);
    let compositionStartState = (useRef)(null);
    return {
        inputProps: ($3ef42575df84b30b$export$9d1611c77c2fe928)(textFieldProps, {
            onBeforeInput: onBeforeInput,
            onCompositionStart () {
                // Chrome does not implement Input Events Level 2, which specifies the insertFromComposition
                // and deleteByComposition inputType values for the beforeinput event. These are meant to occur
                // at the end of a composition (e.g. Pinyin IME, Android auto correct, etc.), and crucially, are
                // cancelable. The insertCompositionText and deleteCompositionText input types are not cancelable,
                // nor would we want to cancel them because the input from the user is incomplete at that point.
                // In Safari, insertFromComposition/deleteFromComposition will fire, however, allowing us to cancel
                // the final composition result if it is invalid. As a fallback for Chrome and Firefox, which either
                // don't support Input Events Level 2, or beforeinput at all, we store the state of the input when
                // the compositionstart event fires, and undo the changes in compositionend (below) if it is invalid.
                // Unfortunately, this messes up the undo/redo stack, but until insertFromComposition/deleteByComposition
                // are implemented, there is no other way to prevent composed input.
                // See https://bugs.chromium.org/p/chromium/issues/detail?id=1022204
                let { value: value , selectionStart: selectionStart , selectionEnd: selectionEnd  } = inputRef.current;
                compositionStartState.current = {
                    value: value,
                    selectionStart: selectionStart,
                    selectionEnd: selectionEnd
                };
            },
            onCompositionEnd () {
                if (!state.validate(inputRef.current.value)) {
                    // Restore the input value in the DOM immediately so we can synchronously update the selection position.
                    // But also update the value in React state as well so it is correct for future updates.
                    let { value: value , selectionStart: selectionStart , selectionEnd: selectionEnd  } = compositionStartState.current;
                    inputRef.current.value = value;
                    inputRef.current.setSelectionRange(selectionStart, selectionEnd);
                    state.setInputValue(value);
                }
            }
        }),
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps
    };
}

function $parcel$interopDefault$3(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 * 
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 





var $2e84e748dc57e459$exports = {};
var $02cb4c75c506befe$exports = {};
$02cb4c75c506befe$exports = {
    "buttonLabel": `عرض المقترحات`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} خيار`,
            other: ()=>`${formatter.number(args.optionCount)} خيارات`
        })} متاحة.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`المجموعة المدخلة ${args.groupTitle}, مع ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} خيار`,
                    other: ()=>`${formatter.number(args.groupCount)} خيارات`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, محدد`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `مقترحات`,
    "selectedAnnouncement": (args)=>`${args.optionText}، محدد`
};


var $568b8163f1e56faf$exports = {};
$568b8163f1e56faf$exports = {
    "buttonLabel": `Покажи предложения`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} опция`,
            other: ()=>`${formatter.number(args.optionCount)} опции`
        })} на разположение.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Въведена група ${args.groupTitle}, с ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} опция`,
                    other: ()=>`${formatter.number(args.groupCount)} опции`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, избрани`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Предложения`,
    "selectedAnnouncement": (args)=>`${args.optionText}, избрани`
};


var $87581c0202d106b8$exports = {};
$87581c0202d106b8$exports = {
    "buttonLabel": `Zobrazit doporučení`,
    "countAnnouncement": (args, formatter)=>`K dispozici ${formatter.plural(args.optionCount, {
            one: ()=>`je ${formatter.number(args.optionCount)} možnost`,
            other: ()=>`jsou/je ${formatter.number(args.optionCount)} možnosti/-í`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Zadaná skupina „${args.groupTitle}“ ${formatter.plural(args.groupCount, {
                    one: ()=>`s ${formatter.number(args.groupCount)} možností`,
                    other: ()=>`se ${formatter.number(args.groupCount)} možnostmi`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: ` (vybráno)`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Návrhy`,
    "selectedAnnouncement": (args)=>`${args.optionText}, vybráno`
};


var $a10a0369f5433ed1$exports = {};
$a10a0369f5433ed1$exports = {
    "buttonLabel": `Vis forslag`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} mulighed tilgængelig`,
            other: ()=>`${formatter.number(args.optionCount)} muligheder tilgængelige`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Angivet gruppe ${args.groupTitle}, med ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} mulighed`,
                    other: ()=>`${formatter.number(args.groupCount)} muligheder`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, valgt`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Forslag`,
    "selectedAnnouncement": (args)=>`${args.optionText}, valgt`
};


var $bfd288727d5cb166$exports = {};
$bfd288727d5cb166$exports = {
    "buttonLabel": `Empfehlungen anzeigen`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} Option`,
            other: ()=>`${formatter.number(args.optionCount)} Optionen`
        })} verfügbar.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Eingetretene Gruppe ${args.groupTitle}, mit ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} Option`,
                    other: ()=>`${formatter.number(args.groupCount)} Optionen`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, ausgewählt`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Empfehlungen`,
    "selectedAnnouncement": (args)=>`${args.optionText}, ausgewählt`
};


var $ca177778f9a74e3c$exports = {};
$ca177778f9a74e3c$exports = {
    "buttonLabel": `Προβολή προτάσεων`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} επιλογή`,
            other: ()=>`${formatter.number(args.optionCount)} επιλογές `
        })} διαθέσιμες.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Εισαγμένη ομάδα ${args.groupTitle}, με ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} επιλογή`,
                    other: ()=>`${formatter.number(args.groupCount)} επιλογές`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, επιλεγμένο`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Προτάσεις`,
    "selectedAnnouncement": (args)=>`${args.optionText}, επιλέχθηκε`
};


var $9b5aa79ef84beb6c$exports = {};
$9b5aa79ef84beb6c$exports = {
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Entered group ${args.groupTitle}, with ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} option`,
                    other: ()=>`${formatter.number(args.groupCount)} options`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, selected`,
            other: ``
        }, args.isSelected)}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} option`,
            other: ()=>`${formatter.number(args.optionCount)} options`
        })} available.`,
    "selectedAnnouncement": (args)=>`${args.optionText}, selected`,
    "buttonLabel": `Show suggestions`,
    "listboxLabel": `Suggestions`
};


var $57968e8209de2557$exports = {};
$57968e8209de2557$exports = {
    "buttonLabel": `Mostrar sugerencias`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opción`,
            other: ()=>`${formatter.number(args.optionCount)} opciones`
        })} disponible(s).`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Se ha unido al grupo ${args.groupTitle}, con ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opción`,
                    other: ()=>`${formatter.number(args.groupCount)} opciones`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, seleccionado`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Sugerencias`,
    "selectedAnnouncement": (args)=>`${args.optionText}, seleccionado`
};


var $60690790bf4c1c6a$exports = {};
$60690790bf4c1c6a$exports = {
    "buttonLabel": `Kuva soovitused`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} valik`,
            other: ()=>`${formatter.number(args.optionCount)} valikud`
        })} saadaval.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Sisestatud rühm ${args.groupTitle}, valikuga ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} valik`,
                    other: ()=>`${formatter.number(args.groupCount)} valikud`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, valitud`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Soovitused`,
    "selectedAnnouncement": (args)=>`${args.optionText}, valitud`
};


var $1101246e8c7d9357$exports = {};
$1101246e8c7d9357$exports = {
    "buttonLabel": `Näytä ehdotukset`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} vaihtoehto`,
            other: ()=>`${formatter.number(args.optionCount)} vaihtoehdot`
        })} saatavilla.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Mentiin ryhmään ${args.groupTitle}, ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} vaihtoehdon`,
                    other: ()=>`${formatter.number(args.groupCount)} vaihtoehdon`
                })} kanssa.`,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, valittu`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Ehdotukset`,
    "selectedAnnouncement": (args)=>`${args.optionText}, valittu`
};


var $6404b5cb5b241730$exports = {};
$6404b5cb5b241730$exports = {
    "buttonLabel": `Afficher les suggestions`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} option`,
            other: ()=>`${formatter.number(args.optionCount)} options`
        })} disponible(s).`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Groupe ${args.groupTitle} saisi, avec ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} option`,
                    other: ()=>`${formatter.number(args.groupCount)} options`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, sélectionné(s)`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Suggestions`,
    "selectedAnnouncement": (args)=>`${args.optionText}, sélectionné`
};


var $dfeafa702e92e31f$exports = {};
$dfeafa702e92e31f$exports = {
    "buttonLabel": `הצג הצעות`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`אפשרות ${formatter.number(args.optionCount)}`,
            other: ()=>`${formatter.number(args.optionCount)} אפשרויות`
        })} במצב זמין.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`נכנס לקבוצה ${args.groupTitle}, עם ${formatter.plural(args.groupCount, {
                    one: ()=>`אפשרות ${formatter.number(args.groupCount)}`,
                    other: ()=>`${formatter.number(args.groupCount)} אפשרויות`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, נבחר`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `הצעות`,
    "selectedAnnouncement": (args)=>`${args.optionText}, נבחר`
};


var $2d125e0b34676352$exports = {};
$2d125e0b34676352$exports = {
    "buttonLabel": `Prikaži prijedloge`,
    "countAnnouncement": (args, formatter)=>`Dostupno još: ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opcija`,
            other: ()=>`${formatter.number(args.optionCount)} opcije/a`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Unesena skupina ${args.groupTitle}, s ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opcijom`,
                    other: ()=>`${formatter.number(args.groupCount)} opcije/a`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, odabranih`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Prijedlozi`,
    "selectedAnnouncement": (args)=>`${args.optionText}, odabrano`
};


var $ea029611d7634059$exports = {};
$ea029611d7634059$exports = {
    "buttonLabel": `Javaslatok megjelenítése`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} lehetőség`,
            other: ()=>`${formatter.number(args.optionCount)} lehetőség`
        })} áll rendelkezésre.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Belépett a(z) ${args.groupTitle} csoportba, amely ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} lehetőséget`,
                    other: ()=>`${formatter.number(args.groupCount)} lehetőséget`
                })} tartalmaz. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, kijelölve`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Javaslatok`,
    "selectedAnnouncement": (args)=>`${args.optionText}, kijelölve`
};


var $77f075bb86ad7091$exports = {};
$77f075bb86ad7091$exports = {
    "buttonLabel": `Mostra suggerimenti`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opzione disponibile`,
            other: ()=>`${formatter.number(args.optionCount)} opzioni disponibili`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Ingresso nel gruppo ${args.groupTitle}, con ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opzione`,
                    other: ()=>`${formatter.number(args.groupCount)} opzioni`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, selezionato`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Suggerimenti`,
    "selectedAnnouncement": (args)=>`${args.optionText}, selezionato`
};


var $6e87462e84907983$exports = {};
$6e87462e84907983$exports = {
    "buttonLabel": `候補を表示`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} 個のオプション`,
            other: ()=>`${formatter.number(args.optionCount)} 個のオプション`
        })}を利用できます。`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`入力されたグループ ${args.groupTitle}、${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} 個のオプション`,
                    other: ()=>`${formatter.number(args.groupCount)} 個のオプション`
                })}を含む。`,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `、選択済み`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `候補`,
    "selectedAnnouncement": (args)=>`${args.optionText}、選択済み`
};


var $9246f2c6edc6b232$exports = {};
$9246f2c6edc6b232$exports = {
    "buttonLabel": `제안 사항 표시`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)}개 옵션`,
            other: ()=>`${formatter.number(args.optionCount)}개 옵션`
        })}을 사용할 수 있습니다.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`입력한 그룹 ${args.groupTitle}, ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)}개 옵션`,
                    other: ()=>`${formatter.number(args.groupCount)}개 옵션`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, 선택됨`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `제안`,
    "selectedAnnouncement": (args)=>`${args.optionText}, 선택됨`
};


var $e587accc6c0a434c$exports = {};
$e587accc6c0a434c$exports = {
    "buttonLabel": `Rodyti pasiūlymus`,
    "countAnnouncement": (args, formatter)=>`Yra ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} parinktis`,
            other: ()=>`${formatter.number(args.optionCount)} parinktys (-ių)`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Įvesta grupė ${args.groupTitle}, su ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} parinktimi`,
                    other: ()=>`${formatter.number(args.groupCount)} parinktimis (-ių)`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, pasirinkta`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Pasiūlymai`,
    "selectedAnnouncement": (args)=>`${args.optionText}, pasirinkta`
};


var $03a1900e7400b5ab$exports = {};
$03a1900e7400b5ab$exports = {
    "buttonLabel": `Rādīt ieteikumus`,
    "countAnnouncement": (args, formatter)=>`Pieejamo opciju skaits: ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opcija`,
            other: ()=>`${formatter.number(args.optionCount)} opcijas`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Ievadīta grupa ${args.groupTitle}, ar ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opciju`,
                    other: ()=>`${formatter.number(args.groupCount)} opcijām`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, atlasīta`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Ieteikumi`,
    "selectedAnnouncement": (args)=>`${args.optionText}, atlasīta`
};


var $1387676441be6cf6$exports = {};
$1387676441be6cf6$exports = {
    "buttonLabel": `Vis forslag`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} alternativ`,
            other: ()=>`${formatter.number(args.optionCount)} alternativer`
        })} finnes.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Angitt gruppe ${args.groupTitle}, med ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} alternativ`,
                    other: ()=>`${formatter.number(args.groupCount)} alternativer`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, valgt`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Forslag`,
    "selectedAnnouncement": (args)=>`${args.optionText}, valgt`
};


var $17e82ebf0f8ab91f$exports = {};
$17e82ebf0f8ab91f$exports = {
    "buttonLabel": `Suggesties weergeven`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} optie`,
            other: ()=>`${formatter.number(args.optionCount)} opties`
        })} beschikbaar.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Groep ${args.groupTitle} ingevoerd met ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} optie`,
                    other: ()=>`${formatter.number(args.groupCount)} opties`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, geselecteerd`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Suggesties`,
    "selectedAnnouncement": (args)=>`${args.optionText}, geselecteerd`
};


var $2f5377d3471630e5$exports = {};
$2f5377d3471630e5$exports = {
    "buttonLabel": `Wyświetlaj sugestie`,
    "countAnnouncement": (args, formatter)=>`dostępna/dostępne(-nych) ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opcja`,
            other: ()=>`${formatter.number(args.optionCount)} opcje(-i)`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Dołączono do grupy ${args.groupTitle}, z ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opcją`,
                    other: ()=>`${formatter.number(args.groupCount)} opcjami`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, wybrano`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Sugestie`,
    "selectedAnnouncement": (args)=>`${args.optionText}, wybrano`
};


var $dee9868b6fa95ffe$exports = {};
$dee9868b6fa95ffe$exports = {
    "buttonLabel": `Mostrar sugestões`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opção`,
            other: ()=>`${formatter.number(args.optionCount)} opções`
        })} disponível.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Grupo inserido ${args.groupTitle}, com ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opção`,
                    other: ()=>`${formatter.number(args.groupCount)} opções`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, selecionado`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Sugestões`,
    "selectedAnnouncement": (args)=>`${args.optionText}, selecionado`
};


var $f8b2e63637cbb5a6$exports = {};
$f8b2e63637cbb5a6$exports = {
    "buttonLabel": `Apresentar sugestões`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opção`,
            other: ()=>`${formatter.number(args.optionCount)} opções`
        })} disponível.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Grupo introduzido ${args.groupTitle}, com ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opção`,
                    other: ()=>`${formatter.number(args.groupCount)} opções`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, selecionado`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Sugestões`,
    "selectedAnnouncement": (args)=>`${args.optionText}, selecionado`
};


var $46a885db3b44ea95$exports = {};
$46a885db3b44ea95$exports = {
    "buttonLabel": `Afișare sugestii`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opțiune`,
            other: ()=>`${formatter.number(args.optionCount)} opțiuni`
        })} disponibile.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Grup ${args.groupTitle} introdus, cu ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opțiune`,
                    other: ()=>`${formatter.number(args.groupCount)} opțiuni`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, selectat`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Sugestii`,
    "selectedAnnouncement": (args)=>`${args.optionText}, selectat`
};


var $50d8a8f0afa9dee5$exports = {};
$50d8a8f0afa9dee5$exports = {
    "buttonLabel": `Показать предложения`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} параметр`,
            other: ()=>`${formatter.number(args.optionCount)} параметров`
        })} доступно.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Введенная группа ${args.groupTitle}, с ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} параметром`,
                    other: ()=>`${formatter.number(args.groupCount)} параметрами`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, выбранными`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Предложения`,
    "selectedAnnouncement": (args)=>`${args.optionText}, выбрано`
};


var $2867ee6173245507$exports = {};
$2867ee6173245507$exports = {
    "buttonLabel": `Zobraziť návrhy`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} možnosť`,
            other: ()=>`${formatter.number(args.optionCount)} možnosti/-í`
        })} k dispozícii.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Zadaná skupina ${args.groupTitle}, s ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} možnosťou`,
                    other: ()=>`${formatter.number(args.groupCount)} možnosťami`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, vybraté`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Návrhy`,
    "selectedAnnouncement": (args)=>`${args.optionText}, vybraté`
};


var $0631b65beeb09b50$exports = {};
$0631b65beeb09b50$exports = {
    "buttonLabel": `Prikaži predloge`,
    "countAnnouncement": (args, formatter)=>`Na voljo je ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opcija`,
            other: ()=>`${formatter.number(args.optionCount)} opcije`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Vnesena skupina ${args.groupTitle}, z ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opcija`,
                    other: ()=>`${formatter.number(args.groupCount)} opcije`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, izbrano`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Predlogi`,
    "selectedAnnouncement": (args)=>`${args.optionText}, izbrano`
};


var $65fc749265dcd686$exports = {};
$65fc749265dcd686$exports = {
    "buttonLabel": `Prikaži predloge`,
    "countAnnouncement": (args, formatter)=>`Dostupno još: ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opcija`,
            other: ()=>`${formatter.number(args.optionCount)} opcije/a`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Unesena grupa ${args.groupTitle}, s ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opcijom`,
                    other: ()=>`${formatter.number(args.groupCount)} optione/a`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, izabranih`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Predlozi`,
    "selectedAnnouncement": (args)=>`${args.optionText}, izabrano`
};


var $69ba655c7853c08e$exports = {};
$69ba655c7853c08e$exports = {
    "buttonLabel": `Visa förslag`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} alternativ`,
            other: ()=>`${formatter.number(args.optionCount)} alternativ`
        })} tillgängliga.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Ingick i gruppen ${args.groupTitle} med ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} alternativ`,
                    other: ()=>`${formatter.number(args.groupCount)} alternativ`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, valda`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Förslag`,
    "selectedAnnouncement": (args)=>`${args.optionText}, valda`
};


var $a79794784d61577c$exports = {};
$a79794784d61577c$exports = {
    "buttonLabel": `Önerileri göster`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} seçenek`,
            other: ()=>`${formatter.number(args.optionCount)} seçenekler`
        })} kullanılabilir.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Girilen grup ${args.groupTitle}, ile ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} seçenek`,
                    other: ()=>`${formatter.number(args.groupCount)} seçenekler`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, seçildi`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Öneriler`,
    "selectedAnnouncement": (args)=>`${args.optionText}, seçildi`
};


var $c2845791417ebaf4$exports = {};
$c2845791417ebaf4$exports = {
    "buttonLabel": `Показати пропозиції`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} параметр`,
            other: ()=>`${formatter.number(args.optionCount)} параметри(-ів)`
        })} доступно.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Введена група ${args.groupTitle}, з ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} параметр`,
                    other: ()=>`${formatter.number(args.groupCount)} параметри(-ів)`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, вибрано`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Пропозиції`,
    "selectedAnnouncement": (args)=>`${args.optionText}, вибрано`
};


var $29b642d0025cc7a4$exports = {};
$29b642d0025cc7a4$exports = {
    "buttonLabel": `显示建议`,
    "countAnnouncement": (args, formatter)=>`有 ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} 个选项`,
            other: ()=>`${formatter.number(args.optionCount)} 个选项`
        })}可用。`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`进入了 ${args.groupTitle} 组，其中有 ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} 个选项`,
                    other: ()=>`${formatter.number(args.groupCount)} 个选项`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, 已选择`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `建议`,
    "selectedAnnouncement": (args)=>`${args.optionText}, 已选择`
};


var $cd36dd33f9d46936$exports = {};
$cd36dd33f9d46936$exports = {
    "buttonLabel": `顯示建議`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} 選項`,
            other: ()=>`${formatter.number(args.optionCount)} 選項`
        })} 可用。`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`輸入的群組 ${args.groupTitle}, 有 ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} 選項`,
                    other: ()=>`${formatter.number(args.groupCount)} 選項`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, 已選取`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `建議`,
    "selectedAnnouncement": (args)=>`${args.optionText}, 已選取`
};


$2e84e748dc57e459$exports = {
    "ar-AE": $02cb4c75c506befe$exports,
    "bg-BG": $568b8163f1e56faf$exports,
    "cs-CZ": $87581c0202d106b8$exports,
    "da-DK": $a10a0369f5433ed1$exports,
    "de-DE": $bfd288727d5cb166$exports,
    "el-GR": $ca177778f9a74e3c$exports,
    "en-US": $9b5aa79ef84beb6c$exports,
    "es-ES": $57968e8209de2557$exports,
    "et-EE": $60690790bf4c1c6a$exports,
    "fi-FI": $1101246e8c7d9357$exports,
    "fr-FR": $6404b5cb5b241730$exports,
    "he-IL": $dfeafa702e92e31f$exports,
    "hr-HR": $2d125e0b34676352$exports,
    "hu-HU": $ea029611d7634059$exports,
    "it-IT": $77f075bb86ad7091$exports,
    "ja-JP": $6e87462e84907983$exports,
    "ko-KR": $9246f2c6edc6b232$exports,
    "lt-LT": $e587accc6c0a434c$exports,
    "lv-LV": $03a1900e7400b5ab$exports,
    "nb-NO": $1387676441be6cf6$exports,
    "nl-NL": $17e82ebf0f8ab91f$exports,
    "pl-PL": $2f5377d3471630e5$exports,
    "pt-BR": $dee9868b6fa95ffe$exports,
    "pt-PT": $f8b2e63637cbb5a6$exports,
    "ro-RO": $46a885db3b44ea95$exports,
    "ru-RU": $50d8a8f0afa9dee5$exports,
    "sk-SK": $2867ee6173245507$exports,
    "sl-SI": $0631b65beeb09b50$exports,
    "sr-SP": $65fc749265dcd686$exports,
    "sv-SE": $69ba655c7853c08e$exports,
    "tr-TR": $a79794784d61577c$exports,
    "uk-UA": $c2845791417ebaf4$exports,
    "zh-CN": $29b642d0025cc7a4$exports,
    "zh-TW": $cd36dd33f9d46936$exports
};






function $c350ade66beef0af$export$8c18d1b4f7232bbf(props, state) {
    let { buttonRef: buttonRef , popoverRef: popoverRef , inputRef: inputRef , listBoxRef: listBoxRef , keyboardDelegate: keyboardDelegate , shouldFocusWrap: // completionMode = 'suggest',
    shouldFocusWrap , isReadOnly: isReadOnly , isDisabled: isDisabled  } = props;
    let stringFormatter = ($fca6afa0e843324b$export$f12b703ca79dfbb1)(((/*@__PURE__*/$parcel$interopDefault$3($2e84e748dc57e459$exports))));
    let { menuTriggerProps: menuTriggerProps , menuProps: menuProps  } = ($168583247155ddda$export$dc9c12ed27dd1b49)({
        type: "listbox",
        isDisabled: isDisabled || isReadOnly
    }, state, buttonRef);
    // Set listbox id so it can be used when calling getItemId later
    ($b1f0cad8af73213b$export$3585ede4d035bf14).set(state, {
        id: menuProps.id
    });
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let delegate = (useMemo)(()=>keyboardDelegate || new ($2a25aae57d74318e$export$a05409b8bb224a5a)(state.collection, state.disabledKeys, listBoxRef), [
        keyboardDelegate,
        state.collection,
        state.disabledKeys,
        listBoxRef
    ]);
    // Use useSelectableCollection to get the keyboard handlers to apply to the textfield
    let { collectionProps: collectionProps  } = ($ae20dd8cbca75726$export$d6daf82dcd84e87c)({
        selectionManager: state.selectionManager,
        keyboardDelegate: delegate,
        disallowTypeAhead: true,
        disallowEmptySelection: true,
        shouldFocusWrap: shouldFocusWrap,
        ref: inputRef,
        // Prevent item scroll behavior from being applied here, should be handled in the user's Popover + ListBox component
        isVirtualized: true
    });
    // For textfield specific keydown operations
    let onKeyDown = (e)=>{
        switch(e.key){
            case "Enter":
            case "Tab":
                // Prevent form submission if menu is open since we may be selecting a option
                if (state.isOpen && e.key === "Enter") e.preventDefault();
                state.commit();
                break;
            case "Escape":
                if (state.selectedKey !== null || state.inputValue === "" || props.allowsCustomValue) e.continuePropagation();
                state.revert();
                break;
            case "ArrowDown":
                state.open("first", "manual");
                break;
            case "ArrowUp":
                state.open("last", "manual");
                break;
            case "ArrowLeft":
            case "ArrowRight":
                state.selectionManager.setFocusedKey(null);
                break;
        }
    };
    let onBlur = (e)=>{
        var _popoverRef_current;
        // Ignore blur if focused moved to the button or into the popover.
        if (e.relatedTarget === (buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) || ((_popoverRef_current = popoverRef.current) === null || _popoverRef_current === void 0 ? void 0 : _popoverRef_current.contains(e.relatedTarget))) return;
        if (props.onBlur) props.onBlur(e);
        state.setFocused(false);
    };
    let onFocus = (e)=>{
        if (state.isFocused) return;
        if (props.onFocus) props.onFocus(e);
        state.setFocused(true);
    };
    let { labelProps: labelProps , inputProps: inputProps , descriptionProps: descriptionProps , errorMessageProps: errorMessageProps  } = ($2d73ec29415bd339$export$712718f7aec83d5)({
        ...props,
        onChange: state.setInputValue,
        onKeyDown: !isReadOnly && ($ff5963eb1fccf552$export$e08e3b67e392101e)(state.isOpen && collectionProps.onKeyDown, onKeyDown, props.onKeyDown),
        onBlur: onBlur,
        value: state.inputValue,
        onFocus: onFocus,
        autoComplete: "off"
    }, inputRef);
    // Press handlers for the ComboBox button
    let onPress = (e)=>{
        if (e.pointerType === "touch") {
            // Focus the input field in case it isn't focused yet
            inputRef.current.focus();
            state.toggle(null, "manual");
        }
    };
    let onPressStart = (e)=>{
        if (e.pointerType !== "touch") {
            inputRef.current.focus();
            state.toggle(e.pointerType === "keyboard" || e.pointerType === "virtual" ? "first" : null, "manual");
        }
    };
    let triggerLabelProps = ($313b98861ee5dd6c$export$d6875122194c7b44)({
        id: menuTriggerProps.id,
        "aria-label": stringFormatter.format("buttonLabel"),
        "aria-labelledby": props["aria-labelledby"] || labelProps.id
    });
    let listBoxProps = ($313b98861ee5dd6c$export$d6875122194c7b44)({
        id: menuProps.id,
        "aria-label": stringFormatter.format("listboxLabel"),
        "aria-labelledby": props["aria-labelledby"] || labelProps.id
    });
    // If a touch happens on direct center of ComboBox input, might be virtual click from iPad so open ComboBox menu
    let lastEventTime = (useRef)(0);
    let onTouchEnd = (e)=>{
        if (isDisabled || isReadOnly) return;
        // Sometimes VoiceOver on iOS fires two touchend events in quick succession. Ignore the second one.
        if (e.timeStamp - lastEventTime.current < 500) {
            e.preventDefault();
            inputRef.current.focus();
            return;
        }
        let rect = e.target.getBoundingClientRect();
        let touch = e.changedTouches[0];
        let centerX = Math.ceil(rect.left + .5 * rect.width);
        let centerY = Math.ceil(rect.top + .5 * rect.height);
        if (touch.clientX === centerX && touch.clientY === centerY) {
            e.preventDefault();
            inputRef.current.focus();
            state.toggle(null, "manual");
            lastEventTime.current = e.timeStamp;
        }
    };
    // VoiceOver has issues with announcing aria-activedescendant properly on change
    // (especially on iOS). We use a live region announcer to announce focus changes
    // manually. In addition, section titles are announced when navigating into a new section.
    let focusedItem = state.selectionManager.focusedKey != null && state.isOpen ? state.collection.getItem(state.selectionManager.focusedKey) : undefined;
    var _focusedItem_parentKey;
    let sectionKey = (_focusedItem_parentKey = focusedItem === null || focusedItem === void 0 ? void 0 : focusedItem.parentKey) !== null && _focusedItem_parentKey !== void 0 ? _focusedItem_parentKey : null;
    var _state_selectionManager_focusedKey;
    let itemKey = (_state_selectionManager_focusedKey = state.selectionManager.focusedKey) !== null && _state_selectionManager_focusedKey !== void 0 ? _state_selectionManager_focusedKey : null;
    let lastSection = (useRef)(sectionKey);
    let lastItem = (useRef)(itemKey);
    (useEffect)(()=>{
        if (($c87311424ea30a05$export$e1865c3bedcd822b)() && focusedItem != null && itemKey !== lastItem.current) {
            let isSelected = state.selectionManager.isSelected(itemKey);
            let section = sectionKey != null ? state.collection.getItem(sectionKey) : null;
            let sectionTitle = (section === null || section === void 0 ? void 0 : section["aria-label"]) || (typeof (section === null || section === void 0 ? void 0 : section.rendered) === "string" ? section.rendered : "") || "";
            let announcement = stringFormatter.format("focusAnnouncement", {
                isGroupChange: section && sectionKey !== lastSection.current,
                groupTitle: sectionTitle,
                groupCount: section ? [
                    ...section.childNodes
                ].length : 0,
                optionText: focusedItem["aria-label"] || focusedItem.textValue || "",
                isSelected: isSelected
            });
            ($319e236875307eab$export$a9b970dcc4ae71a9)(announcement);
        }
        lastSection.current = sectionKey;
        lastItem.current = itemKey;
    });
    // Announce the number of available suggestions when it changes
    let optionCount = ($453cc9f0df89c0a5$export$77d5aafae4e095b2)(state.collection);
    let lastSize = (useRef)(optionCount);
    let lastOpen = (useRef)(state.isOpen);
    (useEffect)(()=>{
        // Only announce the number of options available when the menu opens if there is no
        // focused item, otherwise screen readers will typically read e.g. "1 of 6".
        // The exception is VoiceOver since this isn't included in the message above.
        let didOpenWithoutFocusedItem = state.isOpen !== lastOpen.current && (state.selectionManager.focusedKey == null || ($c87311424ea30a05$export$e1865c3bedcd822b)());
        if (state.isOpen && (didOpenWithoutFocusedItem || optionCount !== lastSize.current)) {
            let announcement = stringFormatter.format("countAnnouncement", {
                optionCount: optionCount
            });
            ($319e236875307eab$export$a9b970dcc4ae71a9)(announcement);
        }
        lastSize.current = optionCount;
        lastOpen.current = state.isOpen;
    });
    // Announce when a selection occurs for VoiceOver. Other screen readers typically do this automatically.
    let lastSelectedKey = (useRef)(state.selectedKey);
    (useEffect)(()=>{
        if (($c87311424ea30a05$export$e1865c3bedcd822b)() && state.isFocused && state.selectedItem && state.selectedKey !== lastSelectedKey.current) {
            let optionText = state.selectedItem["aria-label"] || state.selectedItem.textValue || "";
            let announcement = stringFormatter.format("selectedAnnouncement", {
                optionText: optionText
            });
            ($319e236875307eab$export$a9b970dcc4ae71a9)(announcement);
        }
        lastSelectedKey.current = state.selectedKey;
    });
    (useEffect)(()=>{
        if (state.isOpen) return ($5e3802645cc19319$export$1c3ebcada18427bf)([
            inputRef.current,
            popoverRef.current
        ]);
    }, [
        state.isOpen,
        inputRef,
        popoverRef
    ]);
    return {
        labelProps: labelProps,
        buttonProps: {
            ...menuTriggerProps,
            ...triggerLabelProps,
            excludeFromTabOrder: true,
            onPress: onPress,
            onPressStart: onPressStart,
            isDisabled: isDisabled || isReadOnly
        },
        inputProps: ($3ef42575df84b30b$export$9d1611c77c2fe928)(inputProps, {
            role: "combobox",
            "aria-expanded": menuTriggerProps["aria-expanded"],
            "aria-controls": state.isOpen ? menuProps.id : undefined,
            // TODO: readd proper logic for completionMode = complete (aria-autocomplete: both)
            "aria-autocomplete": "list",
            "aria-activedescendant": focusedItem ? ($b1f0cad8af73213b$export$9145995848b05025)(state, focusedItem.key) : undefined,
            onTouchEnd: onTouchEnd,
            // This disable's iOS's autocorrect suggestions, since the combo box provides its own suggestions.
            autoCorrect: "off",
            // This disable's the macOS Safari spell check auto corrections.
            spellCheck: "false"
        }),
        listBoxProps: ($3ef42575df84b30b$export$9d1611c77c2fe928)(menuProps, listBoxProps, {
            autoFocus: state.focusStrategy,
            shouldUseVirtualFocus: true,
            shouldSelectOnPressUp: true,
            shouldFocusOnHover: true
        }),
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps
    };
}

function $parcel$interopDefault$2(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
var $c6208a7792e31a37$exports = {};
var $ed6aae4e5f766f1e$exports = {};
$ed6aae4e5f766f1e$exports = {
    "Empty": `فارغ`
};


var $38854e2b175151fa$exports = {};
$38854e2b175151fa$exports = {
    "Empty": `Изпразни`
};


var $15b25ab20f3945b2$exports = {};
$15b25ab20f3945b2$exports = {
    "Empty": `Prázdné`
};


var $692a4298b6b649a2$exports = {};
$692a4298b6b649a2$exports = {
    "Empty": `Tom`
};


var $1c6e1539193f1243$exports = {};
$1c6e1539193f1243$exports = {
    "Empty": `Leer`
};


var $1e8678632c464b6d$exports = {};
$1e8678632c464b6d$exports = {
    "Empty": `Άδειο`
};


var $4adc85d9bf5b9eed$exports = {};
$4adc85d9bf5b9eed$exports = {
    "Empty": `Empty`
};


var $41c4b2bb61dafbca$exports = {};
$41c4b2bb61dafbca$exports = {
    "Empty": `Vacío`
};


var $405f8b24f5dd2a60$exports = {};
$405f8b24f5dd2a60$exports = {
    "Empty": `Tühjenda`
};


var $7efe3ed02b9b9dd4$exports = {};
$7efe3ed02b9b9dd4$exports = {
    "Empty": `Tyhjä`
};


var $99fc4c101d92daf3$exports = {};
$99fc4c101d92daf3$exports = {
    "Empty": `Vide`
};


var $f9e155e6e8cacaa2$exports = {};
$f9e155e6e8cacaa2$exports = {
    "Empty": `ריק`
};


var $c31b5e8e9a249fd5$exports = {};
$c31b5e8e9a249fd5$exports = {
    "Empty": `Prazno`
};


var $9c5435bc17499bd9$exports = {};
$9c5435bc17499bd9$exports = {
    "Empty": `Üres`
};


var $6d1fc8e84d8165e1$exports = {};
$6d1fc8e84d8165e1$exports = {
    "Empty": `Vuoto`
};


var $46ea6b3641b83e71$exports = {};
$46ea6b3641b83e71$exports = {
    "Empty": `空`
};


var $0e3cc9a288289dc5$exports = {};
$0e3cc9a288289dc5$exports = {
    "Empty": `비어 있음`
};


var $4ff2bb25c0089ffb$exports = {};
$4ff2bb25c0089ffb$exports = {
    "Empty": `Tuščias`
};


var $6cf33cd4c010a2fb$exports = {};
$6cf33cd4c010a2fb$exports = {
    "Empty": `Tukšs`
};


var $5a9f8486f8b8837e$exports = {};
$5a9f8486f8b8837e$exports = {
    "Empty": `Tom`
};


var $583f94d807f6ecea$exports = {};
$583f94d807f6ecea$exports = {
    "Empty": `Leeg`
};


var $cc4dcfeea2b4050d$exports = {};
$cc4dcfeea2b4050d$exports = {
    "Empty": `Pusty`
};


var $68ac2954d56e12b4$exports = {};
$68ac2954d56e12b4$exports = {
    "Empty": `Vazio`
};


var $fdb0616f309780b0$exports = {};
$fdb0616f309780b0$exports = {
    "Empty": `Vazio`
};


var $fe1eccf4ee1d6f52$exports = {};
$fe1eccf4ee1d6f52$exports = {
    "Empty": `Gol`
};


var $a38b6c4e18725976$exports = {};
$a38b6c4e18725976$exports = {
    "Empty": `Не заполнено`
};


var $6c14ae2b766b652c$exports = {};
$6c14ae2b766b652c$exports = {
    "Empty": `Prázdne`
};


var $8f1c9692e16dc5eb$exports = {};
$8f1c9692e16dc5eb$exports = {
    "Empty": `Prazen`
};


var $d2aa7abea627cafa$exports = {};
$d2aa7abea627cafa$exports = {
    "Empty": `Prazno`
};


var $676b82e4b56408e6$exports = {};
$676b82e4b56408e6$exports = {
    "Empty": `Tomt`
};


var $14c9042552d7ce08$exports = {};
$14c9042552d7ce08$exports = {
    "Empty": `Boş`
};


var $393254ebcb66c9f5$exports = {};
$393254ebcb66c9f5$exports = {
    "Empty": `Пусто`
};


var $d49d621f310cf6ce$exports = {};
$d49d621f310cf6ce$exports = {
    "Empty": `空`
};


var $94b60c866ca5dfe6$exports = {};
$94b60c866ca5dfe6$exports = {
    "Empty": `空白`
};


$c6208a7792e31a37$exports = {
    "ar-AE": $ed6aae4e5f766f1e$exports,
    "bg-BG": $38854e2b175151fa$exports,
    "cs-CZ": $15b25ab20f3945b2$exports,
    "da-DK": $692a4298b6b649a2$exports,
    "de-DE": $1c6e1539193f1243$exports,
    "el-GR": $1e8678632c464b6d$exports,
    "en-US": $4adc85d9bf5b9eed$exports,
    "es-ES": $41c4b2bb61dafbca$exports,
    "et-EE": $405f8b24f5dd2a60$exports,
    "fi-FI": $7efe3ed02b9b9dd4$exports,
    "fr-FR": $99fc4c101d92daf3$exports,
    "he-IL": $f9e155e6e8cacaa2$exports,
    "hr-HR": $c31b5e8e9a249fd5$exports,
    "hu-HU": $9c5435bc17499bd9$exports,
    "it-IT": $6d1fc8e84d8165e1$exports,
    "ja-JP": $46ea6b3641b83e71$exports,
    "ko-KR": $0e3cc9a288289dc5$exports,
    "lt-LT": $4ff2bb25c0089ffb$exports,
    "lv-LV": $6cf33cd4c010a2fb$exports,
    "nb-NO": $5a9f8486f8b8837e$exports,
    "nl-NL": $583f94d807f6ecea$exports,
    "pl-PL": $cc4dcfeea2b4050d$exports,
    "pt-BR": $68ac2954d56e12b4$exports,
    "pt-PT": $fdb0616f309780b0$exports,
    "ro-RO": $fe1eccf4ee1d6f52$exports,
    "ru-RU": $a38b6c4e18725976$exports,
    "sk-SK": $6c14ae2b766b652c$exports,
    "sl-SI": $8f1c9692e16dc5eb$exports,
    "sr-SP": $d2aa7abea627cafa$exports,
    "sv-SE": $676b82e4b56408e6$exports,
    "tr-TR": $14c9042552d7ce08$exports,
    "uk-UA": $393254ebcb66c9f5$exports,
    "zh-CN": $d49d621f310cf6ce$exports,
    "zh-TW": $94b60c866ca5dfe6$exports
};





function $d2e8511e6f209edf$export$e908e06f4b8e3402(props) {
    const _async = (useRef)();
    let { value: value , textValue: textValue , minValue: minValue , maxValue: maxValue , isDisabled: isDisabled , isReadOnly: isReadOnly , isRequired: isRequired , onIncrement: onIncrement , onIncrementPage: onIncrementPage , onDecrement: onDecrement , onDecrementPage: onDecrementPage , onDecrementToMin: onDecrementToMin , onIncrementToMax: onIncrementToMax  } = props;
    const stringFormatter = ($fca6afa0e843324b$export$f12b703ca79dfbb1)(((/*@__PURE__*/$parcel$interopDefault$2($c6208a7792e31a37$exports))));
    const propsRef = (useRef)(props);
    propsRef.current = props;
    const clearAsync = ()=>clearTimeout(_async.current);
    // eslint-disable-next-line arrow-body-style
    (useEffect)(()=>{
        return ()=>clearAsync();
    }, []);
    let onKeyDown = (e)=>{
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || isReadOnly) return;
        switch(e.key){
            case "PageUp":
                if (onIncrementPage) {
                    e.preventDefault();
                    onIncrementPage();
                    break;
                }
            // fallthrough!
            case "ArrowUp":
            case "Up":
                if (onIncrement) {
                    e.preventDefault();
                    onIncrement();
                }
                break;
            case "PageDown":
                if (onDecrementPage) {
                    e.preventDefault();
                    onDecrementPage();
                    break;
                }
            // fallthrough
            case "ArrowDown":
            case "Down":
                if (onDecrement) {
                    e.preventDefault();
                    onDecrement();
                }
                break;
            case "Home":
                if (onDecrementToMin) {
                    e.preventDefault();
                    onDecrementToMin();
                }
                break;
            case "End":
                if (onIncrementToMax) {
                    e.preventDefault();
                    onIncrementToMax();
                }
                break;
        }
    };
    let isFocused = (useRef)(false);
    let onFocus = ()=>{
        isFocused.current = true;
    };
    let onBlur = ()=>{
        isFocused.current = false;
    };
    // Replace Unicode hyphen-minus (U+002D) with minus sign (U+2212).
    // This ensures that macOS VoiceOver announces it as "minus" even with other characters between the minus sign
    // and the number (e.g. currency symbol). Otherwise it announces nothing because it assumes the character is a hyphen.
    // In addition, replace the empty string with the word "Empty" so that iOS VoiceOver does not read "50%" for an empty field.
    textValue = textValue === "" ? stringFormatter.format("Empty") : (textValue || `${value}`).replace("-", "−");
    (useEffect)(()=>{
        if (isFocused.current) ($319e236875307eab$export$a9b970dcc4ae71a9)(textValue, "assertive");
    }, [
        textValue
    ]);
    const onIncrementPressStart = (useCallback)((initialStepDelay)=>{
        clearAsync();
        propsRef.current.onIncrement();
        // Start spinning after initial delay
        _async.current = window.setTimeout(()=>{
            if (isNaN(maxValue) || isNaN(value) || value < maxValue) onIncrementPressStart(60);
        }, initialStepDelay);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onIncrement,
        maxValue,
        value
    ]);
    const onDecrementPressStart = (useCallback)((initialStepDelay)=>{
        clearAsync();
        propsRef.current.onDecrement();
        // Start spinning after initial delay
        _async.current = window.setTimeout(()=>{
            if (isNaN(minValue) || isNaN(value) || value > minValue) onDecrementPressStart(60);
        }, initialStepDelay);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onDecrement,
        minValue,
        value
    ]);
    let cancelContextMenu = (e)=>{
        e.preventDefault();
    };
    let { addGlobalListener: addGlobalListener , removeAllGlobalListeners: removeAllGlobalListeners  } = ($03deb23ff14920c4$export$4eaf04e54aa8eed6)();
    return {
        spinButtonProps: {
            role: "spinbutton",
            "aria-valuenow": !isNaN(value) ? value : null,
            "aria-valuetext": textValue,
            "aria-valuemin": minValue,
            "aria-valuemax": maxValue,
            "aria-disabled": isDisabled || null,
            "aria-readonly": isReadOnly || null,
            "aria-required": isRequired || null,
            onKeyDown: onKeyDown,
            onFocus: onFocus,
            onBlur: onBlur
        },
        incrementButtonProps: {
            onPressStart: ()=>{
                onIncrementPressStart(400);
                addGlobalListener(window, "contextmenu", cancelContextMenu);
            },
            onPressEnd: ()=>{
                clearAsync();
                removeAllGlobalListeners();
            },
            onFocus: onFocus,
            onBlur: onBlur
        },
        decrementButtonProps: {
            onPressStart: ()=>{
                onDecrementPressStart(400);
                addGlobalListener(window, "contextmenu", cancelContextMenu);
            },
            onPressEnd: ()=>{
                clearAsync();
                removeAllGlobalListeners();
            },
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $103790afe9474d1c$export$60b7b4bcf3903d8e;
(function(DROP_OPERATION) {
    DROP_OPERATION[DROP_OPERATION["none"] = 0] = "none";
    DROP_OPERATION[DROP_OPERATION["cancel"] = 0] = "cancel";
    DROP_OPERATION[DROP_OPERATION["move"] = 1] = "move";
    DROP_OPERATION[DROP_OPERATION["copy"] = 2] = "copy";
    DROP_OPERATION[DROP_OPERATION["link"] = 4] = "link";
    DROP_OPERATION[DROP_OPERATION["all"] = 7] = "all";
})($103790afe9474d1c$export$60b7b4bcf3903d8e || ($103790afe9474d1c$export$60b7b4bcf3903d8e = {}));
const $103790afe9474d1c$export$9bbdfc78cf083e16 = {
    ...$103790afe9474d1c$export$60b7b4bcf3903d8e,
    copyMove: $103790afe9474d1c$export$60b7b4bcf3903d8e.copy | $103790afe9474d1c$export$60b7b4bcf3903d8e.move,
    copyLink: $103790afe9474d1c$export$60b7b4bcf3903d8e.copy | $103790afe9474d1c$export$60b7b4bcf3903d8e.link,
    linkMove: $103790afe9474d1c$export$60b7b4bcf3903d8e.link | $103790afe9474d1c$export$60b7b4bcf3903d8e.move,
    all: $103790afe9474d1c$export$60b7b4bcf3903d8e.all,
    uninitialized: $103790afe9474d1c$export$60b7b4bcf3903d8e.all
};
const $103790afe9474d1c$export$dd0165308d8bff45 = $103790afe9474d1c$var$invert($103790afe9474d1c$export$9bbdfc78cf083e16);
$103790afe9474d1c$export$dd0165308d8bff45[$103790afe9474d1c$export$60b7b4bcf3903d8e.all] = "all"; // ensure we don't map to 'uninitialized'.
$103790afe9474d1c$var$invert($103790afe9474d1c$export$60b7b4bcf3903d8e);
const $103790afe9474d1c$export$608ecc6f1b23c35d = {
    none: "cancel",
    link: "link",
    copy: "copy",
    move: "move"
};
$103790afe9474d1c$var$invert($103790afe9474d1c$export$608ecc6f1b23c35d);
function $103790afe9474d1c$var$invert(object) {
    let res = {};
    for(let key in object)res[object[key]] = key;
    return res;
}
($103790afe9474d1c$export$60b7b4bcf3903d8e).none;

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
// use high res timer if available
let $3eb131dcf37ad5f8$var$perf = typeof window !== "undefined" ? window.performance : null;
// @ts-ignore
let $3eb131dcf37ad5f8$var$perfNow = $3eb131dcf37ad5f8$var$perf && ($3eb131dcf37ad5f8$var$perf.now || $3eb131dcf37ad5f8$var$perf.webkitNow || $3eb131dcf37ad5f8$var$perf.msNow || $3eb131dcf37ad5f8$var$perf.mozNow);
$3eb131dcf37ad5f8$var$perfNow ? $3eb131dcf37ad5f8$var$perfNow.bind($3eb131dcf37ad5f8$var$perf) : function() {
    return Date.now ? Date.now() : new Date().getTime();
};

function $parcel$interopDefault$1(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

var $c3ef0f8b54adbb57$exports = {};
var $fb78e0f6ab6349ed$exports = {};
$fb78e0f6ab6349ed$exports = {
    "decrease": (args)=>`خفض ${args.fieldLabel}`,
    "increase": (args)=>`زيادة ${args.fieldLabel}`,
    "numberField": `حقل رقمي`
};


var $2776acdd9959a647$exports = {};
$2776acdd9959a647$exports = {
    "decrease": (args)=>`Намаляване ${args.fieldLabel}`,
    "increase": (args)=>`Усилване ${args.fieldLabel}`,
    "numberField": `Номер на полето`
};


var $741954410a365ad3$exports = {};
$741954410a365ad3$exports = {
    "decrease": (args)=>`Snížit ${args.fieldLabel}`,
    "increase": (args)=>`Zvýšit ${args.fieldLabel}`,
    "numberField": `Číselné pole`
};


var $8321ed0f8ab642f0$exports = {};
$8321ed0f8ab642f0$exports = {
    "decrease": (args)=>`Reducer ${args.fieldLabel}`,
    "increase": (args)=>`Øg ${args.fieldLabel}`,
    "numberField": `Talfelt`
};


var $92978e0c4ecafa32$exports = {};
$92978e0c4ecafa32$exports = {
    "decrease": (args)=>`${args.fieldLabel} verringern`,
    "increase": (args)=>`${args.fieldLabel} erhöhen`,
    "numberField": `Nummernfeld`
};


var $ac5ff71962864a84$exports = {};
$ac5ff71962864a84$exports = {
    "decrease": (args)=>`Μείωση ${args.fieldLabel}`,
    "increase": (args)=>`Αύξηση ${args.fieldLabel}`,
    "numberField": `Πεδίο αριθμού`
};


var $efe4685e2440d8be$exports = {};
$efe4685e2440d8be$exports = {
    "decrease": (args)=>`Decrease ${args.fieldLabel}`,
    "increase": (args)=>`Increase ${args.fieldLabel}`,
    "numberField": `Number field`
};


var $e50a9a48739b90e1$exports = {};
$e50a9a48739b90e1$exports = {
    "decrease": (args)=>`Reducir ${args.fieldLabel}`,
    "increase": (args)=>`Aumentar ${args.fieldLabel}`,
    "numberField": `Campo de número`
};


var $6e0d5294ecbb8ab6$exports = {};
$6e0d5294ecbb8ab6$exports = {
    "decrease": (args)=>`Vähenda ${args.fieldLabel}`,
    "increase": (args)=>`Suurenda ${args.fieldLabel}`,
    "numberField": `Numbri väli`
};


var $e7129d65f607f77f$exports = {};
$e7129d65f607f77f$exports = {
    "decrease": (args)=>`Vähennä ${args.fieldLabel}`,
    "increase": (args)=>`Lisää ${args.fieldLabel}`,
    "numberField": `Numerokenttä`
};


var $d72adf5b20573e34$exports = {};
$d72adf5b20573e34$exports = {
    "decrease": (args)=>`Diminuer ${args.fieldLabel}`,
    "increase": (args)=>`Augmenter ${args.fieldLabel}`,
    "numberField": `Champ de nombre`
};


var $a25c707e88b844a7$exports = {};
$a25c707e88b844a7$exports = {
    "decrease": (args)=>`הקטן ${args.fieldLabel}`,
    "increase": (args)=>`הגדל ${args.fieldLabel}`,
    "numberField": `שדה מספר`
};


var $69b41140b9a4ca54$exports = {};
$69b41140b9a4ca54$exports = {
    "decrease": (args)=>`Smanji ${args.fieldLabel}`,
    "increase": (args)=>`Povećaj ${args.fieldLabel}`,
    "numberField": `Polje broja`
};


var $81dab28f37f59d1a$exports = {};
$81dab28f37f59d1a$exports = {
    "decrease": (args)=>`${args.fieldLabel} csökkentése`,
    "increase": (args)=>`${args.fieldLabel} növelése`,
    "numberField": `Számmező`
};


var $866555b31f2d7711$exports = {};
$866555b31f2d7711$exports = {
    "decrease": (args)=>`Riduci ${args.fieldLabel}`,
    "increase": (args)=>`Aumenta ${args.fieldLabel}`,
    "numberField": `Campo numero`
};


var $dafcd55d52b9d371$exports = {};
$dafcd55d52b9d371$exports = {
    "decrease": (args)=>`${args.fieldLabel}を縮小`,
    "increase": (args)=>`${args.fieldLabel}を拡大`,
    "numberField": `数値フィールド`
};


var $f090c1f8c5da0145$exports = {};
$f090c1f8c5da0145$exports = {
    "decrease": (args)=>`${args.fieldLabel} 감소`,
    "increase": (args)=>`${args.fieldLabel} 증가`,
    "numberField": `번호 필드`
};


var $6f10f3a13360a75c$exports = {};
$6f10f3a13360a75c$exports = {
    "decrease": (args)=>`Sumažinti ${args.fieldLabel}`,
    "increase": (args)=>`Padidinti ${args.fieldLabel}`,
    "numberField": `Numerio laukas`
};


var $47432cefd4b7bd1b$exports = {};
$47432cefd4b7bd1b$exports = {
    "decrease": (args)=>`Samazināšana ${args.fieldLabel}`,
    "increase": (args)=>`Palielināšana ${args.fieldLabel}`,
    "numberField": `Skaitļu lauks`
};


var $dc578a950a2bf23d$exports = {};
$dc578a950a2bf23d$exports = {
    "decrease": (args)=>`Reduser ${args.fieldLabel}`,
    "increase": (args)=>`Øk ${args.fieldLabel}`,
    "numberField": `Tallfelt`
};


var $353f1bfca4dc395a$exports = {};
$353f1bfca4dc395a$exports = {
    "decrease": (args)=>`${args.fieldLabel} verlagen`,
    "increase": (args)=>`${args.fieldLabel} verhogen`,
    "numberField": `Getalveld`
};


var $241bc0bbd870e982$exports = {};
$241bc0bbd870e982$exports = {
    "decrease": (args)=>`Zmniejsz ${args.fieldLabel}`,
    "increase": (args)=>`Zwiększ ${args.fieldLabel}`,
    "numberField": `Pole numeru`
};


var $da3005c7bd72b0a8$exports = {};
$da3005c7bd72b0a8$exports = {
    "decrease": (args)=>`Diminuir ${args.fieldLabel}`,
    "increase": (args)=>`Aumentar ${args.fieldLabel}`,
    "numberField": `Campo de número`
};


var $cf48bfc540882310$exports = {};
$cf48bfc540882310$exports = {
    "decrease": (args)=>`Diminuir ${args.fieldLabel}`,
    "increase": (args)=>`Aumentar ${args.fieldLabel}`,
    "numberField": `Campo numérico`
};


var $b63a28c481ab9ee3$exports = {};
$b63a28c481ab9ee3$exports = {
    "decrease": (args)=>`Scădere ${args.fieldLabel}`,
    "increase": (args)=>`Creștere ${args.fieldLabel}`,
    "numberField": `Câmp numeric`
};


var $19f9df95c2464ab6$exports = {};
$19f9df95c2464ab6$exports = {
    "decrease": (args)=>`Уменьшение ${args.fieldLabel}`,
    "increase": (args)=>`Увеличение ${args.fieldLabel}`,
    "numberField": `Числовое поле`
};


var $b272932a685e8482$exports = {};
$b272932a685e8482$exports = {
    "decrease": (args)=>`Znížiť ${args.fieldLabel}`,
    "increase": (args)=>`Zvýšiť ${args.fieldLabel}`,
    "numberField": `Číselné pole`
};


var $cbaf8b5b61f9e544$exports = {};
$cbaf8b5b61f9e544$exports = {
    "decrease": (args)=>`Upadati ${args.fieldLabel}`,
    "increase": (args)=>`Povečajte ${args.fieldLabel}`,
    "numberField": `Številčno polje`
};


var $e0a3af6ac1449b2f$exports = {};
$e0a3af6ac1449b2f$exports = {
    "decrease": (args)=>`Decrease ${args.fieldLabel}`,
    "increase": (args)=>`Increase ${args.fieldLabel}`,
    "numberField": `Number field`
};


var $71e167d2458a6019$exports = {};
$71e167d2458a6019$exports = {
    "decrease": (args)=>`Minska ${args.fieldLabel}`,
    "increase": (args)=>`Öka ${args.fieldLabel}`,
    "numberField": `Nummerfält`
};


var $3719245abc082946$exports = {};
$3719245abc082946$exports = {
    "decrease": (args)=>`${args.fieldLabel} azalt`,
    "increase": (args)=>`${args.fieldLabel} arttır`,
    "numberField": `Sayı alanı`
};


var $2ccc589e2f51824d$exports = {};
$2ccc589e2f51824d$exports = {
    "decrease": (args)=>`Зменшити ${args.fieldLabel}`,
    "increase": (args)=>`Збільшити ${args.fieldLabel}`,
    "numberField": `Поле номера`
};


var $e1103cb9b4c13942$exports = {};
$e1103cb9b4c13942$exports = {
    "decrease": (args)=>`降低 ${args.fieldLabel}`,
    "increase": (args)=>`提高 ${args.fieldLabel}`,
    "numberField": `数字字段`
};


var $448607634f80dccb$exports = {};
$448607634f80dccb$exports = {
    "decrease": (args)=>`縮小 ${args.fieldLabel}`,
    "increase": (args)=>`放大 ${args.fieldLabel}`,
    "numberField": `數字欄位`
};


$c3ef0f8b54adbb57$exports = {
    "ar-AE": $fb78e0f6ab6349ed$exports,
    "bg-BG": $2776acdd9959a647$exports,
    "cs-CZ": $741954410a365ad3$exports,
    "da-DK": $8321ed0f8ab642f0$exports,
    "de-DE": $92978e0c4ecafa32$exports,
    "el-GR": $ac5ff71962864a84$exports,
    "en-US": $efe4685e2440d8be$exports,
    "es-ES": $e50a9a48739b90e1$exports,
    "et-EE": $6e0d5294ecbb8ab6$exports,
    "fi-FI": $e7129d65f607f77f$exports,
    "fr-FR": $d72adf5b20573e34$exports,
    "he-IL": $a25c707e88b844a7$exports,
    "hr-HR": $69b41140b9a4ca54$exports,
    "hu-HU": $81dab28f37f59d1a$exports,
    "it-IT": $866555b31f2d7711$exports,
    "ja-JP": $dafcd55d52b9d371$exports,
    "ko-KR": $f090c1f8c5da0145$exports,
    "lt-LT": $6f10f3a13360a75c$exports,
    "lv-LV": $47432cefd4b7bd1b$exports,
    "nb-NO": $dc578a950a2bf23d$exports,
    "nl-NL": $353f1bfca4dc395a$exports,
    "pl-PL": $241bc0bbd870e982$exports,
    "pt-BR": $da3005c7bd72b0a8$exports,
    "pt-PT": $cf48bfc540882310$exports,
    "ro-RO": $b63a28c481ab9ee3$exports,
    "ru-RU": $19f9df95c2464ab6$exports,
    "sk-SK": $b272932a685e8482$exports,
    "sl-SI": $cbaf8b5b61f9e544$exports,
    "sr-SP": $e0a3af6ac1449b2f$exports,
    "sv-SE": $71e167d2458a6019$exports,
    "tr-TR": $3719245abc082946$exports,
    "uk-UA": $2ccc589e2f51824d$exports,
    "zh-CN": $e1103cb9b4c13942$exports,
    "zh-TW": $448607634f80dccb$exports
};







function $81397a9303501bda$export$23f548e970bdf099(props, state, inputRef) {
    let { id: id , decrementAriaLabel: decrementAriaLabel , incrementAriaLabel: incrementAriaLabel , isDisabled: isDisabled , isReadOnly: isReadOnly , isRequired: isRequired , minValue: minValue , maxValue: maxValue , autoFocus: autoFocus , validationState: validationState , label: label , formatOptions: formatOptions , onBlur: onBlur = ()=>{} , onFocus: onFocus , onFocusChange: onFocusChange , onKeyDown: onKeyDown , onKeyUp: onKeyUp , description: description , errorMessage: errorMessage , ...otherProps } = props;
    let { increment: increment , incrementToMax: incrementToMax , decrement: decrement , decrementToMin: decrementToMin , numberValue: numberValue , commit: commit  } = state;
    const stringFormatter = ($fca6afa0e843324b$export$f12b703ca79dfbb1)(((/*@__PURE__*/$parcel$interopDefault$1($c3ef0f8b54adbb57$exports))));
    let inputId = ($bdb11010cef70236$export$f680877a34711e37)(id);
    let { focusProps: focusProps  } = ($a1ea59d68270f0dd$export$f8168d8dd8fd66e6)({
        onBlur: ()=>{
            // Set input value to normalized valid value
            commit();
        }
    });
    let { spinButtonProps: spinButtonProps , incrementButtonProps: incButtonProps , decrementButtonProps: decButtonProps  } = ($d2e8511e6f209edf$export$e908e06f4b8e3402)({
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        isRequired: isRequired,
        maxValue: maxValue,
        minValue: minValue,
        onIncrement: increment,
        onIncrementToMax: incrementToMax,
        onDecrement: decrement,
        onDecrementToMin: decrementToMin,
        value: numberValue,
        textValue: state.inputValue
    });
    let [focusWithin, setFocusWithin] = (useState)(false);
    let { focusWithinProps: focusWithinProps  } = ($9ab94262bd0047c7$export$420e68273165f4ec)({
        isDisabled: isDisabled,
        onFocusWithinChange: setFocusWithin
    });
    let onWheel = (useCallback)((e)=>{
        // if on a trackpad, users can scroll in both X and Y at once, check the magnitude of the change
        // if it's mostly in the X direction, then just return, the user probably doesn't mean to inc/dec
        // this isn't perfect, events come in fast with small deltas and a part of the scroll may give a false indication
        // especially if the user is scrolling near 45deg
        if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
        if (e.deltaY > 0) increment();
        else if (e.deltaY < 0) decrement();
    }, [
        decrement,
        increment
    ]);
    // If the input isn't supposed to receive input, disable scrolling.
    let scrollingDisabled = isDisabled || isReadOnly || !focusWithin;
    ($7d0a636d7a4dcefd$export$2123ff2b87c81ca)({
        onScroll: onWheel,
        isDisabled: scrollingDisabled
    }, inputRef);
    // The inputMode attribute influences the software keyboard that is shown on touch devices.
    // Browsers and operating systems are quite inconsistent about what keys are available, however.
    // We choose between numeric and decimal based on whether we allow negative and fractional numbers,
    // and based on testing on various devices to determine what keys are available in each inputMode.
    let numberFormatter = ($a916eb452884faea$export$b7a616150fdb9f44)(formatOptions);
    let intlOptions = (useMemo)(()=>numberFormatter.resolvedOptions(), [
        numberFormatter
    ]);
    let hasDecimals = intlOptions.maximumFractionDigits > 0;
    let hasNegative = isNaN(state.minValue) || state.minValue < 0;
    let inputMode = "numeric";
    if (($c87311424ea30a05$export$186c6964ca17d99)()) {
        // iPhone doesn't have a minus sign in either numeric or decimal.
        // Note this is only for iPhone, not iPad, which always has both
        // minus and decimal in numeric.
        if (hasNegative) inputMode = "text";
        else if (hasDecimals) inputMode = "decimal";
    } else if (($c87311424ea30a05$export$a11b0059900ceec8)()) {
        // Android numeric has both a decimal point and minus key.
        // decimal does not have a minus key.
        if (hasNegative) inputMode = "numeric";
        else if (hasDecimals) inputMode = "decimal";
    }
    let onChange = (value)=>{
        state.setInputValue(value);
    };
    let domProps = ($65484d02dcb7eb3e$export$457c3d6518dd4c6f)(props);
    let { labelProps: labelProps , inputProps: textFieldProps , descriptionProps: descriptionProps , errorMessageProps: errorMessageProps  } = ($d841c8010a73d545$export$4f384c9210e583c3)({
        ...otherProps,
        ...domProps,
        label: label,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        isRequired: isRequired,
        validationState: validationState,
        value: state.inputValue,
        defaultValue: undefined,
        autoComplete: "off",
        "aria-label": props["aria-label"] || null,
        "aria-labelledby": props["aria-labelledby"] || null,
        id: inputId,
        type: "text",
        inputMode: inputMode,
        onChange: onChange,
        onBlur: onBlur,
        onFocus: onFocus,
        onFocusChange: onFocusChange,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        description: description,
        errorMessage: errorMessage
    }, state, inputRef);
    let inputProps = ($3ef42575df84b30b$export$9d1611c77c2fe928)(spinButtonProps, focusProps, textFieldProps, {
        // override the spinbutton role, we can't focus a spin button with VO
        role: null,
        // ignore aria-roledescription on iOS so that required state will announce when it is present
        "aria-roledescription": !($c87311424ea30a05$export$fedb369cb70207f1)() ? stringFormatter.format("numberField") : null,
        "aria-valuemax": null,
        "aria-valuemin": null,
        "aria-valuenow": null,
        "aria-valuetext": null,
        autoCorrect: "off",
        spellCheck: "false"
    });
    let onButtonPressStart = (e)=>{
        // If focus is already on the input, keep it there so we don't hide the
        // software keyboard when tapping the increment/decrement buttons.
        if (document.activeElement === inputRef.current) return;
        // Otherwise, when using a mouse, move focus to the input.
        // On touch, or with a screen reader, focus the button so that the software
        // keyboard does not appear and the screen reader cursor is not moved off the button.
        if (e.pointerType === "mouse") inputRef.current.focus();
        else e.target.focus();
    };
    // Determine the label for the increment and decrement buttons. There are 4 cases:
    //
    // 1. With a visible label that is a string: aria-label: `Increase ${props.label}`
    // 2. With a visible label that is JSX: aria-label: 'Increase', aria-labelledby: '${incrementId} ${labelId}'
    // 3. With an aria-label: aria-label: `Increase ${props['aria-label']}`
    // 4. With an aria-labelledby: aria-label: 'Increase', aria-labelledby: `${incrementId} ${props['aria-labelledby']}`
    //
    // (1) and (2) could possibly be combined and both use aria-labelledby. However, placing the label in
    // the aria-label string rather than using aria-labelledby gives more flexibility to translators to change
    // the order or add additional words around the label if needed.
    let fieldLabel = props["aria-label"] || (typeof props.label === "string" ? props.label : "");
    let ariaLabelledby;
    if (!fieldLabel) ariaLabelledby = props.label != null ? labelProps.id : props["aria-labelledby"];
    let incrementId = ($bdb11010cef70236$export$f680877a34711e37)();
    let decrementId = ($bdb11010cef70236$export$f680877a34711e37)();
    let incrementButtonProps = ($3ef42575df84b30b$export$9d1611c77c2fe928)(incButtonProps, {
        "aria-label": incrementAriaLabel || stringFormatter.format("increase", {
            fieldLabel: fieldLabel
        }).trim(),
        id: ariaLabelledby && !incrementAriaLabel ? incrementId : null,
        "aria-labelledby": ariaLabelledby && !incrementAriaLabel ? `${incrementId} ${ariaLabelledby}` : null,
        "aria-controls": inputId,
        excludeFromTabOrder: true,
        preventFocusOnPress: true,
        allowFocusWhenDisabled: true,
        isDisabled: !state.canIncrement,
        onPressStart: onButtonPressStart
    });
    let decrementButtonProps = ($3ef42575df84b30b$export$9d1611c77c2fe928)(decButtonProps, {
        "aria-label": decrementAriaLabel || stringFormatter.format("decrease", {
            fieldLabel: fieldLabel
        }).trim(),
        id: ariaLabelledby && !decrementAriaLabel ? decrementId : null,
        "aria-labelledby": ariaLabelledby && !decrementAriaLabel ? `${decrementId} ${ariaLabelledby}` : null,
        "aria-controls": inputId,
        excludeFromTabOrder: true,
        preventFocusOnPress: true,
        allowFocusWhenDisabled: true,
        isDisabled: !state.canDecrement,
        onPressStart: onButtonPressStart
    });
    return {
        groupProps: {
            role: "group",
            "aria-disabled": isDisabled,
            "aria-invalid": validationState === "invalid" ? "true" : undefined,
            ...focusWithinProps
        },
        labelProps: labelProps,
        inputProps: inputProps,
        incrementButtonProps: incrementButtonProps,
        decrementButtonProps: decrementButtonProps,
        errorMessageProps: errorMessageProps,
        descriptionProps: descriptionProps
    };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $884aeceb3d67f00f$export$3b7b268d09480394 = new WeakMap();
const $884aeceb3d67f00f$export$8e8b214e06dd397d = new WeakMap();
const $884aeceb3d67f00f$export$61c8d3f0151e21b2 = new WeakMap();




function $0d5c49892c1215da$export$37b0961d2f4751e2(props, state, ref) {
    let { value: value , children: children , "aria-label": ariaLabel , "aria-labelledby": ariaLabelledby  } = props;
    const isDisabled = props.isDisabled || state.isDisabled;
    let hasChildren = children != null;
    let hasAriaLabel = ariaLabel != null || ariaLabelledby != null;
    if (!hasChildren && !hasAriaLabel) console.warn("If you do not provide children, you must specify an aria-label for accessibility");
    let checked = state.selectedValue === value;
    let onChange = (e)=>{
        e.stopPropagation();
        state.setSelectedValue(value);
    };
    let { pressProps: pressProps  } = ($f6c31cce2adf654f$export$45712eceda6fad21)({
        isDisabled: isDisabled
    });
    let { focusableProps: focusableProps  } = ($e6afbd83fe6ebbd2$export$4c014de7c8940b4c)(($3ef42575df84b30b$export$9d1611c77c2fe928)(props, {
        onFocus: ()=>state.setLastFocusedValue(value)
    }), ref);
    let interactions = ($3ef42575df84b30b$export$9d1611c77c2fe928)(pressProps, focusableProps);
    let domProps = ($65484d02dcb7eb3e$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    let tabIndex = state.lastFocusedValue === value || state.lastFocusedValue == null ? 0 : -1;
    if (isDisabled) tabIndex = undefined;
    return {
        inputProps: ($3ef42575df84b30b$export$9d1611c77c2fe928)(domProps, {
            ...interactions,
            type: "radio",
            name: ($884aeceb3d67f00f$export$3b7b268d09480394).get(state),
            tabIndex: tabIndex,
            disabled: isDisabled,
            checked: checked,
            value: value,
            onChange: onChange,
            "aria-describedby": [
                state.validationState === "invalid" ? ($884aeceb3d67f00f$export$61c8d3f0151e21b2).get(state) : null,
                ($884aeceb3d67f00f$export$8e8b214e06dd397d).get(state)
            ].filter(Boolean).join(" ") || undefined
        }),
        isDisabled: isDisabled,
        isSelected: checked
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 





function $430f30ed08ec25fa$export$62b9571f283ff5c2(props, state) {
    let { name: name , validationState: validationState , isReadOnly: isReadOnly , isRequired: isRequired , isDisabled: isDisabled , orientation: orientation = "vertical"  } = props;
    let { direction: direction  } = ($18f2051aff69b9bf$export$43bb16f9c6d9e3f7)();
    let { labelProps: labelProps , fieldProps: fieldProps , descriptionProps: descriptionProps , errorMessageProps: errorMessageProps  } = ($2baaea4c71418dea$export$294aa081a6c6f55d)({
        ...props,
        // Radio group is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: "span"
    });
    ($884aeceb3d67f00f$export$8e8b214e06dd397d).set(state, descriptionProps.id);
    ($884aeceb3d67f00f$export$61c8d3f0151e21b2).set(state, errorMessageProps.id);
    let domProps = ($65484d02dcb7eb3e$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    // When the radio group loses focus, reset the focusable radio to null if
    // there is no selection. This allows tabbing into the group from either
    // direction to go to the first or last radio.
    let { focusWithinProps: focusWithinProps  } = ($9ab94262bd0047c7$export$420e68273165f4ec)({
        onBlurWithin () {
            if (!state.selectedValue) state.setLastFocusedValue(null);
        }
    });
    let onKeyDown = (e)=>{
        let nextDir;
        switch(e.key){
            case "ArrowRight":
                if (direction === "rtl" && orientation !== "vertical") nextDir = "prev";
                else nextDir = "next";
                break;
            case "ArrowLeft":
                if (direction === "rtl" && orientation !== "vertical") nextDir = "next";
                else nextDir = "prev";
                break;
            case "ArrowDown":
                nextDir = "next";
                break;
            case "ArrowUp":
                nextDir = "prev";
                break;
            default:
                return;
        }
        e.preventDefault();
        let walker = ($9bf71ea28793e738$export$2d6ec8fc375ceafa)(e.currentTarget, {
            from: e.target
        });
        let nextElem;
        if (nextDir === "next") {
            nextElem = walker.nextNode();
            if (!nextElem) {
                walker.currentNode = e.currentTarget;
                nextElem = walker.firstChild();
            }
        } else {
            nextElem = walker.previousNode();
            if (!nextElem) {
                walker.currentNode = e.currentTarget;
                nextElem = walker.lastChild();
            }
        }
        if (nextElem) {
            // Call focus on nextElem so that keyboard navigation scrolls the radio into view
            nextElem.focus();
            state.setSelectedValue(nextElem.value);
        }
    };
    let groupName = ($bdb11010cef70236$export$f680877a34711e37)(name);
    ($884aeceb3d67f00f$export$3b7b268d09480394).set(state, groupName);
    return {
        radioGroupProps: ($3ef42575df84b30b$export$9d1611c77c2fe928)(domProps, {
            // https://www.w3.org/TR/wai-aria-1.2/#radiogroup
            role: "radiogroup",
            onKeyDown: onKeyDown,
            "aria-invalid": validationState === "invalid" || undefined,
            "aria-errormessage": props["aria-errormessage"],
            "aria-readonly": isReadOnly || undefined,
            "aria-required": isRequired || undefined,
            "aria-disabled": isDisabled || undefined,
            "aria-orientation": orientation,
            ...fieldProps,
            ...focusWithinProps
        }),
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps
    };
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
var $ad5aea03cc53c961$exports = {};
var $03c9a1a10de12f06$exports = {};
$03c9a1a10de12f06$exports = {
    "Clear search": `مسح البحث`
};


var $4da0c2ffa4ba4159$exports = {};
$4da0c2ffa4ba4159$exports = {
    "Clear search": `Изчистване на търсене`
};


var $8c59fd0c2c96821b$exports = {};
$8c59fd0c2c96821b$exports = {
    "Clear search": `Vymazat hledání`
};


var $0a371f9c1df8120f$exports = {};
$0a371f9c1df8120f$exports = {
    "Clear search": `Ryd søgning`
};


var $67f4d0b0de9f8a52$exports = {};
$67f4d0b0de9f8a52$exports = {
    "Clear search": `Suche zurücksetzen`
};


var $72a312d948f0214b$exports = {};
$72a312d948f0214b$exports = {
    "Clear search": `Απαλοιφή αναζήτησης`
};


var $5012d21d933388c1$exports = {};
$5012d21d933388c1$exports = {
    "Clear search": `Clear search`
};


var $0159854399308e2e$exports = {};
$0159854399308e2e$exports = {
    "Clear search": `Borrar búsqueda`
};


var $390613981d970276$exports = {};
$390613981d970276$exports = {
    "Clear search": `Tühjenda otsing`
};


var $961ae0833f811705$exports = {};
$961ae0833f811705$exports = {
    "Clear search": `Tyhjennä haku`
};


var $26d76742decfd829$exports = {};
$26d76742decfd829$exports = {
    "Clear search": `Effacer la recherche`
};


var $92ef254c82a5c769$exports = {};
$92ef254c82a5c769$exports = {
    "Clear search": `נקה חיפוש`
};


var $e0321b43bdefb8b3$exports = {};
$e0321b43bdefb8b3$exports = {
    "Clear search": `Obriši pretragu`
};


var $0c1ee0b8d50940d9$exports = {};
$0c1ee0b8d50940d9$exports = {
    "Clear search": `Keresés törlése`
};


var $b09198915a38946f$exports = {};
$b09198915a38946f$exports = {
    "Clear search": `Cancella ricerca`
};


var $3a9a3d180c3145c0$exports = {};
$3a9a3d180c3145c0$exports = {
    "Clear search": `検索をクリア`
};


var $b7a611726449f4a3$exports = {};
$b7a611726449f4a3$exports = {
    "Clear search": `검색 지우기`
};


var $d9a3d49db610dd5c$exports = {};
$d9a3d49db610dd5c$exports = {
    "Clear search": `Išvalyti iešką`
};


var $3ab64b73ea27c23a$exports = {};
$3ab64b73ea27c23a$exports = {
    "Clear search": `Notīrīt meklēšanu`
};


var $bf5cce1b47d23baf$exports = {};
$bf5cce1b47d23baf$exports = {
    "Clear search": `Tøm søk`
};


var $4e0c9a9a010e4598$exports = {};
$4e0c9a9a010e4598$exports = {
    "Clear search": `Zoekactie wissen`
};


var $63cf4a75ec270508$exports = {};
$63cf4a75ec270508$exports = {
    "Clear search": `Wyczyść zawartość wyszukiwania`
};


var $083b0cad27fdbd06$exports = {};
$083b0cad27fdbd06$exports = {
    "Clear search": `Limpar pesquisa`
};


var $1b7f0864d830ba6d$exports = {};
$1b7f0864d830ba6d$exports = {
    "Clear search": `Limpar pesquisa`
};


var $d6d2588377fc9718$exports = {};
$d6d2588377fc9718$exports = {
    "Clear search": `Ştergeţi căutarea`
};


var $701c918a4653e946$exports = {};
$701c918a4653e946$exports = {
    "Clear search": `Очистить поиск`
};


var $7cacc29a1e5f4fbe$exports = {};
$7cacc29a1e5f4fbe$exports = {
    "Clear search": `Vymazať vyhľadávanie`
};


var $c63231bcc300d0df$exports = {};
$c63231bcc300d0df$exports = {
    "Clear search": `Počisti iskanje`
};


var $b61510478bc0e6f6$exports = {};
$b61510478bc0e6f6$exports = {
    "Clear search": `Obriši pretragu`
};


var $ce325e6dd3f9c37a$exports = {};
$ce325e6dd3f9c37a$exports = {
    "Clear search": `Rensa sökning`
};


var $1f7e1cf2285af2b2$exports = {};
$1f7e1cf2285af2b2$exports = {
    "Clear search": `Aramayı temizle`
};


var $2d999353ca652e34$exports = {};
$2d999353ca652e34$exports = {
    "Clear search": `Очистити пошук`
};


var $117b536bfb1ae554$exports = {};
$117b536bfb1ae554$exports = {
    "Clear search": `清除搜索`
};


var $525f6fa4ac26e278$exports = {};
$525f6fa4ac26e278$exports = {
    "Clear search": `清除搜尋條件`
};


$ad5aea03cc53c961$exports = {
    "ar-AE": $03c9a1a10de12f06$exports,
    "bg-BG": $4da0c2ffa4ba4159$exports,
    "cs-CZ": $8c59fd0c2c96821b$exports,
    "da-DK": $0a371f9c1df8120f$exports,
    "de-DE": $67f4d0b0de9f8a52$exports,
    "el-GR": $72a312d948f0214b$exports,
    "en-US": $5012d21d933388c1$exports,
    "es-ES": $0159854399308e2e$exports,
    "et-EE": $390613981d970276$exports,
    "fi-FI": $961ae0833f811705$exports,
    "fr-FR": $26d76742decfd829$exports,
    "he-IL": $92ef254c82a5c769$exports,
    "hr-HR": $e0321b43bdefb8b3$exports,
    "hu-HU": $0c1ee0b8d50940d9$exports,
    "it-IT": $b09198915a38946f$exports,
    "ja-JP": $3a9a3d180c3145c0$exports,
    "ko-KR": $b7a611726449f4a3$exports,
    "lt-LT": $d9a3d49db610dd5c$exports,
    "lv-LV": $3ab64b73ea27c23a$exports,
    "nb-NO": $bf5cce1b47d23baf$exports,
    "nl-NL": $4e0c9a9a010e4598$exports,
    "pl-PL": $63cf4a75ec270508$exports,
    "pt-BR": $083b0cad27fdbd06$exports,
    "pt-PT": $1b7f0864d830ba6d$exports,
    "ro-RO": $d6d2588377fc9718$exports,
    "ru-RU": $701c918a4653e946$exports,
    "sk-SK": $7cacc29a1e5f4fbe$exports,
    "sl-SI": $c63231bcc300d0df$exports,
    "sr-SP": $b61510478bc0e6f6$exports,
    "sv-SE": $ce325e6dd3f9c37a$exports,
    "tr-TR": $1f7e1cf2285af2b2$exports,
    "uk-UA": $2d999353ca652e34$exports,
    "zh-CN": $117b536bfb1ae554$exports,
    "zh-TW": $525f6fa4ac26e278$exports
};




function $4d52238874b24f86$export$9bb30bbe003b82e0(props, state, inputRef) {
    let stringFormatter = ($fca6afa0e843324b$export$f12b703ca79dfbb1)(((/*@__PURE__*/$parcel$interopDefault($ad5aea03cc53c961$exports))));
    let { isDisabled: isDisabled , isReadOnly: isReadOnly , onSubmit: onSubmit = ()=>{} , onClear: onClear , type: type = "search"  } = props;
    let onKeyDown = (e)=>{
        const key = e.key;
        if (key === "Enter" || key === "Escape") e.preventDefault();
        if (isDisabled || isReadOnly) return;
        if (key === "Enter") onSubmit(state.value);
        if (key === "Escape") {
            state.setValue("");
            if (onClear) onClear();
        }
    };
    let onClearButtonClick = ()=>{
        state.setValue("");
        if (onClear) onClear();
    };
    let onPressStart = ()=>{
        // this is in PressStart for mobile so that touching the clear button doesn't remove focus from
        // the input and close the keyboard
        inputRef.current.focus();
    };
    let { labelProps: labelProps , inputProps: inputProps , descriptionProps: descriptionProps , errorMessageProps: errorMessageProps  } = ($2d73ec29415bd339$export$712718f7aec83d5)({
        ...props,
        value: state.value,
        onChange: state.setValue,
        onKeyDown: ($ff5963eb1fccf552$export$e08e3b67e392101e)(onKeyDown, props.onKeyDown),
        type: type
    }, inputRef);
    return {
        labelProps: labelProps,
        inputProps: {
            ...inputProps,
            // already handled by useSearchFieldState
            defaultValue: undefined
        },
        clearButtonProps: {
            "aria-label": stringFormatter.format("Clear search"),
            excludeFromTabOrder: true,
            // @ts-ignore
            preventFocusOnPress: true,
            isDisabled: isDisabled || isReadOnly,
            onPress: onClearButtonClick,
            onPressStart: onPressStart
        },
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps
    };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 * 
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 






function $58aed456727eb0f3$export$e64b2f635402ca43(props, state, ref) {
    let { keyboardDelegate: keyboardDelegate , isDisabled: isDisabled  } = props;
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let collator = ($325a3faab7a68acd$export$a16aca283550c30d)({
        usage: "search",
        sensitivity: "base"
    });
    let delegate = (useMemo)(()=>keyboardDelegate || new ($2a25aae57d74318e$export$a05409b8bb224a5a)(state.collection, state.disabledKeys, null, collator), [
        keyboardDelegate,
        state.collection,
        state.disabledKeys,
        collator
    ]);
    let { menuTriggerProps: menuTriggerProps , menuProps: menuProps  } = ($168583247155ddda$export$dc9c12ed27dd1b49)({
        isDisabled: isDisabled,
        type: "listbox"
    }, state, ref);
    let onKeyDown = (e)=>{
        switch(e.key){
            case "ArrowLeft":
                {
                    // prevent scrolling containers
                    e.preventDefault();
                    let key = state.selectedKey != null ? delegate.getKeyAbove(state.selectedKey) : delegate.getFirstKey();
                    if (key) state.setSelectedKey(key);
                    break;
                }
            case "ArrowRight":
                {
                    // prevent scrolling containers
                    e.preventDefault();
                    let key1 = state.selectedKey != null ? delegate.getKeyBelow(state.selectedKey) : delegate.getFirstKey();
                    if (key1) state.setSelectedKey(key1);
                    break;
                }
        }
    };
    let { typeSelectProps: typeSelectProps  } = ($fb3050f43d946246$export$e32c88dfddc6e1d8)({
        keyboardDelegate: delegate,
        selectionManager: state.selectionManager,
        onTypeSelect (key) {
            state.setSelectedKey(key);
        }
    });
    let { labelProps: labelProps , fieldProps: fieldProps , descriptionProps: descriptionProps , errorMessageProps: errorMessageProps  } = ($2baaea4c71418dea$export$294aa081a6c6f55d)({
        ...props,
        labelElementType: "span"
    });
    typeSelectProps.onKeyDown = typeSelectProps.onKeyDownCapture;
    delete typeSelectProps.onKeyDownCapture;
    let domProps = ($65484d02dcb7eb3e$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    let triggerProps = ($3ef42575df84b30b$export$9d1611c77c2fe928)(typeSelectProps, menuTriggerProps, fieldProps);
    let valueId = ($bdb11010cef70236$export$f680877a34711e37)();
    return {
        labelProps: {
            ...labelProps,
            onClick: ()=>{
                if (!props.isDisabled) {
                    ref.current.focus();
                    // Show the focus ring so the user knows where focus went
                    ($507fabe10e71c6fb$export$8397ddfc504fdb9a)("keyboard");
                }
            }
        },
        triggerProps: ($3ef42575df84b30b$export$9d1611c77c2fe928)(domProps, {
            ...triggerProps,
            isDisabled: isDisabled,
            onKeyDown: ($ff5963eb1fccf552$export$e08e3b67e392101e)(triggerProps.onKeyDown, onKeyDown, props.onKeyDown),
            onKeyUp: props.onKeyUp,
            "aria-labelledby": [
                triggerProps["aria-labelledby"],
                triggerProps["aria-label"] && !triggerProps["aria-labelledby"] ? triggerProps.id : null,
                valueId
            ].filter(Boolean).join(" "),
            onFocus (e) {
                if (state.isFocused) return;
                if (props.onFocus) props.onFocus(e);
                if (props.onFocusChange) props.onFocusChange(true);
                state.setFocused(true);
            },
            onBlur (e) {
                if (state.isOpen) return;
                if (props.onBlur) props.onBlur(e);
                if (props.onFocusChange) props.onFocusChange(false);
                state.setFocused(false);
            }
        }),
        valueProps: {
            id: valueId
        },
        menuProps: {
            ...menuProps,
            autoFocus: state.focusStrategy || true,
            shouldSelectOnPressUp: true,
            shouldFocusOnHover: true,
            disallowEmptySelection: true,
            onBlur: (e)=>{
                if (e.currentTarget.contains(e.relatedTarget)) return;
                if (props.onBlur) props.onBlur(e);
                if (props.onFocusChange) props.onFocusChange(false);
                state.setFocused(false);
            },
            "aria-labelledby": [
                fieldProps["aria-labelledby"],
                triggerProps["aria-label"] && !fieldProps["aria-labelledby"] ? triggerProps.id : null
            ].filter(Boolean).join(" ")
        },
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


function $bdd25dc72710631f$export$f809e80f58e251d1(props, state, triggerRef) {
    let { autoComplete: autoComplete , name: name , isDisabled: isDisabled  } = props;
    let modality = ($507fabe10e71c6fb$export$98e20ec92f614cfe)();
    let { visuallyHiddenProps: visuallyHiddenProps  } = ($5c3e21d68f1c4674$export$a966af930f325cab)();
    var _state_selectedKey;
    // In Safari, the <select> cannot have `display: none` or `hidden` for autofill to work.
    // In Firefox, there must be a <label> to identify the <select> whereas other browsers
    // seem to identify it just by surrounding text.
    // The solution is to use <VisuallyHidden> to hide the elements, which clips the elements to a
    // 1px rectangle. In addition, we hide from screen readers with aria-hidden, and make the <select>
    // non tabbable with tabIndex={-1}.
    //
    // In mobile browsers, there are next/previous buttons above the software keyboard for navigating
    // between fields in a form. These only support native form inputs that are tabbable. In order to
    // support those, an additional hidden input is used to marshall focus to the button. It is tabbable
    // except when the button is focused, so that shift tab works properly to go to the actual previous
    // input in the form. Using the <select> for this also works, but Safari on iOS briefly flashes
    // the native menu on focus, so this isn't ideal. A font-size of 16px or greater is required to
    // prevent Safari from zooming in on the input when it is focused.
    //
    // If the current interaction modality is null, then the user hasn't interacted with the page yet.
    // In this case, we set the tabIndex to -1 on the input element so that automated accessibility
    // checkers don't throw false-positives about focusable elements inside an aria-hidden parent.
    return {
        containerProps: {
            ...visuallyHiddenProps,
            "aria-hidden": true
        },
        inputProps: {
            type: "text",
            tabIndex: modality == null || state.isFocused || state.isOpen ? -1 : 0,
            style: {
                fontSize: 16
            },
            onFocus: ()=>triggerRef.current.focus(),
            disabled: isDisabled
        },
        selectProps: {
            tabIndex: -1,
            autoComplete: autoComplete,
            disabled: isDisabled,
            name: name,
            size: state.collection.size,
            value: (_state_selectedKey = state.selectedKey) !== null && _state_selectedKey !== void 0 ? _state_selectedKey : "",
            onChange: (e)=>state.setSelectedKey(e.target.value)
        }
    };
}
function $bdd25dc72710631f$export$cbd84cdb2e668835(props) {
    let { state: state , triggerRef: triggerRef , label: label , name: name , isDisabled: isDisabled  } = props;
    let { containerProps: containerProps , inputProps: inputProps , selectProps: selectProps  } = $bdd25dc72710631f$export$f809e80f58e251d1(props, state, triggerRef);
    // If used in a <form>, use a hidden input so the value can be submitted to a server.
    // If the collection isn't too big, use a hidden <select> element for this so that browser
    // autofill will work. Otherwise, use an <input type="hidden">.
    if (state.collection.size <= 300) return /*#__PURE__*/ (React__default).createElement("div", containerProps, /*#__PURE__*/ (React__default).createElement("input", inputProps), /*#__PURE__*/ (React__default).createElement("label", null, label, /*#__PURE__*/ (React__default).createElement("select", selectProps, /*#__PURE__*/ (React__default).createElement("option", null), [
        ...state.collection.getKeys()
    ].map((key)=>{
        let item = state.collection.getItem(key);
        if (item.type === "item") return /*#__PURE__*/ (React__default).createElement("option", {
            key: item.key,
            value: item.key
        }, item.textValue);
    }))));
    else if (name) return /*#__PURE__*/ (React__default).createElement("input", {
        type: "hidden",
        autoComplete: selectProps.autoComplete,
        name: name,
        disabled: isDisabled,
        value: state.selectedKey
    });
    return null;
}

const classnames$1 = (...classes) => classes.join(' ');
const combineClassnames = (classes) => {
    const classNames = Object.keys(classes);
    return classnames$1(...classNames.filter((className) => classes[className].valueOf()));
};

const StyledSpinner = styled.svg `
  animation: rotate 1s linear infinite;
  flex-shrink: 0;
  font-size: ${({ size }) => size}px;
  height: 1em;
  width: 1em;

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
`;
const Spinner = ({ color = Colors$1.ElectricBrand, size = 24 }) => {
    return (jsxs(StyledSpinner, { className: 'spinner', "data-testid": 'spinner-icon', role: 'img', size: size, viewBox: '0 0 24 24', xmlns: 'http://www.w3.org/2000/svg', children: [jsx("title", { children: "Loading spinner" }), jsx("path", { fill: color, fillRule: 'evenodd', d: 'M12 19a7 7 0 100-14 7 7 0 000 14zm0 3c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z', clipRule: 'evenodd', opacity: '0.2' }), jsx("path", { fill: color, d: 'M2 12C2 6.477 6.477 2 12 2v3a7 7 0 00-7 7H2z' })] }));
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var classnames = {exports: {}};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/

(function (module) {
	/* global define */

	(function () {

		var hasOwn = {}.hasOwnProperty;

		function classNames() {
			var classes = [];

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;

				var argType = typeof arg;

				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					if (arg.length) {
						var inner = classNames.apply(null, arg);
						if (inner) {
							classes.push(inner);
						}
					}
				} else if (argType === 'object') {
					if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
						classes.push(arg.toString());
						continue;
					}

					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}

			return classes.join(' ');
		}

		if (module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else {
			window.classNames = classNames;
		}
	}());
} (classnames));

var Ft = classnames.exports;

function getAlignment(placement) {
  return placement.split('-')[1];
}

function getLengthFromAxis(axis) {
  return axis === 'y' ? 'height' : 'width';
}

function getSide(placement) {
  return placement.split('-')[0];
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].includes(getSide(placement)) ? 'x' : 'y';
}

function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const mainAxis = getMainAxisFromPlacement(placement);
  const length = getLengthFromAxis(mainAxis);
  const commonAlign = reference[length] / 2 - floating[length] / 2;
  const side = getSide(placement);
  const isVertical = mainAxis === 'x';
  let coords;
  switch (side) {
    case 'top':
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case 'bottom':
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case 'right':
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case 'left':
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case 'start':
      coords[mainAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case 'end':
      coords[mainAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */
const computePosition$1 = async (reference, floating, config) => {
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform
  } = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
  let rects = await platform.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const {
      name,
      fn
    } = validMiddleware[i];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === 'object') {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
      continue;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};

function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}

function getSideObjectFromPadding(padding) {
  return typeof padding !== 'number' ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}

function rectToClientRect(rect) {
  return {
    ...rect,
    top: rect.y,
    left: rect.x,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  };
}

/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x,
    y,
    platform,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = 'clippingAncestors',
    rootBoundary = 'viewport',
    elementContext = 'floating',
    altBoundary = false,
    padding = 0
  } = options;
  const paddingObject = getSideObjectFromPadding(padding);
  const altContext = elementContext === 'floating' ? 'reference' : 'floating';
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform.getClippingRect({
    element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || (await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating))),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === 'floating' ? {
    ...rects.floating,
    x,
    y
  } : rects.reference;
  const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
  const offsetScale = (await (platform.isElement == null ? void 0 : platform.isElement(offsetParent))) ? (await (platform.getScale == null ? void 0 : platform.getScale(offsetParent))) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}

const min$1 = Math.min;
const max$1 = Math.max;

function within(min$1$1, value, max$1$1) {
  return max$1(min$1$1, min$1(value, max$1$1));
}

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow = options => ({
  name: 'arrow',
  options,
  async fn(state) {
    // Since `element` is required, we don't Partial<> the type.
    const {
      element,
      padding = 0
    } = options || {};
    const {
      x,
      y,
      placement,
      rects,
      platform,
      elements
    } = state;
    if (element == null) {
      return {};
    }
    const paddingObject = getSideObjectFromPadding(padding);
    const coords = {
      x,
      y
    };
    const axis = getMainAxisFromPlacement(placement);
    const length = getLengthFromAxis(axis);
    const arrowDimensions = await platform.getDimensions(element);
    const isYAxis = axis === 'y';
    const minProp = isYAxis ? 'top' : 'left';
    const maxProp = isYAxis ? 'bottom' : 'right';
    const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;

    // DOM platform can return `window` as the `offsetParent`.
    if (!clientSize || !(await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent)))) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;

    // Make sure the arrow doesn't overflow the floating element if the center
    // point is outside the floating element's bounds.
    const min = paddingObject[minProp];
    const max = clientSize - arrowDimensions[length] - paddingObject[maxProp];
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset = within(min, center, max);

    // If the reference is small enough that the arrow's padding causes it to
    // to point to nothing for an aligned placement, adjust the offset of the
    // floating element itself. This stops `shift()` from taking action, but can
    // be worked around by calling it again after the `arrow()` if desired.
    const shouldAddOffset = getAlignment(placement) != null && center != offset && rects.reference[length] / 2 - (center < min ? paddingObject[minProp] : paddingObject[maxProp]) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min ? min - center : max - center : 0;
    return {
      [axis]: coords[axis] - alignmentOffset,
      data: {
        [axis]: offset,
        centerOffset: center - offset
      }
    };
  }
});

const oppositeSideMap = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, side => oppositeSideMap[side]);
}

function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const mainAxis = getMainAxisFromPlacement(placement);
  const length = getLengthFromAxis(mainAxis);
  let mainAlignmentSide = mainAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return {
    main: mainAlignmentSide,
    cross: getOppositePlacement(mainAlignmentSide)
  };
}

const oppositeAlignmentMap = {
  start: 'end',
  end: 'start'
};
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, alignment => oppositeAlignmentMap[alignment]);
}

function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}

function getSideList(side, isStart, rtl) {
  const lr = ['left', 'right'];
  const rl = ['right', 'left'];
  const tb = ['top', 'bottom'];
  const bt = ['bottom', 'top'];
  switch (side) {
    case 'top':
    case 'bottom':
      if (rtl) return isStart ? rl : lr;
      return isStart ? lr : rl;
    case 'left':
    case 'right':
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === 'start', rtl);
  if (alignment) {
    list = list.map(side => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'flip',
    options,
    async fn(state) {
      var _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = 'bestFit',
        fallbackAxisSideDirection = 'none',
        flipAlignment = true,
        ...detectOverflowOptions
      } = options;
      const side = getSide(placement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== 'none') {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const {
          main,
          cross
        } = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[main], overflow[cross]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];

      // One or more sides is overflowing.
      if (!overflows.every(side => side <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          // Try next placement and re-run the lifecycle.
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }

        // First, find the candidates that fit on the mainAxis side of overflow,
        // then find the placement that fits the best on the main crossAxis side.
        let resetPlacement = (_overflowsData$filter = overflowsData.filter(d => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;

        // Otherwise fallback.
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case 'bestFit':
              {
                var _overflowsData$map$so;
                const placement = (_overflowsData$map$so = overflowsData.map(d => [d.placement, d.overflows.filter(overflow => overflow > 0).reduce((acc, overflow) => acc + overflow, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                if (placement) {
                  resetPlacement = placement;
                }
                break;
              }
            case 'initialPlacement':
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};

async function convertValueToCoords(state, value) {
  const {
    placement,
    platform,
    elements
  } = state;
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getMainAxisFromPlacement(placement) === 'x';
  const mainAxisMulti = ['left', 'top'].includes(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = typeof value === 'function' ? value(state) : value;

  // eslint-disable-next-line prefer-const
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === 'number' ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...rawValue
  };
  if (alignment && typeof alignmentAxis === 'number') {
    crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const offset = function (value) {
  if (value === void 0) {
    value = 0;
  }
  return {
    name: 'offset',
    options: value,
    async fn(state) {
      const {
        x,
        y
      } = state;
      const diffCoords = await convertValueToCoords(state, value);
      return {
        x: x + diffCoords.x,
        y: y + diffCoords.y,
        data: diffCoords
      };
    }
  };
};

function getCrossAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'shift',
    options,
    async fn(state) {
      const {
        x,
        y,
        placement
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: _ref => {
            let {
              x,
              y
            } = _ref;
            return {
              x,
              y
            };
          }
        },
        ...detectOverflowOptions
      } = options;
      const coords = {
        x,
        y
      };
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const mainAxis = getMainAxisFromPlacement(getSide(placement));
      const crossAxis = getCrossAxis(mainAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === 'y' ? 'top' : 'left';
        const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
        const min = mainAxisCoord + overflow[minSide];
        const max = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = within(min, mainAxisCoord, max);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === 'y' ? 'top' : 'left';
        const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
        const min = crossAxisCoord + overflow[minSide];
        const max = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = within(min, crossAxisCoord, max);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y
        }
      };
    }
  };
};

function getWindow(node) {
  var _node$ownerDocument;
  return ((_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}

function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}

function isNode(value) {
  return value instanceof getWindow(value).Node;
}
function getNodeName(node) {
  return isNode(node) ? (node.nodeName || '').toLowerCase() : '';
}

let uaString;
function getUAString() {
  if (uaString) {
    return uaString;
  }
  const uaData = navigator.userAgentData;
  if (uaData && Array.isArray(uaData.brands)) {
    uaString = uaData.brands.map(item => item.brand + "/" + item.version).join(' ');
    return uaString;
  }
  return navigator.userAgent;
}

function isHTMLElement(value) {
  return value instanceof getWindow(value).HTMLElement;
}
function isElement(value) {
  return value instanceof getWindow(value).Element;
}
function isShadowRoot(node) {
  // Browsers without `ShadowRoot` support.
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }
  const OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle$1(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !['inline', 'contents'].includes(display);
}
function isTableElement(element) {
  return ['table', 'td', 'th'].includes(getNodeName(element));
}
function isContainingBlock(element) {
  // TODO: Try to use feature detection here instead.
  const isFirefox = /firefox/i.test(getUAString());
  const css = getComputedStyle$1(element);
  const backdropFilter = css.backdropFilter || css.WebkitBackdropFilter;

  // This is non-exhaustive but covers the most common CSS properties that
  // create a containing block.
  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  return css.transform !== 'none' || css.perspective !== 'none' || (backdropFilter ? backdropFilter !== 'none' : false) || isFirefox && css.willChange === 'filter' || isFirefox && (css.filter ? css.filter !== 'none' : false) || ['transform', 'perspective'].some(value => css.willChange.includes(value)) || ['paint', 'layout', 'strict', 'content'].some(value => {
    // Add type check for old browsers.
    const contain = css.contain;
    return contain != null ? contain.includes(value) : false;
  });
}

/**
 * Determines whether or not `.getBoundingClientRect()` is affected by visual
 * viewport offsets. In Safari, the `x`/`y` offsets are values relative to the
 * visual viewport, while in other engines, they are values relative to the
 * layout viewport.
 */
function isClientRectVisualViewportBased() {
  // TODO: Try to use feature detection here instead. Feature detection for
  // this can fail in various ways, making the userAgent check the most
  // reliable:
  // • Always-visible scrollbar or not
  // • Width of <html>

  // Is Safari.
  return /^((?!chrome|android).)*safari/i.test(getUAString());
}
function isLastTraversableNode(node) {
  return ['html', 'body', '#document'].includes(getNodeName(node));
}

const min = Math.min;
const max = Math.max;
const round = Math.round;

function getCssDimensions(element) {
  const css = getComputedStyle$1(element);
  let width = parseFloat(css.width);
  let height = parseFloat(css.height);
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    fallback: shouldFallback
  };
}

function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}

const FALLBACK_SCALE = {
  x: 1,
  y: 1
};
function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return FALLBACK_SCALE;
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    fallback
  } = getCssDimensions(domElement);
  let x = (fallback ? round(rect.width) : rect.width) / width;
  let y = (fallback ? round(rect.height) : rect.height) / height;

  // 0, NaN, or Infinity should always fallback to 1.

  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}

function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  var _win$visualViewport, _win$visualViewport2;
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = FALLBACK_SCALE;
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const win = domElement ? getWindow(domElement) : window;
  const addVisualOffsets = isClientRectVisualViewportBased() && isFixedStrategy;
  let x = (clientRect.left + (addVisualOffsets ? ((_win$visualViewport = win.visualViewport) == null ? void 0 : _win$visualViewport.offsetLeft) || 0 : 0)) / scale.x;
  let y = (clientRect.top + (addVisualOffsets ? ((_win$visualViewport2 = win.visualViewport) == null ? void 0 : _win$visualViewport2.offsetTop) || 0 : 0)) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentIFrame = win.frameElement;
    while (currentIFrame && offsetParent && offsetWin !== win) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle(currentIFrame);
      iframeRect.x += (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      iframeRect.y += (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += iframeRect.x;
      y += iframeRect.y;
      currentIFrame = getWindow(currentIFrame).frameElement;
    }
  }
  return rectToClientRect({
    width,
    height,
    x,
    y
  });
}

function getDocumentElement(node) {
  return ((isNode(node) ? node.ownerDocument : node.document) || window.document).documentElement;
}

function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.pageXOffset,
    scrollTop: element.pageYOffset
  };
}

function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  if (offsetParent === documentElement) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = {
    x: 1,
    y: 1
  };
  const offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== 'fixed') {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  return getBoundingClientRect(getDocumentElement(element)).left + getNodeScroll(element).scrollLeft;
}

// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  if (getComputedStyle$1(body).direction === 'rtl') {
    x += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}

function getParentNode(node) {
  if (getNodeName(node) === 'html') {
    return node;
  }
  const result =
  // Step into the shadow DOM of the parent of a slotted node.
  node.assignedSlot ||
  // DOM Element detected.
  node.parentNode ||
  // ShadowRoot detected.
  isShadowRoot(node) && node.host ||
  // Fallback.
  getDocumentElement(node);
  return isShadowRoot(result) ? result.host : result;
}

function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    // `getParentNode` will never return a `Document` due to the fallback
    // check, so it's either the <html> or <body> element.
    return parentNode.ownerDocument.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}

function getOverflowAncestors(node, list) {
  var _node$ownerDocument;
  if (list === void 0) {
    list = [];
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor));
}

function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isClientRectVisualViewportBased();
    if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x,
    y
  };
}

// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement(element) ? getScale(element) : {
    x: 1,
    y: 1
  };
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === 'viewport') {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === 'document') {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const mutableRect = {
      ...clippingAncestor
    };
    if (isClientRectVisualViewportBased()) {
      var _win$visualViewport, _win$visualViewport2;
      const win = getWindow(element);
      mutableRect.x -= ((_win$visualViewport = win.visualViewport) == null ? void 0 : _win$visualViewport.offsetLeft) || 0;
      mutableRect.y -= ((_win$visualViewport2 = win.visualViewport) == null ? void 0 : _win$visualViewport2.offsetTop) || 0;
    }
    rect = mutableRect;
  }
  return rectToClientRect(rect);
}

// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element).filter(el => isElement(el) && getNodeName(el) !== 'body');
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle$1(element).position === 'fixed';
  let currentNode = elementIsFixed ? getParentNode(element) : element;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle$1(currentNode);
    const containingBlock = isContainingBlock(currentNode);
    if (computedStyle.position === 'fixed') {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !containingBlock && !currentContainingBlockComputedStyle : !containingBlock && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && ['absolute', 'fixed'].includes(currentContainingBlockComputedStyle.position);
    if (shouldDropCurrentNode) {
      // Drop non-containing blocks.
      result = result.filter(ancestor => ancestor !== currentNode);
    } else {
      // Record last containing block for next iteration.
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}

// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === 'clippingAncestors' ? getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}

function getDimensions(element) {
  return getCssDimensions(element);
}

function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement(element) || getComputedStyle$1(element).position === 'fixed') {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  return element.offsetParent;
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else {
      currentNode = getParentNode(currentNode);
    }
  }
  return null;
}

// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
  const window = getWindow(element);
  if (!isHTMLElement(element)) {
    return window;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static' && !isContainingBlock(offsetParent))) {
    return window;
  }
  return offsetParent || getContainingBlock(element) || window;
}

function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const rect = getBoundingClientRect(element, true, strategy === 'fixed', offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== 'fixed') {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent, true);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

const platform = {
  getClippingRect,
  convertOffsetParentRelativeRectToViewportRelativeRect,
  isElement,
  getDimensions,
  getOffsetParent,
  getDocumentElement,
  getScale,
  async getElementRects(_ref) {
    let {
      reference,
      floating,
      strategy
    } = _ref;
    const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    return {
      reference: getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
      floating: {
        x: 0,
        y: 0,
        ...(await getDimensionsFn(floating))
      }
    };
  },
  getClientRects: element => Array.from(element.getClientRects()),
  isRTL: element => getComputedStyle$1(element).direction === 'rtl'
};

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */
const computePosition = (reference, floating, options) => {
  // This caches the expensive `getClippingElementAncestors` function so that
  // multiple lifecycle resets re-use the same result. It only lives for a
  // single call. If other functions become expensive, we can add them as well.
  const cache = new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition$1(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};

var Xt=(o,d,h)=>{let c=null;return function(...p){let E=()=>{c=null,h||o.apply(this,p);};c&&clearTimeout(c),c=setTimeout(E,d);}},Pt=Xt;var gt="DEFAULT_TOOLTIP_ID",Gt={anchorRefs:new Set,activeAnchor:{current:null},attach:()=>{},detach:()=>{},setActiveAnchor:()=>{}},Qt={getTooltipData:()=>Gt},Rt=createContext(Qt);function j(o=gt){return useContext(Rt).getTooltipData(o)}var ce=typeof window!="undefined"?useLayoutEffect:useEffect,$t=ce;var Mt=async({elementReference:o=null,tooltipReference:d=null,tooltipArrowReference:h=null,place:c="top",offset:m=10,strategy:p="absolute",middlewares:E=[offset(Number(m)),flip(),shift({padding:5})]})=>{if(!o)return {tooltipStyles:{},tooltipArrowStyles:{},place:c};if(d===null)return {tooltipStyles:{},tooltipArrowStyles:{},place:c};let v=E;return h?(v.push(arrow({element:h,padding:5})),computePosition(o,d,{placement:c,strategy:p,middleware:v}).then(({x:b,y:A,placement:r,middlewareData:a})=>{var M,R;let s={left:`${b}px`,top:`${A}px`},{x:n,y}=(M=a.arrow)!=null?M:{x:0,y:0},L=(R={top:"bottom",right:"left",bottom:"top",left:"right"}[r.split("-")[0]])!=null?R:"bottom",tt={left:n!=null?`${n}px`:"",top:y!=null?`${y}px`:"",right:"",bottom:"",[L]:"-4px"};return {tooltipStyles:s,tooltipArrowStyles:tt,place:r}})):computePosition(o,d,{placement:"bottom",strategy:p,middleware:v}).then(({x:b,y:A,placement:r})=>({tooltipStyles:{left:`${b}px`,top:`${A}px`},tooltipArrowStyles:{},place:r}))};var F={arrow:"react-tooltip__arrow_KtSkBq",clickable:"react-tooltip__clickable_KtSkBq",dark:"react-tooltip__dark_KtSkBq",error:"react-tooltip__error_KtSkBq",fixed:"react-tooltip__fixed_KtSkBq",info:"react-tooltip__info_KtSkBq",light:"react-tooltip__light_KtSkBq",noArrow:"react-tooltip__no-arrow_KtSkBq",show:"react-tooltip__show_KtSkBq",success:"react-tooltip__success_KtSkBq",tooltip:"react-tooltip__tooltip_KtSkBq",warning:"react-tooltip__warning_KtSkBq"};var Te=({id:o,className:d,classNameArrow:h,variant:c="dark",anchorId:m,anchorSelect:p,place:E="top",offset:v=10,events:b=["hover"],openOnClick:A=!1,positionStrategy:r="absolute",middlewares:a,wrapper:s,delayShow:n=0,delayHide:y=0,float:L=!1,noArrow:tt=!1,clickable:M=!1,closeOnEsc:R=!1,style:et,position:ot,afterShow:rt,afterHide:nt,content:J,contentWrapperRef:I,isOpen:U,setIsOpen:it,activeAnchor:H,setActiveAnchor:lt})=>{let S=useRef(null),z=useRef(null),B=useRef(null),q=useRef(null),[Lt,st]=useState(E),[Tt,dt]=useState({}),[kt,mt]=useState({}),[D,yt]=useState(!1),[ht,Y]=useState(!1),Et=useRef(!1),ct=useRef(null),{anchorRefs:_t,setActiveAnchor:xt}=j(o),at=useRef(!1),[$,pt]=useState([]),X=useRef(!1),P=A||b.includes("click");$t(()=>(X.current=!0,()=>{X.current=!1;}),[]),useEffect(()=>{if(!D){let t=setTimeout(()=>{Y(!1);},150);return ()=>{clearTimeout(t);}}return ()=>null},[D]);let O=t=>{X.current&&(t&&Y(!0),setTimeout(()=>{X.current&&(it==null||it(t),U===void 0&&yt(t));},10));};useEffect(()=>{if(U===void 0)return ()=>null;U&&Y(!0);let t=setTimeout(()=>{yt(U);},10);return ()=>{clearTimeout(t);}},[U]),useEffect(()=>{D!==Et.current&&(Et.current=D,D?rt==null||rt():nt==null||nt());},[D]);let wt=()=>{B.current&&clearTimeout(B.current),B.current=setTimeout(()=>{O(!0);},n);},G=(t=y)=>{q.current&&clearTimeout(q.current),q.current=setTimeout(()=>{at.current||O(!1);},t);},ut=t=>{var i;if(!t)return;n?wt():O(!0);let l=(i=t.currentTarget)!=null?i:t.target;lt(l),xt({current:l}),q.current&&clearTimeout(q.current);},ft=()=>{M?G(y||100):y?G():O(!1),B.current&&clearTimeout(B.current);},W=({x:t,y:l})=>{Mt({place:E,offset:v,elementReference:{getBoundingClientRect(){return {x:t,y:l,width:0,height:0,top:l,left:t,right:t,bottom:l}}},tooltipReference:S.current,tooltipArrowReference:z.current,strategy:r,middlewares:a}).then(f=>{Object.keys(f.tooltipStyles).length&&dt(f.tooltipStyles),Object.keys(f.tooltipArrowStyles).length&&mt(f.tooltipArrowStyles),st(f.place);});},bt=t=>{if(!t)return;let l=t,i={x:l.clientX,y:l.clientY};W(i),ct.current=i;},Dt=t=>{ut(t),y&&G();},T=t=>{var f;[document.querySelector(`[id='${m}']`),...$].some(g=>g==null?void 0:g.contains(t.target))||(f=S.current)!=null&&f.contains(t.target)||O(!1);},k=t=>{t.key==="Escape"&&O(!1);},e=Pt(ut,50),u=Pt(ft,50);useEffect(()=>{var _,x;let t=new Set(_t);$.forEach(w=>{t.add({current:w});});let l=document.querySelector(`[id='${m}']`);l&&t.add({current:l}),R&&window.addEventListener("keydown",k);let i=[];P?(window.addEventListener("click",T),i.push({event:"click",listener:Dt})):(i.push({event:"mouseenter",listener:e},{event:"mouseleave",listener:u},{event:"focus",listener:e},{event:"blur",listener:u}),L&&i.push({event:"mousemove",listener:bt}));let f=()=>{at.current=!0;},g=()=>{at.current=!1,ft();};return M&&!P&&((_=S.current)==null||_.addEventListener("mouseenter",f),(x=S.current)==null||x.addEventListener("mouseleave",g)),i.forEach(({event:w,listener:At})=>{t.forEach(Ct=>{var St;(St=Ct.current)==null||St.addEventListener(w,At);});}),()=>{var w,At;P&&window.removeEventListener("click",T),R&&window.removeEventListener("keydown",k),M&&!P&&((w=S.current)==null||w.removeEventListener("mouseenter",f),(At=S.current)==null||At.removeEventListener("mouseleave",g)),i.forEach(({event:Ct,listener:St})=>{t.forEach(Ut=>{var Kt;(Kt=Ut.current)==null||Kt.removeEventListener(Ct,St);});});}},[ht,_t,$,R,b]),useEffect(()=>{let t=p!=null?p:"";!t&&o&&(t=`[data-tooltip-id='${o}']`);let l=f=>{let g=[];f.forEach(_=>{if(_.type==="attributes"&&_.attributeName==="data-tooltip-id"&&_.target.getAttribute("data-tooltip-id")===o&&g.push(_.target),_.type==="childList"&&(H&&[..._.removedNodes].some(x=>{var w;return (w=x==null?void 0:x.contains)!=null&&w.call(x,H)?(Y(!1),O(!1),lt(null),!0):!1}),!!t))try{let x=[..._.addedNodes].filter(w=>w.nodeType===1);g.push(...x.filter(w=>w.matches(t))),g.push(...x.flatMap(w=>[...w.querySelectorAll(t)]));}catch(x){}}),g.length&&pt(_=>[..._,...g]);},i=new MutationObserver(l);return i.observe(document.body,{childList:!0,subtree:!0,attributes:!0,attributeFilter:["data-tooltip-id"]}),()=>{i.disconnect();}},[o,p,H]);let K=()=>{if(ot){W(ot);return}if(L){ct.current&&W(ct.current);return}Mt({place:E,offset:v,elementReference:H,tooltipReference:S.current,tooltipArrowReference:z.current,strategy:r,middlewares:a}).then(t=>{X.current&&(Object.keys(t.tooltipStyles).length&&dt(t.tooltipStyles),Object.keys(t.tooltipArrowStyles).length&&mt(t.tooltipArrowStyles),st(t.place));});};useEffect(()=>{K();},[D,H,J,et,E,v,r,ot]),useEffect(()=>{if(!(I!=null&&I.current))return ()=>null;let t=new ResizeObserver(()=>{K();});return t.observe(I.current),()=>{t.disconnect();}},[J,I==null?void 0:I.current]),useEffect(()=>{var i;let t=document.querySelector(`[id='${m}']`),l=[...$,t];(!H||!l.includes(H))&&lt((i=$[0])!=null?i:t);},[m,$,H]),useEffect(()=>()=>{B.current&&clearTimeout(B.current),q.current&&clearTimeout(q.current);},[]),useEffect(()=>{let t=p;if(!t&&o&&(t=`[data-tooltip-id='${o}']`),!!t)try{let l=Array.from(document.querySelectorAll(t));pt(l);}catch(l){pt([]);}},[o,p]);let Q=J&&D&&Object.keys(Tt).length>0;return ht?jsxs(s,{id:o,role:"tooltip",className:Ft("react-tooltip",F.tooltip,F[c],d,`react-tooltip__place-${Lt}`,{[F.show]:Q,[F.fixed]:r==="fixed",[F.clickable]:M}),style:{...et,...Tt},ref:S,children:[J,jsx(s,{className:Ft("react-tooltip-arrow",F.arrow,h,{[F.noArrow]:tt}),style:kt,ref:z})]}):null},Ht=Te;var ye=({content:o})=>jsx("span",{dangerouslySetInnerHTML:{__html:o}}),Bt=ye;var _e=({id:o,anchorId:d,anchorSelect:h,content:c,html:m,render:p,className:E,classNameArrow:v,variant:b="dark",place:A="top",offset:r=10,wrapper:a="div",children:s=null,events:n=["hover"],openOnClick:y=!1,positionStrategy:L="absolute",middlewares:tt,delayShow:M=0,delayHide:R=0,float:et=!1,noArrow:ot=!1,clickable:rt=!1,closeOnEsc:nt=!1,style:J,position:I,isOpen:U,setIsOpen:it,afterShow:H,afterHide:lt})=>{let[S,z]=useState(c),[B,q]=useState(m),[Lt,st]=useState(A),[Tt,dt]=useState(b),[kt,mt]=useState(r),[D,yt]=useState(M),[ht,Y]=useState(R),[Et,ct]=useState(et),[_t,xt]=useState(a),[at,$]=useState(n),[pt,X]=useState(L),[P,O]=useState(null),{anchorRefs:wt,activeAnchor:G}=j(o),ut=T=>T==null?void 0:T.getAttributeNames().reduce((e,u)=>{var K;if(u.startsWith("data-tooltip-")){let Q=u.replace(/^data-tooltip-/,"");e[Q]=(K=T==null?void 0:T.getAttribute(u))!=null?K:null;}return e},{}),ft=T=>{let k={place:e=>{st(e!=null?e:A);},content:e=>{z(e!=null?e:c);},html:e=>{q(e!=null?e:m);},variant:e=>{dt(e!=null?e:b);},offset:e=>{mt(e===null?r:Number(e));},wrapper:e=>{xt(e!=null?e:a);},events:e=>{let u=e==null?void 0:e.split(" ");$(u!=null?u:n);},"position-strategy":e=>{X(e!=null?e:L);},"delay-show":e=>{yt(e===null?M:Number(e));},"delay-hide":e=>{Y(e===null?R:Number(e));},float:e=>{ct(e===null?et:e==="true");}};Object.values(k).forEach(e=>e(null)),Object.entries(T).forEach(([e,u])=>{var K;(K=k[e])==null||K.call(k,u);});};useEffect(()=>{z(c);},[c]),useEffect(()=>{q(m);},[m]),useEffect(()=>{st(A);},[A]),useEffect(()=>{var l;let T=new Set(wt),k=h;if(!k&&o&&(k=`[data-tooltip-id='${o}']`),k)try{document.querySelectorAll(k).forEach(f=>{T.add({current:f});});}catch(i){}let e=document.querySelector(`[id='${d}']`);if(e&&T.add({current:e}),!T.size)return ()=>null;let u=(l=P!=null?P:e)!=null?l:G.current,K=i=>{i.forEach(f=>{var _;if(!u||f.type!=="attributes"||!((_=f.attributeName)!=null&&_.startsWith("data-tooltip-")))return;let g=ut(u);ft(g);});},Q=new MutationObserver(K),t={attributes:!0,childList:!1,subtree:!1};if(u){let i=ut(u);ft(i),Q.observe(u,t);}return ()=>{Q.disconnect();}},[wt,G,P,d,h]);let W=s,bt=useRef(null);return p?W=jsx("div",{ref:bt,className:"react-tooltip-content-wrapper",children:p({content:S!=null?S:null,activeAnchor:P})}):S&&(W=S),B&&(W=jsx(Bt,{content:B})),jsx(Ht,{...{id:o,anchorId:d,anchorSelect:h,className:E,classNameArrow:v,content:W,contentWrapperRef:bt,place:Lt,variant:Tt,offset:kt,wrapper:_t,events:at,openOnClick:y,positionStrategy:pt,middlewares:tt,delayShow:D,delayHide:ht,float:Et,noArrow:ot,clickable:rt,closeOnEsc:nt,style:J,position:I,isOpen:U,setIsOpen:it,afterShow:H,afterHide:lt,activeAnchor:P,setActiveAnchor:T=>O(T)}})},Vt=_e;

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "/* src/tokens.css */\n:root {\n  --rt-color-white: #fff;\n  --rt-color-dark: #222;\n  --rt-color-success: #8dc572;\n  --rt-color-error: #be6464;\n  --rt-color-warning: #f0ad4e;\n  --rt-color-info: #337ab7;\n  --rt-opacity: 0.9;\n}\n\n/* esbuild-css-modules-plugin-namespace:./src/components/Tooltip/styles.module.css?esbuild-css-modules-plugin-built */\n.react-tooltip__tooltip_KtSkBq {\n  visibility: hidden;\n  width: max-content;\n  pointer-events: none;\n  opacity: 0;\n  will-change: opacity, visibility;\n  border-radius: 3px;\n  padding: 8px 16px;\n  font-size: 90%;\n  transition: opacity .3s ease-out;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.react-tooltip__fixed_KtSkBq {\n  position: fixed;\n}\n.react-tooltip__arrow_KtSkBq {\n  background: inherit;\n  width: 8px;\n  height: 8px;\n  position: absolute;\n  transform: rotate(45deg);\n}\n.react-tooltip__no-arrow_KtSkBq {\n  display: none;\n}\n.react-tooltip__clickable_KtSkBq {\n  pointer-events: auto;\n}\n.react-tooltip__show_KtSkBq {\n  visibility: visible;\n  opacity: var(--rt-opacity);\n}\n.react-tooltip__dark_KtSkBq {\n  background: var(--rt-color-dark);\n  color: var(--rt-color-white);\n}\n.react-tooltip__light_KtSkBq {\n  background-color: var(--rt-color-white);\n  color: var(--rt-color-dark);\n}\n.react-tooltip__success_KtSkBq {\n  background-color: var(--rt-color-success);\n  color: var(--rt-color-white);\n}\n.react-tooltip__warning_KtSkBq {\n  background-color: var(--rt-color-warning);\n  color: var(--rt-color-white);\n}\n.react-tooltip__error_KtSkBq {\n  background-color: var(--rt-color-error);\n  color: var(--rt-color-white);\n}\n.react-tooltip__info_KtSkBq {\n  background-color: var(--rt-color-info);\n  color: var(--rt-color-white);\n}\n";
styleInject(css_248z);

const useOnClickOutside = (ref, handler) => {
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                handler(event);
            }
        };
        document?.addEventListener('click', handleClickOutside, true);
        document?.addEventListener('mousedown', handleClickOutside, true);
        document?.addEventListener('touchstart', handleClickOutside, true);
        return () => {
            document?.removeEventListener('click', handleClickOutside, true);
            document?.removeEventListener('mousedown', handleClickOutside, true);
            document?.removeEventListener('touchstart', handleClickOutside, true);
        };
    }, [ref, handler]);
};

const ZIndex = {
    /*
      LEVEL 0
      Turntable: Nothing, this is below the data table
    */
    level0: 0,
    /*
      LEVEL 100
      Spaces: ContentContainer (everything to the right of the sidebar), full screen page not found page, sidebar
    */
    level100: 100,
    /*
      LEVEL 200
      Turntable: Cells and cell outlines
      Spaces: Sidebar collapse/expand button
    */
    level200: 200,
    /*
      LEVEL 300
      Turntable: Cell tooltips
    */
    level300: 300,
    /*
      LEVEL 400
      Turntable: Cell inner
    */
    level400: 400,
    /*
      LEVEL 500
      Turntable: Cell editors
    */
    level500: 500,
    /*
      LEVEL 600
      Turntable: Pinned columns
    */
    level600: 600,
    /*
      LEVEL 700
      Turntable: Column Headers
    */
    level700: 700,
    /*
      LEVEL 800
      Turntable: Index corner cell
      Spaces: 'Add data' overlay for empty table
    */
    level800: 800,
    /*
      LEVEL 900
      Turntable: Toolbar
     */
    level900: 900,
    /*
      LEVEL 1000
      Turntable: nothing, this should be above the data table
      Spaces: Jobs panel, tooltips
      Design system: context menus, dropdowns, popovers,
     */
    level1000: 1000,
    /*
      LEVEL 1100
      Turntable: nothing, this should be above the data table
      Spaces: File upload overlay
     */
    level1100: 1100,
    /*
      LEVEL 1200
      Turntable: nothing, this should be above the data table
      Spaces: File => workbook flow (workbook selection, mapping etc), modals
     */
    level1200: 1200,
};

const AMP_TOOLTIP_ID = 'amp-tooltip-4242911';
// Props need to be declared explicitly outside of ITooltip
// or Storybook won't pick them up. For some reason it's also
// necessary to refresh the Storybook page to see changes to float
// For more props info see https://react-tooltip.com/docs/options
const tooltipStyles = css `
  ${getFont('b1')}

  overflow-wrap: break-word;
  white-space: pre-wrap;
  background-color: ${Colors$1.MidnightBrand};
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px;
  z-index: ${ZIndex.level1200};
`;
const StyledTooltip = styled(Vt) `
  ${tooltipStyles}
  max-width: ${({ $maxWidth }) => $maxWidth}px;
`;
const StyledActionsTooltip$1 = styled(Vt) `
  background-color: ${Colors$1.MidnightBrand};
  padding: 0;
`;
const TooltipContent = styled.div `
  ${tooltipStyles}
  max-width: ${({ $maxWidth }) => $maxWidth}px;
`;
const AMPWrapper = ({ children }) => {
    return (jsxs(Fragment, { children: [children, jsx(Tooltip, { id: AMP_TOOLTIP_ID })] }));
};
const Tooltip = ({ place = 'top', float = false, offset = 20, $maxWidth = 296, ...props }) => {
    return (jsx(StyledTooltip, { className: 'amp-tooltip', "$maxWidth": $maxWidth, delayShow: 60, float: float, place: place, ...props }));
};
const ActionsContainer = styled.div `
  display: flex;
  gap: 12px;

  .action-text {
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
`;
const ActionsTooltip = ({ actions, children, text, $maxWidth = 296, ...otherProps }) => {
    const tooltipRef = useRef(null);
    const timeoutRef = useRef();
    const [isOpen, setIsOpen] = useState(false);
    const closeTooltip = () => {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = undefined;
        setIsOpen(false);
    };
    const openTooltip = () => {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = undefined;
        setIsOpen(true);
        timeoutRef.current = setTimeout(closeTooltip, 3000);
    };
    const sharedId = `tooltip-${Math.random()}`;
    useOnClickOutside(tooltipRef, closeTooltip);
    return (jsxs("div", { "data-tooltip-id": sharedId, onMouseEnter: openTooltip, onClick: closeTooltip, ref: tooltipRef, children: [children, jsx(StyledActionsTooltip$1, { clickable: true, id: sharedId, isOpen: isOpen, ...otherProps, children: jsxs(TooltipContent, { "data-testid": 'actions-tooltip-content', "$maxWidth": $maxWidth, children: [text, jsx(ActionsContainer, { children: actions.map((action, i) => (jsx(Typography, { type: 'actionMd', color: Colors$1.Electric300, onClick: () => {
                                    action.onClick();
                                    closeTooltip();
                                }, className: 'action-text', children: action.text }, i))) })] }) })] }));
};

const getFocusOutline = (color) => {
    return css `
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05), 0px 0px 0px 2px ${Colors$1.White},
      0px 0px 0px 4px ${color};
  `;
};

const getButtonStyles = ({ variant, isFocusVisible, isHovered, isPressed, }) => {
    switch (variant) {
        case 'primary':
            return css `
        background-color: ${Colors$1.Electric700};
        border: none;
        color: ${Colors$1.White};

        ${isHovered &&
                css `
            background-color: ${Colors$1.ElectricBrand};
          `}

        ${isPressed &&
                css `
            background-color: ${Colors$1.Electric900};
          `}

        ${isFocusVisible && getFocusOutline(Colors$1.Electric600)}}

        .button-text {
          color: ${Colors$1.White};
        }
      `;
        case 'secondary':
            return css `
        background-color: ${Colors$1.Electric100};
        border: none;
        color: ${Colors$1.ElectricBrand};

        ${isHovered &&
                css `
            background-color: ${Colors$1.Electric300};
          `}

        ${isPressed &&
                css `
            background-color: ${Colors$1.Electric400};
          `}

        ${isFocusVisible && getFocusOutline(Colors$1.Electric600)}}

        .button-text {
          color: ${Colors$1.ElectricBrand};
        }
      `;
        case 'tertiary':
            return css `
        background-color: transparent;
        border: none;
        color: ${Colors$1.Pigeon800};

        ${isHovered &&
                css `
            background-color: ${Colors$1.Pigeon100};
          `}

        ${isPressed &&
                css `
            background-color: ${Colors$1.Pigeon200};
          `}

        ${isFocusVisible && getFocusOutline(Colors$1.MidnightBrand)}}

        .button-text {
          color: ${Colors$1.Pigeon800};
        }
      `;
        case 'tertiary-border':
            return css `
          background-color: ${Colors$1.White};
          border: 1px solid ${Colors$1.Pigeon400};
  
          ${isHovered &&
                css `
              background-color: ${Colors$1.Pigeon100};
            `}
  
          ${isPressed &&
                css `
              background-color: ${Colors$1.Pigeon200};
            `}
  
          ${isFocusVisible && getFocusOutline(Colors$1.Electric600)}}
        `;
        case 'tertiary-border-green':
            return css `
            border-radius: 0;
            background-color: ${Colors$1.White};
            border: 1px solid ${Colors$1.Jade800};
            color: ${Colors$1.Jade800};
            & svg {
              fill: ${Colors$1.Jade800};
            }
            ${isHovered &&
                css `
                background-color: ${Colors$1.Jade100};
                border-color: ${Colors$1.Jade800};
              `}
    
            ${isPressed &&
                css `
                background-color: ${Colors$1.Jade200};
              `}
    
            ${isFocusVisible && getFocusOutline(Colors$1.Electric600)}}
          `;
        case 'ghost':
            return css `
        background-color: transparent;
        border: none;
        color: ${Colors$1.Electric700};

        ${isHovered &&
                css `
            background-color: ${Colors$1.Pigeon100};
          `}

        ${isPressed &&
                css `
            background-color: ${Colors$1.Pigeon200};
          `}

        ${isFocusVisible && getFocusOutline(Colors$1.Electric600)}}

        .button-text {
          color: ${Colors$1.Electric700};
        }
      `;
        case 'warning':
            return css `
        background-color: ${Colors$1.Pinata900};
        border: none;
        color: ${Colors$1.White};

        ${isHovered &&
                css `
          background-color: ${Colors$1.Pinata700};
        `}

        ${isPressed &&
                css `
          background-color: ${Colors$1.Pinata800};
        `}

          ${isFocusVisible && getFocusOutline(Colors$1.Pinata900)}

          .button-text {
          color: ${Colors$1.White};
        }
      `;
        case 'warning-ghost':
            return css `
            background-color: transparent;
            border: none;
            color: ${Colors$1.Pinata700};

            ${isHovered &&
                css `
                background-color: ${Colors$1.Pigeon100};
              `}

            ${isPressed &&
                css `
                background-color: ${Colors$1.Pigeon200};
              `}

            ${isFocusVisible && getFocusOutline(Colors$1.Pinata600)}}

            .button-text {
              color: ${Colors$1.Pinata700};
            }
          `;
        case 'confirm-ghost':
            return css `
                background-color: transparent;
                border: none;
                color: ${Colors$1.Jade800};

                ${isHovered &&
                css `
                    background-color: ${Colors$1.Pigeon100};
                  `}

                ${isPressed &&
                css `
                    background-color: ${Colors$1.Pigeon200};
                  `}

                ${isFocusVisible && getFocusOutline(Colors$1.Jade800)}}

                .button-text {
                  color: ${Colors$1.Jade800};
                }
              `;
        case 'code-snippet':
            return css `
        background-color: transparent;
        border: none;
        color: ${Colors$1.White};

        ${isHovered &&
                css `
            background-color: ${Colors$1.Midnight600};
          `}

        ${isPressed &&
                css `
            background-color: ${Colors$1.Midnight700};
          `}

        ${isFocusVisible && getFocusOutline(Colors$1.White)}}

        .button-text {
          color: ${Colors$1.White};
        }
      `;
    }
};
const getButtonSizing = (size) => {
    switch (size) {
        case 'xs':
            return css `
        height: 20px;
        min-width: 64px;
        padding: 2px 8px;
      `;
        case 'sm':
            return css `
        height: 32px;
        min-width: 80px;
        padding: 8px 12px;
      `;
        case 'md':
            return css `
        height: 40px;
        min-width: 96px;
        padding: 8px 12px;
      `;
        case 'lg':
            return css `
        height: 48px;
        min-width: 104px;
        padding: 8px 12px;
      `;
    }
};

const iconSizeLookup = {
    xs: 16,
    sm: 16,
    md: 24,
    lg: 32,
};
const typographyLookup = {
    xs: 'actionXs',
    sm: 'actionSm',
    md: 'actionMd',
    lg: 'actionLg',
};
const baseButtonStyles = css `
  align-items: center;
  box-sizing: border-box;
  display: flex;
  gap: 8px;
  justify-content: center;
  max-width: 240px;
`;
const StyledButton$1 = styled.button `
  ${({ variant, isFocusVisible, isHovered, isPressed }) => getButtonStyles({ variant, isFocusVisible, isHovered, isPressed })}
  ${({ size }) => getButtonSizing(size)}

  ${baseButtonStyles}

  border-radius: 2px;
  cursor: pointer;
  outline: none;
  transition: background-color 0.2s ease;

  ${({ fullWidth }) => fullWidth &&
    `
    max-width: none;
    width: 100%;
  `}

  ${({ isDisabled }) => isDisabled &&
    css `
      opacity: 50%;
      pointer-events: none;
    `}
`;
const Button = ({ variant = 'primary', isDisabled = false, iconLeft, iconRight, iconSize, label, fullWidth, loading = false, size = 'md', ...otherProps }) => {
    const ref = useRef(null);
    const isDisabledOrLoading = isDisabled || loading;
    const { buttonProps } = $701a24aa0da5b062$export$ea18c227d4417cc3({ ...otherProps, isDisabled: isDisabledOrLoading }, ref);
    const { pressProps, isPressed } = $f6c31cce2adf654f$export$45712eceda6fad21({
        ...otherProps,
        isDisabled,
        ref,
    });
    const { hoverProps, isHovered } = $6179b936705e76d3$export$ae780daf29e6d456({
        isDisabled: isDisabledOrLoading,
    });
    const { isFocusVisible, focusProps } = $f7dceffc5ad7768b$export$4e328f61c538687f();
    const combinedProps = {
        ...buttonProps,
        ...focusProps,
        ...hoverProps,
        ...pressProps,
    };
    const buttonSize = size;
    const buttonIconSize = (iconSize ?? iconSizeLookup[buttonSize]);
    const tooltipContent = isDisabled
        ? otherProps?.tooltip?.disabled
        : otherProps?.tooltip?.active;
    const ButtonComponent = (jsxs(StyledButton$1, { className: classnames$1('styled-button', ...[variant]), variant: variant, isDisabled: isDisabledOrLoading, isFocusVisible: isFocusVisible, isHovered: isHovered, isPressed: isPressed, size: size, fullWidth: fullWidth, ...combinedProps, children: [!!iconLeft && (jsx(Icon, { name: iconLeft, size: buttonIconSize, "data-testid": 'icon-left' })), jsx(Typography, { className: 'button-text', truncate: true, type: typographyLookup[buttonSize], children: label }), !!iconRight && !loading && (jsx(Icon, { name: iconRight, size: buttonIconSize, "data-testid": 'icon-right' })), loading && (jsx(Spinner, { color: Colors$1.ElectricBrand, size: buttonIconSize }))] }));
    if (!tooltipContent) {
        return ButtonComponent;
    }
    return (jsx("div", { "data-tooltip-id": AMP_TOOLTIP_ID, "data-tooltip-content": tooltipContent, children: ButtonComponent }));
};

const ButtonRow$1 = styled.div `
  display: flex;
  gap: 4px;
  align-items: center;
  margin-bottom: 1em;

  ${({ centered }) => centered &&
    css `
      justify-content: center;
    `}
`;

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $e40ea825a81a3709$export$52baac22726c72bf extends Set {
    constructor(keys, anchorKey, currentKey){
        super(keys);
        if (keys instanceof $e40ea825a81a3709$export$52baac22726c72bf) {
            this.anchorKey = anchorKey || keys.anchorKey;
            this.currentKey = currentKey || keys.currentKey;
        } else {
            this.anchorKey = anchorKey;
            this.currentKey = currentKey;
        }
    }
}



function $7af3f5b51489e0b5$var$equalSets(setA, setB) {
    if (setA.size !== setB.size) return false;
    for (let item of setA){
        if (!setB.has(item)) return false;
    }
    return true;
}
function $7af3f5b51489e0b5$export$253fe78d46329472(props) {
    let { selectionMode: selectionMode = "none" , disallowEmptySelection: disallowEmptySelection , allowDuplicateSelectionEvents: allowDuplicateSelectionEvents , selectionBehavior: selectionBehaviorProp = "toggle" , disabledBehavior: disabledBehavior = "all"  } = props;
    // We want synchronous updates to `isFocused` and `focusedKey` after their setters are called.
    // But we also need to trigger a react re-render. So, we have both a ref (sync) and state (async).
    let isFocusedRef = (useRef)(false);
    let [, setFocused] = (useState)(false);
    let focusedKeyRef = (useRef)(null);
    let childFocusStrategyRef = (useRef)(null);
    let [, setFocusedKey] = (useState)(null);
    let selectedKeysProp = (useMemo)(()=>$7af3f5b51489e0b5$var$convertSelection(props.selectedKeys), [
        props.selectedKeys
    ]);
    let defaultSelectedKeys = (useMemo)(()=>$7af3f5b51489e0b5$var$convertSelection(props.defaultSelectedKeys, new ($e40ea825a81a3709$export$52baac22726c72bf)()), [
        props.defaultSelectedKeys
    ]);
    let [selectedKeys, setSelectedKeys] = ($458b0a5536c1a7cf$export$40bfa8c7b0832715)(selectedKeysProp, defaultSelectedKeys, props.onSelectionChange);
    let disabledKeysProp = (useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let [selectionBehavior, setSelectionBehavior] = (useState)(selectionBehaviorProp);
    // If the selectionBehavior prop is set to replace, but the current state is toggle (e.g. due to long press
    // to enter selection mode on touch), and the selection becomes empty, reset the selection behavior.
    if (selectionBehaviorProp === "replace" && selectionBehavior === "toggle" && typeof selectedKeys === "object" && selectedKeys.size === 0) setSelectionBehavior("replace");
    // If the selectionBehavior prop changes, update the state as well.
    let lastSelectionBehavior = (useRef)(selectionBehaviorProp);
    (useEffect)(()=>{
        if (selectionBehaviorProp !== lastSelectionBehavior.current) {
            setSelectionBehavior(selectionBehaviorProp);
            lastSelectionBehavior.current = selectionBehaviorProp;
        }
    }, [
        selectionBehaviorProp
    ]);
    return {
        selectionMode: selectionMode,
        disallowEmptySelection: disallowEmptySelection,
        selectionBehavior: selectionBehavior,
        setSelectionBehavior: setSelectionBehavior,
        get isFocused () {
            return isFocusedRef.current;
        },
        setFocused (f) {
            isFocusedRef.current = f;
            setFocused(f);
        },
        get focusedKey () {
            return focusedKeyRef.current;
        },
        get childFocusStrategy () {
            return childFocusStrategyRef.current;
        },
        setFocusedKey (k, childFocusStrategy = "first") {
            focusedKeyRef.current = k;
            childFocusStrategyRef.current = childFocusStrategy;
            setFocusedKey(k);
        },
        selectedKeys: selectedKeys,
        setSelectedKeys (keys) {
            if (allowDuplicateSelectionEvents || !$7af3f5b51489e0b5$var$equalSets(keys, selectedKeys)) setSelectedKeys(keys);
        },
        disabledKeys: disabledKeysProp,
        disabledBehavior: disabledBehavior
    };
}
function $7af3f5b51489e0b5$var$convertSelection(selection, defaultValue) {
    if (!selection) return defaultValue;
    return selection === "all" ? "all" : new ($e40ea825a81a3709$export$52baac22726c72bf)(selection);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
class $d496c0a20b6e58ec$export$6c8a5aaad13c9852 {
    /**
   * The type of selection that is allowed in the collection.
   */ get selectionMode() {
        return this.state.selectionMode;
    }
    /**
   * Whether the collection allows empty selection.
   */ get disallowEmptySelection() {
        return this.state.disallowEmptySelection;
    }
    /**
   * The selection behavior for the collection.
   */ get selectionBehavior() {
        return this.state.selectionBehavior;
    }
    /**
   * Sets the selection behavior for the collection.
   */ setSelectionBehavior(selectionBehavior) {
        this.state.setSelectionBehavior(selectionBehavior);
    }
    /**
   * Whether the collection is currently focused.
   */ get isFocused() {
        return this.state.isFocused;
    }
    /**
   * Sets whether the collection is focused.
   */ setFocused(isFocused) {
        this.state.setFocused(isFocused);
    }
    /**
   * The current focused key in the collection.
   */ get focusedKey() {
        return this.state.focusedKey;
    }
    /** Whether the first or last child of the focused key should receive focus. */ get childFocusStrategy() {
        return this.state.childFocusStrategy;
    }
    /**
   * Sets the focused key.
   */ setFocusedKey(key, childFocusStrategy) {
        if (key == null || this.collection.getItem(key)) this.state.setFocusedKey(key, childFocusStrategy);
    }
    /**
   * The currently selected keys in the collection.
   */ get selectedKeys() {
        return this.state.selectedKeys === "all" ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
    }
    /**
   * The raw selection value for the collection.
   * Either 'all' for select all, or a set of keys.
   */ get rawSelection() {
        return this.state.selectedKeys;
    }
    /**
   * Returns whether a key is selected.
   */ isSelected(key) {
        if (this.state.selectionMode === "none") return false;
        key = this.getKey(key);
        return this.state.selectedKeys === "all" ? this.canSelectItem(key) : this.state.selectedKeys.has(key);
    }
    /**
   * Whether the selection is empty.
   */ get isEmpty() {
        return this.state.selectedKeys !== "all" && this.state.selectedKeys.size === 0;
    }
    /**
   * Whether all items in the collection are selected.
   */ get isSelectAll() {
        if (this.isEmpty) return false;
        if (this.state.selectedKeys === "all") return true;
        if (this._isSelectAll != null) return this._isSelectAll;
        let allKeys = this.getSelectAllKeys();
        let selectedKeys = this.state.selectedKeys;
        this._isSelectAll = allKeys.every((k)=>selectedKeys.has(k));
        return this._isSelectAll;
    }
    get firstSelectedKey() {
        let first = null;
        for (let key of this.state.selectedKeys){
            let item = this.collection.getItem(key);
            if (!first || (item === null || item === void 0 ? void 0 : item.index) < first.index) first = item;
        }
        return first === null || first === void 0 ? void 0 : first.key;
    }
    get lastSelectedKey() {
        let last = null;
        for (let key of this.state.selectedKeys){
            let item = this.collection.getItem(key);
            if (!last || (item === null || item === void 0 ? void 0 : item.index) > last.index) last = item;
        }
        return last === null || last === void 0 ? void 0 : last.key;
    }
    get disabledKeys() {
        return this.state.disabledKeys;
    }
    get disabledBehavior() {
        return this.state.disabledBehavior;
    }
    /**
   * Extends the selection to the given key.
   */ extendSelection(toKey) {
        if (this.selectionMode === "none") return;
        if (this.selectionMode === "single") {
            this.replaceSelection(toKey);
            return;
        }
        toKey = this.getKey(toKey);
        let selection;
        // Only select the one key if coming from a select all.
        if (this.state.selectedKeys === "all") selection = new ($e40ea825a81a3709$export$52baac22726c72bf)([
            toKey
        ], toKey, toKey);
        else {
            let selectedKeys = this.state.selectedKeys;
            let anchorKey = selectedKeys.anchorKey || toKey;
            selection = new ($e40ea825a81a3709$export$52baac22726c72bf)(selectedKeys, anchorKey, toKey);
            for (let key of this.getKeyRange(anchorKey, selectedKeys.currentKey || toKey))selection.delete(key);
            for (let key1 of this.getKeyRange(toKey, anchorKey))if (this.canSelectItem(key1)) selection.add(key1);
        }
        this.state.setSelectedKeys(selection);
    }
    getKeyRange(from, to) {
        let fromItem = this.collection.getItem(from);
        let toItem = this.collection.getItem(to);
        if (fromItem && toItem) {
            if (fromItem.index <= toItem.index) return this.getKeyRangeInternal(from, to);
            return this.getKeyRangeInternal(to, from);
        }
        return [];
    }
    getKeyRangeInternal(from, to) {
        let keys = [];
        let key = from;
        while(key){
            let item = this.collection.getItem(key);
            if (item && item.type === "item" || item.type === "cell" && this.allowsCellSelection) keys.push(key);
            if (key === to) return keys;
            key = this.collection.getKeyAfter(key);
        }
        return [];
    }
    getKey(key) {
        let item = this.collection.getItem(key);
        if (!item) // ¯\_(ツ)_/¯
        return key;
        // If cell selection is allowed, just return the key.
        if (item.type === "cell" && this.allowsCellSelection) return key;
        // Find a parent item to select
        while(item.type !== "item" && item.parentKey != null)item = this.collection.getItem(item.parentKey);
        if (!item || item.type !== "item") return null;
        return item.key;
    }
    /**
   * Toggles whether the given key is selected.
   */ toggleSelection(key) {
        if (this.selectionMode === "none") return;
        if (this.selectionMode === "single" && !this.isSelected(key)) {
            this.replaceSelection(key);
            return;
        }
        key = this.getKey(key);
        if (key == null) return;
        let keys = new ($e40ea825a81a3709$export$52baac22726c72bf)(this.state.selectedKeys === "all" ? this.getSelectAllKeys() : this.state.selectedKeys);
        if (keys.has(key)) keys.delete(key);
        else if (this.canSelectItem(key)) {
            keys.add(key);
            keys.anchorKey = key;
            keys.currentKey = key;
        }
        if (this.disallowEmptySelection && keys.size === 0) return;
        this.state.setSelectedKeys(keys);
    }
    /**
   * Replaces the selection with only the given key.
   */ replaceSelection(key) {
        if (this.selectionMode === "none") return;
        key = this.getKey(key);
        if (key == null) return;
        let selection = this.canSelectItem(key) ? new ($e40ea825a81a3709$export$52baac22726c72bf)([
            key
        ], key, key) : new ($e40ea825a81a3709$export$52baac22726c72bf)();
        this.state.setSelectedKeys(selection);
    }
    /**
   * Replaces the selection with the given keys.
   */ setSelectedKeys(keys) {
        if (this.selectionMode === "none") return;
        let selection = new ($e40ea825a81a3709$export$52baac22726c72bf)();
        for (let key of keys){
            key = this.getKey(key);
            if (key != null) {
                selection.add(key);
                if (this.selectionMode === "single") break;
            }
        }
        this.state.setSelectedKeys(selection);
    }
    getSelectAllKeys() {
        let keys = [];
        let addKeys = (key)=>{
            while(key){
                if (this.canSelectItem(key)) {
                    let item = this.collection.getItem(key);
                    if (item.type === "item") keys.push(key);
                    // Add child keys. If cell selection is allowed, then include item children too.
                    if (item.hasChildNodes && (this.allowsCellSelection || item.type !== "item")) addKeys([
                        ...item.childNodes
                    ][0].key);
                }
                key = this.collection.getKeyAfter(key);
            }
        };
        addKeys(this.collection.getFirstKey());
        return keys;
    }
    /**
   * Selects all items in the collection.
   */ selectAll() {
        if (this.selectionMode === "multiple") this.state.setSelectedKeys("all");
    }
    /**
   * Removes all keys from the selection.
   */ clearSelection() {
        if (!this.disallowEmptySelection && (this.state.selectedKeys === "all" || this.state.selectedKeys.size > 0)) this.state.setSelectedKeys(new ($e40ea825a81a3709$export$52baac22726c72bf)());
    }
    /**
   * Toggles between select all and an empty selection.
   */ toggleSelectAll() {
        if (this.isSelectAll) this.clearSelection();
        else this.selectAll();
    }
    select(key, e) {
        if (this.selectionMode === "none") return;
        if (this.selectionMode === "single") {
            if (this.isSelected(key) && !this.disallowEmptySelection) this.toggleSelection(key);
            else this.replaceSelection(key);
        } else if (this.selectionBehavior === "toggle" || e && (e.pointerType === "touch" || e.pointerType === "virtual")) // if touch or virtual (VO) then we just want to toggle, otherwise it's impossible to multi select because they don't have modifier keys
        this.toggleSelection(key);
        else this.replaceSelection(key);
    }
    /**
   * Returns whether the current selection is equal to the given selection.
   */ isSelectionEqual(selection) {
        if (selection === this.state.selectedKeys) return true;
        // Check if the set of keys match.
        let selectedKeys = this.selectedKeys;
        if (selection.size !== selectedKeys.size) return false;
        for (let key of selection){
            if (!selectedKeys.has(key)) return false;
        }
        for (let key1 of selectedKeys){
            if (!selection.has(key1)) return false;
        }
        return true;
    }
    canSelectItem(key) {
        if (this.state.selectionMode === "none" || this.state.disabledKeys.has(key)) return false;
        let item = this.collection.getItem(key);
        if (!item || item.type === "cell" && !this.allowsCellSelection) return false;
        return true;
    }
    isDisabled(key) {
        return this.state.disabledKeys.has(key) && this.state.disabledBehavior === "all";
    }
    constructor(collection, state, options){
        this.collection = collection;
        this.state = state;
        var _options_allowsCellSelection;
        this.allowsCellSelection = (_options_allowsCellSelection = options === null || options === void 0 ? void 0 : options.allowsCellSelection) !== null && _options_allowsCellSelection !== void 0 ? _options_allowsCellSelection : false;
        this._isSelectAll = null;
    }
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
let $a02d57049d202695$var$_Symbol_iterator = Symbol.iterator;
class $a02d57049d202695$export$d085fb9e920b5ca7 {
    *[$a02d57049d202695$var$_Symbol_iterator]() {
        yield* this.iterable;
    }
    get size() {
        return this.keyMap.size;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        return node ? node.prevKey : null;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        return node ? node.nextKey : null;
    }
    getFirstKey() {
        return this.firstKey;
    }
    getLastKey() {
        return this.lastKey;
    }
    getItem(key) {
        return this.keyMap.get(key);
    }
    at(idx) {
        const keys = [
            ...this.getKeys()
        ];
        return this.getItem(keys[idx]);
    }
    constructor(nodes){
        (_defineProperty)(this, "keyMap", new Map());
        this.iterable = nodes;
        let visit = (node)=>{
            this.keyMap.set(node.key, node);
            if (node.childNodes && node.type === "section") for (let child of node.childNodes)visit(child);
        };
        for (let node of nodes)visit(node);
        let last;
        let index = 0;
        for (let [key, node1] of this.keyMap){
            if (last) {
                last.nextKey = key;
                node1.prevKey = last.key;
            } else {
                this.firstKey = key;
                node1.prevKey = undefined;
            }
            if (node1.type === "item") node1.index = index++;
            last = node1;
            // Set nextKey as undefined since this might be the last node
            // If it isn't the last node, last.nextKey will properly set at start of new loop
            last.nextKey = undefined;
        }
        this.lastKey = last === null || last === void 0 ? void 0 : last.key;
    }
}




function $e72dd72e1c76a225$export$2f645645f7bca764(props) {
    let { filter: filter  } = props;
    let selectionState = ($7af3f5b51489e0b5$export$253fe78d46329472)(props);
    let disabledKeys = (useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let factory = (nodes)=>filter ? new ($a02d57049d202695$export$d085fb9e920b5ca7)(filter(nodes)) : new ($a02d57049d202695$export$d085fb9e920b5ca7)(nodes);
    let context = (useMemo)(()=>({
            suppressTextValueWarning: props.suppressTextValueWarning
        }), [
        props.suppressTextValueWarning
    ]);
    let collection = ($7613b1592d41b092$export$6cd28814d92fa9c9)(props, factory, context, [
        filter
    ]);
    // Reset focused key if that item is deleted from the collection.
    (useEffect)(()=>{
        if (selectionState.focusedKey != null && !collection.getItem(selectionState.focusedKey)) selectionState.setFocusedKey(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        collection,
        selectionState.focusedKey
    ]);
    return {
        collection: collection,
        disabledKeys: disabledKeys,
        selectionManager: new ($d496c0a20b6e58ec$export$6c8a5aaad13c9852)(collection, selectionState)
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


function $a0d645289fe9b86b$export$e7f05e985daf4b5f(props) {
    var _props_defaultSelectedKey;
    let [selectedKey, setSelectedKey] = ($458b0a5536c1a7cf$export$40bfa8c7b0832715)(props.selectedKey, (_props_defaultSelectedKey = props.defaultSelectedKey) !== null && _props_defaultSelectedKey !== void 0 ? _props_defaultSelectedKey : null, props.onSelectionChange);
    let selectedKeys = (useMemo)(()=>selectedKey != null ? [
            selectedKey
        ] : [], [
        selectedKey
    ]);
    let { collection: collection , disabledKeys: disabledKeys , selectionManager: selectionManager  } = ($e72dd72e1c76a225$export$2f645645f7bca764)({
        ...props,
        selectionMode: "single",
        disallowEmptySelection: true,
        allowDuplicateSelectionEvents: true,
        selectedKeys: selectedKeys,
        onSelectionChange: (keys)=>{
            let key = keys.values().next().value;
            // Always fire onSelectionChange, even if the key is the same
            // as the current key (useControlledState does not).
            if (key === selectedKey && props.onSelectionChange) props.onSelectionChange(key);
            setSelectedKey(key);
        }
    });
    let selectedItem = selectedKey != null ? collection.getItem(selectedKey) : null;
    return {
        collection: collection,
        disabledKeys: disabledKeys,
        selectionManager: selectionManager,
        selectedKey: selectedKey,
        setSelectedKey: setSelectedKey,
        selectedItem: selectedItem
    };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
function $fc909762b330b746$export$61c6a8c84e605fb6(props) {
    let [isOpen, setOpen] = ($458b0a5536c1a7cf$export$40bfa8c7b0832715)(props.isOpen, props.defaultOpen || false, props.onOpenChange);
    return {
        isOpen: isOpen,
        setOpen: setOpen,
        open () {
            setOpen(true);
        },
        close () {
            setOpen(false);
        },
        toggle () {
            setOpen(!isOpen);
        }
    };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

function $a28c903ee9ad8dc5$export$79fefeb1c2091ac3(props) {
    let overlayTriggerState = ($fc909762b330b746$export$61c6a8c84e605fb6)(props);
    let [focusStrategy, setFocusStrategy] = (useState)(null);
    return {
        focusStrategy: focusStrategy,
        ...overlayTriggerState,
        open (focusStrategy = null) {
            setFocusStrategy(focusStrategy);
            overlayTriggerState.open();
        },
        toggle (focusStrategy = null) {
            setFocusStrategy(focusStrategy);
            overlayTriggerState.toggle();
        }
    };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 * 
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 



function $a9e7382a7d111cb5$export$b453a3bfd4a5fa9e(props) {
    var _collection_getItem;
    let { defaultFilter: defaultFilter , menuTrigger: menuTrigger = "input" , allowsEmptyCollection: allowsEmptyCollection = false , allowsCustomValue: allowsCustomValue , shouldCloseOnBlur: shouldCloseOnBlur = true  } = props;
    let [showAllItems, setShowAllItems] = (useState)(false);
    let [isFocused, setFocusedState] = (useState)(false);
    var _props_defaultInputValue;
    let [inputValue, setInputValue] = ($458b0a5536c1a7cf$export$40bfa8c7b0832715)(props.inputValue, (_props_defaultInputValue = props.defaultInputValue) !== null && _props_defaultInputValue !== void 0 ? _props_defaultInputValue : "", props.onInputChange);
    let onSelectionChange = (key)=>{
        if (props.onSelectionChange) props.onSelectionChange(key);
        // If key is the same, reset the inputValue and close the menu
        // (scenario: user clicks on already selected option)
        if (key === selectedKey) {
            resetInputValue();
            triggerState.close();
        }
    };
    var _props_items;
    let { collection: collection , selectionManager: selectionManager , selectedKey: selectedKey , setSelectedKey: setSelectedKey , selectedItem: selectedItem , disabledKeys: disabledKeys  } = ($a0d645289fe9b86b$export$e7f05e985daf4b5f)({
        ...props,
        onSelectionChange: onSelectionChange,
        items: (_props_items = props.items) !== null && _props_items !== void 0 ? _props_items : props.defaultItems
    });
    // Preserve original collection so we can show all items on demand
    let originalCollection = collection;
    let filteredCollection = (useMemo)(()=>// No default filter if items are controlled.
        props.items != null || !defaultFilter ? collection : $a9e7382a7d111cb5$var$filterCollection(collection, inputValue, defaultFilter), [
        collection,
        inputValue,
        defaultFilter,
        props.items
    ]);
    // Track what action is attempting to open the menu
    let menuOpenTrigger = (useRef)("focus");
    let onOpenChange = (open)=>{
        if (props.onOpenChange) props.onOpenChange(open, open ? menuOpenTrigger.current : undefined);
    };
    let triggerState = ($a28c903ee9ad8dc5$export$79fefeb1c2091ac3)({
        ...props,
        onOpenChange: onOpenChange,
        isOpen: undefined,
        defaultOpen: undefined
    });
    let open = (focusStrategy, trigger)=>{
        let displayAllItems = trigger === "manual" || trigger === "focus" && menuTrigger === "focus";
        // Prevent open operations from triggering if there is nothing to display
        // Also prevent open operations from triggering if items are uncontrolled but defaultItems is empty, even if displayAllItems is true.
        // This is to prevent comboboxes with empty defaultItems from opening but allow controlled items comboboxes to open even if the inital list is empty (assumption is user will provide swap the empty list with a base list via onOpenChange returning `menuTrigger` manual)
        if (allowsEmptyCollection || filteredCollection.size > 0 || displayAllItems && originalCollection.size > 0 || props.items) {
            if (displayAllItems && !triggerState.isOpen && props.items === undefined) // Show all items if menu is manually opened. Only care about this if items are undefined
            setShowAllItems(true);
            menuOpenTrigger.current = trigger;
            triggerState.open(focusStrategy);
        }
    };
    let toggle = (focusStrategy, trigger)=>{
        let displayAllItems = trigger === "manual" || trigger === "focus" && menuTrigger === "focus";
        // If the menu is closed and there is nothing to display, early return so toggle isn't called to prevent extraneous onOpenChange
        if (!(allowsEmptyCollection || filteredCollection.size > 0 || displayAllItems && originalCollection.size > 0 || props.items) && !triggerState.isOpen) return;
        if (displayAllItems && !triggerState.isOpen && props.items === undefined) // Show all items if menu is toggled open. Only care about this if items are undefined
        setShowAllItems(true);
        // Only update the menuOpenTrigger if menu is currently closed
        if (!triggerState.isOpen) menuOpenTrigger.current = trigger;
        triggerState.toggle(focusStrategy);
    };
    let lastValue = (useRef)(inputValue);
    let resetInputValue = ()=>{
        var _collection_getItem;
        var _collection_getItem_textValue;
        let itemText = (_collection_getItem_textValue = (_collection_getItem = collection.getItem(selectedKey)) === null || _collection_getItem === void 0 ? void 0 : _collection_getItem.textValue) !== null && _collection_getItem_textValue !== void 0 ? _collection_getItem_textValue : "";
        lastValue.current = itemText;
        setInputValue(itemText);
    };
    let isInitialRender = (useRef)(true);
    var _props_selectedKey, _ref;
    let lastSelectedKey = (useRef)((_ref = (_props_selectedKey = props.selectedKey) !== null && _props_selectedKey !== void 0 ? _props_selectedKey : props.defaultSelectedKey) !== null && _ref !== void 0 ? _ref : null);
    var _collection_getItem_textValue;
    let lastSelectedKeyText = (useRef)((_collection_getItem_textValue = (_collection_getItem = collection.getItem(selectedKey)) === null || _collection_getItem === void 0 ? void 0 : _collection_getItem.textValue) !== null && _collection_getItem_textValue !== void 0 ? _collection_getItem_textValue : "");
    // intentional omit dependency array, want this to happen on every render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (useEffect)(()=>{
        var _collection_getItem;
        // Open and close menu automatically when the input value changes if the input is focused,
        // and there are items in the collection or allowEmptyCollection is true.
        if (isFocused && (filteredCollection.size > 0 || allowsEmptyCollection) && !triggerState.isOpen && inputValue !== lastValue.current && menuTrigger !== "manual") open(null, "input");
        // Close the menu if the collection is empty. Don't close menu if filtered collection size is 0
        // but we are currently showing all items via button press
        if (!showAllItems && !allowsEmptyCollection && triggerState.isOpen && filteredCollection.size === 0) triggerState.close();
        // Close when an item is selected.
        if (selectedKey != null && selectedKey !== lastSelectedKey.current) triggerState.close();
        // Clear focused key when input value changes and display filtered collection again.
        if (inputValue !== lastValue.current) {
            selectionManager.setFocusedKey(null);
            setShowAllItems(false);
            // Set selectedKey to null when the user clears the input.
            // If controlled, this is the application developer's responsibility.
            if (inputValue === "" && (props.inputValue === undefined || props.selectedKey === undefined)) setSelectedKey(null);
        }
        // If it is the intial render and inputValue isn't controlled nor has an intial value, set input to match current selected key if any
        if (isInitialRender.current && props.inputValue === undefined && props.defaultInputValue === undefined) resetInputValue();
        // If the selectedKey changed, update the input value.
        // Do nothing if both inputValue and selectedKey are controlled.
        // In this case, it's the user's responsibility to update inputValue in onSelectionChange.
        if (selectedKey !== lastSelectedKey.current && (props.inputValue === undefined || props.selectedKey === undefined)) resetInputValue();
        else lastValue.current = inputValue;
        var _collection_getItem_textValue;
        // Update the inputValue if the selected item's text changes from its last tracked value.
        // This is to handle cases where a selectedKey is specified but the items aren't available (async loading) or the selected item's text value updates.
        // Only reset if the user isn't currently within the field so we don't erroneously modify user input.
        // If inputValue is controlled, it is the user's responsibility to update the inputValue when items change.
        let selectedItemText = (_collection_getItem_textValue = (_collection_getItem = collection.getItem(selectedKey)) === null || _collection_getItem === void 0 ? void 0 : _collection_getItem.textValue) !== null && _collection_getItem_textValue !== void 0 ? _collection_getItem_textValue : "";
        if (!isFocused && selectedKey != null && props.inputValue === undefined && selectedKey === lastSelectedKey.current) {
            if (lastSelectedKeyText.current !== selectedItemText) {
                lastValue.current = selectedItemText;
                setInputValue(selectedItemText);
            }
        }
        isInitialRender.current = false;
        lastSelectedKey.current = selectedKey;
        lastSelectedKeyText.current = selectedItemText;
    });
    (useEffect)(()=>{
        // Reset focused key when the menu closes
        if (!triggerState.isOpen) selectionManager.setFocusedKey(null);
    }, [
        triggerState.isOpen,
        selectionManager
    ]);
    // Revert input value and close menu
    let revert = ()=>{
        if (allowsCustomValue && selectedKey == null) commitCustomValue();
        else commitSelection();
    };
    let commitCustomValue = ()=>{
        lastSelectedKey.current = null;
        setSelectedKey(null);
        triggerState.close();
    };
    let commitSelection = ()=>{
        // If multiple things are controlled, call onSelectionChange
        if (props.selectedKey !== undefined && props.inputValue !== undefined) {
            var _collection_getItem;
            props.onSelectionChange(selectedKey);
            var _collection_getItem_textValue;
            // Stop menu from reopening from useEffect
            let itemText = (_collection_getItem_textValue = (_collection_getItem = collection.getItem(selectedKey)) === null || _collection_getItem === void 0 ? void 0 : _collection_getItem.textValue) !== null && _collection_getItem_textValue !== void 0 ? _collection_getItem_textValue : "";
            lastValue.current = itemText;
            triggerState.close();
        } else {
            // If only a single aspect of combobox is controlled, reset input value and close menu for the user
            resetInputValue();
            triggerState.close();
        }
    };
    let commit = ()=>{
        if (triggerState.isOpen && selectionManager.focusedKey != null) {
            // Reset inputValue and close menu here if the selected key is already the focused key. Otherwise
            // fire onSelectionChange to allow the application to control the closing.
            if (selectedKey === selectionManager.focusedKey) commitSelection();
            else setSelectedKey(selectionManager.focusedKey);
        } else if (allowsCustomValue) commitCustomValue();
        else // Reset inputValue and close menu if no item is focused but user triggers a commit
        commitSelection();
    };
    let setFocused = (isFocused)=>{
        if (isFocused) {
            if (menuTrigger === "focus") open(null, "focus");
        } else if (shouldCloseOnBlur) {
            var _collection_getItem;
            var _collection_getItem_textValue;
            let itemText = (_collection_getItem_textValue = (_collection_getItem = collection.getItem(selectedKey)) === null || _collection_getItem === void 0 ? void 0 : _collection_getItem.textValue) !== null && _collection_getItem_textValue !== void 0 ? _collection_getItem_textValue : "";
            if (allowsCustomValue && inputValue !== itemText) commitCustomValue();
            else commitSelection();
        }
        setFocusedState(isFocused);
    };
    return {
        ...triggerState,
        toggle: toggle,
        open: open,
        close: commit,
        selectionManager: selectionManager,
        selectedKey: selectedKey,
        setSelectedKey: setSelectedKey,
        disabledKeys: disabledKeys,
        isFocused: isFocused,
        setFocused: setFocused,
        selectedItem: selectedItem,
        collection: showAllItems ? originalCollection : filteredCollection,
        inputValue: inputValue,
        setInputValue: setInputValue,
        commit: commit,
        revert: revert
    };
}
function $a9e7382a7d111cb5$var$filterCollection(collection, inputValue, filter) {
    return new ($a02d57049d202695$export$d085fb9e920b5ca7)($a9e7382a7d111cb5$var$filterNodes(collection, inputValue, filter));
}
function $a9e7382a7d111cb5$var$filterNodes(nodes, inputValue, filter) {
    let filteredNode = [];
    for (let node of nodes){
        if (node.type === "section" && node.hasChildNodes) {
            let filtered = $a9e7382a7d111cb5$var$filterNodes(node.childNodes, inputValue, filter);
            if ([
                ...filtered
            ].length > 0) filteredNode.push({
                ...node,
                childNodes: filtered
            });
        } else if (node.type !== "section" && filter(node.textValue, inputValue)) filteredNode.push({
            ...node
        });
    }
    return filteredNode;
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
// These placeholders are based on the strings used by the <input type="date">
// implementations in Chrome and Firefox. Additional languages are supported
// here than React Spectrum's typical translations.
new ($5b160d28a433310d$export$c17fa47878dc55b6)({
    ach: {
        year: "mwaka",
        month: "dwe",
        day: "nino"
    },
    af: {
        year: "jjjj",
        month: "mm",
        day: "dd"
    },
    am: {
        year: "ዓዓዓዓ",
        month: "ሚሜ",
        day: "ቀቀ"
    },
    an: {
        year: "aaaa",
        month: "mm",
        day: "dd"
    },
    ar: {
        year: "سنة",
        month: "شهر",
        day: "يوم"
    },
    ast: {
        year: "aaaa",
        month: "mm",
        day: "dd"
    },
    az: {
        year: "iiii",
        month: "aa",
        day: "gg"
    },
    be: {
        year: "гггг",
        month: "мм",
        day: "дд"
    },
    bg: {
        year: "гггг",
        month: "мм",
        day: "дд"
    },
    bn: {
        year: "yyyy",
        month: "মিমি",
        day: "dd"
    },
    br: {
        year: "bbbb",
        month: "mm",
        day: "dd"
    },
    bs: {
        year: "gggg",
        month: "mm",
        day: "dd"
    },
    ca: {
        year: "aaaa",
        month: "mm",
        day: "dd"
    },
    cak: {
        year: "jjjj",
        month: "ii",
        day: "q'q'"
    },
    ckb: {
        year: "ساڵ",
        month: "مانگ",
        day: "ڕۆژ"
    },
    cs: {
        year: "rrrr",
        month: "mm",
        day: "dd"
    },
    cy: {
        year: "bbbb",
        month: "mm",
        day: "dd"
    },
    da: {
        year: "\xe5\xe5\xe5\xe5",
        month: "mm",
        day: "dd"
    },
    de: {
        year: "jjjj",
        month: "mm",
        day: "tt"
    },
    dsb: {
        year: "llll",
        month: "mm",
        day: "źź"
    },
    el: {
        year: "εεεε",
        month: "μμ",
        day: "ηη"
    },
    en: {
        year: "yyyy",
        month: "mm",
        day: "dd"
    },
    eo: {
        year: "jjjj",
        month: "mm",
        day: "tt"
    },
    es: {
        year: "aaaa",
        month: "mm",
        day: "dd"
    },
    et: {
        year: "aaaa",
        month: "kk",
        day: "pp"
    },
    eu: {
        year: "uuuu",
        month: "hh",
        day: "ee"
    },
    fa: {
        year: "سال",
        month: "ماه",
        day: "روز"
    },
    ff: {
        year: "hhhh",
        month: "ll",
        day: "\xf1\xf1"
    },
    fi: {
        year: "vvvv",
        month: "kk",
        day: "pp"
    },
    fr: {
        year: "aaaa",
        month: "mm",
        day: "jj"
    },
    fy: {
        year: "jjjj",
        month: "mm",
        day: "dd"
    },
    ga: {
        year: "bbbb",
        month: "mm",
        day: "ll"
    },
    gd: {
        year: "bbbb",
        month: "mm",
        day: "ll"
    },
    gl: {
        year: "aaaa",
        month: "mm",
        day: "dd"
    },
    he: {
        year: "שנה",
        month: "חודש",
        day: "יום"
    },
    hr: {
        year: "gggg",
        month: "mm",
        day: "dd"
    },
    hsb: {
        year: "llll",
        month: "mm",
        day: "dd"
    },
    hu: {
        year: "\xe9\xe9\xe9\xe9",
        month: "hh",
        day: "nn"
    },
    ia: {
        year: "aaaa",
        month: "mm",
        day: "dd"
    },
    id: {
        year: "tttt",
        month: "bb",
        day: "hh"
    },
    it: {
        year: "aaaa",
        month: "mm",
        day: "gg"
    },
    ja: {
        year: " 年 ",
        month: "月",
        day: "日"
    },
    ka: {
        year: "წწწწ",
        month: "თთ",
        day: "რრ"
    },
    kk: {
        year: "жжжж",
        month: "аа",
        day: "кк"
    },
    kn: {
        year: "ವವವವ",
        month: "ಮಿಮೀ",
        day: "ದಿದಿ"
    },
    ko: {
        year: "연도",
        month: "월",
        day: "일"
    },
    lb: {
        year: "jjjj",
        month: "mm",
        day: "dd"
    },
    lo: {
        year: "ປປປປ",
        month: "ດດ",
        day: "ວວ"
    },
    lt: {
        year: "mmmm",
        month: "mm",
        day: "dd"
    },
    lv: {
        year: "gggg",
        month: "mm",
        day: "dd"
    },
    meh: {
        year: "aaaa",
        month: "mm",
        day: "dd"
    },
    ml: {
        year: "വർഷം",
        month: "മാസം",
        day: "തീയതി"
    },
    ms: {
        year: "tttt",
        month: "mm",
        day: "hh"
    },
    nl: {
        year: "jjjj",
        month: "mm",
        day: "dd"
    },
    nn: {
        year: "\xe5\xe5\xe5\xe5",
        month: "mm",
        day: "dd"
    },
    no: {
        year: "\xe5\xe5\xe5\xe5",
        month: "mm",
        day: "dd"
    },
    oc: {
        year: "aaaa",
        month: "mm",
        day: "jj"
    },
    pl: {
        year: "rrrr",
        month: "mm",
        day: "dd"
    },
    pt: {
        year: "aaaa",
        month: "mm",
        day: "dd"
    },
    rm: {
        year: "oooo",
        month: "mm",
        day: "dd"
    },
    ro: {
        year: "aaaa",
        month: "ll",
        day: "zz"
    },
    ru: {
        year: "гггг",
        month: "мм",
        day: "дд"
    },
    sc: {
        year: "aaaa",
        month: "mm",
        day: "dd"
    },
    scn: {
        year: "aaaa",
        month: "mm",
        day: "jj"
    },
    sk: {
        year: "rrrr",
        month: "mm",
        day: "dd"
    },
    sl: {
        year: "llll",
        month: "mm",
        day: "dd"
    },
    sr: {
        year: "гггг",
        month: "мм",
        day: "дд"
    },
    sv: {
        year: "\xe5\xe5\xe5\xe5",
        month: "mm",
        day: "dd"
    },
    szl: {
        year: "rrrr",
        month: "mm",
        day: "dd"
    },
    tg: {
        year: "сссс",
        month: "мм",
        day: "рр"
    },
    th: {
        year: "ปปปป",
        month: "ดด",
        day: "วว"
    },
    tr: {
        year: "yyyy",
        month: "aa",
        day: "gg"
    },
    uk: {
        year: "рррр",
        month: "мм",
        day: "дд"
    },
    "zh-CN": {
        year: "年",
        month: "月",
        day: "日"
    },
    "zh-TW": {
        year: "年",
        month: "月",
        day: "日"
    }
}, "en");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


function $de67e98908f0c6ee$export$7f629e9dc1ecf37c(props) {
    let { minValue: minValue , maxValue: maxValue , step: step , formatOptions: formatOptions , value: value , defaultValue: defaultValue , onChange: onChange , locale: locale , isDisabled: isDisabled , isReadOnly: isReadOnly  } = props;
    let [numberValue, setNumberValue] = ($458b0a5536c1a7cf$export$40bfa8c7b0832715)(value, isNaN(defaultValue) ? NaN : defaultValue, onChange);
    let [inputValue, setInputValue] = (useState)(()=>isNaN(numberValue) ? "" : new ($488c6ddbf4ef74c2$export$cc77c4ff7e8673c5)(locale, formatOptions).format(numberValue));
    let numberParser = (useMemo)(()=>new ($6c7bd7858deea686$export$cd11ab140839f11d)(locale, formatOptions), [
        locale,
        formatOptions
    ]);
    let numberingSystem = (useMemo)(()=>numberParser.getNumberingSystem(inputValue), [
        numberParser,
        inputValue
    ]);
    let formatter = (useMemo)(()=>new ($488c6ddbf4ef74c2$export$cc77c4ff7e8673c5)(locale, {
            ...formatOptions,
            numberingSystem: numberingSystem
        }), [
        locale,
        formatOptions,
        numberingSystem
    ]);
    let intlOptions = (useMemo)(()=>formatter.resolvedOptions(), [
        formatter
    ]);
    let format = (useCallback)((value)=>isNaN(value) || value === null ? "" : formatter.format(value), [
        formatter
    ]);
    let clampStep = !isNaN(step) ? step : 1;
    if (intlOptions.style === "percent" && isNaN(step)) clampStep = 0.01;
    // Update the input value when the number value or format options change. This is done
    // in a useEffect so that the controlled behavior is correct and we only update the
    // textfield after prop changes.
    let prevValue = (useRef)(numberValue);
    let prevLocale = (useRef)(locale);
    let prevFormatOptions = (useRef)(formatOptions);
    if (!Object.is(numberValue, prevValue.current) || locale !== prevLocale.current || formatOptions !== prevFormatOptions.current) {
        setInputValue(format(numberValue));
        prevValue.current = numberValue;
        prevLocale.current = locale;
        prevFormatOptions.current = formatOptions;
    }
    // Store last parsed value in a ref so it can be used by increment/decrement below
    let parsedValue = (useMemo)(()=>numberParser.parse(inputValue), [
        numberParser,
        inputValue
    ]);
    let parsed = (useRef)(0);
    parsed.current = parsedValue;
    let commit = ()=>{
        // Set to empty state if input value is empty
        if (!inputValue.length) {
            setNumberValue(NaN);
            setInputValue(value === undefined ? "" : format(numberValue));
            return;
        }
        // if it failed to parse, then reset input to formatted version of current number
        if (isNaN(parsed.current)) {
            setInputValue(format(numberValue));
            return;
        }
        // Clamp to min and max, round to the nearest step, and round to specified number of digits
        let clampedValue;
        if (isNaN(step)) clampedValue = ($9446cca9a3875146$export$7d15b64cf5a3a4c4)(parsed.current, minValue, maxValue);
        else clampedValue = ($9446cca9a3875146$export$cb6e0bb50bc19463)(parsed.current, minValue, maxValue, step);
        clampedValue = numberParser.parse(format(clampedValue));
        setNumberValue(clampedValue);
        // in a controlled state, the numberValue won't change, so we won't go back to our old input without help
        setInputValue(format(value === undefined ? clampedValue : numberValue));
    };
    let safeNextStep = (operation, minMax)=>{
        let prev = parsed.current;
        if (isNaN(prev)) {
            // if the input is empty, start from the min/max value when incrementing/decrementing,
            // or zero if there is no min/max value defined.
            let newValue = isNaN(minMax) ? 0 : minMax;
            return ($9446cca9a3875146$export$cb6e0bb50bc19463)(newValue, minValue, maxValue, clampStep);
        } else {
            // otherwise, first snap the current value to the nearest step. if it moves in the direction
            // we're going, use that value, otherwise add the step and snap that value.
            let newValue1 = ($9446cca9a3875146$export$cb6e0bb50bc19463)(prev, minValue, maxValue, clampStep);
            if (operation === "+" && newValue1 > prev || operation === "-" && newValue1 < prev) return newValue1;
            return ($9446cca9a3875146$export$cb6e0bb50bc19463)($de67e98908f0c6ee$var$handleDecimalOperation(operation, prev, clampStep), minValue, maxValue, clampStep);
        }
    };
    let increment = ()=>{
        let newValue = safeNextStep("+", minValue);
        // if we've arrived at the same value that was previously in the state, the
        // input value should be updated to match
        // ex type 4, press increment, highlight the number in the input, type 4 again, press increment
        // you'd be at 5, then incrementing to 5 again, so no re-render would happen and 4 would be left in the input
        if (newValue === numberValue) setInputValue(format(newValue));
        setNumberValue(newValue);
    };
    let decrement = ()=>{
        let newValue = safeNextStep("-", maxValue);
        if (newValue === numberValue) setInputValue(format(newValue));
        setNumberValue(newValue);
    };
    let incrementToMax = ()=>{
        if (maxValue != null) setNumberValue(($9446cca9a3875146$export$cb6e0bb50bc19463)(maxValue, minValue, maxValue, clampStep));
    };
    let decrementToMin = ()=>{
        if (minValue != null) setNumberValue(minValue);
    };
    let canIncrement = (useMemo)(()=>!isDisabled && !isReadOnly && (isNaN(parsedValue) || isNaN(maxValue) || ($9446cca9a3875146$export$cb6e0bb50bc19463)(parsedValue, minValue, maxValue, clampStep) > parsedValue || $de67e98908f0c6ee$var$handleDecimalOperation("+", parsedValue, clampStep) <= maxValue), [
        isDisabled,
        isReadOnly,
        minValue,
        maxValue,
        clampStep,
        parsedValue
    ]);
    let canDecrement = (useMemo)(()=>!isDisabled && !isReadOnly && (isNaN(parsedValue) || isNaN(minValue) || ($9446cca9a3875146$export$cb6e0bb50bc19463)(parsedValue, minValue, maxValue, clampStep) < parsedValue || $de67e98908f0c6ee$var$handleDecimalOperation("-", parsedValue, clampStep) >= minValue), [
        isDisabled,
        isReadOnly,
        minValue,
        maxValue,
        clampStep,
        parsedValue
    ]);
    let validate = (value)=>numberParser.isValidPartialNumber(value, minValue, maxValue);
    return {
        validate: validate,
        increment: increment,
        incrementToMax: incrementToMax,
        decrement: decrement,
        decrementToMin: decrementToMin,
        canIncrement: canIncrement,
        canDecrement: canDecrement,
        minValue: minValue,
        maxValue: maxValue,
        numberValue: parsedValue,
        setInputValue: setInputValue,
        inputValue: inputValue,
        commit: commit
    };
}
function $de67e98908f0c6ee$var$handleDecimalOperation(operator, value1, value2) {
    let result = operator === "+" ? value1 + value2 : value1 - value2;
    // Check if we have decimals
    if (value1 % 1 !== 0 || value2 % 1 !== 0) {
        const value1Decimal = value1.toString().split(".");
        const value2Decimal = value2.toString().split(".");
        const value1DecimalLength = value1Decimal[1] && value1Decimal[1].length || 0;
        const value2DecimalLength = value2Decimal[1] && value2Decimal[1].length || 0;
        const multiplier = Math.pow(10, Math.max(value1DecimalLength, value2DecimalLength));
        // Transform the decimals to integers based on the precision
        value1 = Math.round(value1 * multiplier);
        value2 = Math.round(value2 * multiplier);
        // Perform the operation on integers values to make sure we don't get a fancy decimal value
        result = operator === "+" ? value1 + value2 : value1 - value2;
        // Transform the integer result back to decimal
        result /= multiplier;
    }
    return result;
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

let $a54cdc5c1942b639$var$instance = Math.round(Math.random() * 10000000000);
let $a54cdc5c1942b639$var$i = 0;
function $a54cdc5c1942b639$export$bca9d026f8e704eb(props) {
    // Preserved here for backward compatibility. React Aria now generates the name instead of stately.
    let name = (useMemo)(()=>props.name || `radio-group-${$a54cdc5c1942b639$var$instance}-${++$a54cdc5c1942b639$var$i}`, [
        props.name
    ]);
    let [selectedValue, setSelected] = ($458b0a5536c1a7cf$export$40bfa8c7b0832715)(props.value, props.defaultValue, props.onChange);
    let [lastFocusedValue, setLastFocusedValue] = (useState)(null);
    let setSelectedValue = (value)=>{
        if (!props.isReadOnly && !props.isDisabled) setSelected(value);
    };
    return {
        name: name,
        selectedValue: selectedValue,
        setSelectedValue: setSelectedValue,
        lastFocusedValue: lastFocusedValue,
        setLastFocusedValue: setLastFocusedValue,
        isDisabled: props.isDisabled || false,
        isReadOnly: props.isReadOnly || false,
        validationState: props.validationState
    };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
function $0b2218c4e3fe7d7e$export$3f8be18b0f41eaf2(props) {
    let [value, setValue] = ($458b0a5536c1a7cf$export$40bfa8c7b0832715)($0b2218c4e3fe7d7e$var$toString(props.value), $0b2218c4e3fe7d7e$var$toString(props.defaultValue) || "", props.onChange);
    return {
        value: value,
        setValue: setValue
    };
}
function $0b2218c4e3fe7d7e$var$toString(val) {
    if (val == null) return;
    return val.toString();
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 * 
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


function $2bc3a590c5373a4e$export$5159ec8b34d4ec12(props) {
    let triggerState = ($a28c903ee9ad8dc5$export$79fefeb1c2091ac3)(props);
    let listState = ($a0d645289fe9b86b$export$e7f05e985daf4b5f)({
        ...props,
        onSelectionChange: (key)=>{
            if (props.onSelectionChange != null) props.onSelectionChange(key);
            triggerState.close();
        }
    });
    let [isFocused, setFocused] = (useState)(false);
    return {
        ...listState,
        ...triggerState,
        open () {
            // Don't open if the collection is empty.
            if (listState.collection.size !== 0) triggerState.open();
        },
        toggle (focusStrategy) {
            if (listState.collection.size !== 0) triggerState.toggle(focusStrategy);
        },
        isFocused: isFocused,
        setFocused: setFocused
    };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

"row-header-column-" + Math.random().toString(36).slice(2);

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
let $05ca4cd7c4a5a999$var$_Symbol_iterator = Symbol.iterator;
class $05ca4cd7c4a5a999$export$863faf230ee2118a {
    *[$05ca4cd7c4a5a999$var$_Symbol_iterator]() {
        yield* this.iterable;
    }
    get size() {
        return this.keyMap.size;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        return node ? node.prevKey : null;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        return node ? node.nextKey : null;
    }
    getFirstKey() {
        return this.firstKey;
    }
    getLastKey() {
        return this.lastKey;
    }
    getItem(key) {
        return this.keyMap.get(key);
    }
    at(idx) {
        const keys = [
            ...this.getKeys()
        ];
        return this.getItem(keys[idx]);
    }
    constructor(nodes, { expandedKeys: expandedKeys  } = {}){
        (_defineProperty)(this, "keyMap", new Map());
        this.iterable = nodes;
        expandedKeys = expandedKeys || new Set();
        let visit = (node)=>{
            this.keyMap.set(node.key, node);
            if (node.childNodes && (node.type === "section" || expandedKeys.has(node.key))) for (let child of node.childNodes)visit(child);
        };
        for (let node of nodes)visit(node);
        let last;
        let index = 0;
        for (let [key, node1] of this.keyMap){
            if (last) {
                last.nextKey = key;
                node1.prevKey = last.key;
            } else {
                this.firstKey = key;
                node1.prevKey = undefined;
            }
            if (node1.type === "item") node1.index = index++;
            last = node1;
            // Set nextKey as undefined since this might be the last node
            // If it isn't the last node, last.nextKey will properly set at start of new loop
            last.nextKey = undefined;
        }
        this.lastKey = last === null || last === void 0 ? void 0 : last.key;
    }
}




function $875d6693e12af071$export$728d6ba534403756(props) {
    let [expandedKeys, setExpandedKeys] = ($458b0a5536c1a7cf$export$40bfa8c7b0832715)(props.expandedKeys ? new Set(props.expandedKeys) : undefined, props.defaultExpandedKeys ? new Set(props.defaultExpandedKeys) : new Set(), props.onExpandedChange);
    let selectionState = ($7af3f5b51489e0b5$export$253fe78d46329472)(props);
    let disabledKeys = (useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let tree = ($7613b1592d41b092$export$6cd28814d92fa9c9)(props, (nodes)=>new ($05ca4cd7c4a5a999$export$863faf230ee2118a)(nodes, {
            expandedKeys: expandedKeys
        }), null, [
        expandedKeys
    ]);
    // Reset focused key if that item is deleted from the collection.
    (useEffect)(()=>{
        if (selectionState.focusedKey != null && !tree.getItem(selectionState.focusedKey)) selectionState.setFocusedKey(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tree,
        selectionState.focusedKey
    ]);
    let onToggle = (key)=>{
        setExpandedKeys($875d6693e12af071$var$toggleKey(expandedKeys, key));
    };
    return {
        collection: tree,
        expandedKeys: expandedKeys,
        disabledKeys: disabledKeys,
        toggleKey: onToggle,
        selectionManager: new ($d496c0a20b6e58ec$export$6c8a5aaad13c9852)(tree, selectionState)
    };
}
function $875d6693e12af071$var$toggleKey(set, key) {
    let res = new Set(set);
    if (res.has(key)) res.delete(key);
    else res.add(key);
    return res;
}

const inputStyles = {
    sm: {
        height: '28px',
        font: 'b2',
        padding: '0px 6px',
    },
    md: {
        height: '32px',
        font: 'b1',
        padding: '0px 12px',
    },
    lg: {
        height: '40px',
        font: 'b1',
        padding: '9px 12px',
    },
};
const Container$3 = styled.div `
  display: flex;
  flex-direction: column;
  gap: 4px;

  ${({ width }) => width !== undefined
    ? css `
          width: ${width}px;
        `
    : css `
          width: 100%;
        `}

  ${({ minWidth }) => minWidth !== undefined &&
    css `
      min-width: ${minWidth}px;
    `}
  ${({ maxWidth }) => maxWidth !== undefined &&
    css `
      max-width: ${maxWidth}px;
    `}

  * {
    box-sizing: border-box;
  }
`;
const PromptContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: 4px;
  height: 40px;
  position: relative;

  ${({ width }) => width !== undefined
    ? css `
          width: ${width}px;
        `
    : css `
          width: 100%;
        `}

  ${({ minWidth }) => minWidth !== undefined &&
    css `
      min-width: ${minWidth}px;
    `}
  ${({ maxWidth }) => maxWidth !== undefined &&
    css `
      max-width: ${maxWidth}px;
    `}

  * {
    box-sizing: border-box;
  }
`;
const PromptWrapper = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1199;
`;
const PromptMenu = styled.div `
  display: flex;
  padding-top: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: calc(100% - 2px);
  transform: translateX(1px);
  background-color: ${Colors$1.White};
  box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.1),
    0px 4px 6px -2px rgba(0, 0, 0, 0.05), 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
`;
const PromptMenuContent = styled.div `
  display: flex;
  flex-direction: column;
  gap: 8px;
  background-color: ${Colors$1.White};
  width: 100%;
`;
const PromptMenuFooter = styled.div `
  margin-top: 16px;
  background-color: rgba(246, 248, 252, 1);
  color: rgba(139, 147, 164, 1);
  font-size: 12px;
  padding: 12px 16px;
  border-radius: 0 0 2px 2px;
  border-top: 1px solid rgba(232, 237, 244, 1);
  width: 100%;
`;
const InputContainer = styled.div.attrs(({ className }) => ({
    className: ((className ? className + ' ' : '') +
        'amp-input-container'),
})) `
  position: relative;
  display: flex;
  align-items: center;
  border-radius: 2px;
  border: 1px solid ${Colors$1.Pigeon400};
  background-color: ${Colors$1.White};
  gap: 8px;

  ${({ mono, size, isPrompt, expanded }) => {
    const styles = inputStyles[size];
    const fontType = mono ? styles.font + 'Mono' : styles.font;
    if (isPrompt) {
        return css `
        max-height: ${expanded ? undefined : '40px'};
        overflow: hidden;
        padding: 7px 12px;
        width: 100%;
        align-items: flex-start;
        textarea {
          ${getFont(fontType)}
        }
      `;
    }
    return css `
      height: ${styles.height};
      padding: ${styles.padding};

      input {
        ${getFont(fontType)}
      }
    `;
}}

  ${({ hug }) => hug &&
    css `
      ${hug === 'left' ? 'padding-left: 0;' : 'padding-right: 0;'}
    `}

  ${({ tint }) => tint &&
    css `
      background-color: ${Colors$1.Pigeon100};
      border-color: ${Colors$1.Pigeon100};
    `}

  ${({ disabled, canCopy }) => disabled &&
    css `
      background-color: ${Colors$1.Pigeon100};

      input {
        color: ${canCopy ? Colors$1.Pigeon700 : Colors$1.Pigeon600};
      }
    `}

  ${({ collapsed }) => collapsed &&
    css `
      background-color: ${Colors$1.Transparent};
      border-color: ${Colors$1.Transparent} !important;
      width: 0px;
    `}

  svg {
    color: ${({ tint, canCopy }) => tint && !canCopy ? Colors$1.Pigeon600 : Colors$1.Pigeon700};
  }

  button svg {
    color: ${Colors$1.Pigeon700};
  }

  ${({ error }) => error &&
    css `
      color: ${Colors$1.Pinata900};
      border-color: ${Colors$1.Pinata600};

      input {
        color: ${Colors$1.Pinata900};
      }
    `}

  ${({ error, isFocusVisible }) => isFocusVisible &&
    getFocusOutline(error ? Colors$1.Pinata900 : Colors$1.Electric600)}
`;
const SpinnerContainer = styled.div `
  display: flex;
  align-items: center;

  svg {
    color: ${Colors$1.Pigeon700};
  }

  .spinner {
    height: 16px;
    width: 16px;
  }
`;
const StyledInput$1 = styled.input `
  padding: ${({ padding }) => padding ?? '0'};
  background: inherit;
  outline: 2px solid transparent;
  outline-offset: 2px;
  height: 100%;
  border: none;
  width: 100%;
  border-radius: 2px;
  ${({ textAlign = 'left' }) => css `
    text-align: ${textAlign};
  `}

  ::placeholder {
    color: ${Colors$1.Pigeon600};
  }

  ::-webkit-search-cancel-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;
styled.textarea `
  padding: ${({ padding }) => padding ?? '0'};
  background: inherit;
  outline: 2px solid transparent;
  outline-offset: 2px;
  border: none;
  width: 100%;
  resize: none;
  border-radius: 2px;
  transform: translateY(2px);
  ${({ textAlign = 'left' }) => css `
    text-align: ${textAlign};
  `}

  ::placeholder {
    color: ${Colors$1.Pigeon600};
  }

  ::-webkit-search-cancel-button {
    -webkit-appearance: none;
    margin: 0;
  }
  overflow-y: hidden;
`;
const IconContainer = styled.div `
  display: flex;
  align-items: center;

  ${({ weighted }) => weighted &&
    css `
      path {
        stroke: currentColor;
        stroke-width: 0.5px;
      }
    `}

  ${({ error }) => error &&
    css `
      svg {
        color: ${Colors$1.Pinata900};
      }

      path {
        stroke: ${Colors$1.Pinata900};
        stroke-width: 0.5px;
      }
    `}
`;
const IconButtonContainer = styled.div `
  display: flex;
  align-items: center;
  margin-right: -4px;

  ${({ weighted }) => weighted &&
    css `
      path {
        stroke: currentColor;
        stroke-width: 0.5px;
      }
    `}
  ${({ left }) => left &&
    css `
      margin-left: -4px;
    `}
  ${({ dark }) => dark &&
    css `
      svg {
        color: ${Colors$1.Pigeon700} !important;
      }
    `}
`;
const Label$1 = styled.label `
  ${getFont('actionMd')}
`;
const Description = ({ children }) => (jsx(Typography, { type: 'b1', color: Colors$1.Pigeon700, children: children }));
const CopyMessage = styled.div `
  ${getFont('b1')}
  color: ${Colors$1.Pigeon700};
  position: absolute;
  left: 100%;
  padding: 0px 12px;
  opacity: 0;
  transition: opacity ease-in-out 100ms;

  ${({ show }) => show &&
    css `
      opacity: 1;
    `}
`;
const getBorderStyles = (align) => {
    if (align === 'left') {
        return css `
      border-left: 0;
      border-right: 1px solid ${Colors$1.Pigeon400};
    `;
    }
    return css `
    border-left: 1px solid ${Colors$1.Pigeon400};
    border-right: 0;
  `;
};
const InputDecorator = styled.div.attrs({
    className: 'amp-input-decorator',
}) `
  display: flex;
  align-items: center;
  background-color: ${Colors$1.Pigeon100};
  border: 1px solid ${Colors$1.Pigeon400};
  ${({ align = 'right' }) => getBorderStyles(align)};
  border-radius: ${({ align }) => align === 'left' ? '2px 2px 0 0' : '0 0 2px 2px'};
  padding: 9px 12px;
  color: ${Colors$1.Pigeon700};
  max-width: min-content;
  height: 40px; // only supports large inputs currently
  ${getFont('b1')};
`;

const ButtonGroupContainer = styled.div `
  display: flex;
  flex-direction: column;
`;
const ButtonGroupItemsContainer = styled.div `
  display: flex;
  margin: 4px 0;
`;
const ButtonGroupItemContainer = styled.label `
  display: flex;
  justify-content: center;
  ${getFont('actionMd')};
  transition: background-color 0.2s ease;
  padding: 9px 17px;
  min-width: ${({ $minWidth = 100 }) => $minWidth}px;
  z-index: ${({ isSelected }) => (isSelected ? 3 : 'auto')};

  background-color: ${({ isSelected }) => isSelected ? Colors$1.Electric700 : Colors$1.Pigeon100};
  color: ${({ isSelected }) => isSelected ? Colors$1.White : Colors$1.MidnightBrand};

  ${({ isHovered, isSelected }) => css `
    cursor: pointer;
    background-color: ${isHovered &&
    (isSelected ? Colors$1.Electric900 : Colors$1.Pigeon200)};
  `}

  ${({ isFocusVisible, isSelected }) => isFocusVisible &&
    getFocusOutline(isSelected ? Colors$1.Electric600 : Colors$1.Pigeon200)}

  &:first-child {
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
  }

  &:last-child {
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
  }
`;

const ButtonGroupContext = createContext(null);
const ButtonGroup = (props) => {
    const { label, description, children } = props;
    const state = $a54cdc5c1942b639$export$bca9d026f8e704eb(props);
    const { radioGroupProps, labelProps, descriptionProps } = $430f30ed08ec25fa$export$62b9571f283ff5c2(props, state);
    return (jsxs(ButtonGroupContainer, { ...radioGroupProps, children: [label && jsx(Label$1, { ...labelProps, children: label }), jsx(ButtonGroupItemsContainer, { children: jsx(ButtonGroupContext.Provider, { value: state, children: children }) }), description && (jsx(Description, { ...descriptionProps, children: description }))] }));
};

const ButtonGroupItem = (props) => {
    const { children, selected, value, minWidth } = props;
    const stateOrNull = useContext(ButtonGroupContext);
    const state = stateOrNull;
    const inputRef = useRef(null);
    const { hoverProps, isHovered } = $6179b936705e76d3$export$ae780daf29e6d456({});
    const { inputProps } = $0d5c49892c1215da$export$37b0961d2f4751e2(props, state, inputRef);
    const { visuallyHiddenProps } = $5c3e21d68f1c4674$export$a966af930f325cab();
    const { isFocusVisible, focusProps } = $f7dceffc5ad7768b$export$4e328f61c538687f({
        within: true,
    });
    return (jsxs(ButtonGroupItemContainer, { "data-testid": `button-group-item-container-${value}`, id: value, isSelected: selected, isFocusVisible: isFocusVisible, isHovered: isHovered, "$minWidth": minWidth, ...focusProps, ...hoverProps, children: [jsx("input", { "data-testid": `button-group-item-input-${value}`, ...inputProps, ref: inputRef, ...visuallyHiddenProps }), children] }));
};

const IconButtonStyles = css `
  ${({ variant, $isFocusVisible, $isHovered, $isPressed }) => getButtonStyles({
    variant,
    isFocusVisible: $isFocusVisible,
    isHovered: $isHovered,
    isPressed: $isPressed,
})}

  align-items: center;
  border-radius: 2px;
  cursor: pointer;
  display: flex;
  height: ${({ size = 24 }) => `${size + 8}px`};
  justify-content: center;
  outline: none;
  transition: background-color 0.2s ease;
  width: ${({ size = 24 }) => `${size + 8}px`};

  ${({ $rotateIcon }) => $rotateIcon !== undefined &&
    css `
      svg {
        transition: ease-in-out transform 0.1s;
        transform: rotate(${$rotateIcon}deg);
      }
    `}

  ${({ $isDisabled }) => $isDisabled &&
    css `
      opacity: 50%;
      pointer-events: none;
    `}
`;
const ButtonContainer = styled.button `
  ${IconButtonStyles}
`;
const LinkContainer = styled(Link) `
  ${IconButtonStyles}
`;
const AnchorLinkContainer = styled.a `
  ${IconButtonStyles}
`;
const getContainer = (href, to) => {
    if (to)
        return LinkContainer;
    if (href)
        return AnchorLinkContainer;
    return ButtonContainer;
};
const IconButton = ({ variant = 'tertiary', name, rotateIcon, size = 24, isDisabled = false, color, ...otherProps }) => {
    const ref = useRef(null);
    const { buttonProps } = $701a24aa0da5b062$export$ea18c227d4417cc3({ ...otherProps, isDisabled }, ref);
    const { pressProps, isPressed } = $f6c31cce2adf654f$export$45712eceda6fad21({
        ...otherProps,
        isDisabled,
        ref,
    });
    const { hoverProps, isHovered } = $6179b936705e76d3$export$ae780daf29e6d456({ isDisabled });
    const { isFocusVisible, focusProps } = $f7dceffc5ad7768b$export$4e328f61c538687f();
    const combinedProps = {
        ...buttonProps,
        ...focusProps,
        ...hoverProps,
        ...pressProps,
    };
    const Container = getContainer(otherProps.href, otherProps.to);
    return (
    // @ts-ignore
    jsx(Container, { className: classnames$1('styled-icon-button', ...[variant]), variant: variant, size: size, "$rotateIcon": rotateIcon, "$isDisabled": isDisabled, "$isFocusVisible": isFocusVisible, "$isHovered": isHovered, "$isPressed": isPressed, role: 'button', ...combinedProps, children: jsx(Icon, { name: name, size: size, color: color }) }));
};

var MenuTrigger;
(function (MenuTrigger) {
    MenuTrigger["click"] = "click";
    MenuTrigger["hover"] = "hover";
})(MenuTrigger || (MenuTrigger = {}));
var MenuPlacement;
(function (MenuPlacement) {
    MenuPlacement["none"] = "none";
    MenuPlacement["top"] = "top";
    MenuPlacement["bottom"] = "bottom";
    MenuPlacement["right"] = "right";
    MenuPlacement["left"] = "left";
    // TODO: flip = 'flip',
})(MenuPlacement || (MenuPlacement = {}));
var MenuAlignment;
(function (MenuAlignment) {
    MenuAlignment["start"] = "start";
    MenuAlignment["end"] = "end";
    MenuAlignment["center"] = "center";
})(MenuAlignment || (MenuAlignment = {}));
var MenuDirection;
(function (MenuDirection) {
    MenuDirection["up"] = "up";
    MenuDirection["down"] = "down";
})(MenuDirection || (MenuDirection = {}));
var MenuSize;
(function (MenuSize) {
    MenuSize["sm"] = "sm";
    MenuSize["md"] = "md";
    MenuSize["lg"] = "lg";
})(MenuSize || (MenuSize = {}));
var MenuType;
(function (MenuType) {
    MenuType["dropdown"] = "dropdown";
    MenuType["context"] = "context";
})(MenuType || (MenuType = {}));
var MenuSelectionMode;
(function (MenuSelectionMode) {
    MenuSelectionMode["multiple"] = "multiple";
    MenuSelectionMode["single"] = "single";
    MenuSelectionMode["none"] = "none";
})(MenuSelectionMode || (MenuSelectionMode = {}));

const isDropdownType = (props) => {
    return (props.type === MenuType.dropdown || props.borderType === MenuType.dropdown);
};
const getMenuBorderStyles = (props) => {
    const defaultColor = isDropdownType(props)
        ? Colors$1.Pigeon400
        : Colors$1.Pigeon200;
    return `1px solid ${props.error ? Colors$1.Pinata900 : defaultColor}`;
};
const getMenuBorderTopStyles = (props) => {
    if (props.type === MenuType.dropdown) {
        return getMenuBorderStyles(props);
    }
    return `1px solid ${Colors$1.Pigeon200}`;
};
const getMenuShadowStyles = (props) => {
    if (props.placement === MenuPlacement.top) {
        return `0px -10px 15px -3px rgba(0, 0, 0, 0.1),
    0px -4px 6px -2px rgba(0, 0, 0, 0.05)`;
    }
    return `0px 10px 15px -3px rgba(0, 0, 0, 0.1),
  0px 4px 6px -2px rgba(0, 0, 0, 0.05)`;
};
const getMenuTriggerStyles = ({ direction, error, size, isFocusVisible, isOpen, }) => {
    return css `
    &,
    input {
      ${getFont(size === MenuSize.sm ? 'b2' : 'b1')}
    }

    ${isFocusVisible &&
        getFocusOutline(error ? Colors$1.Pinata900 : Colors$1.Electric600)}

    align-items: center;
    background-color: ${Colors$1.White};
    border: ${getMenuBorderStyles({ error, type: MenuType.dropdown })};
    border-radius: ${isOpen
        ? direction === MenuDirection.down
            ? '2px 2px 0 0'
            : '0 0 2px 2px'
        : '2px'};
    cursor: pointer;
    display: flex;
    height: 32px;
    justify-content: space-between;
    outline: none;
    padding: 8px 16px 8px 16px !important; // because of the global padding overrides
    width: 100%;
  `;
};
const getMenuPositioningStyles = (props) => {
    // TODO: handle alignment as well
    switch (props.placement) {
        case MenuPlacement.none:
            return css ``;
        case MenuPlacement.right:
            return css `
        position: absolute;
        left: 100%;
        top: 0px;
        margin-top: -1px;
      `;
        case MenuPlacement.left:
            return css `
        position: absolute;
        left: 0px;
        top: 0px;
        margin-top: -1px;
      `;
        case MenuPlacement.top:
            return css `
        position: absolute;
        bottom: 100%;
        margin-bottom: 4px;
      `;
        default:
            return css `
        position: absolute;
        right: 0px;
        margin-top: 4px;
      `;
    }
};
const MenuPopoverElement = styled.div.attrs(({ className }) => ({
    className: (className ? className + ' ' : '') + 'amp-menu-popover',
})) `
  border: ${(props) => getMenuBorderStyles(props)};
  border-radius: 2px;
  z-index: ${ZIndex.level1100};
  width: 100%;
  min-width: ${(props) => props.minWidth ?? 'max-content'};
  box-shadow: ${(props) => getMenuShadowStyles(props)};
  background: ${Colors$1.White};

  ${(props) => props.maxWidth
    ? `
    &, ul {
      max-width: ${props.maxWidth};
    }`
    : ''}

  ${(props) => getMenuPositioningStyles(props)}

  ${(props) => {
    if (props.type !== MenuType.dropdown)
        return '';
    if (props.placement === MenuPlacement.top) {
        return css `
        border-bottom: ${getMenuBorderTopStyles({ error: props.error })};
        margin-bottom: -1px;
        border-radius: 2px 2px 0 0;
      `;
    }
    return css `
      border-top: ${getMenuBorderTopStyles({ error: props.error })};
      margin-top: -1px;
      border-radius: 0 0 2px 2px;
    `;
}}
`;
const MenuInputContainer = styled.div `
  ${(props) => getMenuTriggerStyles(props)}

  ${({ $canClear }) => $canClear &&
    `
    padding-right: 8px !important;
  `}

  ${({ inner, error, direction }) => inner &&
    css `
      height: 33px;
      border-right: none;
      border-left: none;

      ${direction === MenuDirection.up
        ? css `
            border-bottom: none;
            border-top: ${getMenuBorderTopStyles({ error, direction })};
            border-top-right-radius: 0px;
            border-top-left-radius: 0px;
          `
        : css `
            border-top: none;
            border-bottom: ${getMenuBorderTopStyles({ error, direction })};
            border-bottom-right-radius: 0px;
            border-bottom-left-radius: 0px;
          `}
    `}
`;
const MenuInputElement = styled.input `
  flex-grow: 1;
  outline: none;
  border: none;
  padding: 0;

  &::placeholder {
    color: ${Colors$1.Pigeon600};
  }
`;
const MenuList = styled.ul `
  border-radius: 2px;
  margin: 0;
  list-style: none;
  padding: 8px 0 0 0;
  outline: ${({ isFocusVisible }) => isFocusVisible ? `2px solid ${Colors$1.Electric700}` : 'none'};

  ${({ size }) => size === MenuSize.sm &&
    css `
      input,
      li div,
      li span {
        font-size: 12px !important;
      }
    `}

  ${({ maxHeight }) => maxHeight &&
    css `
      max-height: ${maxHeight};
      overflow: auto;
    `}
`;
const MenuDivider = styled.div `
  width: 100%;
  height: 1px;
  background-color: ${Colors$1.Pigeon200};
  margin-top: 4px;
  margin-bottom: 4px;
`;
const MenuListItemElement = styled.li `
    background-color: ${({ isFocused }) => isFocused ? Colors$1.Pigeon100 : Colors$1.White}};
    color: ${({ isDisabled }) => isDisabled ? Colors$1.Pigeon400 : Colors$1.MidnightBrand};
    cursor: ${({ isDisabled }) => (isDisabled ? 'default' : 'pointer')};
    height: 32px;
    outline: none;
    overflow: visible;

    ${({ isPressed }) => isPressed &&
    css `
        background-color: ${Colors$1.Pigeon200};
      `}
  
  ${({ isSelected, isCheckbox }) => css `
    ${MenuItemText} {
      ${getFont(isSelected && !isCheckbox ? 'actionMd' : 'b1')}
    }
  `}

  &:first-of-type {
    margin-top: 4px;
  }

  &:last-of-type {
    margin-bottom: 4px;
  }
`;
const MenuGroup = styled.li `
  > ul {
    margin: 0;
    list-style: none;
    padding: 0;
  }
`;
const MenuGroupText = styled.span `
  ${truncated}
  ${getFont('b2')}
  color: ${Colors$1.Pigeon600};
  flex-grow: 1;
  text-align: left;
  padding: 8px 16px;
`;
const MenuItemContent = styled.div `
  display: flex;
  align-items: center;
  height: 32px;
  padding: 0 16px;
  gap: 12px;
`;
const MenuEmptyContent = styled.div `
  ${getFont('b1')}
  color: ${Colors$1.Pigeon600};
  padding: 6px 16px;
  background-color: ${Colors$1.Pigeon100};
`;
const MenuMessage = styled(MenuEmptyContent) `
  border-bottom: 1px solid ${Colors$1.Pigeon200};
  position: sticky;
  top: 0;
`;
const MenuItemText = styled.span `
  ${truncated}
  flex-grow: 1;
  text-align: left;
`;
const MenuItemBadge = styled.span `
  ${getFont('actionSm')}
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px 4px;
  border-radius: 4px;
  color: ${Colors$1.Pinata900};
  background-color: ${Colors$1.Pinata100};
  line-height: 12px;
  font-size: 11px !important;
`;
const MenuItemIcon = styled.span `
  display: flex;
  justify-content: center;
  align-items: center;
`;
const ChevronRight = styled(Icon).attrs({
    name: 'chevronDown',
    size: 12,
}) `
  transform: rotate(-90deg);
  color: ${Colors$1.MidnightBrand};

  path {
    stroke: currentColor;
    stroke-width: 2px;
  }
`;
const Checkmark = styled(Icon).attrs({ name: 'checkmark', size: 16 }) `
  color: ${Colors$1.MidnightBrand};
`;

const MenuInput = ({ autoFocus, inputRef, placeholder, onChange, onClear, onClick, onFocus, onKeyDown, size, value, ...props }) => {
    return (jsxs(MenuInputContainer, { ...props, size: size, "$canClear": !!onClear, "data-testid": 'menu-input-container', children: [jsx(MenuInputElement, { ...props, ref: inputRef, autoFocus: autoFocus, placeholder: placeholder, value: value, role: 'input', onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown }), onClear ? (jsx(IconButton, { "aria-label": 'clear input', "data-testid": 'menu-input-clear', onPress: onClear, name: 'cross', size: 16 })) : null] }));
};

/*
  When utilizing Dropdowns and Menus from the Design System, it is essential that
  any keys used are encoded/decoded appropriately. We URI encode the key because the
  react-aria logic will throw errors when attempting to perform some DOM functions on
  keys containing special characters.

  The helpers below should be leveraged when constructing options lists and managing selections
*/
const decodeKey = (key) => {
    return typeof key === 'string' ? decodeURIComponent(key) : key;
};
const decodeKeys = (keys) => {
    const decoded = [];
    keys.forEach((key) => decoded.push(decodeKey(key)));
    return decoded;
};
const encodeKey = (key) => {
    return typeof key === 'string' ? encodeURIComponent(key) : key;
};
const encodeKeys = (keys) => {
    const encoded = [];
    keys.forEach((key) => encoded.push(encodeKey(key)));
    return encoded;
};

const FilteredDropdownMenu = (props) => {
    const ref = useRef(null);
    const { listBoxRef = ref, state, filter, optionsMap } = props;
    const { contains } = $bb77f239b46e8c72$export$3274cf84b703fff({ sensitivity: 'base' });
    const { menuProps } = $d5336fe17ce95402$export$38eaa17faae8f579({
        ...props,
        'aria-label': 'dropdown-menu-list',
    }, state, ref);
    const collection = useMemo(() => {
        if (!filter)
            return [...state.collection];
        return [...state.collection].filter((item) => {
            const matchString = `${(item.rendered ?? '').toString()} ${(item.key ?? '').toString()}`;
            return contains(matchString, filter);
        });
    }, [filter, state.collection]);
    return (jsx(MenuList, { ...menuProps, size: props.size, isEmpty: props.loading || !collection.length, maxHeight: props.maxHeight ?? '12em', ref: listBoxRef, children: props.loading ? (jsx(MenuEmptyContent, { children: "Loading options..." })) : collection.length ? (jsxs(Fragment, { children: [props.message && jsx(MenuMessage, { children: props.message }), collection.map((item) => (jsx(MenuItem, { "data-testId": `option-${item.key}`, option: optionsMap[item.key], item: item, state: state, onClose: state.close, checkbox: props.selectionMode === MenuSelectionMode.multiple }, item.key)))] })) : (props.searchable && (jsx(MenuEmptyContent, { children: "No matches found" }))) }));
};
const GroupedMenuItems = ({ section, optionsMap, state, selectionMode, }) => {
    let { itemProps, headingProps, groupProps } = $af383d3bef1cfdc9$export$c3f9f39876e4bc7({
        heading: section.rendered,
        'aria-label': section['aria-label'],
    });
    return (jsxs(MenuGroup, { ...itemProps, children: [section.rendered && (jsx(MenuGroupText, { ...headingProps, children: section.rendered.toUpperCase() })), jsx("ul", { ...groupProps, children: [...section.childNodes].map((node) => (jsx(MenuItem, { "data-testId": `henry-${node.key}`, option: optionsMap[node.key], item: node, state: state, onClose: state.close, checkbox: selectionMode === MenuSelectionMode.multiple }, node.key))) })] }));
};
const DropdownMenu = (props) => {
    const ref = useRef(null);
    const { listBoxRef = ref, state, optionsMap } = props;
    const { listBoxProps } = $c132121280ec012d$export$50eacbbf140a3141(props, state, listBoxRef);
    const collection = [...state.collection];
    if (!collection.length) {
        return jsx(MenuEmptyContent, { children: "No matches found" });
    }
    return (jsx(MenuList, { ...listBoxProps, size: props.size, maxHeight: props.maxHeight ?? '12em', ref: listBoxRef, children: collection.map((item) => {
            return item.type === 'section' ? (jsx(GroupedMenuItems, { section: item, state: state, optionsMap: optionsMap, selectionMode: props.selectionMode }, item.key)) : (jsx(MenuItem, { "data-testId": `option-${item.key}`, option: optionsMap[item.key], item: item, state: state, onClose: state.close, checkbox: props.selectionMode === MenuSelectionMode.multiple }, item.key));
        }) }));
};

const AnchorContainer = styled.div `
  position: relative;
`;
const DropdownTriggerContainer = styled.div `
  display: flex;
  flex: 1;
  position: relative;
  gap: 12px;
  svg {
    stroke: var(--color-pigeon-600);
  }
  span {
    max-width: 100%;
    overflow: hidden;
    white-space: pre;
  }
`;
const StyledButton = styled.button.attrs({
    className: 'amp-dropdown-button',
}) `
  ${(props) => getMenuTriggerStyles(props)}

  color: ${({ hasSelection }) => !hasSelection && Colors$1.Pigeon600};
  justify-content: flex-start;
`;
const StyledTrigger = styled.div.attrs({
    className: 'amp-dropdown-trigger',
}) `
  ${(props) => getMenuTriggerStyles(props)}

  color: ${({ hasSelection }) => !hasSelection && Colors$1.Pigeon600};
  justify-content: flex-start;
`;
styled(Typography).attrs({
    type: 'b1',
    color: Colors$1.Pigeon600,
}) `
  padding: 6px 16px;
  background-color: ${Colors$1.Pigeon100};
`;
const CustomTriggerButton = styled.button `
  cursor: pointer;
  background: none;
  border: none;
  outline: none;
  display: block;
  font-size: inherit;
  margin: 0;
  padding: 0;
  width: 100%;
  border-radius: 2px;

  ${({ isFocusVisible }) => isFocusVisible && getFocusOutline(Colors$1.Electric600)}
`;
const IconsContainer = styled.div `
  align-items: center;
  background-color: ${Colors$1.White};
  display: flex;
  gap: 8px;
  padding-left: 8px;
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
`;

const DropdownTriggerIcons = ({ loading, error, hideArrow, triggerProps, }) => {
    return (jsx(IconsContainer, { children: loading ? (jsx(Spinner, {})) : (jsxs(Fragment, { children: [error && (jsx(Icon, { name: 'alertCircle', size: 16, "aria-label": 'error-icon', color: Colors$1.Pinata900 })), !hideArrow &&
                    (triggerProps ? (jsx(IconButton, { ...triggerProps, name: 'chevronDown', size: 16, "aria-label": 'dropdown-arrows-icon' })) : (jsx(Icon, { name: 'chevronDown', size: 16, "aria-label": 'dropdown-arrows-icon' })))] })) }));
};
const DropdownTrigger = ({ loading, error, direction, icon, buttonProps, buttonRef, label, isOpen, isFocusVisible, valueProps = {}, triggerProps, }) => {
    const TriggerElement = (buttonProps ? StyledButton : StyledTrigger);
    return (jsxs(DropdownTriggerContainer, { children: [jsxs(TriggerElement, { ...(buttonProps ?? {}), ref: buttonRef, error: error, hasSelection: !!label, isOpen: !!isOpen, direction: direction, isFocusVisible: isFocusVisible, "data-testid": 'dropdown-trigger-element', children: [icon, jsx("span", { ...valueProps, children: label ?? 'Select an option' })] }), jsx(DropdownTriggerIcons, { loading: loading, error: error, triggerProps: triggerProps })] }));
};

const useDropdownHover = ({ isDisabled }) => {
    const [isHovering, setIsHovering] = useState(false);
    const { hoverProps, isHovered } = $6179b936705e76d3$export$ae780daf29e6d456({ isDisabled });
    const handleTriggerEnter = () => {
        if (!isDisabled) {
            setIsHovering(true);
        }
    };
    useEffect(() => {
        if (isHovered) {
            setIsHovering(isHovered);
        }
    }, [isHovered]);
    return {
        isHovering,
        setIsHovering,
        hoverProps,
        triggerProps: { onMouseEnter: handleTriggerEnter },
    };
};

const MultiSelectDropdown = (props) => {
    const { error, loading, searchable, defaultOpen, customButton, minWidth, maxWidth, initializeEmptyInput, trigger, onDropdownClose, onBeforeOpen, onSearchChange, isDisabled, isFocused, isClickOutsideDisabled, } = props;
    const buttonRef = useRef(null);
    const inputRef = useRef(null);
    const containerRef = useRef(null);
    const state = $875d6693e12af071$export$728d6ba534403756(props);
    const [isOpen, setIsOpen] = useState(defaultOpen ?? false);
    const [inputValue, setInputValue] = useState('');
    const { isHovering, setIsHovering, hoverProps, triggerProps } = useDropdownHover({ isDisabled });
    const openDropdown = () => {
        if (isOpen) {
            return;
        }
        if (onBeforeOpen) {
            onBeforeOpen();
        }
        setIsOpen(true);
    };
    const closeDropdown = () => {
        if (!isOpen) {
            return;
        }
        setIsOpen(false);
        setIsHovering(false);
        if (onDropdownClose) {
            onDropdownClose(decodeKeys(state.selectionManager.selectedKeys));
        }
    };
    const toggleDropdown = () => {
        if (isOpen) {
            closeDropdown();
        }
        else {
            openDropdown();
        }
    };
    const focusInput = () => {
        inputRef?.current?.focus();
    };
    const blurInput = () => {
        inputRef?.current?.blur();
    };
    const { buttonProps } = $701a24aa0da5b062$export$ea18c227d4417cc3({ onPress: toggleDropdown, isDisabled }, buttonRef);
    const { isFocusVisible, focusProps } = $f7dceffc5ad7768b$export$4e328f61c538687f();
    useEffect(() => {
        if (isOpen && initializeEmptyInput) {
            setInputValue('');
            focusInput();
        }
    }, [isOpen]);
    useEffect(() => {
        if (isOpen && !loading) {
            focusInput();
        }
    }, [loading]);
    useEffect(() => {
        if (trigger !== 'hover')
            return;
        if (isHovering) {
            openDropdown();
        }
    }, [isHovering, trigger]);
    useEffect(() => {
        if (trigger !== 'hover')
            return;
        if (isFocused === false) {
            closeDropdown();
        }
    }, [isFocused, trigger]);
    const handleKeyDown = (e) => {
        if (trigger !== 'hover' || !isFocused || isDisabled) {
            return;
        }
        if (e.key === 'ArrowRight' && !isOpen) {
            e.preventDefault();
            e.stopPropagation();
            openDropdown();
        }
    };
    const handleInputChange = (e) => {
        const value = e?.target.value ?? '';
        setInputValue(value);
        if (onSearchChange) {
            onSearchChange(value);
        }
    };
    const handleClearInput = () => {
        handleInputChange();
    };
    const handleInputClick = () => {
        focusInput();
    };
    const handleClickOutside = () => {
        if (isClickOutsideDisabled || !isOpen)
            return;
        blurInput();
        closeDropdown();
    };
    useEffect(() => {
        if (trigger === 'hover' && isFocused) {
            document.addEventListener('keydown', handleKeyDown);
        }
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [isFocused, isOpen]);
    useOnClickOutside(containerRef, handleClickOutside);
    const DropdownPopoverInput = searchable ? (jsxs(DropdownTriggerContainer, { children: [jsx(MenuInput, { "aria-label": 'dropdown-search-input', autoFocus: props.autoFocus ?? true, value: inputValue, onChange: handleInputChange, onClick: handleInputClick, onClear: inputValue ? handleClearInput : undefined, inputRef: inputRef, error: error, inner: true, isOpen: isOpen, placeholder: props.placeholder || 'Search or select...', direction: props.direction }), jsx(DropdownTriggerIcons, { loading: loading, error: error, hideArrow: true, triggerProps: {} })] })) : null;
    return (jsxs(Container$3, { minWidth: minWidth, maxWidth: maxWidth, children: [props.label ? jsx(Label$1, { children: props.label }) : null, jsxs(AnchorContainer, { ...hoverProps, ref: containerRef, children: [customButton ? (jsx(CustomTriggerButton, { ...$3ef42575df84b30b$export$9d1611c77c2fe928(buttonProps, focusProps), ...triggerProps, isFocusVisible: isFocusVisible, ref: buttonRef, "data-testid": 'dropdown-trigger', children: customButton })) : (jsx(DropdownTrigger, { error: error, direction: props.direction, isOpen: isOpen, isFocusVisible: isFocusVisible, buttonRef: buttonRef, buttonProps: $3ef42575df84b30b$export$9d1611c77c2fe928(buttonProps, focusProps), label: 'Select options', icon: props.leftIcon, valueProps: {}, triggerProps: triggerProps })), isOpen && (jsx(MenuPopover, { error: error, isOpen: isOpen, onClose: () => null, direction: props.direction, placement: props.placement, type: customButton ? MenuType.context : MenuType.dropdown, borderType: props.borderType, minWidth: props.minPopoverWidth, maxWidth: props.maxPopoverWidth, children: jsxs($9bf71ea28793e738$export$20e40289641fbbb6, { contain: true, restoreFocus: true, autoFocus: true, children: [props.direction !== MenuDirection.up && DropdownPopoverInput, jsx(FilteredDropdownMenu, { optionsMap: props.optionsMap, maxHeight: props.maxPopoverHeight, selectionMode: props.selectionMode, size: props.size, filter: inputValue, searchable: searchable, loading: loading, message: props.message, state: {
                                        ...state,
                                        isOpen,
                                        open: openDropdown,
                                        close: closeDropdown,
                                    } }), props.direction === MenuDirection.up && DropdownPopoverInput] }) }))] }), props.description ? (jsx(Description, { children: props.description })) : null] }));
};

const SearchableDropdown = (props) => {
    const { error, loading, defaultOpen, customButton, minWidth, maxWidth, maxPopoverWidth, initializeEmptyInput, hideArrow, trigger, isDisabled, isClickOutsideDisabled, } = props;
    const { contains } = $bb77f239b46e8c72$export$3274cf84b703fff({ sensitivity: 'base' });
    const onSelectionChange = (key) => {
        props.onSelectionChange?.(decodeKey(key));
    };
    const state = $a9e7382a7d111cb5$export$b453a3bfd4a5fa9e({
        ...props,
        onSelectionChange,
        defaultFilter: contains,
    });
    const buttonRef = useRef(null);
    const inputRef = useRef(null);
    const listBoxRef = useRef(null);
    const popoverRef = useRef(null);
    const containerRef = useRef(null);
    const { inputProps, buttonProps, listBoxProps, labelProps } = $c350ade66beef0af$export$8c18d1b4f7232bbf({
        ...props,
        onSelectionChange,
        inputRef,
        buttonRef,
        listBoxRef,
        popoverRef,
    }, state);
    const [isOpen, setIsOpen] = useState(defaultOpen);
    const { isHovering, setIsHovering, hoverProps, triggerProps } = useDropdownHover({ isDisabled });
    const openDropdown = () => {
        setIsOpen(true);
        state.open();
    };
    const closeDropdown = () => {
        setIsOpen(false);
        state.setOpen(false);
        setIsHovering(false);
    };
    const toggleDropdown = () => {
        if (isOpen) {
            closeDropdown();
        }
        else {
            openDropdown();
        }
    };
    const { buttonProps: customButtonProps } = $701a24aa0da5b062$export$ea18c227d4417cc3({ onPress: toggleDropdown, isDisabled }, buttonRef);
    const { isFocusVisible, focusProps } = $f7dceffc5ad7768b$export$4e328f61c538687f(customButton
        ? undefined
        : {
            within: true,
            isTextInput: true,
        });
    useEffect(() => {
        if (customButton)
            return;
        if (defaultOpen) {
            openDropdown();
        }
        if (initializeEmptyInput) {
            state.setInputValue('');
        }
    }, []);
    useEffect(() => {
        if (customButton && isOpen && initializeEmptyInput) {
            state.setInputValue('');
        }
    }, [isOpen]);
    useEffect(() => {
        if (customButton) {
            closeDropdown();
        }
    }, [state.selectedKey]);
    useEffect(() => {
        if (trigger !== 'hover')
            return;
        if (isHovering) {
            openDropdown();
        }
        else {
            closeDropdown();
        }
    }, [isHovering, trigger]);
    const onInputChange = (e) => {
        if (!customButton) {
            openDropdown();
        }
        if (inputProps.onChange) {
            inputProps.onChange(e);
        }
    };
    const onInputFocus = (e) => {
        if (inputProps.disabled) {
            return;
        }
        if (inputProps.onFocus) {
            inputProps.onFocus(e);
        }
    };
    const onInputClick = (e) => {
        if (!customButton && !state.isOpen) {
            buttonProps?.onPressStart?.(e);
        }
    };
    const showDropdown = customButton ? isOpen : state.isOpen && !loading;
    const onClickOutside = () => {
        if (isClickOutsideDisabled)
            return;
        inputRef?.current?.blur();
        closeDropdown();
    };
    useOnClickOutside(containerRef, onClickOutside);
    const InputContainer = (jsxs(DropdownTriggerContainer, { children: [jsx(MenuInput, { ...(customButton ? inputProps : $3ef42575df84b30b$export$9d1611c77c2fe928(inputProps, focusProps)), size: undefined, autoFocus: props.autoFocus || !!customButton, onChange: onInputChange, onFocus: onInputFocus, onClick: onInputClick, inputRef: inputRef, error: error, inner: !!customButton, isOpen: !!showDropdown, placeholder: props.placeholder || 'Search or select...', direction: props.direction, isFocusVisible: isFocusVisible }), jsx(DropdownTriggerIcons, { loading: loading, error: error, hideArrow: !!(hideArrow || customButton), triggerProps: buttonProps })] }));
    const DropdownPopoverInput = customButton ? InputContainer : null;
    return (jsxs(Container$3, { minWidth: minWidth, maxWidth: maxWidth, children: [props.label ? jsx(Label$1, { ...labelProps, children: props.label }) : null, jsxs(AnchorContainer, { ...hoverProps, ref: containerRef, children: [customButton ? (jsx(CustomTriggerButton, { ...$3ef42575df84b30b$export$9d1611c77c2fe928(customButtonProps, focusProps), ...triggerProps, isFocusVisible: isFocusVisible, ref: buttonRef, "data-testid": 'dropdown-trigger', children: customButton })) : (InputContainer), showDropdown && (jsxs(MenuPopover, { popoverRef: popoverRef, error: error, isOpen: showDropdown, onClose: () => (customButton ? null : closeDropdown()), direction: props.direction, placement: props.placement, type: customButton ? MenuType.context : MenuType.dropdown, borderType: props.borderType, maxWidth: maxPopoverWidth, children: [props.direction !== MenuDirection.up && DropdownPopoverInput, jsx(DropdownMenu, { ...listBoxProps, optionsMap: props.optionsMap, listBoxRef: listBoxRef, maxHeight: props.maxPopoverHeight, selectionMode: props.selectionMode, size: props.size, state: {
                                    ...state,
                                    open: openDropdown,
                                    isOpen: showDropdown,
                                    close: () => (customButton ? null : closeDropdown()),
                                } }), props.direction === MenuDirection.up && DropdownPopoverInput] }))] }), props.description ? (jsx(Description, { children: props.description })) : null] }));
};

function DropdownPopover({ children, state, offset = 0, ...props }) {
    let popoverRef = useRef(null);
    let { popoverProps, underlayProps, arrowProps, placement } = $f2f8a6077418541e$export$542a6fd13ac93354({
        ...props,
        offset,
        popoverRef,
    }, state);
    return (jsx($337b884510726a0d$export$c6fdb837b070b4ff, { children: jsxs("div", { children: [jsx("div", { ...underlayProps, className: 'underlay' }), jsxs("div", { ...popoverProps, ref: popoverRef, className: 'popover', children: [jsx($86ea4cb521eb2e37$export$2317d149ed6f78c4, { onDismiss: state.close }), children, jsx($86ea4cb521eb2e37$export$2317d149ed6f78c4, { onDismiss: state.close })] })] }) }));
}

const SelectDropdown = (props) => {
    const { error, loading, customButton, minWidth, maxWidth, leftIcon } = props;
    const onSelectionChange = (key) => {
        props.onSelectionChange?.(decodeKey(key));
    };
    const state = $2bc3a590c5373a4e$export$5159ec8b34d4ec12({ ...props, onSelectionChange });
    const triggerRef = useRef(null);
    const { labelProps, triggerProps, valueProps, menuProps } = $58aed456727eb0f3$export$e64b2f635402ca43({ ...props, onSelectionChange }, state, triggerRef);
    const { isFocusVisible, focusProps } = $f7dceffc5ad7768b$export$4e328f61c538687f();
    const { buttonProps } = $701a24aa0da5b062$export$ea18c227d4417cc3(triggerProps, triggerRef);
    const maxPopoverWidth = props.maxPopoverWidth ?? maxWidth ? maxWidth + 'px' : undefined;
    let triggerState = $fc909762b330b746$export$61c6a8c84e605fb6(props);
    $628037886ba31236$export$f9d5c8beee7d008d({ type: 'dialog' }, triggerState, triggerRef);
    return (jsxs(Container$3, { minWidth: minWidth, maxWidth: maxWidth, children: [props.label ? jsx(Label$1, { ...labelProps, children: props.label }) : null, jsxs(AnchorContainer, { children: [jsx($bdd25dc72710631f$export$cbd84cdb2e668835, { state: state, triggerRef: triggerRef, label: props.label, name: props.name }), customButton ? (jsx(CustomTriggerButton, { ...$3ef42575df84b30b$export$9d1611c77c2fe928(buttonProps, focusProps), isFocusVisible: isFocusVisible, ref: triggerRef, "data-testid": 'dropdown-trigger', children: customButton })) : (jsx(DropdownTrigger, { loading: loading, error: error, direction: props.direction, isOpen: props.isOpen, isFocusVisible: isFocusVisible, buttonRef: triggerRef, buttonProps: $3ef42575df84b30b$export$9d1611c77c2fe928(buttonProps, focusProps), label: state.selectedItem?.rendered, icon: leftIcon, valueProps: valueProps, triggerProps: triggerProps })), state.isOpen && !loading && (jsx(DropdownPopover, { ...props, placement: 'bottom', triggerRef: triggerRef, state: state, children: jsx(MenuPopoverElement, { minWidth: minWidth + 'px', error: error, type: customButton ? MenuType.context : MenuType.dropdown, borderType: props.borderType, direction: props.direction, placement: MenuPlacement.none /* placement is handled by the DropdownPopover */, maxWidth: maxPopoverWidth, children: jsx(DropdownMenu, { ...menuProps, selectionMode: props.selectionMode, optionsMap: props.optionsMap, state: state, size: props.size, maxHeight: props.maxPopoverHeight }) }) }))] }), props.description ? (jsx(Description, { children: props.description })) : null] }));
};

const Dropdown = ({ direction = MenuDirection.down, placement = MenuPlacement.bottom, grouped = false, searchable, minWidth = 320, maxWidth = 320, selectionMode = MenuSelectionMode.single, ...props }) => {
    const DropdownComponent = selectionMode === MenuSelectionMode.multiple
        ? MultiSelectDropdown
        : searchable
            ? SearchableDropdown
            : SelectDropdown;
    const { disabledKeys, selectedKeys, children, optionsMap } = useMemo(() => grouped
        ? buildMenuGroups(props.optionsList)
        : buildMenuOptions(props.optionsList), [props.optionsList]);
    return (jsx(DropdownComponent, { className: 'ff-ds', direction: direction, placement: direction === MenuDirection.up ? MenuPlacement.top : placement, minWidth: minWidth, maxWidth: maxWidth, disabledKeys: disabledKeys, defaultSelectedKeys: selectedKeys, selectionMode: selectionMode, searchable: searchable, "aria-label": searchable ? 'searchable-dropdown' : 'select-dropdown', ...props, optionsMap: optionsMap, children: children }));
};

const DAY = 24 * 60 * 60 * 1000;
const getDateFromPast = (days, time) => {
    const date = new Date(Date.now() - days * DAY);
    const [startHour, startMinute, startSecond, startMillisecond] = time === 'start' ? [0, 0, 0, 0] : [23, 59, 59, 999];
    date.setUTCHours(startHour, startMinute, startSecond, startMillisecond);
    return date.toISOString();
};
const dateDropdownOptions = [
    {
        label: 'All time',
        key: 'all',
        interval: { start: undefined, end: undefined },
    },
    {
        label: 'Today',
        key: 'today',
        interval: {
            start: getDateFromPast(0, 'start'),
            end: getDateFromPast(0, 'end'),
        },
    },
    {
        label: 'Yesterday',
        key: 'yesterday',
        interval: {
            start: getDateFromPast(1, 'start'),
            end: getDateFromPast(0, 'end'),
        },
    },
    {
        label: 'Last 7 days',
        key: '7-days',
        interval: {
            start: getDateFromPast(7, 'start'),
            end: getDateFromPast(0, 'end'),
        },
    },
    {
        label: 'Last 30 days',
        key: '30-days',
        interval: {
            start: getDateFromPast(30, 'start'),
            end: getDateFromPast(0, 'end'),
        },
    },
    {
        label: 'Last 3 months',
        key: '3-months',
        interval: {
            start: getDateFromPast(90, 'start'),
            end: getDateFromPast(0, 'end'),
        },
    },
    {
        label: 'Last 12 months',
        key: '12-months',
        interval: {
            start: getDateFromPast(365, 'start'),
            end: getDateFromPast(0, 'end'),
        },
    },
];
const CalIcon = styled(Icon) `
  fill: none !important;
  margin-right: 8px;
  transform: scale(0.6);
  color: ${Colors$1.Pigeon600} !important;
`;
const DateDropdown = ({ onChange, loading, }) => {
    return (jsx(Dropdown, { "aria-label": 'Date filter', optionsList: dateDropdownOptions, onSelectionChange: onChange, leftIcon: jsx(CalIcon, { name: 'calendarLight', height: '14', width: '14', viewBox: '0 0 14 14' }), loading: loading }));
};

const IconNames = Object.keys(Icons);

const CheckboxContainer = styled.span `
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;

  label {
    ${({ smallLabel }) => getFont(smallLabel ? 'b2' : 'b1')}
  }

  input[type='checkbox'] {
    width: 16px;
    height: 16px;
    margin: 0;
    appearance: none;
    border-radius: ${({ borderRadius }) => borderRadius ?? `4px`};
    border: ${`1px solid ${Colors$1.Pigeon600}`};
    background-color: ${Colors$1.White};

    ${({ borderColor }) => borderColor &&
    css `
        border-color: ${borderColor} !important;
      `}

    &:checked {
      background-color: ${({ color }) => color ?? Colors$1.ElectricBrand};
    }
  }

  .checkmark {
    position: absolute;
    display: block;
    color: ${Colors$1.White};
    align-self: center;
    justify-self: center;
    top: 2px;
    left: 2px;
    path {
      stroke: currentColor;
      stroke-width: 2px;
    }
  }
`;
const PartialIcon = styled.div `
  background: ${Colors$1.Pigeon600};
  height: 2px;
  width: 8px;
  position: absolute;
  border-radius: 2px;
  margin-left: 4px;
  align-self: center;
`;
const CheckboxInput = ({ color, partial, smallLabel, borderColor, ...props }) => {
    const onChange = props.disabled
        ? undefined
        : (e) => props.onChange(e);
    const onClick = props.disabled
        ? undefined
        : (e) => {
            if (props.onChange) {
                const fakeEvent = {
                    target: { checked: !props.checked },
                    currentTarget: { checked: !props.checked },
                };
                props.onChange(fakeEvent);
            }
        };
    return (jsxs(CheckboxContainer, { color: color, smallLabel: smallLabel, borderColor: borderColor, "data-testid": 'amp-checkbox', children: [jsx("input", { ...props, onChange: onChange, type: 'checkbox', role: 'checkbox', id: 'amp-checkbox' }), partial && jsx(PartialIcon, { onClick: onClick }), props.label ? jsx("label", { onClick: onClick, children: props.label }) : null, props.checked && (jsx(Icon, { onClick: onClick, name: 'checkmark', size: 12, className: 'checkmark' }))] }));
};

const onMention = (text, list) => {
    const search = text.substr(1).trim().toLocaleLowerCase();
    const originalSearch = text.substr(1).toLocaleLowerCase();
    const results = list.filter((item) => item.name.toLocaleLowerCase().includes(search) ||
        (item.key && item.key.toLocaleLowerCase().includes(search)));
    const hasExactMatch = list.some((item) => item.name.toLocaleLowerCase() === search);
    const hasTwoOrMoreTrailingSpaces = originalSearch.length - search.length >= 2;
    if (results.length === 0 || (hasTwoOrMoreTrailingSpaces && hasExactMatch)) {
        return [
            {
                name: 'Dismiss',
                ref: 'no_results',
                type: 'no_results',
                groupName: 'No Results Found',
            },
        ];
    }
    return results;
};

const noop$1 = () => { };

const initialContext = {
    getTransformedValue: () => '',
    insertFragment: noop$1,
    setValue: noop$1,
    activeSearch: '',
    inputElement: null,
    setInputElement: noop$1,
    selectItem: noop$1,
    executeActionCallback: noop$1,
    setActiveItemIndex: noop$1,
    opened: null,
    index: 0,
    loading: false,
    results: [],
    closeAutocomplete: noop$1,
    openAutocomplete: noop$1,
    onBeforeChanges: noop$1,
    onKeyDown: noop$1,
    onChanges: noop$1,
    fixed: true,
    setPositionFixed: noop$1,
};
const RichMentionsContext = createContext(initialContext);

// Function to extract mentions from defaultValue
const extractMentionsFromDefaultValue = (htmlString) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    const mentionElements = doc.querySelectorAll('[data-rich-mentions]');
    const mentions = Array.from(mentionElements).map((el) => el.getAttribute('data-rich-mentions') || '');
    return mentions.filter((mention) => mention);
};
function RichMentionsInput({ defaultValue, autoFocus, onMentionChange, ...divAttributes }) {
    const ref = useRef(null);
    const { inputElement, setInputElement, onBeforeChanges, onKeyDown, onChanges, getInitialHTML, } = useContext(RichMentionsContext);
    const [mentions, setMentions] = useState(() => {
        if (defaultValue && getInitialHTML) {
            const html = getInitialHTML(defaultValue);
            return extractMentionsFromDefaultValue(html);
        }
        return [];
    });
    if (ref.current === null && defaultValue && getInitialHTML) {
        const html = getInitialHTML(defaultValue);
        ref.current = html;
    }
    const mergeOnKeyDown = (event) => {
        onKeyDown(event);
        if (divAttributes.onKeyDown) {
            divAttributes.onKeyDown(event);
        }
    };
    const onInput = (event) => {
        if (divAttributes.onInput) {
            divAttributes.onInput(event);
        }
        onChanges(event);
    };
    const onBeforeInput = (event) => {
        onBeforeChanges(event);
        if (divAttributes.onBeforeInput) {
            divAttributes.onBeforeInput(event);
        }
    };
    // autoFocus
    React__default.useEffect(() => {
        if (inputElement && autoFocus) {
            const range = document.createRange();
            range.selectNodeContents(inputElement);
            range.collapse(false); // false parameter sets the cursor at the end, true would set it at the start
            const selection = window.getSelection();
            if (selection) {
                selection.removeAllRanges();
                selection.addRange(range);
            }
            inputElement.focus();
        }
    }, [inputElement, autoFocus]);
    // Manages the addition and removal of mentions
    React__default.useEffect(() => {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    // @ts-ignore
                    if (node?.parentNode?.dataset?.richMentions) {
                        // @ts-ignore
                        const ref = node?.parentNode?.dataset?.richMentions;
                        if (ref) {
                            setMentions((prevMentions) => [...prevMentions, ref]);
                        }
                    }
                    else if (node.nodeType === Node.ELEMENT_NODE) {
                        // @ts-ignore
                        if (node?.hasAttribute('data-rich-mentions')) {
                            // @ts-ignore
                            const ref = node?.getAttribute('data-rich-mentions');
                            if (ref) {
                                setMentions((prevMentions) => [...prevMentions, ref]);
                            }
                        }
                    }
                });
                mutation.removedNodes.forEach((node) => {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        const element = node;
                        if (element.hasAttribute('data-rich-mentions')) {
                            const ref = element.getAttribute('data-rich-mentions');
                            if (ref) {
                                setMentions((prevMentions) => prevMentions.filter((mention) => mention !== ref));
                            }
                        }
                    }
                });
            });
        });
        // Configuration for the observer (what mutations to observe)
        const config = { childList: true, subtree: true };
        // Start observing the target node for configured mutations
        if (inputElement) {
            observer.observe(inputElement, config);
        }
        // Disconnect the observer on component unmount
        return () => observer.disconnect();
    }, [inputElement]); // Dependencies
    // Invoke the onMentionChange callback with the current mentions
    React__default.useEffect(() => {
        if (onMentionChange) {
            onMentionChange(mentions);
        }
    }, [mentions, onMentionChange]);
    return (jsx("div", { ref: setInputElement, ...divAttributes, "data-testid": 'input', contentEditable: true, onBeforeInput: onBeforeInput, onKeyDown: mergeOnKeyDown, onInput: onInput, dangerouslySetInnerHTML: { __html: ref.current || '' }, placeholder: 'Describe how you would like to transform your data...' }));
}

function setCursorPosition(element, position) {
    const selection = document.getSelection();
    const range = document.createRange();
    range.setStart(element, position);
    range.collapse(true);
    if (selection) {
        selection.removeAllRanges();
        selection.addRange(range);
    }
}

function deleteSelection(selection, event) {
    let deleted = false;
    let lastDeletedRange = null;
    for (let i = 0; i < selection.rangeCount; ++i) {
        const range = selection.getRangeAt(i);
        if (range.startContainer !== range.endContainer ||
            range.startOffset !== range.endOffset) {
            deleted = true;
            lastDeletedRange = range;
            range.deleteContents();
        }
    }
    // @ts-ignore
    if (event?.data && lastDeletedRange) {
        // @ts-ignore
        const textNode = document.createTextNode(event.data);
        lastDeletedRange.insertNode(textNode);
        setCursorPosition(textNode, 1);
        event.preventDefault();
    }
    return deleted;
}

function nodeToHtmlElement(node) {
    return node.nodeType === Node.TEXT_NODE
        ? node.parentElement
        : node;
}

function escapeFragmentWithValue(element, text, position = 'after') {
    const textNode = document.createTextNode(text.replace(/\s/g, '\u00A0'));
    const parent = element.parentElement;
    if (parent) {
        if (position === 'after') {
            parent.insertBefore(textNode, element.nextSibling);
        }
        else {
            parent.insertBefore(textNode, element);
        }
        setCursorPosition(textNode, text.length);
    }
}

function fixCursorInsertion(event, selection) {
    if (event.defaultPrevented) {
        return;
    }
    // @ts-ignore
    const insertion = event.data;
    const container = event.currentTarget;
    for (let i = 0; i < selection.rangeCount; i++) {
        const range = selection.getRangeAt(i);
        // Same element
        if (range.startContainer === range.endContainer) {
            const element = nodeToHtmlElement(range.startContainer);
            if (!container.contains(element)) {
                continue;
            }
            // If outside pending fragment, insert char inside
            if (range.startContainer instanceof Text && range.startOffset === 0) {
                const previousChild = range.startContainer.previousSibling;
                const previousElement = range.startContainer.previousElementSibling;
                if (previousChild &&
                    previousElement &&
                    previousChild === previousElement &&
                    previousElement.hasAttribute('data-rich-mentions') &&
                    !previousElement.hasAttribute('data-integrity')) {
                    previousElement.appendChild(document.createTextNode(insertion));
                    event.preventDefault();
                    continue;
                }
            }
            // TODO range.endContainer
            if (!element ||
                container === element ||
                !element.hasAttribute('data-rich-mentions')) {
                continue;
            }
            // At first position of fragment, move before it
            if (range.endOffset === 0) {
                escapeFragmentWithValue(element, insertion, 'before');
                event.preventDefault();
                continue;
            }
            const isFinal = element.hasAttribute('data-integrity');
            const text = element.textContent || '';
            // Move outside final fragment
            if (isFinal && range.startOffset === text.length) {
                escapeFragmentWithValue(element, insertion, 'after');
                event.preventDefault();
                continue;
            }
        }
    }
}

function transformFinalFragment(span, ref, config) {
    const content = ref
        .replace(config.match, config.matchDisplay)
        .replace(/\s/g, '\u00A0');
    span.textContent = content;
    span.setAttribute('data-rich-mentions', ref);
    span.setAttribute('spellcheck', 'false');
    if (process.env.NODE_ENV !== 'production') {
        span.setAttribute('data-testid', 'final');
    }
    if (config.customizeFragment) {
        config.customizeFragment(span, true);
    }
    span.setAttribute('data-integrity', span.innerHTML);
    if (span.parentElement) {
        // TODO only if no space after
        const textNode = document.createTextNode('\u00A0');
        span.parentElement.insertBefore(textNode, span.nextSibling);
        setCursorPosition(textNode, 1);
    }
}

function replaceSpacesWithInsecableSpaces(text) {
    const div = document.createElement('div');
    div.innerHTML = text;
    function recursiveSpaceReplacer(element) {
        Array.from(element.childNodes).forEach((element) => {
            if (element instanceof Text && element.nodeValue) {
                element.nodeValue = element.nodeValue.replace(/( |\t)/g, '\u00A0');
            }
            else if (element instanceof HTMLElement) {
                recursiveSpaceReplacer(element);
                if (element.hasAttribute('data-rich-mentions') &&
                    !element.hasAttribute('data-integrity')) {
                    element.setAttribute('data-integrity', element.innerHTML);
                }
            }
        });
    }
    recursiveSpaceReplacer(div);
    return div.innerHTML;
}
function getConfigsInitialValue(configs) {
    return (text) => {
        // This replace all fragment "<@vince|U515>" to html ones based on your configs
        const formattedTextWithHtml = configs.reduce((acc, config) => {
            return acc.replace(config.match, ($0) => {
                const span = document.createElement('span');
                transformFinalFragment(span, $0, config);
                return span.outerHTML;
            });
        }, text);
        // We replace all text spaces with unbreakable ones to avoid problem with contenteditable.
        // Currently, contenteditable remove multiple space but we want to keep it.
        return replaceSpacesWithInsecableSpaces(formattedTextWithHtml);
    };
}

function getFragment(node) {
    const element = nodeToHtmlElement(node);
    return element?.hasAttribute('data-rich-mentions') ? element : null;
}

function getTransformedValue(inputElement) {
    if (!inputElement || inputElement.innerHTML === '<br>') {
        return '';
    }
    const brCharacter = `_br_${Date.now()}_`;
    const brMatcher = new RegExp(`\\n?${brCharacter}\\n?`, 'g');
    return Array.from(inputElement.childNodes)
        .map((el) => getNodeContent(el, brCharacter))
        .join('')
        .replace(/\u00A0/g, ' ') // Replace back insecable spaces
        .replace(/\n{2,}/g, '\n') // Following lines are considered as one in HTML
        .replace(brMatcher, '\n') // Replace <br/> to line break
        .trim();
}
function getNodeContent(element, brCharacter) {
    if (element instanceof Text) {
        return element.textContent || '';
    }
    if (element instanceof HTMLBRElement) {
        return brCharacter;
    }
    if (element instanceof Element) {
        const richValue = element.getAttribute('data-rich-mentions');
        if (richValue) {
            return richValue;
        }
        const char = element instanceof HTMLDivElement ? '\n' : '';
        const result = Array.from(element.childNodes)
            .map((el) => getNodeContent(el, brCharacter))
            .join('');
        return `${char}${result}${char}`;
    }
    return '';
}

function handleFragmentCreation(event, selection, configs, ctx) {
    const { anchorNode, anchorOffset } = selection;
    if (event.defaultPrevented || !anchorNode || getFragment(anchorNode)) {
        return;
    }
    // @ts-ignore Find a property type instead of React.FormEvent<HTMLDivElement> ?
    const insertion = event.data;
    const fragmentText = anchorNode.textContent || '';
    // Build new text fragment with insertion
    const text = fragmentText.substr(0, anchorOffset) +
        insertion +
        fragmentText.substr(anchorOffset);
    // No match
    const config = configs.find((cfg) => text.match(cfg.query));
    if (!config) {
        return;
    }
    const matches = text.match(config.query);
    const index = matches.index || 0;
    const textBeforeQuery = text.substr(0, index);
    // Do nothing if there is a valid character before.
    // Do nothing if the range overflow the fragment position
    if ((textBeforeQuery.length && !/\W$/.test(textBeforeQuery)) ||
        anchorOffset < index ||
        anchorOffset >= index + matches[0].length) {
        return;
    }
    anchorNode.textContent = textBeforeQuery;
    const fragment = document.createElement('span');
    const textQuery = matches[0].substr(0, anchorOffset - index + insertion.length);
    const afterInsertion = text.substr(index + textQuery.length);
    fragment.setAttribute('data-rich-mentions', '');
    fragment.setAttribute('spellcheck', 'false');
    if (process.env.NODE_ENV !== 'production') {
        fragment.setAttribute('data-testid', 'pending');
    }
    fragment.textContent = textQuery;
    if (config.customizeFragment) {
        config.customizeFragment(fragment, false);
    }
    const after = document.createTextNode(/^\s/.test(afterInsertion) ? afterInsertion : ' ' + afterInsertion);
    const isContainer = event.currentTarget === anchorNode;
    const parent = isContainer ? anchorNode : anchorNode.parentElement;
    if (parent) {
        if (isContainer) {
            parent.appendChild(fragment);
            parent.appendChild(after);
        }
        else {
            parent.insertBefore(after, anchorNode.nextSibling);
            parent.insertBefore(fragment, anchorNode.nextSibling);
        }
    }
    event.preventDefault();
    if (!fragment.childNodes[0]) {
        return;
    }
    setCursorPosition(fragment.childNodes[0], anchorOffset - textBeforeQuery.length + 1);
    ctx.openAutocomplete(fragment, textQuery, config);
}

const removeIfFinalFragment = (node, container) => {
    const element = nodeToHtmlElement(node);
    if (!container.contains(element) || container === element) {
        return;
    }
    if (element && element.hasAttribute('data-integrity')) {
        container.removeChild(element);
    }
};
function handleFragmentDeletion(event, selection) {
    if (event.defaultPrevented) {
        return;
    }
    const container = event.currentTarget;
    for (let i = 0; i < selection.rangeCount; i++) {
        const range = selection.getRangeAt(i);
        removeIfFinalFragment(range.startContainer, container);
        removeIfFinalFragment(range.endContainer, container);
    }
}

function removeBrokenFragments(inputElement, configs) {
    Array.from(inputElement.children).forEach(function fixBrokenElement(element, index) {
        const parent = element.parentElement;
        // Replace BR with div>br
        // There is a bug on chrome occuring when the cursor is just after a br, the selection is broken and
        // we can't locate its position. By moving them inside a div it fixes the problem
        if (element instanceof HTMLBRElement) {
            if (parent.children.length !== 1 &&
                index !== parent.children.length - 1) {
                const div = document.createElement('div');
                parent.insertBefore(div, element);
                div.appendChild(element);
            }
            return;
        }
        if (element instanceof HTMLDivElement && !element.attributes.length) {
            Array.from(element.children).forEach(fixBrokenElement);
            return;
        }
        const text = element.textContent || '';
        // Fixes a Chrome bug:
        // - Add a span with color on a contenteditable.
        // - Remove the span with backspace.
        // - Type text.
        // Chrome will try to restore the style by adding a <font> with specific styles.
        if (!(element instanceof Text) &&
            !element.hasAttribute('data-rich-mentions')) {
            parent.insertBefore(document.createTextNode(text), element);
            parent.removeChild(element);
            return;
        }
        // On final fragments, avoid edition.
        // The data-integrity attribute contains the original fragment content.
        // If it does not match, just remove the entire fragment.
        if (element.hasAttribute('data-integrity')) {
            // final fragment, if not valid remove it completely
            if (element.getAttribute('data-integrity') !== element.innerHTML) {
                // Assuming `element` is the one being removed
                const parentNode = element.parentNode;
                if (parentNode) {
                    let targetNode = element.previousSibling;
                    let position = 0; // Default to start
                    if (targetNode && targetNode.nodeType === Node.TEXT_NODE) {
                        // If there's a text node before, set cursor at its end
                        // @ts-ignore
                        position = targetNode.length;
                        setCursorPosition(targetNode, position);
                    }
                    else if (!targetNode && parentNode.firstChild) {
                        // If no previous sibling, but there are other children, set at start of the first child
                        setCursorPosition(parentNode.firstChild, 0);
                    }
                    else {
                        // Fallback to setting at the start of the parent
                        setCursorPosition(parentNode, 0);
                    }
                    // Remove the element after calculating position
                    parentNode.removeChild(element);
                }
            }
            return;
        }
        // If we have a pending fragment that is now invalid since the last (let
        // say you just removed the '@' from it, then we can safely extract the
        // text, remove the fragment, and insert the text back without it.
        const isValid = configs.some((cfg) => text.match(cfg.query));
        if (!isValid) {
            parent.insertBefore(document.createTextNode(text), element.nextSibling);
            parent.removeChild(element);
        }
    });
}

const isSpace = (char) => /(\u00A0|\s)/.test(char);
const needSpaceBefore = (text, offset, node, defaultValue) => {
    if (offset > 0) {
        return !isSpace(text.charAt(offset - 1));
    }
    // Do not add space if the previous element is a block adding a line break
    if (['DIV', 'BR'].includes(node.nodeName)) {
        return false;
    }
    if (node.previousSibling) {
        // TODO get first previous element with text
        const prevText = node.previousSibling.textContent || '';
        return !!prevText.length && !isSpace(prevText.charAt(prevText.length - 1));
    }
    return defaultValue;
};
const needSpaceAfter = (text, offset, node) => {
    if (offset < text.length) {
        return !isSpace(text.charAt(text.length - 1));
    }
    if (!node.nextSibling) {
        return true;
    }
    const nextText = node.nextSibling.textContent || '';
    // TODO get first next fragment with content...
    return !nextText.length || !isSpace(nextText.charAt(0));
};
function insertFragment(ref, customFragment, configs, inputElement) {
    const config = configs.find((cfg) => ref.match(cfg.match));
    // inputElement was removed from DOM for some reasons
    if (!inputElement || (!config && !customFragment)) {
        return;
    }
    let insertAfterNode = null;
    let insertBeforeNode = null;
    let addSpaceBefore = false;
    let addSpaceAfter = false;
    const selection = document.getSelection();
    // Is selection inside inputElement ?
    // (avoid inserting fragments on other parts of the website)
    if (selection &&
        selection.anchorNode &&
        inputElement.contains(selection.anchorNode)) {
        let { anchorNode: node, anchorOffset: offset } = selection;
        let fragment = getFragment(node);
        // Avoid problem with text selection
        // Just delete it before processing
        deleteSelection(selection);
        // If we are at the fragment end when inserting content, we have to
        // change the cursor position to be at first position on the next one.
        // If the next fragment does not exist, add a new one.
        // <span>"text"|<span>   -> <span>"text"</span>"|"
        if (fragment && offset === (node.textContent || '').length) {
            if (!fragment.nextSibling) {
                inputElement.insertBefore(document.createTextNode(''), null);
            }
            node = fragment.nextSibling;
            offset = 0;
            fragment = null;
        }
        if (fragment) {
            // Final fragment can't be edited
            // Just remove it and add the insertion just after.
            if (fragment.hasAttribute('data-integrity')) {
                insertBeforeNode = fragment.nextSibling;
                fragment.parentElement?.removeChild(fragment);
            }
            else {
                const text = node.textContent || '';
                // In this case, we are in the middle of a pending fragment.
                // <span>@vin|ce</span> -> <span>@vin</span>" [insertion] "ce"
                if (offset > 0 && offset < text.length) {
                    const firstPart = text.substr(0, offset);
                    const secondPart = text.substr(offset);
                    const subFragment = document.createTextNode(secondPart);
                    inputElement.insertBefore(subFragment, fragment.nextSibling);
                    node.textContent = firstPart;
                    addSpaceBefore = true;
                    insertBeforeNode = subFragment;
                }
                addSpaceBefore = needSpaceBefore(text, offset, node, addSpaceBefore);
                addSpaceAfter = needSpaceAfter(text, offset, node);
            }
        }
        else {
            // Text inside the contenteditable (not nested)
            let text = node.textContent || '';
            // If we are at the first position in a fragment, we need to insert the new
            // fragment before it, not after.
            if (offset > 0) {
                insertAfterNode = node;
            }
            else {
                // If next block is <div><br/></div> we have to replace it to a single <div></div>
                const element = node;
                if (!text &&
                    element.nodeName === 'DIV' &&
                    !element.attributes.length &&
                    element.childNodes.length === 1 &&
                    element.firstElementChild instanceof HTMLBRElement) {
                    if (element.previousSibling instanceof HTMLDivElement) {
                        insertBeforeNode = node;
                        element.removeChild(element.firstElementChild);
                    }
                    else {
                        insertAfterNode = node;
                        element.removeChild(element.firstElementChild);
                    }
                }
                else {
                    insertBeforeNode = node;
                }
            }
            // In this case, we need to add the insertion at the center of a TextNode.
            // Let say we have "hello|world", as you can't add span inside TextNode, we have
            // to split it in two differents nodes : "Hello" and "world", and insert the span
            // between them.
            if (offset > 0 && offset < text.length) {
                const firstPart = text.substr(0, offset);
                const secondPart = text.substr(offset);
                text = firstPart;
                node.textContent = firstPart;
                node.parentElement?.insertBefore(document.createTextNode(secondPart), node.nextSibling);
            }
            addSpaceBefore = needSpaceBefore(text, offset, node, addSpaceBefore);
            addSpaceAfter = needSpaceAfter(text, offset, node);
        }
    }
    else {
        // Can't find the selection, let's just insert the fragment at the
        // end of the div[contenteditable]
        const text = inputElement.textContent || '';
        addSpaceAfter = true;
        addSpaceBefore = !isSpace(text.charAt(text.length - 1));
    }
    // Create fragment
    const span = document.createElement('span');
    if (config) {
        transformFinalFragment(span, ref, config);
    }
    else if (customFragment) {
        span.appendChild(customFragment);
        span.setAttribute('data-rich-mentions', ref);
        span.setAttribute('data-integrity', span.innerHTML);
        span.setAttribute('spellcheck', 'false');
        if (process.env.NODE_ENV !== 'production') {
            span.setAttribute('data-testid', 'final');
        }
    }
    // Insert it at chosen position
    if (insertAfterNode && insertAfterNode !== inputElement) {
        insertAfterNode.parentElement?.insertBefore(span, insertAfterNode.nextSibling);
    }
    else if (insertBeforeNode && insertBeforeNode !== inputElement) {
        insertBeforeNode.parentElement?.insertBefore(span, insertBeforeNode);
    }
    else {
        inputElement.appendChild(span);
    }
    // Insert space before if needed
    if (addSpaceBefore) {
        const space = document.createTextNode('\u00A0');
        span.parentElement?.insertBefore(space, span);
    }
    // Insert space after if needed
    if (addSpaceAfter) {
        const space = document.createTextNode('\u00A0');
        span.parentElement?.insertBefore(space, span.nextSibling);
    }
    // Set cursor position (always true)
    if (span.nextSibling) {
        setCursorPosition(span.nextSibling, addSpaceAfter ? 1 : 0);
    }
    // If the user is selecting text and some parts of fragment, we need to be sure to delete it correctly
    // Ex where "[" and "]" are the start and ending of text selection:
    // input: "he[llo <span>@vin]ce</span>"
    // output: "he @insertedfragment <span>ce</span>"
    // In this case, the fragment "ce" need to be deleted.
    removeBrokenFragments(inputElement, configs);
}

function markFragmentAsStale(element) {
    // Example: Remove 'pending' class if it exists
    element.classList.remove('pending');
    // Add 'stale' class to the element
    element.classList.add('stale');
    // Remove the 'data-rich-mentions' attribute
    element.removeAttribute('data-rich-mentions');
    // Optionally, move the cursor outside the stale element
    if (element.nextSibling) {
        setCursorPosition(element.nextSibling, 0);
    }
    else {
        // If there's no nextSibling, append a text node to ensure there's a place to set the cursor
        const textNode = document.createTextNode('\u00A0');
        element.parentNode?.appendChild(textNode);
        setCursorPosition(textNode, 1);
    }
}

function RichMentionsProvider({ children, configs, getContext, getInitialHTML = getConfigsInitialValue(configs), }) {
    // The reference to always have function context working
    const ref = useRef({
        // @ts-ignore
        ...initialContext,
        getInitialHTML,
        setPositionFixed,
        setInputElement,
        selectItem,
        executeActionCallback,
        onBeforeChanges,
        onChanges,
        onKeyDown,
        closeAutocomplete,
        openAutocomplete,
        setActiveItemIndex,
        getTransformedValue: getTransformedValue$1,
        insertFragment: insertFragment$1,
        setValue,
    });
    // The state to controls react rendering
    const [__ctx__, setState] = useState(ref.current);
    const updateState = (data) => {
        ref.current = {
            ...ref.current,
            ...data,
        };
        setState(ref.current);
    };
    // Listen for selection change to open/close the autocomplete modal
    useEffect(() => {
        document.addEventListener('selectionchange', onSelectionChange, false);
        return () => {
            document.removeEventListener('selectionchange', onSelectionChange, false);
        };
    }, []);
    // Expose reference with new context
    useEffect(() => {
        if (typeof getContext === 'function') {
            getContext(__ctx__);
        }
        else if (typeof getContext === 'object') {
            getContext.current = __ctx__;
        }
    }, [getContext, __ctx__]);
    /**
     * Listener to update autocomplete css fixed position
     * Helpful if you have an input fixed at the top/bottom of your website.
     *
     * @param {boolean} fixed Is input element position fixed ? Help to set correct autocomplete position
     * @returns {void}
     */
    function setPositionFixed(fixed) {
        updateState({ fixed });
    }
    /**
     * Listener to set new inputElement.
     * Should be used only by the <InputElement /> to mount/unmount itself
     *
     * @param {HTMLDivElement | null} inputElement input element
     * @returns {void}
     */
    function setInputElement(inputElement) {
        updateState({ inputElement });
    }
    /**
     * Called by the autocomplete to select an item.
     * It will transform the current pending fragment to a final one and
     * reset the autocomplete
     *
     * @param {TMentionItem} item The item from autocomplete to select
     * @returns {void}
     */
    function selectItem(item) {
        const opened = ref.current.opened;
        if (opened?.element) {
            transformFinalFragment(opened.element, item.ref, opened.config);
        }
        updateState({
            index: 0,
            results: [],
            opened: null,
            loading: false,
            activeSearch: '',
        });
    }
    function executeActionCallback(item) {
        if (item.callback) {
            item.callback();
            // Assuming the pending span is the opened element in the context
            const { opened } = ref.current;
            if (opened?.element) {
                // Remove the pending span from the DOM
                opened.element.remove();
            }
            // After executing the callback, you might want to reset the autocomplete state
            updateState({
                index: 0,
                results: [],
                opened: null,
                loading: false,
                activeSearch: '',
            });
        }
    }
    /**
     * Bounded to input.onBeforeInput event.
     * Will help to insert/delete/escape fragment before it already happens to avoid a flash
     *
     * @param {FormEvent<HTMLDivElement>} event
     * @returns {void}
     */
    function onBeforeChanges(event) {
        let selection = document.getSelection();
        if (!selection || !selection.anchorNode) {
            return;
        }
        // If there is text selection, delete it.
        // We need to do it manually because of the preventDefault() :'(
        // Update 'text' variable as the content could be updated
        if (deleteSelection(selection, event)) {
            selection = document.getSelection();
            if (!selection || !selection.anchorNode) {
                return;
            }
        }
        // todo: create new text nodes around fragments which are not valid. i.e @gmail.com should be its own textnode,
        // so a trigger after this text node will open the autocomplete
        //console.log('onBeforeChanges', selection)
        fixCursorInsertion(event, selection);
        handleFragmentDeletion(event, selection);
        //handleFragmentEscape(event, selection, configs)
        handleFragmentCreation(event, selection, configs, ref.current);
        removeBrokenFragments(event.currentTarget, configs);
    }
    /**
     * Will handle document.onSelectionChange event
     * In this case, just to know if wha have focus on a fragment to open/close the autocomplete
     *
     * @returns {void}
     */
    function onSelectionChange() {
        const { inputElement, opened, closeAutocomplete, openAutocomplete } = ref.current;
        const selection = document.getSelection();
        const fragment = selection?.anchorNode &&
            (getFragment(selection.anchorNode) ||
                (selection.anchorOffset === 0 &&
                    selection.anchorNode.previousSibling &&
                    getFragment(selection.anchorNode.previousSibling)));
        const shouldOpened = fragment &&
            !fragment.hasAttribute('data-integrity') &&
            inputElement &&
            inputElement.contains(fragment);
        if (opened && !shouldOpened) {
            closeAutocomplete();
        }
        else if (shouldOpened &&
            fragment &&
            (!opened || opened.element !== fragment)) {
            const text = fragment.textContent || '';
            const config = configs.find((cfg) => text.match(cfg.query));
            if (config) {
                openAutocomplete(fragment, text, config);
            }
        }
    }
    /**
     * Handle input.onChange event
     * This part is just to remove broken fragment (let say you removed the "@" of a mention) and to
     * Open/Close autocomplete based on the new cursor position.
     *
     * @param {FormEvent<HTMLDivElement>} event
     * @returns {void}
     */
    function onChanges() {
        const { inputElement, openAutocomplete, closeAutocomplete } = ref.current;
        const selection = document.getSelection();
        if (inputElement) {
            removeBrokenFragments(inputElement, configs);
        }
        // Autocomplete
        const fragment = selection?.anchorNode && getFragment(selection.anchorNode);
        if (fragment && !fragment.hasAttribute('data-integrity')) {
            const text = fragment.textContent || '';
            const config = configs.find((cfg) => text.match(cfg.query));
            if (config) {
                openAutocomplete(fragment, text, config);
            }
        }
        else if (ref.current.opened) {
            closeAutocomplete();
        }
    }
    /**
     * Handle input.onKeyDown event
     * Just to manage the selected item on the autocomplete if opened
     *
     * @param {KeyboardEvent<HTMLDivElement>} event
     * @returns {void}
     */
    function onKeyDown(event) {
        const { opened, results, index, selectItem, closeAutocomplete } = ref.current;
        if (!opened || !results.length) {
            return;
        }
        switch (event.keyCode) {
            case 40: // down
                event.preventDefault();
                updateState({
                    index: index + 1 < results.length ? index + 1 : 0, // Loop to the top if at the bottom
                });
                break;
            case 38: // up
                event.preventDefault();
                updateState({
                    index: index - 1 >= 0 ? index - 1 : results.length - 1, // Loop to the bottom if at the top
                });
                break;
            case 9: // tab
            case 13: // enter
                if (results[index]) {
                    event.preventDefault();
                    event.stopPropagation();
                    // Check if the selected item is of type 'no_results'
                    // Inside the event handler where 'no_results' is detected
                    if (results[index].type === 'no_results') {
                        if (opened?.element) {
                            markFragmentAsStale(opened.element);
                        }
                    }
                    // Check if the selected item is an action with a callback
                    else if (results[index].type === 'action' &&
                        typeof results[index].callback === 'function') {
                        // Execute the callback function
                        executeActionCallback(results[index]);
                    }
                    else {
                        // For non-action items or actions without a callback, proceed with the standard selectItem action
                        selectItem(results[index]);
                    }
                }
                break;
            case 32: // space bar
                if (opened &&
                    results.length === 1 &&
                    results[0].type === 'no_results') {
                    event.preventDefault();
                    markFragmentAsStale(opened.element); // Mark the mention fragment as stale.
                    // This could involve visually indicating that the mention query is not valid (e.g., by changing its color or styling).
                    updateState({
                        index: 0,
                        results: [],
                        opened: null,
                        loading: false,
                        activeSearch: '',
                    });
                    return; // Exit the function early since we've handled the space bar press in this specific context.
                }
                break;
            case 27: // escape
                closeAutocomplete();
                break;
        }
    }
    /**
     * Public method to close the autocomplete
     *
     * @returns {void}
     */
    function closeAutocomplete() {
        updateState({
            opened: null,
            loading: false,
            results: [],
            index: 0,
            activeSearch: '',
        });
    }
    /**
     * Public method to open the autocomplete
     *
     * @param {HTMLElement} node Selected fragment where to open the autocomplete (for position)
     * @param {string} text The fragment text we are autocompleting for
     * @param {TMentionConfig} config The config object linked to the mention
     * @returns {void}
     */
    function openAutocomplete(node, text, config) {
        const fixed = ref.current.fixed;
        const rect = { top: 0, right: 0, bottom: 0, left: 0 };
        const nodeRect = node.getBoundingClientRect();
        rect.top = nodeRect.top;
        rect.right = nodeRect.right;
        rect.bottom = nodeRect.bottom;
        rect.left = nodeRect.left;
        // Substract based on relative parent if not position:fixed
        if (!fixed && node.offsetParent) {
            const parentRect = node.offsetParent.getBoundingClientRect();
            rect.top -= parentRect.top;
            rect.right = rect.right - parentRect.right + parentRect.width;
            rect.left -= parentRect.left;
            rect.bottom = rect.bottom - parentRect.bottom + parentRect.height;
        }
        // TODO ELEMENT_WIDTH and ELEMENT_HEIGHT from Input Autocomplete element
        const ELEMENT_WIDTH = 200;
        const ELEMENT_HEIGHT = 300;
        // TODO calculate overflow
        const overflowX = nodeRect.left + 10 + ELEMENT_WIDTH - window.innerWidth;
        const overflowY = nodeRect.bottom + ELEMENT_HEIGHT - window.innerHeight;
        const x = overflowX > 0 ? rect.right + 15 : rect.left - 3;
        const y = overflowY > 0 ? rect.top - 3 : rect.bottom + 3;
        updateState({
            loading: true,
            index: 0,
            opened: {
                config,
                fixed,
                bottom: overflowY > 0,
                right: overflowX > 0,
                element: node,
                x,
                y,
            },
            activeSearch: text,
        });
        const onResolve = (results = []) => {
            if (ref.current.opened?.element === node) {
                updateState({
                    results,
                    loading: false,
                });
            }
        };
        const p = config.onMention(text, onResolve);
        if (p instanceof Promise) {
            p.then(onResolve, onResolve);
        }
        else if (p instanceof Array) {
            onResolve(p);
        }
    }
    /**
     * Just set the active item in the autocomplete based on the index.
     * Will work only if autocomplete is already opened
     *
     * @param {number} index The active element in autocomplete to hover
     * @returns {void}
     */
    function setActiveItemIndex(index) {
        updateState({ index });
    }
    /**
     * Transform input html content to usable text by transforming the
     * fragments to valid text and erasing all invalid fragments.
     *
     * @returns {string}
     */
    function getTransformedValue$1() {
        return getTransformedValue(ref.current.inputElement);
    }
    /**
     * Helper to be able to insert a fragment "<@test|U211212>" inside the text
     *
     * @param {string} code The code to insert as fragment (preprocess by configs). Ex: "<@test|U211212>"
     * @param {HTMLElement?} element (optional) the html element to insert
     * @returns {void}
     */
    function insertFragment$1(code, element = null) {
        insertFragment(code, element, configs, ref.current.inputElement);
    }
    /**
     * Helper to be able to change the input content externaly
     *
     * @param {string} text The text to insert
     * @returns {void}
     */
    function setValue(text) {
        const { inputElement, closeAutocomplete } = ref.current;
        if (inputElement) {
            inputElement.innerHTML = getInitialHTML(text);
            removeBrokenFragments(inputElement, configs);
        }
        closeAutocomplete();
    }
    return (jsx(RichMentionsContext.Provider, { value: __ctx__, children: children }));
}

function RichMentionsAutocomplete({ fixed = true }) {
    const { opened, index, 
    //loading,
    results, setActiveItemIndex, selectItem, setPositionFixed, executeActionCallback, } = useContext(RichMentionsContext);
    const listRef = useRef(null); // Ref for the container of the list items
    const onSelectItem = (item) => () => {
        if (item.type === 'action' && item.callback) {
            executeActionCallback(item);
        }
        else {
            selectItem(item);
        }
    };
    const onHoverOrFocusItem = (index) => () => setActiveItemIndex(index);
    const divAttributes = process.env.NODE_ENV !== 'production'
        ? { 'data-testid': 'autocomplete' }
        : {};
    const itemAttributes = process.env.NODE_ENV !== 'production'
        ? { 'data-testid': 'autocomplete_item' }
        : {};
    useEffect(() => {
        setPositionFixed(fixed);
    }, [fixed]);
    useEffect(() => {
        // Ensure the selected item is visible in the viewport, including its group header if it's the first item
        if (listRef.current && opened) {
            const selectableItems = listRef.current.querySelectorAll('.autocomplete-item');
            if (selectableItems.length > 0 && index < selectableItems.length) {
                let elementToScroll = selectableItems[index];
                // Check if the selected item is the first in its group
                const isGroupStart = index === 0 ||
                    elementToScroll.previousElementSibling?.classList.contains('autocomplete-group-name');
                if (isGroupStart && elementToScroll.previousElementSibling) {
                    // If it's the first item, scroll to the group header instead
                    elementToScroll =
                        elementToScroll.previousElementSibling;
                }
                elementToScroll.scrollIntoView({ block: 'nearest' });
            }
        }
    }, [index, opened]);
    const OFFSET = 3;
    return opened && results.length ? (jsx("div", { ...divAttributes, className: 'autocomplete', style: {
            position: fixed ? 'fixed' : 'absolute',
            left: opened.x + OFFSET + 'px',
            top: opened.y + 'px',
        }, children: jsx("div", { ref: listRef, className: 'autocomplete-list', style: {
                bottom: opened.bottom ? '0px' : 'auto',
                right: opened.right ? '0px' : 'auto',
            }, children: results.map((item, i) => {
                const isGroupStart = i === 0 || item.groupName !== results[i - 1].groupName;
                const type = item.type;
                const isMention = item.type === 'mention';
                return (jsxs(React__default.Fragment, { children: [isGroupStart && item.groupName && (jsx("div", { className: 'autocomplete-group-name', children: item.groupName })), jsxs("button", { className: `autocomplete-item autocomplete-item-${type} ${i === index ? 'autocomplete-item-selected' : ''}`, type: 'button', onClick: onSelectItem(item), onMouseOver: onHoverOrFocusItem(i), onFocus: onHoverOrFocusItem(i), ...itemAttributes, children: [jsx("span", { className: 'autocomplete-item-name', children: item.name }), isMention && (jsx("span", { className: 'autocomplete-item-ref', children: item.display }))] })] }, item.ref));
            }) }) })) : null;
}

(jsxs("svg", { width: '12', height: '12', viewBox: '0 0 12 12', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', children: [jsx("g", { clipPath: 'url(#clip0_3766_118549)', children: jsx("path", { d: 'M11.25 1.125C11.25 0.91875 11.4187 0.75 11.625 0.75C11.8312 0.75 12 0.91875 12 1.125V5.25C12 6.28594 11.1609 7.125 10.125 7.125H1.27968L3.63983 9.48516C3.78514 9.63047 3.78514 9.86953 3.63983 10.0148C3.49452 10.1602 3.25546 10.1602 3.11014 10.0148L0.110144 7.01484C-0.0351685 6.86953 -0.0351685 6.63047 0.110144 6.48516L3.11014 3.48516C3.25546 3.33984 3.49452 3.33984 3.63983 3.48516C3.78514 3.63047 3.78514 3.86953 3.63983 4.01484L1.27968 6.375H10.125C10.7461 6.375 11.25 5.87109 11.25 5.25V1.125Z', fill: 'white' }) }), jsx("defs", { children: jsx("clipPath", { id: 'clip0_3766_118549', children: jsx("rect", { width: '12', height: '12', fill: 'white' }) }) })] }));
const CodeIcon = (jsx("svg", { width: '15', height: '9', viewBox: '0 0 15 9', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', children: jsx("path", { d: 'M7.5 7.125C8.4375 7.125 9.28125 6.63281 9.75 5.8125C10.2422 5.01562 10.2422 4.00781 9.75 3.1875C9.28125 2.39062 8.4375 1.875 7.5 1.875C6.53906 1.875 5.69531 2.39062 5.22656 3.1875C4.73438 4.00781 4.73438 5.01562 5.22656 5.8125C5.69531 6.63281 6.53906 7.125 7.5 7.125ZM11.2031 5.0625C10.9219 6.86719 9.375 8.25 7.5 8.25C5.60156 8.25 4.05469 6.86719 3.77344 5.0625H0.5625C0.234375 5.0625 0 4.82812 0 4.5C0 4.19531 0.234375 3.9375 0.5625 3.9375H3.77344C4.05469 2.13281 5.60156 0.75 7.5 0.75C9.375 0.75 10.9219 2.13281 11.2031 3.9375H14.4375C14.7422 3.9375 15 4.19531 15 4.5C15 4.82812 14.7422 5.0625 14.4375 5.0625H11.2031Z', fill: '#8B93A4' }) }));
const StyledShow = styled.div `
  background: #fff;
  padding: 9px;
  font-size: 11px;
  color: rgba(59, 47, 201, 1);
  cursor: pointer;
  border-radius: 2px;
`;
const StyledPromptMenuTitle = styled.div `
  font-size: 12px;
  color: rgba(97, 106, 125, 1);
  font-weight: 500;
  padding: 12px 16px 6px;
`;
const StyledMentionList = styled.div `
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex-wrap: wrap;
  padding: 0 16px;
`;
const StyledMentionItem = styled.div `
  background: ${({ warning }) => warning ? '#FFE9E8' : 'rgba(236, 238, 255, 1)'};
  padding: 8px;
  font-size: 12px;
  color: ${({ warning }) => (warning ? '#920D0D' : 'rgba(59, 47, 201, 1)')};
  cursor: pointer;
  border-radius: 2px;
`;
const StyledInput = styled.div `
  position: relative;
  font-size: 14px;

  [contenteditable='true']:empty:before {
    content: attr(placeholder);
    display: block;
    color: ${Colors$1.Pigeon600};
  }

  & > div[contenteditable='true'] {
    border: 1px solid rgba(202, 208, 220, 1);
    outline: none;
    padding: 10px 16px;
    padding-right: 30px;
    cursor: text;
    background: white;
    max-height: 150px;
    overflow-y: auto;

    &:focus {
      border: 1px solid rgba(139, 147, 164, 1);
    }
  }
`;
const SvgWrapper = styled.div `
  svg path {
    fill: white;
  }
`;
const StyledRichMentionsAutocomplete = styled.div `
  .autocomplete {
    z-index: 99999999;
    font-family: 'Proxima Nova', 'Helvetica', sans-serif;
  }

  .autocomplete-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 12px 0px;
    background-color: #fff;
    border: 1px solid rgba(202, 208, 220, 1);
    min-width: 200px;
    box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 4px 6px -2px rgba(0, 0, 0, 0.05);
    box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
    max-height: 200px;
    overflow: scroll;
  }

  .autocomplete-item {
    padding: 4px 12px;
    outline: none;
    border: none;
    text-align: left;
    background-color: #fff;
    cursor: pointer;
    color: rgba(64, 72, 87, 1);
    font-size: 14px;
    display: flex;
    justify-content: space-between;
  }

  .autocomplete-item-ref {
    color: ${Colors$1.Pigeon600};
    padding-left: 4px;
  }

  .autocomplete-item-selected {
    background-color: rgba(246, 248, 252, 1);
    color: rgba(64, 72, 87, 1);
  }

  .autocomplete-item-action {
    color: rgba(76, 72, 239, 1);
  }

  .autocomplete-item:hover {
    background-color: rgba(246, 248, 252, 1);
  }

  .final {
    background-color: rgba(232, 237, 244, 1);
    color: rgba(9, 11, 43, 1);
    padding: 2px 2px;
  }

  .pending {
    background-color: rgba(236, 238, 255, 1);
    color: rgba(139, 147, 164, 1);
    padding: 2px 2px;
  }

  .autocomplete-group-name {
    font-size: 12px;
    font-weight: 500;
    color: rgba(139, 147, 164, 1);
    padding: 0px 12px;
  }
`;
const PromptList = styled.ul `
  display: flex;
  flex-direction: column;
  margin: 0;
  list-style: none;
  padding: 0;

  > li {
    cursor: pointer;
    padding: 6px 0;

    &:hover,
    :focus {
      background-color: ${Colors$1.Pigeon200};
    }
  }
`;
const PromptListItemContainer = styled.div `
  padding: 0 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
`;
const MentionInput = ({ recentPromptData, defaultValue, onChange, onSubmit, isLoading, mentions, autoFocus, warning: _warning, onMentionChange, }) => {
    const containerRef = React.useRef(null);
    const [isMenuOpen, setIsMenuOpen] = React.useState(false);
    const [inputHeight, setInputHeight] = React.useState('auto');
    const [showAllMentions, setShowAllMentions] = React.useState(false);
    const [inputValue, setInputValue] = React.useState(defaultValue || '');
    const [warning, setWarning] = React.useState(_warning);
    const enterButtonRef = React.useRef(null);
    const mentionItemRefs = React.useRef([]);
    const ref = React.useRef(null);
    const addMention = (name) => ref.current?.insertFragment(name);
    const handleInput = (e) => {
        const transformedValue = ref.current?.getTransformedValue() || '';
        onChange?.(transformedValue); // Notify parent component of the change
        setInputValue(transformedValue);
    };
    React.useEffect(() => {
        setWarning(_warning);
    }, [_warning]);
    const list = mentions?.map((mention) => ({
        name: mention.label,
        key: mention.key,
        warning: mention.warning,
        ref: `<@${mention.key}>`,
        display: `@${mention.key}`,
        type: 'mention',
        groupName: 'Fields',
        tooltip: mention.tooltip,
    }));
    /**
     * Utility function which takes a text string and parses it into styled JSX fragments.
     * Any strings which follow the <@field_name> syntax AND have a perfect match to a key
     * in the list of fields wil result in a BOLDED fragment. Any other text is treated
     * as normal text
     *
     * @param text
     * @param fields
     * @returns JSX list of style text elements which can be rendered as a complete block
     */
    const generateStyledPrompt = (text, fields) => {
        const regex = /<@(\w+)>/g;
        const result = [];
        const matchedFields = [];
        let lastIndex = 0;
        let match;
        while ((match = regex.exec(text)) !== null) {
            const fieldName = match[1];
            const matchingField = fields.find((field) => field.key === fieldName);
            if (matchingField) {
                const fieldStartIndex = match.index;
                const fieldEndIndex = fieldStartIndex + match[0].length;
                result.push(jsx(React.Fragment, { children: text.substring(lastIndex, fieldStartIndex) }, lastIndex));
                result.push(jsx("b", { children: `@${matchingField.key}` }, fieldStartIndex));
                lastIndex = fieldEndIndex;
                matchedFields.push(matchingField.key);
            }
        }
        result.push(jsx(React.Fragment, { children: text.substring(lastIndex) }, lastIndex));
        return { jsxPrompt: result, matchedFields: matchedFields };
    };
    const promptHistory = React.useMemo(() => {
        if (recentPromptData.prompts) {
            return recentPromptData.prompts.map((prompt) => {
                const { jsxPrompt, matchedFields } = generateStyledPrompt(prompt.prompt, mentions);
                return {
                    ...prompt,
                    styledPrompt: jsxPrompt,
                    matchedFields,
                };
            });
        }
        return [];
    }, [recentPromptData]);
    const configs = [
        {
            // The query that will start the autocomplete
            // In this case it will match:
            // - @
            // - @test
            // _ @test_
            // Can be changed to catch spaces or some special characters.
            query: /@([a-zA-Z0-9_-]+)?/,
            // The fragment to transform to readable element.
            // For example, slack is using `<[name]>` -> `<vince>`
            match: /<(@\w+)>/g,
            // Use it in combinaison with .match to choose what to display to your user instead of the fragment
            // Given the regex `/<(@\w+)>/g` and the fragment `<vince>`
            // - $& -> <vince>
            // - $1 -> vince
            matchDisplay: '$1',
            // Called to customize visual elements inside input.
            // Can be used to add classes, aria, ...
            // `final` is a boolean to know if the fragment is resolved still
            // waiting for user to select an entry in autocomplete
            customizeFragment: (fragment, final) => {
                fragment.className = final ? 'final' : 'pending';
            },
            // This is called when the user selects a mention
            // It should return the filtered list of mentions
            onMention: (text) => {
                return onMention(text, list);
            },
        },
    ];
    // on enter, if autocomplete is open, submit the value
    // focus interactivity
    React.useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Enter' && e.shiftKey) {
                // do nothing
                return;
            }
            const isMentionFocused = mentionItemRefs.current.some((ref) => document.activeElement === ref.current);
            const currentFocusedMention = mentionItemRefs.current.find((ref) => document.activeElement === ref.current);
            if (e.key === 'Enter' && isMentionFocused) {
                e.preventDefault();
                e.stopPropagation();
                const mention = document.activeElement?.textContent?.trim();
                const decoratedMention = `<${mention}>`;
                addMention(decoratedMention);
                return;
            }
            if (e.key === 'Enter' && ref.current?.opened == null) {
                e.preventDefault();
                setIsMenuOpen(false);
                onSubmit?.(ref.current?.getTransformedValue() || '');
            }
            if (e.key === ' ' && isMentionFocused) {
                e.preventDefault();
                e.stopPropagation();
                const mention = document.activeElement?.textContent?.trim();
                const decoratedMention = `<${mention}>`;
                addMention(decoratedMention);
                if (currentFocusedMention) {
                    currentFocusedMention.current.focus();
                }
                return;
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [onSubmit]);
    // on Tab, focus the first mention when focus is on Enter icon
    React.useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Tab' && !e.shiftKey) {
                e.preventDefault();
                // Delay focusing the first mention slightly to ensure it happens after the default tab handling
                setTimeout(() => {
                    if (mentionItemRefs.current[0]) {
                        mentionItemRefs.current[0].current.focus();
                    }
                }, 0);
            }
        };
        const enterButtonEl = enterButtonRef.current;
        enterButtonEl?.addEventListener('keydown', handleKeyDown);
        return () => {
            enterButtonEl?.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    // close menu on click outside
    React.useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current &&
                !containerRef.current.contains(event?.target)) {
                setIsMenuOpen(false);
                setInputHeight('inherit');
                setShowAllMentions(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    // close menu on escape
    React.useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape' && isMenuOpen) {
                e.preventDefault();
                e.stopPropagation();
                setIsMenuOpen(false);
                setShowAllMentions(false);
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [isMenuOpen]);
    const handleFocus = () => {
        setIsMenuOpen(true);
        setInputHeight('auto');
    };
    const handleMenuInteraction = (e) => {
        e.preventDefault();
        setIsMenuOpen(true);
    };
    const toggleShowAllMentions = () => {
        setShowAllMentions(!showAllMentions);
    };
    const handleRecentPromptSelected = (event, recentPromptIndex) => {
        event.preventDefault();
        event.stopPropagation();
        const foundPrompt = recentPromptData.prompts[recentPromptIndex].prompt || '';
        ref.current?.setValue(foundPrompt);
        handleInput();
        setIsMenuOpen(false);
    };
    const visibleMentions = showAllMentions ? list : list?.slice(0, 5);
    const hiddenMentionsCount = list?.length - visibleMentions?.length;
    const examples = [
        {
            title: 'Extract',
            description: 'Easily extract partial or complete text from one or more fields.',
            icon: CodeIcon,
        },
        {
            title: 'Combine',
            description: 'Combine data from multiple fields to replace or populate data in the field of your choice',
            icon: CodeIcon,
        },
        {
            title: 'Transform',
            description: 'Describe how you want data in a field to be transformed based on any logic, including data in any field',
            icon: CodeIcon,
        },
        {
            title: 'Calculate',
            description: 'populate numeric fields by describing the calculation',
            icon: CodeIcon,
        },
    ];
    if (visibleMentions) {
        mentionItemRefs.current = visibleMentions.map((_, index) => mentionItemRefs.current[index] ?? React.createRef());
    }
    const styledMentionList = (jsxs(StyledMentionList, { children: [visibleMentions
                ?.filter((item) => item.type === 'mention')
                .map((item, index) => (jsxs("div", { ref: mentionItemRefs.current[index], tabIndex: 0, children: [jsx(Tooltip, { id: 'mention-tooltip', place: 'bottom', positionStrategy: 'fixed' }), jsx("span", { "data-tooltip-html": item?.tooltip, "data-tooltip-id": 'mention-tooltip', children: jsx(StyledMentionItem, { warning: item.warning, onClick: () => addMention(item.ref), children: item.display }) })] }, item.ref))), showAllMentions ? (jsx(StyledShow, { onClick: toggleShowAllMentions, children: "Show Less" })) : (hiddenMentionsCount > 0 && (jsxs(StyledShow, { onClick: toggleShowAllMentions, children: ["+", hiddenMentionsCount, " Others"] })))] }));
    const promptIdeas = (jsx(Fragment, { children: !inputValue && (jsxs(Fragment, { children: [jsx(StyledPromptMenuTitle, { children: "Prompt Ideas" }), jsx("div", { style: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 12,
                    }, children: examples.map((example) => (jsxs("div", { style: {
                            display: 'flex',
                            alignItems: 'center',
                            padding: '0 16px',
                        }, children: [jsx("div", { style: {
                                    background: 'rgba(246, 248, 252, 1)',
                                    borderRadius: '50%',
                                    width: 25,
                                    height: 25,
                                    padding: 4,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginRight: 12,
                                    border: '1px solid rgba(232, 237, 244, 1)',
                                }, children: example.icon }), jsxs("div", { style: {
                                    fontWeight: 600,
                                    fontSize: 13,
                                    color: 'rgba(97, 106, 125, 1)',
                                    marginRight: 8,
                                }, children: [example.title, ":"] }), jsx("div", { style: {
                                    fontSize: 12,
                                    fontWeight: 400,
                                    color: 'rgba(97, 106, 125, 1)',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    maxWidth: '600px',
                                }, children: example.description })] }, example.title))) })] })) }));
    const promptHistoryList = (jsxs(Fragment, { children: [jsx(StyledPromptMenuTitle, { children: "Recent Prompts" }), jsx(PromptList, { role: 'list', children: promptHistory.map((prompt, index) => (jsx("li", { onClick: (e) => handleRecentPromptSelected(e, index), children: jsxs(PromptListItemContainer, { children: [jsx(Icon, { name: 'history', size: 20, color: Colors$1.Pigeon600 }), jsx(Typography, { type: 'b2', color: Colors$1.Pigeon900, children: prompt.styledPrompt })] }) }, prompt.id))) })] }));
    const footer = (jsx("div", { children: warning ? (jsx("div", { style: {
                color: 'rgba(146, 13, 13, 1)',
                fontWeight: '500',
                fontSize: '12px',
            }, children: warning })) : inputValue?.length === 0 ? (jsx("div", { children: "Quick Tip: Including examples in your prompt improves the results." })) : (jsx("div", { children: "After you submit your prompt, you'll see a preview of how your data would be transformed." })) }));
    return (jsx(PromptContainer, { "data-testid": 'prompt-field', className: 'prompt-container', style: {
            minWidth: '600px',
            fontFamily: "'Proxima Nova', 'Helvetica', sans-serif",
        }, children: jsx(PromptWrapper, { children: jsx(StyledRichMentionsAutocomplete, { children: jsx(RichMentionsProvider, { configs: configs, getContext: ref, children: jsxs("div", { ref: containerRef, children: [jsxs(StyledInput, { children: [jsx(RichMentionsInput, { "data-testid": 'input', placeholder: 'Describe how you would like to transform your data...', defaultValue: defaultValue, onInput: handleInput, onFocus: handleFocus, style: { height: inputHeight }, autoFocus: autoFocus, onMentionChange: onMentionChange }), jsx(IconButtonContainer, { style: {
                                            position: 'absolute',
                                            right: 12,
                                            top: 8,
                                        }, children: !isLoading ? (jsx(SvgWrapper
                                        // @ts-ignore
                                        , { 
                                            // @ts-ignore
                                            ref: enterButtonRef, tabIndex: -1, children: jsx(IconButton, { name: 'enter', className: 'white fooo', variant: 'primary', size: 16, onPress: () => onSubmit?.(ref.current?.getTransformedValue() || ''), isDisabled: isLoading || !inputValue }) })) : (jsx("div", { style: {
                                                display: 'flex',
                                                width: 25,
                                                justifyContent: 'center',
                                                marginTop: 4,
                                            }, children: jsx(Spinner, { size: 16 }) })) })] }), isMenuOpen && (jsxs(PromptMenu, { children: [jsx(PromptMenuContent, { children: jsxs("div", { onClick: handleMenuInteraction, children: [styledMentionList, recentPromptData?.isFetching
                                                    ? promptIdeas // Show prompt ideas immediately if data is still fetching
                                                    : promptHistory.length > 0
                                                        ? promptHistoryList // Show prompt history list if there are recent prompts
                                                        : promptIdeas // Show prompt ideas if there are no recent prompts
                                            ] }) }), jsx(PromptMenuFooter, { children: footer })] })), jsx(RichMentionsAutocomplete, { fixed: false })] }) }) }) }) }));
};

const defaultProps$2 = {
    type: 'number',
    placeholder: '',
    'aria-label': 'Number Field',
};
const NumberInput = ({ minWidth, decorator, decoratorAlign = 'right', label, width = 180, disabled, description, ...props }) => {
    const combinedProps = { ...defaultProps$2, isDisabled: disabled, ...props };
    let { locale } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7();
    let state = $de67e98908f0c6ee$export$7f629e9dc1ecf37c({ ...combinedProps, locale });
    let inputRef = React__default.useRef(null);
    let { labelProps, inputProps, descriptionProps } = $81397a9303501bda$export$23f548e970bdf099(combinedProps, state, inputRef);
    const { isFocusVisible, focusProps } = $f7dceffc5ad7768b$export$4e328f61c538687f({
        within: true,
        isTextInput: true,
    });
    return (jsxs(Container$3, { "data-testid": 'number-field', minWidth: minWidth, width: width, children: [label && jsx(Label$1, { ...labelProps, children: label }), jsxs(InputContainer, { ...focusProps, size: 'lg', isFocusVisible: isFocusVisible, hug: decoratorAlign, mono: true, children: [decorator && decoratorAlign === 'left' && (jsx(InputDecorator, { align: decoratorAlign, children: decorator })), jsx(StyledInput$1, { ...inputProps, ref: inputRef, textAlign: 'right', padding: '12px', "data-testid": 'number-input' }), decorator && decoratorAlign === 'right' && (jsx(InputDecorator, { align: decoratorAlign, children: decorator }))] }), description && (jsx(Description, { ...descriptionProps, children: description }))] }));
};

const defaultProps$1 = {
    placeholder: 'Search...',
    type: 'search',
    'aria-label': 'Search',
};
const SearchInput = forwardRef(({ disabled, onClear, onClickIcon, onExpand, size = 'lg', tint, minWidth = 320, collapsed, width, expandTooltip, ...props }, ref) => {
    const combinedProps = { ...defaultProps$1, isDisabled: disabled, ...props };
    const state = $0b2218c4e3fe7d7e$export$3f8be18b0f41eaf2(combinedProps);
    const { inputProps, clearButtonProps } = $4d52238874b24f86$export$9bb30bbe003b82e0(combinedProps, state, ref);
    const { isFocusVisible, focusProps } = $f7dceffc5ad7768b$export$4e328f61c538687f({
        within: true,
        isTextInput: true,
    });
    const handleClearSearch = () => {
        state.setValue('');
        if (onClear) {
            onClear();
        }
    };
    return (jsx(Container$3, { width: width, minWidth: collapsed ? 0 : minWidth, "data-testid": 'search-field', children: jsxs(InputContainer, { ...focusProps, size: size, error: props.error, disabled: combinedProps.isDisabled, collapsed: collapsed, className: 'search-input-container', isFocusVisible: isFocusVisible, children: [onClickIcon ? (jsx(IconButtonContainer, { left: true, weighted: true, children: jsx(IconButton, { onPress: onClickIcon, name: 'search', size: 16 }) })) : (jsx(IconContainer, { weighted: true, children: jsx(Icon, { name: 'search', size: 16 }) })), jsx(StyledInput$1, { defaultValue: '', ...inputProps, autoFocus: false, ref: ref }), combinedProps.loading ? (jsx(SpinnerContainer, { children: jsx(Spinner, {}) })) : (state.value !== '' && (jsx(IconButtonContainer, { dark: true, weighted: true, children: jsx(IconButton, { ...clearButtonProps, name: 'cross', size: 16, onPress: handleClearSearch }) }))), onExpand && (jsx(IconButtonContainer, { dark: true, weighted: true, "data-tooltip-id": expandTooltip ? AMP_TOOLTIP_ID : undefined, "data-tooltip-content": expandTooltip, children: jsx(IconButton, { name: 'arrowsMaximize', onPress: onExpand, size: 16 }) }))] }) }));
});
SearchInput.displayName = 'SearchInput';

const defaultProps = {
    placeholder: '',
    type: 'text',
    'aria-label': 'Text Field',
};
const TextInput = ({ disabled, size = 'lg', tint, mono, minWidth = 320, width, ...props }) => {
    const combinedProps = { ...defaultProps, isDisabled: disabled, ...props };
    const inputRef = useRef(null);
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [showCopyMessage, setShowCopyMessage] = useState(false);
    const { inputProps, labelProps, descriptionProps } = $2d73ec29415bd339$export$712718f7aec83d5(combinedProps, inputRef);
    const { isFocusVisible, focusProps } = $f7dceffc5ad7768b$export$4e328f61c538687f({
        within: true,
        isTextInput: true,
    });
    const onCopySuccess = () => {
        setShowCopyMessage(true);
        setTimeout(() => setShowCopyMessage(false), 1200);
    };
    const togglePasswordVisible = useCallback(() => {
        setPasswordVisible(!passwordVisible);
    }, [passwordVisible, setPasswordVisible]);
    const copyToClipboard = useCallback(async () => {
        if (inputRef.current) {
            await navigator.clipboard.writeText(inputRef.current.value);
            onCopySuccess();
        }
    }, []);
    return (jsxs(Container$3, { className: 'ff-ds', "data-testid": 'text-field', minWidth: minWidth, width: width, children: [props.label ? (jsx(Label$1, { className: 'ff-ds', ...labelProps, children: props.label })) : null, jsxs(InputContainer, { ...focusProps, size: size, tint: tint, mono: mono, canCopy: props.canCopy, error: props.error, disabled: combinedProps.isDisabled, isFocusVisible: isFocusVisible, children: [jsx(StyledInput$1, { ...inputProps, ref: inputRef, type: passwordVisible ? 'text' : props.type }), props.error && props.type !== 'password' && (jsx(IconContainer, { error: true, children: jsx(Icon, { name: 'alertCircle', "aria-label": 'error-icon', size: 16 }) })), props.type === 'password' && (jsx(IconButtonContainer, { children: jsx(IconButton, { "data-testid": 'text-field-password-toggle', onPress: togglePasswordVisible, name: passwordVisible ? 'eyeSlash' : 'eye', size: 16 }) })), props.canCopy && (jsxs(Fragment, { children: [jsx(IconButtonContainer, { children: jsx(IconButton, { onPress: copyToClipboard, name: 'documentCopy', "data-testid": 'copy-icon', size: 16 }) }), jsx(CopyMessage, { show: showCopyMessage, children: "Copied!" })] }))] }), props.description ? (jsx(Description, { ...descriptionProps, children: props.description })) : null] }));
};

const noop = () => null;
const getTooltipContent = (props) => {
    if (props.disabled)
        return props.tooltip?.disabled;
    return props.tooltip?.active;
};
const MenuListItem = (props) => {
    const ref = useRef(null);
    const { icon, badge, label, menu, disabled, selected, focused, pressed, itemRef = ref, checkbox, onPress, divider, ...otherProps } = props;
    const { hoverProps, isHovered } = $6179b936705e76d3$export$ae780daf29e6d456({ isDisabled: disabled });
    const { focusProps, isFocusVisible } = $f7dceffc5ad7768b$export$4e328f61c538687f({ within: true });
    const { pressProps, isPressed } = $f6c31cce2adf654f$export$45712eceda6fad21({
        onPress,
        isDisabled: disabled,
        ref: itemRef,
    });
    const validIcon = icon && IconNames.find((n) => n === icon);
    const isFocused = focused || isHovered || isFocusVisible;
    const combinedProps = $3ef42575df84b30b$export$9d1611c77c2fe928(otherProps, focusProps, hoverProps, pressProps);
    const content = (jsxs(MenuItemContent, { children: [checkbox && (jsx(CheckboxInput, { checked: selected, disabled: disabled, onChange: noop })), jsx(MenuItemText, { children: label }), badge && jsx(MenuItemBadge, { children: badge }), !checkbox && selected && jsx(Checkmark, { "aria-hidden": 'true' }), icon && validIcon && (jsx(MenuItemIcon, { children: jsx(Icon, { name: icon, color: Colors$1.Pigeon400, size: 16 }) })), menu && jsx(ChevronRight, {})] }));
    return (jsxs(Fragment, { children: [jsx(MenuListItemElement, { role: 'menuitem', ...combinedProps, "aria-haspopup": menu ? 'menu' : undefined, "data-testid": `option-${label?.toString()}`, "data-tooltip-id": AMP_TOOLTIP_ID, "data-tooltip-content": getTooltipContent(props), "data-tooltip-place": 'right', ref: itemRef, isDisabled: disabled, isSelected: selected, isFocused: isFocused, isPressed: pressed || isPressed, isCheckbox: checkbox, children: menu ? (jsx(Dropdown, { ...menu, trigger: MenuTrigger.hover, placement: MenuPlacement.right, customButton: content, initializeEmptyInput: true, isFocused: isFocused })) : (content) }), divider && jsx(MenuDivider, {}, `divider:${combinedProps['data-key']}`)] }));
};
const MenuItem = ({ item, option, state, checkbox, onClose, }) => {
    const ref = useRef(null);
    const shouldCloseOnSelect = checkbox || option?.menu ? false : option?.shouldCloseOnSelect ?? true;
    const { menuItemProps, isDisabled, isSelected, isFocused, isPressed } = $a2e5df62f93c7633$export$9d32628fc2aea7da({
        key: item.key,
        'aria-label': 'menu-item',
        closeOnSelect: shouldCloseOnSelect,
        isDisabled: option?.disabled,
        isSelected: option?.selected,
        onClose,
        onAction: option?.onAction ?? noop,
    }, state, ref);
    let selected = isSelected;
    /*
      In the multi-select state, the built-in logic for isSelected is not reliable
      for certain characters like '' and '('. To get around this, we check the set
      of selectedKeys directly.
    */
    const selectedKeys = state?.selectionManager?.selectedKeys;
    if (selectedKeys) {
        selected = selectedKeys.has(item.key);
    }
    return (jsx(MenuListItem, { ...item, ...menuItemProps, itemRef: ref, checkbox: checkbox, icon: option?.icon, menu: option?.menu, badge: option?.badge, divider: option?.divider, tooltip: option?.tooltip, label: item.rendered, disabled: isDisabled, selected: selected, pressed: isPressed, focused: isFocused }));
};

const MenuPopover = (props) => {
    const ref = useRef(null);
    const { direction, placement, alignment, type, borderType, popoverRef = ref, isDismissable, isOpen, onClose, children, error, minWidth, maxWidth, restoreFocus = true, shouldCloseOnInteractOutside, shouldCloseOnBlur = true, } = props;
    const { overlayProps } = $a11501f3d1d39e6c$export$ea8f71083e90600f({
        isOpen,
        isDismissable,
        onClose,
        shouldCloseOnInteractOutside,
        shouldCloseOnBlur,
    }, popoverRef);
    return (jsx($9bf71ea28793e738$export$20e40289641fbbb6, { restoreFocus: restoreFocus, children: jsxs(MenuPopoverElement, { ...overlayProps, error: error, type: type, borderType: borderType, direction: direction, placement: placement, alignment: alignment, minWidth: minWidth, maxWidth: maxWidth, ref: popoverRef, children: [children, jsx($86ea4cb521eb2e37$export$2317d149ed6f78c4, { onDismiss: onClose })] }) }));
};

const buildMenuOptions = (options, encode = true) => {
    /* Iterate only once through the menu options to build the options metadata */
    const disabledKeys = [];
    const selectedKeys = [];
    const children = [];
    const optionsMap = {};
    options.forEach((option) => {
        /*
          We URI encode the key because the react-aria logic will throw errors when
          attempting to perform some DOM functions on keys containing special characters.
        */
        const encodedKey = encode
            ? typeof option.key === 'string'
                ? encodeURIComponent(option.key ?? '')
                : option.key
            : option.key;
        /* Provides an array of disabled keys for the react-aria combobox logic */
        if (option.disabled) {
            disabledKeys.push(encodedKey);
        }
        /* Provides an array of default selected keys for the react-aria combobox logic */
        if (option.selected) {
            selectedKeys.push(encodedKey);
        }
        /* Provides an array of items for the react-stately item collection logic */
        if (!option.hidden) {
            children.push(jsx($c1d7fb2ec91bae71$export$6d08773d2e66f8f2, { textValue: option.label, children: option.label }, encodedKey));
        }
        /*
          Creates a map of option data so that the individual options can access it
          when rendering, without having to re-iterate through the list of options
        */
        optionsMap[option.key] = option;
    });
    return { disabledKeys, selectedKeys, children, optionsMap };
};
const buildMenuGroups = (groups, encode = true) => {
    const disabledKeys = [];
    const selectedKeys = [];
    const children = [];
    let optionsMap = {};
    groups.forEach((group) => {
        const { disabledKeys: groupDisabledKeys, selectedKeys: groupSelectedKeys, children: groupChildren, optionsMap: groupOptionsMap, } = buildMenuOptions(group.options);
        const groupKey = encode ? encodeURIComponent(group.name ?? '') : group.name;
        disabledKeys.push(...groupDisabledKeys);
        selectedKeys.push(...groupSelectedKeys);
        optionsMap = { ...optionsMap, ...groupOptionsMap };
        children.push(jsx($9fc4852771d079eb$export$6e2c8f0811a474ce, { title: group.name, children: groupChildren }, groupKey));
    });
    return { disabledKeys, selectedKeys, children, optionsMap };
};

const ContextMenuPopover = (props) => {
    const { children, optionsMap } = useMemo(() => buildMenuOptions(props.options, false), [props.options]);
    const { isFocusVisible, focusProps } = $f7dceffc5ad7768b$export$4e328f61c538687f();
    const state = $875d6693e12af071$export$728d6ba534403756({
        ...props,
        children,
        selectionMode: 'none',
    });
    // Get props for the menu element
    const ref = React__default.useRef(null);
    const { menuProps } = $d5336fe17ce95402$export$38eaa17faae8f579(props, state, ref);
    return (jsx(MenuPopover, { placement: props.placement, isOpen: true, isDismissable: true, onClose: props.onClose, shouldCloseOnInteractOutside: props.onInteractOutside, children: jsx(MenuList, { ...$3ef42575df84b30b$export$9d1611c77c2fe928(menuProps, focusProps), ref: ref, isFocusVisible: isFocusVisible && props.showFocus, children: [...state.collection].map((item) => (jsx(MenuItem, { item: item, state: state, option: optionsMap[item.key], onClose: props.onClose }, item.key))) }) }));
};

const Container$2 = styled.span `
  display: inline-block;
  position: relative;
  width: fit-content;
`;
const ContextMenu = (props) => {
    const state = $a28c903ee9ad8dc5$export$79fefeb1c2091ac3(props);
    const ref = React__default.useRef(null);
    const { menuProps } = $168583247155ddda$export$dc9c12ed27dd1b49({}, state, ref);
    const { index, onMenuStateChange } = props;
    useEffect(() => {
        if (onMenuStateChange) {
            onMenuStateChange({ isOpen: state.isOpen, index: index ?? undefined });
        }
    }, [onMenuStateChange, state.isOpen, index]);
    const onClose = useCallback(() => {
        state.close();
        props.onClose?.();
    }, [props, state]);
    const onPress = useCallback(() => !props.rightClick && state.open(), [props, state]);
    const onContextMenu = useCallback((e) => {
        if (props.rightClick) {
            e.preventDefault();
            state.open();
        }
    }, [props, state]);
    const combinedMenuProps = { ...props, ...menuProps };
    return (jsxs(Container$2, { children: [jsx("span", { onContextMenu: onContextMenu, children: props.children ? (props.children(state.open)) : (jsx(IconButton, { onPress: onPress, size: props.size === MenuSize.sm ? 16 : 24, name: 'dotsVertical', "data-testid": 'context-menu-trigger', isDisabled: props.isDisabled })) }), state.isOpen && (jsx(ContextMenuPopover, { ...combinedMenuProps, options: props.options, onClose: onClose }))] }));
};

const TitleBarContainer = styled.div `
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
`;
const TitleBarTitle = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const TitleBarDescription = styled(Typography) `
  margin-top: 8px;
`;
const RightContent = styled.span `
  display: inline-flex;
  gap: 8px;
  align-items: center;
`;
const StyledActionsTooltip = styled(ActionsTooltip) `
  display: flex;
`;
const IconFlex = styled.div `
  display: flex;
`;
const TitleBar = ({ title, type, description, button, icon, }) => {
    const TitleContent = () => {
        if (!title)
            return null;
        if (typeof title === 'string') {
            return jsx(Typography, { type: type ?? 'h4Serif', children: title });
        }
        return title;
    };
    return (jsxs(TitleBarContainer, { "data-testid": 'list-title-bar', children: [jsxs(TitleBarTitle, { children: [jsx(TitleContent, {}), jsxs(RightContent, { children: [icon && (jsx(StyledActionsTooltip, { text: icon.tooltip.text, actions: [
                                    {
                                        text: 'Learn more',
                                        onClick: () => window.open(icon.tooltip.url, '_blank'),
                                    },
                                ], children: jsx(IconFlex, { children: jsx(Icon, { name: icon.name, color: icon.color, "data-testid": 'alert-icon' }) }) })), button && jsx(Button, { ...button })] })] }), description ? (jsx(TitleBarDescription, { type: 'b1', color: Colors$1.Pigeon700, children: description })) : null] }));
};

const SearchBarContainer = styled.div `
  ${({ width }) => width !== undefined
    ? css `
          width: ${width}px;
        `
    : css `
          width: 100%;
        `}
`;
const SearchBar = ({ loading, disabled, placeholder, onSearch, width, }) => {
    return (jsx(SearchBarContainer, { width: width, children: jsx(SearchInput, { tint: true, placeholder: placeholder, loading: loading, disabled: disabled, onChange: onSearch, width: width }) }));
};

const ActionBar = ({ actions }) => {
    return (jsx(ButtonRow$1, { children: actions.map((action) => {
            const { label, disabled, onClick, icon } = action;
            return (jsx(Button, { variant: 'tertiary', iconLeft: icon.name, onPress: onClick, label: label, isDisabled: disabled, size: 'sm', "data-testid": `action-button-${label}` }, action.label));
        }) }));
};

/* Styled HTML table elements that can be used outside of the List if desired. */
const cellPadding = '0.75em';
const Table = styled.table `
  color: ${Colors$1.MidnightBrand};
  border-collapse: collapse;
  width: 100%;

  ${({ fixed }) => (fixed ? 'table-layout: fixed;' : '')}

  ${({ condensed }) => condensed
    ? css `
          ${getFont('b2')}

          td,
          th {
            padding-top: 0;
            padding-bottom: 0;
          }
        `
    : getFont('b1')}
`;
const TableBody = styled.tbody ``;
const TableRow = styled.tr `
  width: 100%;

  ${({ height }) => height
    ? `
    td, th {
      padding-top: 0;
      padding-bottom: 0;
    }
  `
    : ''}
  ${({ condensed }) => !condensed && `border-bottom: 1px solid ${Colors$1.Pigeon200};`}

  ${({ odd }) => odd && `background-color: ${Colors$1.Pigeon100};`}
  ${({ disabled }) => disabled && `opacity: 0.5;`}

  .show-on-hover {
    opacity: 0;
  }

  &:hover {
    .show-on-hover {
      opacity: 1;
    }
    ${({ hoverable }) => hoverable &&
    `
    background-color: ${Colors$1.Pigeon100};
    `}
    ${({ clickable }) => clickable &&
    `
    cursor: pointer;
    `}
  }

  ${({ isFooter }) => isFooter && `border-top: none;`}
  ${({ hasFooter }) => hasFooter && `border-bottom: none;`}
`;
const TableHeader = styled.thead `
  tr {
    border-bottom: 1px solid ${Colors$1.Pigeon400};
  }
`;
const CellStyles = css `
  ${({ colWidth }) => {
    if (colWidth === undefined)
        return '';
    return `
      width: ${typeof colWidth === 'number' ? colWidth + 'px' : colWidth};
    `;
}}
  text-align: left;
  padding: ${cellPadding};
  ${({ verticalAlign }) => {
    if (verticalAlign !== 'middle')
        return `vertical-align: ${verticalAlign};`;
}}
`;
const TableHeaderCell = styled.th `
  ${CellStyles}
  font-weight: 600;
  color: ${Colors$1.MidnightBrand};

  div {
    font-weight: 600;
    color: ${Colors$1.MidnightBrand};
  }
`;
const TableCell = styled.td `
  ${CellStyles}
`;
const FooterTableCell = styled.td `
  ${CellStyles}
  padding-top: 0;
`;

const CONDENSED_ROW_HEIGHT = 28;
const cellKey = (row, column) => `cell-${row}-${column}`;
const rowKey = (row) => `row-${row}`;
const isOdd = (row) => !!(row % 2);
const CellContent = styled.div `
  ${({ height }) => height
    ? `
    height: ${height}px;
    max-height: ${height}px;
    display: flex;
    align-items: center;
    overflow: hidden;
  `
    : ''}
  ${({ condensed, height }) => (condensed || !!height) &&
    css `
      div,
      span {
        max-width: 100%;
        ${truncated}
      }
    `}
`;
const TableWrapper = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  width: 100%;
  min-height: 100px;
  padding: 24px;

  .spinner {
    height: 40px;
    width: 40px;
  }
`;
const ListWrapper = styled.div `
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  ${getFont('b1')}
  overflow: visible;
`;
const FiltersWrapper = styled.div `
  display: flex;
  gap: 24px;
  width: 100%;

  > * {
    margin-top: 8px;
    margin-bottom: 16px;
  }
`;
const StyledTypography = styled(Typography) `
  ${({ width }) => width && `word-break: break-all;`}
`;
const DefaultEmptyComponent = () => {
    return jsx("div", {});
};
const ListEmpty = ({ component }) => {
    return jsx(TableWrapper, { children: component ?? jsx(DefaultEmptyComponent, {}) });
};
const ListError = ({ component }) => {
    return jsx(TableWrapper, { "data-testid": 'list-table-error', children: component });
};
const ListLoading = ({ component }) => {
    return jsx(TableWrapper, { children: component ?? jsx(Spinner, {}) });
};
const Header = ({ header, condensed, verticalAlign, }) => {
    return (jsx(Cell, { header: true, width: header.width, height: condensed ? CONDENSED_ROW_HEIGHT : undefined, condensed: condensed, cell: header.content, verticalAlign: verticalAlign }));
};
const SelectAllHeader = ({ condensed, selectOptions, verticalAlign, }) => {
    const { selectedItems, setSelectedItems, allItems } = selectOptions;
    const selectAllItems = () => {
        setSelectedItems(allItems);
    };
    const clearAllSelectedItems = () => {
        setSelectedItems([]);
    };
    const numSelectedItems = selectedItems.length;
    const allSelected = numSelectedItems > 0 && numSelectedItems === allItems.length;
    const someSelected = numSelectedItems > 0 && !allSelected;
    const onToggleSelectAll = () => {
        if (allSelected || someSelected) {
            clearAllSelectedItems();
        }
        else {
            selectAllItems();
        }
    };
    return (jsx(Cell, { header: true, width: '37px', height: condensed ? CONDENSED_ROW_HEIGHT : undefined, condensed: condensed, verticalAlign: verticalAlign, cell: jsx(CheckboxInput, { checked: allSelected, onChange: onToggleSelectAll, partial: someSelected, disabled: !allItems.length, "data-testid": 'select-all-checkbox' }) }));
};
const Cell = ({ cell, height, width, condensed, header, verticalAlign, }) => {
    const CellComponent = header ? TableHeaderCell : TableCell;
    const cellContent = typeof cell === 'string' ? (jsx(StyledTypography, { type: condensed ? 'b2' : 'b1', truncate: !!height || condensed, width: width, className: 'ff-ds', children: cell })) : (cell);
    return (jsx(CellComponent, { colWidth: width, verticalAlign: verticalAlign, "data-testid": 'list-cell-id', children: jsx(CellContent, { height: height, condensed: condensed, children: cellContent }) }));
};
const SelectCell = ({ selectOptions, selectKey, width, height, condensed, verticalAlign, toggleSelected, }) => {
    const isSelected = selectOptions?.selectedItems.includes(selectKey);
    return (jsx(Cell, { cell: jsx(CheckboxInput, { onChange: toggleSelected, checked: isSelected, "data-testid": `select-checkbox-${selectKey}` }), height: height, condensed: condensed, verticalAlign: verticalAlign, width: width }));
};
const Row = ({ headers, row, index, condensed, selectOptions, toggleSelected, verticalAlign, }) => {
    const height = row.height ?? (condensed ? CONDENSED_ROW_HEIGHT : undefined);
    const classNames = `${row.className}, amp-table-row`;
    /*
      We wrap each individual cell in the context menu instead of the entire row
      because the context menu wraps its children in a span, which would interfere
      with the HTML table structure.
    */
    const getCellContent = (cell, key) => {
        if (row.onRightClick && key !== 'menu' && !condensed) {
            return (jsx(ContextMenu, { "data-testid": 'list-row-context-menu', rightClick: true, placement: MenuPlacement.right, options: row.onRightClick, children: (onOpen) => jsx(Fragment, { children: cell }) }));
        }
        return cell;
    };
    /*
      If the table has headers, assign cell order based on the headers. Otherwise,
      simply iterate through the cells.
    */
    const cells = headers.length > 0
        ? headers.map((header, columnIndex) => (jsx(Cell, { cell: getCellContent(row.data[header.key], header.key), width: header.width, height: height, condensed: condensed, verticalAlign: verticalAlign }, cellKey(index, columnIndex))))
        : Object.keys(row.data).map((key, columnIndex) => (jsx(Cell, { cell: getCellContent(row.data[key]), height: height, condensed: condensed, verticalAlign: verticalAlign }, cellKey(index, columnIndex))));
    return (jsxs(Fragment, { children: [jsx(TableRow, { height: height, condensed: condensed, odd: condensed && isOdd(index), hoverable: row.hoverable, clickable: !!row.onClick, onClick: row.onClick, className: classNames, disabled: row.disabled, hasFooter: !!row.footer, "data-testid": row.testId, "data-tooltip-id": row['data-tooltip-id'], "data-tooltip-content": row['data-tooltip-content'], "data-tooltip-float": row['data-tooltip-float'], children: selectOptions ? (jsxs(Fragment, { children: [jsx(SelectCell, { selectOptions: selectOptions, selectKey: row.key, width: 30, height: height, condensed: condensed, verticalAlign: verticalAlign, toggleSelected: toggleSelected }, row.key), cells] })) : (cells) }), row.footer && (jsx(TableRow, { height: height, condensed: condensed, odd: condensed && isOdd(index), hoverable: row.hoverable, clickable: !!row.onClick, onClick: row.onClick, className: row.className, "data-testid": row.testId + '-footer', disabled: row.disabled, isFooter: true, children: jsx(FooterTableCell, { colSpan: cells.length, children: row.footer }) }))] }));
};
const TableHeaders = ({ headers, condensed, selectOptions, verticalAlign, }) => {
    if (!headers.length) {
        return null;
    }
    const headerCells = headers.map((header) => (jsx(Header, { header: header, condensed: condensed, verticalAlign: verticalAlign }, header.key)));
    return (jsx(TableHeader, { "data-testid": 'list-header-row', className: 'amp-table-header', children: jsx(TableRow, { children: selectOptions ? (jsxs(Fragment, { children: [jsx(SelectAllHeader, { condensed: condensed, verticalAlign: verticalAlign, selectOptions: selectOptions }), headerCells] })) : (headerCells) }) }));
};
const TableBodyContent = ({ data, headers, condensed, selectOptions, verticalAlign, }) => {
    const lastCheckedRef = useRef(null);
    if (!data.length) {
        return null;
    }
    const selectedItems = selectOptions?.selectedItems;
    const setSelectedItems = selectOptions?.setSelectedItems;
    const toggleSelected = useCallback((index, selectKey) => (e) => {
        if (selectedItems && setSelectedItems) {
            const isSelected = selectedItems.includes(selectKey);
            const isShiftKey = e.nativeEvent instanceof MouseEvent && e.nativeEvent.shiftKey;
            if (isShiftKey && !isSelected && lastCheckedRef.current !== null) {
                const start = Math.min(lastCheckedRef.current, index);
                const end = Math.max(lastCheckedRef.current, index);
                const newSelectedItems = [...selectedItems];
                for (let i = start; i <= end; i++) {
                    const itemKey = data[i].key;
                    if (!newSelectedItems.includes(itemKey)) {
                        newSelectedItems.push(itemKey);
                    }
                }
                setSelectedItems(newSelectedItems);
            }
            else {
                if (isSelected) {
                    setSelectedItems(selectedItems.filter((item) => item !== selectKey));
                    lastCheckedRef.current = null;
                }
                else {
                    setSelectedItems([...selectedItems, selectKey]);
                    lastCheckedRef.current = index;
                }
            }
        }
    }, [selectedItems, setSelectedItems, lastCheckedRef, data]);
    return (jsx(TableBody, { children: data.map((row, index) => (jsx(Row, { index: index, row: row, headers: headers, condensed: condensed, verticalAlign: verticalAlign, selectOptions: selectOptions, toggleSelected: toggleSelected(index, row.key) }, rowKey(index)))) }));
};
const getTableIsFixed = (props) => {
    if (props.condensed || props.fixed)
        return true;
    return props.headers.some((header) => header.width !== undefined);
};
const ListTable = (props) => {
    const { data, headers, condensed, components, selectOptions } = props;
    const noSearchResults = props.isSearching && !data.length;
    /*
      We render the empty component outside of the table structure so that it is
      not forced to obey table styles.
    */
    return (jsxs(Fragment, { children: [jsxs(Table, { condensed: condensed, fixed: getTableIsFixed(props), className: 'ff-ds', children: [jsx(TableHeaders, { headers: headers, condensed: condensed, verticalAlign: props.verticalAlign, selectOptions: selectOptions }), !noSearchResults && (jsx(TableBodyContent, { data: data, headers: headers, condensed: condensed, verticalAlign: props.verticalAlign, selectOptions: selectOptions }))] }), (noSearchResults || (!data.length && !props.isSearching)) && (jsx(ListEmpty, { component: noSearchResults ? components?.noSeachResults : components?.empty }))] }));
};
const ListContent = ({ loading, error, data, headers, fixed, condensed, components, isSearching, selectOptions, verticalAlign, }) => {
    if (loading) {
        return jsx(ListLoading, { component: components?.loading });
    }
    if (error) {
        return jsx(ListError, { component: components?.error });
    }
    if (!data.length && !headers.length && !isSearching) {
        return jsx(ListEmpty, { component: components?.empty });
    }
    return (jsx(ListTable, { data: data, headers: headers, fixed: fixed, condensed: condensed, components: components, isSearching: isSearching, selectOptions: selectOptions, verticalAlign: verticalAlign }));
};
const Content = styled.div `
  display: block;
  width: 100%;
  ${({ minHeight }) => minHeight &&
    `
    min-height: ${minHeight}px;
  `}
`;
const List = ({ title, search, filters, actions, minHeight, dateDropdown, dropdownFilter, verticalAlign, ...props }) => {
    /* Disable the search bar if data is loading or errored */
    const disableSearch = !!(search?.disabled ?? props.loading ?? props.error);
    return (jsxs(ListWrapper, { "data-testid": 'table-list', className: 'ff-ds', children: [title && jsx(TitleBar, { ...title }), jsxs(FiltersWrapper, { children: [search && jsx(SearchBar, { ...search, disabled: disableSearch }), dropdownFilter && jsx(Dropdown, { ...dropdownFilter }), dateDropdown && jsx(DateDropdown, { ...dateDropdown }), filters && filters] }), actions && jsx(ActionBar, { actions: actions }), jsx(Content, { minHeight: minHeight, children: jsx(ListContent, { verticalAlign: verticalAlign ?? 'middle', ...props }) })] }));
};

const Menu = styled.div `
  display: flex;
  justify-content: flex-end;
  margin-right: -0.75em;

  svg {
    color: ${Colors$1.Pigeon700};
  }
`;
const MenuCell = ({ options }) => {
    return (jsx(Menu, { "data-testid": 'list-row-menu', children: jsx(ContextMenu, { options: options }) }));
};

const SemiBoldCell = styled.div `
  font-weight: 600;
`;

var ESortOptions$1;
(function (ESortOptions) {
    ESortOptions[ESortOptions["None"] = 0] = "None";
    ESortOptions[ESortOptions["Asc"] = 1] = "Asc";
    ESortOptions[ESortOptions["Desc"] = 2] = "Desc";
})(ESortOptions$1 || (ESortOptions$1 = {}));
const StyledIconButton = styled(IconButton) `
  ${({ active }) => (active ? 'opacity: 1' : 'opacity: 0')};

  &:hover,
  &:focus {
    opacity: 1;
  }
`;
const SortButton = ({ onSort, order, active, isDisabled }) => {
    return (jsx(StyledIconButton, { name: 'chevronDown', size: 16, active: active, order: order, rotateIcon: order === ESortOptions$1.Asc ? 180 : 0, onPress: onSort, className: 'sort-button', "data-testid": 'sort-button', isDisabled: isDisabled }));
};

const HeaderContent = styled.div `
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: space-between;

  &:hover {
    .sort-button {
      opacity: 1;
    }
  }
`;
const SortableHeaderCell = ({ content, order, onSort, }) => {
    return (jsxs(HeaderContent, { children: [content, jsx(SortButton, { "data-testid": 'sort-button', order: order, active: order !== ESortOptions$1.None, onSort: onSort })] }));
};

var ESortOptions;
(function (ESortOptions) {
    ESortOptions[ESortOptions["None"] = 0] = "None";
    ESortOptions[ESortOptions["Asc"] = 1] = "Asc";
    ESortOptions[ESortOptions["Desc"] = 2] = "Desc";
})(ESortOptions || (ESortOptions = {}));

const innerModalStyles = (size) => css `
  background-color: ${Colors$1.White};
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: ${size === 'sm' ? '512px' : '800px'};
  min-height: 136px;
  padding: 24px;
  position: relative;
  width: 100%;
`;
const overlayBackground = css `
  background-color: rgb(64 72 87 / 0.2);
`;
const Overlay = styled.div `
  > * {
    box-sizing: border-box;
  }

  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0px;
  position: fixed;
  top: 0px;
  right: 0px;
  width: 100%;
  z-index: 1200;

  ${({ hasOpaqueOverlay }) => hasOpaqueOverlay
    ? css `
          background-color: ${Colors$1.White};
        `
    : overlayBackground}
`;
const Container$1 = styled.div `
  ${({ size }) => innerModalStyles(size)}

  ${({ hasOpaqueOverlay }) => !hasOpaqueOverlay &&
    css `
      box-shadow: 0px 20px 25px -5px rgba(0, 0, 0, 0.1),
        0px 10px 10px -5px rgba(0, 0, 0, 0.04);
    `}

  max-height: calc(100vh - 64px);
  overflow-y: auto;
`;
const LimitedOverlay = styled.div `
  > * {
    box-sizing: border-box;
  }

  ${overlayBackground}

  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: ${ZIndex.level900};
`;
const ButtonRow = styled.div `
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 16px;
  width: 100%;
`;
const StyledSubheading = styled(Typography) `
  margin-top: 24px;
`;
const ModalHeader = ({ children }) => {
    return (jsx(Typography, { type: 'h5', className: 'ff-ds', children: children }));
};
const ModalText = ({ children }) => {
    return (jsx(Typography, { type: 'b1', className: 'ff-ds', color: Colors$1.Pigeon700, "data-testid": 'modal-text', children: children }));
};
const ModalSubHeading = ({ children, }) => {
    return (jsx(StyledSubheading, { type: 'actionLg', "data-testid": 'modal-sub-heading', children: children }));
};
const ModalButtonRow = ({ children }) => {
    return jsx(ButtonRow, { children: children });
};
const ModalCloseButton = ({ onClose, ...props }) => (jsx(Button, { "data-testid": props['data-testid'], variant: props.variant || 'tertiary-border', onPress: onClose, label: props?.label || 'Close' }));
const Modal = ({ content, overlayType = 'default', size = 'sm', ...props }) => {
    if (overlayType === 'limited') {
        return (jsx(LimitedOverlay, { "data-testid": 'limited-outer-modal-wrapper', children: jsx(Container$1, { size: size, children: content }) }));
    }
    else {
        return (jsx(Overlay, { hasOpaqueOverlay: overlayType === 'opaque', "data-testid": props['data-testid'], children: jsx(Container$1, { "data-testid": 'modal-inner-wrapper', className: 'amp-modal', hasOpaqueOverlay: overlayType === 'opaque', size: size, children: content }) }));
    }
};

const DEFAULT_PAGE_SIZE = 20;
const useListPagination = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const onChangePage = useCallback((page) => {
        const newPage = typeof page === 'string' ? Number.parseInt(page) : page;
        if (!isNaN(newPage)) {
            setCurrentPage(newPage);
        }
    }, [setCurrentPage, currentPage]);
    return { onChangePage, currentPage, setCurrentPage };
};

const DOTS = '...';
const range = (start, end) => {
    const length = end - start + 1;
    return Array.from({ length }, (_, idx) => idx + start);
};
const usePagination = ({ totalCount, pageSize = DEFAULT_PAGE_SIZE, siblingCount = 1, currentPage, }) => {
    const paginationRange = useMemo(() => {
        const totalPageCount = Math.ceil(totalCount / pageSize);
        const totalPageNumbers = siblingCount + 4;
        if (totalPageNumbers >= totalPageCount) {
            return range(1, totalPageCount);
        }
        const leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
        const rightSiblingIndex = Math.min(currentPage + siblingCount, totalPageCount);
        const shouldShowLeftDots = leftSiblingIndex > 2;
        const shouldShowRightDots = rightSiblingIndex < totalPageCount - 2;
        const firstPageIndex = 1;
        const lastPageIndex = totalPageCount;
        if (!shouldShowLeftDots && shouldShowRightDots) {
            const leftItemCount = 3 + 2 * siblingCount;
            const leftRange = range(1, leftItemCount);
            return [...leftRange, DOTS, totalPageCount];
        }
        if (shouldShowLeftDots && !shouldShowRightDots) {
            const rightItemCount = 3 + 2 * siblingCount;
            const rightRange = range(totalPageCount - rightItemCount + 1, totalPageCount);
            return [firstPageIndex, DOTS, ...rightRange];
        }
        if (shouldShowLeftDots && shouldShowRightDots) {
            const middleRange = range(leftSiblingIndex, rightSiblingIndex);
            return [firstPageIndex, DOTS, ...middleRange, DOTS, lastPageIndex];
        }
    }, [totalCount, pageSize, siblingCount, currentPage]);
    return paginationRange;
};

const PAGINATION_STYLES = {
    border: {
        sm: '',
        lg: `border-top: 1px solid ${Colors$1.Pigeon400};`,
    },
    height: {
        sm: 24,
        lg: 32,
    },
    width: {
        sm: 24,
        lg: 32,
    },
    fontSize: {
        sm: '12px',
        lg: '14px',
    },
    paddingTop: {
        sm: 12,
        lg: 12,
    },
    activeBorderColor: {
        sm: Colors$1.Transparent,
        lg: Colors$1.Electric700,
    },
};
const PaginationContainer = styled.div `
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  margin-top: -1px;
  box-sizing: content-box;
  flex-shrink: 0;

  .styled-button.tertiary,
  .styled-button.tertiary .button-text {
    color: ${Colors$1.Pigeon700};
  }

  ${({ size }) => css `
    height: ${PAGINATION_STYLES.height[size]};
    padding-top: ${PAGINATION_STYLES.paddingTop[size]}px;
    ${PAGINATION_STYLES.border[size]}

    .styled-button .button-text {
      font-size: ${PAGINATION_STYLES.fontSize[size]};
    }

    .styled-button,
    .icon-button {
      height: ${PAGINATION_STYLES.height[size]}px;
      border-radius: 6px;
    }

    .icon-button {
      width: ${PAGINATION_STYLES.width[size]}px;
    }
  `}
`;
const PageButtons = styled.div `
  display: flex;
  align-items: center;
  flex-grow: 1;
  justify-content: center;
  gap: 4px;

  .styled-button.tertiary .button-text {
    font-weight: 400;
  }

  .styled-button:disabled {
    opacity: 1;
  }

  ${({ size }) => css `
    .styled-button {
      min-width: ${PAGINATION_STYLES.width[size]}px;
      padding: 8px;
      position: relative;
      transition: background-color 0ms ease;

      // Remove the background color animation because it can cause an unwanted
      // flash when changing pages.
    }

    .styled-button::before {
      content: '';
      position: absolute;
      height: 2px;
      background-color: transparent;
      width: 100%;
      top: -${PAGINATION_STYLES.paddingTop[size] + 1}px;
    }

    .styled-button.secondary::before {
      background-color: ${PAGINATION_STYLES.activeBorderColor[size]};
    }
  `}
`;
const Pagination = ({ onPageChange, totalCount, siblingCount = 1, currentPage, pageSize = DEFAULT_PAGE_SIZE, size, testId, }) => {
    const sizing = size ?? 'lg';
    const paginationRange = usePagination({
        currentPage,
        totalCount,
        siblingCount,
        pageSize,
    });
    const lastPage = paginationRange?.[paginationRange.length - 1];
    const onNext = useCallback(() => {
        if (currentPage === lastPage)
            return;
        onPageChange(currentPage + 1);
    }, [currentPage, onPageChange, lastPage]);
    const onPrevious = useCallback(() => {
        if (currentPage === 1)
            return;
        onPageChange(currentPage - 1);
    }, [currentPage, onPageChange]);
    if (currentPage === 0 || (paginationRange && paginationRange.length < 2)) {
        return null;
    }
    return (jsxs(PaginationContainer, { "data-testid": testId ?? 'pagination', size: sizing, children: [sizing === 'sm' ? (jsx(IconButton, { name: 'chevronDown', onPress: onPrevious, size: 16, rotateIcon: 90, isDisabled: currentPage === 1, className: 'icon-button' })) : (jsx(Button, { variant: 'tertiary', onPress: onPrevious, isDisabled: currentPage === 1, iconLeft: 'arrowLeft', label: 'Previous', size: 'sm' })), jsx(PageButtons, { size: sizing, children: paginationRange?.map((pageNumber, idx) => {
                    if (pageNumber === DOTS) {
                        return (jsx(Button, { variant: 'tertiary', label: '\u2026', isDisabled: true }, `page-dots-${idx}`));
                    }
                    return (jsx(Button, { variant: pageNumber === currentPage ? 'secondary' : 'tertiary', onPress: () => onPageChange(pageNumber), label: `${pageNumber}` }, `page-${pageNumber}`));
                }) }), sizing === 'sm' ? (jsx(IconButton, { name: 'chevronDown', onPress: onNext, size: 16, rotateIcon: -90, isDisabled: currentPage === lastPage, className: 'icon-button' })) : (jsx(Button, { variant: 'tertiary', onPress: onNext, isDisabled: currentPage === lastPage, iconRight: 'arrowRight', label: 'Next', size: 'sm' }))] }));
};

const Pill = styled.div `
  ${getFont('actionSm')}
  ${({ $truncate }) => ($truncate ? truncated : '')}
  line-height: 16px;
  color: ${Colors$1.MidnightBrand};
  padding: 2px 8px;
  border-radius: 4px;
  background-color: ${Colors$1.Pigeon200};
  max-width: 150px;
`;
const PillContainer = styled.div `
  display: flex;
  align-items: center;
  gap: 4px;
`;

var PopoverAnimation;
(function (PopoverAnimation) {
    PopoverAnimation[PopoverAnimation["SlideUp"] = 0] = "SlideUp";
})(PopoverAnimation || (PopoverAnimation = {}));
const slideUpAnimation = keyframes `
  from {
    transform: translate(-50%, 300%)
  }
  to {
    transform: translate(-50%, -50%)
  }
`;
const slideUpStyle$1 = css `
  animation: ${slideUpAnimation} 0.3s linear;
`;
const PopoverContainer = styled.div `
  background-color: ${Colors$1.MidnightBrand};
  border-radius: 2px;
  box-shadow: 0 0 0 1px #0000000d, 0 4px 6px -2px #0000000d,
    0px 10px 15px -3px #0000001a;
  font-family: 'Proxima Nova', sans-serif;
  display: flex;
  max-width: 100%;
  width: 600px;
  position: fixed;
  left: 50%;
  bottom: 40px;
  transform: translate(-50%);
  z-index: ${ZIndex.level1000};
  flex-direction: column;
  transition: max-height 300ms ease-in, transform 300ms ease-in;
  max-height: ${(props) => props.maxHeight}px;
  ${(props) => {
    switch (props.animation) {
        case PopoverAnimation.SlideUp:
            return slideUpStyle$1;
        default:
            return;
    }
}};
`;
const PopoverSection = styled.div `
  justify-content: space-between;
  align-items: start;
  gap: 16px;
  flex-direction: row;
  display: flex;
  padding: 16px;
  color: white;
  font-size: 16px;

  ${({ expanded }) => expanded &&
    css `
      border-bottom: 1px solid ${Colors$1.Midnight500};
    `}
`;
const MessageContainer$1 = styled.div `
  display: flex;
  gap: 16px;
  align-items: center;
`;
const FlexIconContainer = styled.div `
  display: inline-flex;
`;
const ActionContainer$1 = styled.div `
  display: flex;
  align-items: start;
  gap: 21px;
`;
const Action = styled.span `
  text-decoration: underline;
  cursor: pointer;
`;
const CursorIcon = styled(Icon) `
  cursor: pointer;
`;
const RightContainer = styled.div `
  display: flex;
  gap: 8px;
  align-items: center;
`;
const ExpandToggle = styled(CursorIcon) `
  transform: ${(props) => !props.expanded && 'rotate(180deg)'};
`;
const ExpandContainer = styled.div `
  max-height: 300px;
  scrollbar-width: thin;
  scrollbar-color: ${Colors$1.Midnight300} ${Colors$1.Midnight700};
  overflow-y: scroll;
  padding-right: ${(props) => (props.scrollable ? '12px' : '0')};
`;
const PopoverAction = ({ action }) => {
    if (!action)
        return null;
    return jsx(Action, { onClick: action.onClick, children: action.label });
};
const PopoverIcon = ({ icon }) => (jsx(FlexIconContainer, { children: icon }));
const PopoverContent = ({ icon, message, action, }) => (jsxs(Fragment, { children: [jsxs(MessageContainer$1, { children: [icon && jsx(PopoverIcon, { icon: icon }), message] }), jsx(ActionContainer$1, { children: jsx(PopoverAction, { action: action }) })] }));
const Popover = ({ icon, message, action, onClose, animation, expandedContent, }) => {
    const [expanded, setExpanded] = useState(false);
    const [scrollable, setScrollable] = useState(false);
    const expandable = expandedContent?.length;
    const [maxHeight, setMaxHeight] = useState(0);
    const expandContainerRef = useRef(null);
    const topRef = useRef(null);
    useEffect(() => {
        if (expandContainerRef.current) {
            const containerHeight = expandContainerRef.current.scrollHeight;
            const isScrollable = containerHeight > maxHeight;
            setScrollable(isScrollable);
        }
    }, [expandedContent]);
    useEffect(() => {
        if (topRef.current) {
            const topHeight = topRef?.current?.offsetHeight;
            const expandedHeight = topHeight + 300;
            setMaxHeight(expanded ? expandedHeight : topHeight);
        }
    }, [expanded]);
    const toggleExpand = useCallback(() => setExpanded((prev) => !prev), [expanded]);
    return (jsxs(PopoverContainer, { animation: animation, "data-testid": 'popover', className: 'amp-popover', expanded: expanded, maxHeight: maxHeight, children: [jsxs(PopoverSection, { expanded: expanded, ref: topRef, children: [jsx(PopoverContent, { icon: icon, message: message }), jsxs(RightContainer, { children: [expandable ? (jsx(ExpandToggle, { name: 'chevronDown', onClick: toggleExpand, expanded: expanded })) : (jsx(PopoverAction, { action: action })), onClose && (jsx(CursorIcon, { name: 'xCircle', onClick: onClose, "data-testid": 'close-popover' }))] })] }), expandable && (jsx(ExpandContainer, { scrollable: scrollable, ref: expandContainerRef, children: expandedContent.map((item, index) => {
                    return (jsx(PopoverSection, { children: jsx(PopoverContent, { icon: item.icon, message: item.message, action: item.action }) }, index));
                }) }))] }));
};

function Portal({ children, wrapperId = 'portal-root', }) {
    let element = document.getElementById(wrapperId);
    return createPortal(children, element);
}

const Container = styled.div `
  min-width: 320px;
  width: 100%;
  background-color: ${Colors$1.Electric200};
  border-radius: 30px;
  padding: 4px;
  position: relative;
  height: 21px;
`;
const Filler = styled.div `
  width: ${({ progress }) => `${progress}%`};
  background-color: ${Colors$1.Electric700};
  border-radius: inherit;
  height: 13px;
  transition: 1s width;
`;
const BounceContainer = styled.div `
  width: 100%;
  height: 100%;
  position: relative;
  padding-left: 4px;
  padding-right: 4px;
  border-radius: inherit;
`;
const Bounce = styled.div `
  @keyframes bounceEffect {
    0% {
      left: 0%;
      right: 100%;
      width: 0%;
    }
    25% {
      left: 0%;
      right: 50%;
      width: 50%;
    }
    75% {
      right: 0%;
      left: 50%;
      width: 50%;
    }
    100% {
      left: 100%;
      right: 0%;
      width: 0%;
    }
  }
  position: absolute;
  animation: bounceEffect 1s linear infinite;
  background-color: ${Colors$1.Electric700};
  border-radius: inherit;
  height: 13px;
  margin: 0 auto;
`;
const ProgressBar = ({ progress }) => {
    const value = Math.max(0, Math.min(100, progress || 0));
    return (jsx(Container, { className: 'progress-bar-container', children: progress !== undefined ? (jsx(Filler, { role: 'progressbar', "aria-label": 'progress-bar', "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": value, progress: value, id: 'progressbar' })) : (jsx(BounceContainer, { children: jsx(Bounce, { role: 'progressbar', id: 'progressbar', "aria-label": 'progress-bar-infinite' }) })) }));
};

const TabStripOuter = styled.div `
  position: relative;

  &:before {
    content: '';
    position: absolute;
    width: 100%;
    bottom: 0;
    height: 1px;
    background-color: var(--color-border);
  }
`;
const TabStripInner = styled.div `
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  gap: 0.75em;
  justify-content: flex-start;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;

  a {
    border-bottom: 2px solid transparent;
    cursor: pointer;
    color: var(--color-text-light);
    padding: 0.5em 0.75em;
    text-decoration: none;
    font-weight: 400;
    flex-shrink: 0;
    position: relative;
    max-width: 25%;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  a:hover {
    color: ${Colors$1.Pigeon800};
    border-color: ${Colors$1.Pigeon600};
  }

  a.active {
    border-color: 2px solid var(--color-action);
    color: var(--color-action);
    font-weight: 500;
  }
`;
const StyledLink = styled.a `
  ${getFont('b1')}
  font-weight: 400 !important;
  padding: 0px 4px 16px 4px !important;
`;
const TabStrip = ({ children }) => {
    return (jsx(TabStripOuter, { "data-testid": 'tab-strip', children: jsx(TabStripInner, { children: children }) }));
};
const TabLink = ({ active, onClick, className, children, ...otherProps }) => {
    return (jsx(StyledLink, { className: active ? (className ?? '') + ' active' : className, onClick: onClick, ...otherProps, children: children }));
};

var ToastAnimation;
(function (ToastAnimation) {
    ToastAnimation[ToastAnimation["SlideIn"] = 0] = "SlideIn";
})(ToastAnimation || (ToastAnimation = {}));
const slideInAnimation = keyframes `
  from {
    transform: translate(300% , 0)
  }
  to {
    transform: translate(0, 0)
  }
`;
const slideUpStyle = css `
  animation: ${slideInAnimation} 0.3s linear;
`;
const ToastContainer = styled.div `
  background-color: ${Colors$1.MidnightBrand};
  border-radius: 2px;
  box-shadow: 0 0 0 1px #0000000d, 0 4px 6px -2px #0000000d,
    0px 10px 15px -3px #0000001a;
  color: white;
  line-height: 1.5;
  font-size: 16px;
  font-family: 'Proxima Nova', sans-serif;
  display: flex;
  flex-direction: column;
  max-width: 100%;
  width: 350px;
  position: fixed;
  right: 42px;
  top: 90px;
  padding: 16px;
  z-index: ${ZIndex.level1000};

  ${(props) => {
    switch (props.animation) {
        case ToastAnimation.SlideIn:
            return slideUpStyle;
        default:
            return;
    }
}}
`;
const MessageContainer = styled.div `
  display: flex;
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  overflow-wrap: break-word;
`;
const SubMessageContainer = styled.div `
  display: flex;
  color: ${Colors$1.Pigeon400};
  font-size: 14px;
  font-weight: 400;
  overflow-wrap: break-word;
`;
const ActionContainer = styled.div `
  display: flex;
  font-size: 14px;
  font-weight: 400;
  a {
    color: white;
  }
`;
const CloseIcon = styled(Icon) `
  cursor: pointer;
`;
const HeadingContainer = styled.div `
  display: flex;
  justify-content: space-between;
`;
const Toast = ({ heading, message, action, onClose, animation, }) => {
    return (jsxs(ToastContainer, { animation: animation, "data-testid": 'toast', children: [jsxs(HeadingContainer, { children: [jsx(MessageContainer, { children: heading }), jsx(ActionContainer, { children: onClose && (jsx(CloseIcon, { name: 'cross', size: 16, onClick: onClose, "data-testid": 'close-toast' })) })] }), message && jsx(SubMessageContainer, { children: message }), action && jsx(ActionContainer, { children: action })] }));
};

const Checkbox = styled.input.attrs({ type: 'checkbox' }) `
  height: 0;
  width: 0;
  visibility: hidden;
`;
const Label = styled.label `
  cursor: pointer;
  top: 0;
  left: 0;
  text-indent: -9999px;
  width: 30px;
  height: 16px;
  background: ${Colors$1.Pigeon400};
  display: block;
  border-radius: 100px;
  position: absolute;
  transition: background-color 0.3s;

  ::after {
    content: '';
    position: absolute;
    top: 1px;
    left: 1px;
    width: 14px;
    height: 14px;
    border-radius: 45px;
    transition: 0.3s;
    background: #ffffff;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);
  }
`;
const ToggleContainer = styled.div `
  display: inline-block;
  height: 16px;
  position: relative;
  width: 30px;

  ${Checkbox}:checked + ${Label} {
    background: ${({ checkedColor = Colors$1.Pinata800 }) => checkedColor};

    ::after {
      left: calc(100% - 1px);
      transform: translateX(-100%);
    }
  }

  ${Label}:active::after {
    width: 20px;
  }
`;
const Toggle = ({ id, checked, onChange, checkedColor }) => {
    const handleToggleChange = (e) => {
        onChange(!checked);
    };
    return (jsxs(ToggleContainer, { checkedColor: checkedColor, "data-testid": 'toggle-container', children: [jsx(Checkbox, { id: id, checked: checked, onChange: handleToggleChange, "data-testid": 'toggle-checkbox' }), jsx(Label, { "data-testid": 'toggle-label', htmlFor: id })] }));
};

var lodash_isequal = {exports: {}};

/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

(function (module, exports) {
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;

	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    asyncTag = '[object AsyncFunction]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    nullTag = '[object Null]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    proxyTag = '[object Proxy]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    undefinedTag = '[object Undefined]',
	    weakMapTag = '[object WeakMap]';

	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';

	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;

	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;

	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;

	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;

	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());

	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];

	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;

	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;

	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);

	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);

	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);

	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}

	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;

	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];

	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;

	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);

	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols,
	    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeKeys = overArg(Object.keys, Object);

	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');

	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);

	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}

	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}

	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}

	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}

	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;

	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}

	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}

	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  return index < 0 ? undefined : data[index][1];
	}

	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}

	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}

	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;

	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}

	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}

	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}

	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}

	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;

	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}

	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;

	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;

	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}

	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}

	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;

	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}

	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);

	  this.size = data.size;
	  return result;
	}

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}

	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}

	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;

	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;

	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}

	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}

	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}

	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}

	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}

	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}

	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);

	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;

	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;

	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;

	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}

	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}

	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}

	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}

	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;

	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

	  stack.set(array, other);
	  stack.set(other, array);

	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];

	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}

	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;

	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;

	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);

	    case errorTag:
	      return object.name == other.name && object.message == other.message;

	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');

	    case mapTag:
	      var convert = mapToArray;

	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);

	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;

	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;

	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}

	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;

	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);

	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];

	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;

	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}

	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}

	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}

	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}

	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];

	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}

	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}

	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};

	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;

	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';

	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}

	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}

	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}

	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

	  return value === proto;
	}

	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}

	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}

	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;

	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}

	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;

	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}

	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}

	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}

	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}

	module.exports = isEqual;
} (lodash_isequal, lodash_isequal.exports));

var isEqual = lodash_isequal.exports;

const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
        const timeout = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);
        return () => {
            clearTimeout(timeout);
        };
    }, [value, delay]);
    return debouncedValue;
};
function isDebouncedLoadPending(value, debouncedValue, isRequestLoading = false) {
    /*
      A debounced load request is pending either if the request itself is loading (isRequestLoading)
      or if the current value and the debounced value are not equal. If unequal, then the
      request for the current value has not yet been submitted.
    */
    return isRequestLoading || !isEqual(value, debouncedValue);
}

/**
 * Smoothes the change of a boolean value over time to prevent flickering
 * @param value The boolean value to be smoothed
 * @param suppressTime The time in ms to wait before setting the value to true
 * @param forceTime The minimum time in ms to wait before going back from true to false
 */
const useDelayedBoolean = ({ value, suppressTime, forceTime, }) => {
    const [delayedValue, setDelayedValue] = useState(false);
    const [forceValue, setForceValue] = useState(false);
    const forceTrue = () => {
        setForceValue(true);
        setTimeout(() => {
            setForceValue(false);
        }, forceTime);
    };
    useEffect(() => {
        if (value) {
            const timeout = setTimeout(() => {
                setDelayedValue(true);
                forceTrue();
            }, suppressTime);
            return () => {
                clearTimeout(timeout);
            };
        }
        else {
            setDelayedValue(false);
        }
    }, [value]);
    return delayedValue || forceValue;
};

/*
  This hook allows us to save a value on the ref that consistently updates on change
  without causing re-renders the way useState would. It's very useful for cases where
  you have a component that uses functions that rely on state, but are bound to a
  specific state. This can happen in popovers or event listeners, for example. Using ref
  in those cases is similar to using bind--it ensures that the reference reflects
  the current state, rather than the state when the component or function was instantiated.
*/
function useSynchronizedRef(value) {
    const valueRef = useRef(value);
    useKeepRefSynchronized(valueRef, value);
    return valueRef;
}
/*
  This hook allows us to keep a given ref synchronized with a value, updating the ref
  whenever the value changes.
*/
function useKeepRefSynchronized(ref, value) {
    useEffect(() => {
        ref.current = value;
    }, [value]);
}

/**
 * lodash 4.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

var lodash_isarray = isArray;

function forceNumber(value) {
    let parsed = value;
    if (typeof parsed === 'string') {
        parsed = parseFloat(parsed);
    }
    if (typeof parsed === 'number' && isNaN(parsed)) {
        return 0;
    }
    if (typeof parsed !== 'number') {
        return 0;
    }
    return parsed;
}
function forceString(value) {
    if (value === undefined || value === null)
        return '';
    return value.toString();
}
function forceArray(value) {
    if (value === undefined || value === null)
        return [];
    if (lodash_isarray(value))
        return value;
    return [value];
}

export { AMPWrapper, AMP_TOOLTIP_ID, ActionsTooltip, Badge, BadgeRadiusSize, BadgeVariant, Banner, Breadcrumbs, Button, ButtonGroup, ButtonGroupItem, ButtonRow$1 as ButtonRow, CheckboxInput, Colors$1 as Colors, ContextMenu, DEFAULT_PAGE_SIZE, DateDropdown, Dropdown, MenuPopoverElement as DropdownPopover, DropdownTrigger, ESortOptions, Icon, IconButton, IconNames, List, MentionInput, MenuCell, MenuDirection, MenuInput, MenuList, MenuListItem, MenuPlacement, MenuPopover, MenuSelectionMode, MenuSize, MenuType, Modal, ModalButtonRow, ModalCloseButton, ModalHeader, ModalSubHeading, ModalText, NumberInput, Pagination, Pill, PillContainer, Popover, PopoverAnimation, Portal, ProgressBar, SearchBar, SearchInput, SemiBoldCell, SortButton, SortableHeaderCell, Spinner, TabLink, TabStrip, TextInput, TitleBar, Toast, ToastAnimation, Toggle, Tooltip, Typography, ZIndex, classnames$1 as classnames, combineClassnames, dateDropdownOptions, decodeKey, decodeKeys, encodeKey, encodeKeys, forceArray, forceNumber, forceString, getFont, isDebouncedLoadPending, truncated, useDebounce, useDelayedBoolean, $bb77f239b46e8c72$export$3274cf84b703fff as useFilter, useIsTruncated, useKeepRefSynchronized, useListPagination, useOnClickOutside, useSynchronizedRef };
//# sourceMappingURL=index.esm.js.map
